module.exports = {
    2024: [
        { "id": 18153, "year": 2024, "is_wenli": 1, "score": 671, "ranking": 12, "num": 12 },
        { "id": 18154, "year": 2024, "is_wenli": 1, "score": 668, "ranking": 13, "num": 1 },
        { "id": 18155, "year": 2024, "is_wenli": 1, "score": 667, "ranking": 15, "num": 2 },
        { "id": 18156, "year": 2024, "is_wenli": 1, "score": 666, "ranking": 17, "num": 2 },
        { "id": 18157, "year": 2024, "is_wenli": 1, "score": 665, "ranking": 18, "num": 1 },
        { "id": 18158, "year": 2024, "is_wenli": 1, "score": 664, "ranking": 19, "num": 1 },
        { "id": 18159, "year": 2024, "is_wenli": 1, "score": 663, "ranking": 22, "num": 3 },
        { "id": 18160, "year": 2024, "is_wenli": 1, "score": 662, "ranking": 25, "num": 3 }, { "id": 18161, "year": 2024, "is_wenli": 1, "score": 661, "ranking": 28, "num": 3 }, { "id": 18162, "year": 2024, "is_wenli": 1, "score": 659, "ranking": 33, "num": 5 }, { "id": 18163, "year": 2024, "is_wenli": 1, "score": 658, "ranking": 36, "num": 3 }, { "id": 18164, "year": 2024, "is_wenli": 1, "score": 657, "ranking": 41, "num": 5 }, { "id": 18165, "year": 2024, "is_wenli": 1, "score": 656, "ranking": 44, "num": 3 }, { "id": 18166, "year": 2024, "is_wenli": 1, "score": 655, "ranking": 49, "num": 5 }, { "id": 18167, "year": 2024, "is_wenli": 1, "score": 654, "ranking": 59, "num": 10 }, { "id": 18168, "year": 2024, "is_wenli": 1, "score": 653, "ranking": 68, "num": 9 }, { "id": 18169, "year": 2024, "is_wenli": 1, "score": 652, "ranking": 76, "num": 8 }, { "id": 18170, "year": 2024, "is_wenli": 1, "score": 651, "ranking": 83, "num": 7 }, { "id": 18171, "year": 2024, "is_wenli": 1, "score": 650, "ranking": 91, "num": 8 }, { "id": 18172, "year": 2024, "is_wenli": 1, "score": 649, "ranking": 96, "num": 5 }, { "id": 18173, "year": 2024, "is_wenli": 1, "score": 648, "ranking": 101, "num": 5 }, { "id": 18174, "year": 2024, "is_wenli": 1, "score": 647, "ranking": 112, "num": 11 }, { "id": 18175, "year": 2024, "is_wenli": 1, "score": 646, "ranking": 121, "num": 9 }, { "id": 18176, "year": 2024, "is_wenli": 1, "score": 645, "ranking": 130, "num": 9 }, { "id": 18177, "year": 2024, "is_wenli": 1, "score": 644, "ranking": 142, "num": 12 }, { "id": 18178, "year": 2024, "is_wenli": 1, "score": 643, "ranking": 151, "num": 9 }, { "id": 18179, "year": 2024, "is_wenli": 1, "score": 642, "ranking": 170, "num": 19 }, { "id": 18180, "year": 2024, "is_wenli": 1, "score": 641, "ranking": 188, "num": 18 }, { "id": 18181, "year": 2024, "is_wenli": 1, "score": 640, "ranking": 208, "num": 20 }, { "id": 18182, "year": 2024, "is_wenli": 1, "score": 639, "ranking": 221, "num": 13 }, { "id": 18183, "year": 2024, "is_wenli": 1, "score": 638, "ranking": 233, "num": 12 }, { "id": 18184, "year": 2024, "is_wenli": 1, "score": 637, "ranking": 246, "num": 13 }, { "id": 18185, "year": 2024, "is_wenli": 1, "score": 636, "ranking": 260, "num": 14 }, { "id": 18186, "year": 2024, "is_wenli": 1, "score": 635, "ranking": 285, "num": 25 }, { "id": 18187, "year": 2024, "is_wenli": 1, "score": 634, "ranking": 302, "num": 17 }, { "id": 18188, "year": 2024, "is_wenli": 1, "score": 633, "ranking": 321, "num": 19 }, { "id": 18189, "year": 2024, "is_wenli": 1, "score": 632, "ranking": 340, "num": 19 }, { "id": 18190, "year": 2024, "is_wenli": 1, "score": 631, "ranking": 360, "num": 20 }, { "id": 18191, "year": 2024, "is_wenli": 1, "score": 630, "ranking": 388, "num": 28 }, { "id": 18192, "year": 2024, "is_wenli": 1, "score": 629, "ranking": 410, "num": 22 }, { "id": 18193, "year": 2024, "is_wenli": 1, "score": 628, "ranking": 428, "num": 18 }, { "id": 18194, "year": 2024, "is_wenli": 1, "score": 627, "ranking": 455, "num": 27 }, { "id": 18195, "year": 2024, "is_wenli": 1, "score": 626, "ranking": 482, "num": 27 }, { "id": 18196, "year": 2024, "is_wenli": 1, "score": 625, "ranking": 500, "num": 18 }, { "id": 18197, "year": 2024, "is_wenli": 1, "score": 624, "ranking": 539, "num": 39 }, { "id": 18198, "year": 2024, "is_wenli": 1, "score": 623, "ranking": 571, "num": 32 }, { "id": 18199, "year": 2024, "is_wenli": 1, "score": 622, "ranking": 614, "num": 43 }, { "id": 18200, "year": 2024, "is_wenli": 1, "score": 621, "ranking": 652, "num": 38 }, { "id": 18201, "year": 2024, "is_wenli": 1, "score": 620, "ranking": 690, "num": 38 }, { "id": 18202, "year": 2024, "is_wenli": 1, "score": 619, "ranking": 742, "num": 52 }, { "id": 18203, "year": 2024, "is_wenli": 1, "score": 618, "ranking": 788, "num": 46 }, { "id": 18204, "year": 2024, "is_wenli": 1, "score": 617, "ranking": 839, "num": 51 }, { "id": 18205, "year": 2024, "is_wenli": 1, "score": 616, "ranking": 887, "num": 48 }, { "id": 18206, "year": 2024, "is_wenli": 1, "score": 615, "ranking": 916, "num": 29 }, { "id": 18207, "year": 2024, "is_wenli": 1, "score": 614, "ranking": 974, "num": 58 }, { "id": 18208, "year": 2024, "is_wenli": 1, "score": 613, "ranking": 1038, "num": 64 }, { "id": 18209, "year": 2024, "is_wenli": 1, "score": 612, "ranking": 1108, "num": 70 }, { "id": 18210, "year": 2024, "is_wenli": 1, "score": 611, "ranking": 1163, "num": 55 }, { "id": 18211, "year": 2024, "is_wenli": 1, "score": 610, "ranking": 1227, "num": 64 }, { "id": 18212, "year": 2024, "is_wenli": 1, "score": 609, "ranking": 1292, "num": 65 }, { "id": 18213, "year": 2024, "is_wenli": 1, "score": 608, "ranking": 1351, "num": 59 }, { "id": 18214, "year": 2024, "is_wenli": 1, "score": 607, "ranking": 1416, "num": 65 }, { "id": 18215, "year": 2024, "is_wenli": 1, "score": 606, "ranking": 1496, "num": 80 }, { "id": 18216, "year": 2024, "is_wenli": 1, "score": 605, "ranking": 1570, "num": 74 }, { "id": 18217, "year": 2024, "is_wenli": 1, "score": 604, "ranking": 1661, "num": 91 }, { "id": 18218, "year": 2024, "is_wenli": 1, "score": 603, "ranking": 1723, "num": 62 }, { "id": 18219, "year": 2024, "is_wenli": 1, "score": 602, "ranking": 1802, "num": 79 }, { "id": 18220, "year": 2024, "is_wenli": 1, "score": 601, "ranking": 1902, "num": 100 }, { "id": 18221, "year": 2024, "is_wenli": 1, "score": 600, "ranking": 1985, "num": 83 }, { "id": 18222, "year": 2024, "is_wenli": 1, "score": 599, "ranking": 2083, "num": 98 }, { "id": 18223, "year": 2024, "is_wenli": 1, "score": 598, "ranking": 2188, "num": 105 }, { "id": 18224, "year": 2024, "is_wenli": 1, "score": 597, "ranking": 2288, "num": 100 }, { "id": 18225, "year": 2024, "is_wenli": 1, "score": 596, "ranking": 2393, "num": 105 }, { "id": 18226, "year": 2024, "is_wenli": 1, "score": 595, "ranking": 2503, "num": 110 }, { "id": 18227, "year": 2024, "is_wenli": 1, "score": 594, "ranking": 2620, "num": 117 }, { "id": 18228, "year": 2024, "is_wenli": 1, "score": 593, "ranking": 2728, "num": 108 }, { "id": 18229, "year": 2024, "is_wenli": 1, "score": 592, "ranking": 2855, "num": 127 }, { "id": 18230, "year": 2024, "is_wenli": 1, "score": 591, "ranking": 2990, "num": 135 }, { "id": 18231, "year": 2024, "is_wenli": 1, "score": 590, "ranking": 3112, "num": 122 }, { "id": 18232, "year": 2024, "is_wenli": 1, "score": 589, "ranking": 3241, "num": 129 }, { "id": 18233, "year": 2024, "is_wenli": 1, "score": 588, "ranking": 3378, "num": 137 }, { "id": 18234, "year": 2024, "is_wenli": 1, "score": 587, "ranking": 3514, "num": 136 }, { "id": 18235, "year": 2024, "is_wenli": 1, "score": 586, "ranking": 3651, "num": 137 }, { "id": 18236, "year": 2024, "is_wenli": 1, "score": 585, "ranking": 3808, "num": 157 }, { "id": 18237, "year": 2024, "is_wenli": 1, "score": 584, "ranking": 4004, "num": 196 }, { "id": 18238, "year": 2024, "is_wenli": 1, "score": 583, "ranking": 4196, "num": 192 }, { "id": 18239, "year": 2024, "is_wenli": 1, "score": 582, "ranking": 4356, "num": 160 }, { "id": 18240, "year": 2024, "is_wenli": 1, "score": 581, "ranking": 4526, "num": 170 }, { "id": 18241, "year": 2024, "is_wenli": 1, "score": 580, "ranking": 4709, "num": 183 }, { "id": 18242, "year": 2024, "is_wenli": 1, "score": 579, "ranking": 4869, "num": 160 }, { "id": 18243, "year": 2024, "is_wenli": 1, "score": 578, "ranking": 5068, "num": 199 }, { "id": 18244, "year": 2024, "is_wenli": 1, "score": 577, "ranking": 5265, "num": 197 }, { "id": 18245, "year": 2024, "is_wenli": 1, "score": 576, "ranking": 5468, "num": 203 }, { "id": 18246, "year": 2024, "is_wenli": 1, "score": 575, "ranking": 5676, "num": 208 }, { "id": 18247, "year": 2024, "is_wenli": 1, "score": 574, "ranking": 5879, "num": 203 }, { "id": 18248, "year": 2024, "is_wenli": 1, "score": 573, "ranking": 6088, "num": 209 }, { "id": 18249, "year": 2024, "is_wenli": 1, "score": 572, "ranking": 6284, "num": 196 }, { "id": 18250, "year": 2024, "is_wenli": 1, "score": 571, "ranking": 6515, "num": 231 }, { "id": 18251, "year": 2024, "is_wenli": 1, "score": 570, "ranking": 6767, "num": 252 }, { "id": 18252, "year": 2024, "is_wenli": 1, "score": 569, "ranking": 7002, "num": 235 }, { "id": 18253, "year": 2024, "is_wenli": 1, "score": 568, "ranking": 7217, "num": 215 }, { "id": 18254, "year": 2024, "is_wenli": 1, "score": 567, "ranking": 7469, "num": 252 }, { "id": 18255, "year": 2024, "is_wenli": 1, "score": 566, "ranking": 7718, "num": 249 }, { "id": 18256, "year": 2024, "is_wenli": 1, "score": 565, "ranking": 7940, "num": 222 }, { "id": 18257, "year": 2024, "is_wenli": 1, "score": 564, "ranking": 8193, "num": 253 }, { "id": 18258, "year": 2024, "is_wenli": 1, "score": 563, "ranking": 8497, "num": 304 }, { "id": 18259, "year": 2024, "is_wenli": 1, "score": 562, "ranking": 8811, "num": 314 }, { "id": 18260, "year": 2024, "is_wenli": 1, "score": 561, "ranking": 9080, "num": 269 }, { "id": 18261, "year": 2024, "is_wenli": 1, "score": 560, "ranking": 9395, "num": 315 }, { "id": 18262, "year": 2024, "is_wenli": 1, "score": 559, "ranking": 9687, "num": 292 }, { "id": 18263, "year": 2024, "is_wenli": 1, "score": 558, "ranking": 10012, "num": 325 }, { "id": 18264, "year": 2024, "is_wenli": 1, "score": 557, "ranking": 10292, "num": 280 }, { "id": 18265, "year": 2024, "is_wenli": 1, "score": 556, "ranking": 10619, "num": 327 }, { "id": 18266, "year": 2024, "is_wenli": 1, "score": 555, "ranking": 10923, "num": 304 }, { "id": 18267, "year": 2024, "is_wenli": 1, "score": 554, "ranking": 11266, "num": 343 }, { "id": 18268, "year": 2024, "is_wenli": 1, "score": 553, "ranking": 11610, "num": 344 }, { "id": 18269, "year": 2024, "is_wenli": 1, "score": 552, "ranking": 12001, "num": 391 }, { "id": 18270, "year": 2024, "is_wenli": 1, "score": 551, "ranking": 12326, "num": 325 }, { "id": 18271, "year": 2024, "is_wenli": 1, "score": 550, "ranking": 12699, "num": 373 }, { "id": 18272, "year": 2024, "is_wenli": 1, "score": 549, "ranking": 13056, "num": 357 }, { "id": 18273, "year": 2024, "is_wenli": 1, "score": 548, "ranking": 13425, "num": 369 }, { "id": 18274, "year": 2024, "is_wenli": 1, "score": 547, "ranking": 13805, "num": 380 }, { "id": 18275, "year": 2024, "is_wenli": 1, "score": 546, "ranking": 14153, "num": 348 }, { "id": 18276, "year": 2024, "is_wenli": 1, "score": 545, "ranking": 14531, "num": 378 }, { "id": 18277, "year": 2024, "is_wenli": 1, "score": 544, "ranking": 14934, "num": 403 }, { "id": 18278, "year": 2024, "is_wenli": 1, "score": 543, "ranking": 15332, "num": 398 }, { "id": 18279, "year": 2024, "is_wenli": 1, "score": 542, "ranking": 15720, "num": 388 }, { "id": 18280, "year": 2024, "is_wenli": 1, "score": 541, "ranking": 16148, "num": 428 }, { "id": 18281, "year": 2024, "is_wenli": 1, "score": 540, "ranking": 16573, "num": 425 }, { "id": 18282, "year": 2024, "is_wenli": 1, "score": 539, "ranking": 17011, "num": 438 }, { "id": 18283, "year": 2024, "is_wenli": 1, "score": 538, "ranking": 17448, "num": 437 }, { "id": 18284, "year": 2024, "is_wenli": 1, "score": 537, "ranking": 17884, "num": 436 }, { "id": 18285, "year": 2024, "is_wenli": 1, "score": 536, "ranking": 18289, "num": 405 }, { "id": 18286, "year": 2024, "is_wenli": 1, "score": 535, "ranking": 18736, "num": 447 }, { "id": 18287, "year": 2024, "is_wenli": 1, "score": 534, "ranking": 19197, "num": 461 }, { "id": 18288, "year": 2024, "is_wenli": 1, "score": 533, "ranking": 19675, "num": 478 }, { "id": 18289, "year": 2024, "is_wenli": 1, "score": 532, "ranking": 20150, "num": 475 }, { "id": 18290, "year": 2024, "is_wenli": 1, "score": 531, "ranking": 20613, "num": 463 }, { "id": 18291, "year": 2024, "is_wenli": 1, "score": 530, "ranking": 21051, "num": 438 }, { "id": 18292, "year": 2024, "is_wenli": 1, "score": 529, "ranking": 21553, "num": 502 }, { "id": 18293, "year": 2024, "is_wenli": 1, "score": 528, "ranking": 22068, "num": 515 }, { "id": 18294, "year": 2024, "is_wenli": 1, "score": 527, "ranking": 22561, "num": 493 }, { "id": 18295, "year": 2024, "is_wenli": 1, "score": 526, "ranking": 23057, "num": 496 }, { "id": 18296, "year": 2024, "is_wenli": 1, "score": 525, "ranking": 23548, "num": 491 }, { "id": 18297, "year": 2024, "is_wenli": 1, "score": 524, "ranking": 24082, "num": 534 }, { "id": 18298, "year": 2024, "is_wenli": 1, "score": 523, "ranking": 24648, "num": 566 }, { "id": 18299, "year": 2024, "is_wenli": 1, "score": 522, "ranking": 25181, "num": 533 }, { "id": 18300, "year": 2024, "is_wenli": 1, "score": 521, "ranking": 25688, "num": 507 }, { "id": 18301, "year": 2024, "is_wenli": 1, "score": 520, "ranking": 26237, "num": 549 }, { "id": 18302, "year": 2024, "is_wenli": 1, "score": 519, "ranking": 26743, "num": 506 }, { "id": 18303, "year": 2024, "is_wenli": 1, "score": 518, "ranking": 27273, "num": 530 }, { "id": 18304, "year": 2024, "is_wenli": 1, "score": 517, "ranking": 27870, "num": 597 }, { "id": 18305, "year": 2024, "is_wenli": 1, "score": 516, "ranking": 28443, "num": 573 }, { "id": 18306, "year": 2024, "is_wenli": 1, "score": 515, "ranking": 29013, "num": 570 }, { "id": 18307, "year": 2024, "is_wenli": 1, "score": 514, "ranking": 29603, "num": 590 }, { "id": 18308, "year": 2024, "is_wenli": 1, "score": 513, "ranking": 30160, "num": 557 }, { "id": 18309, "year": 2024, "is_wenli": 1, "score": 512, "ranking": 30726, "num": 566 }, { "id": 18310, "year": 2024, "is_wenli": 1, "score": 511, "ranking": 31332, "num": 606 }, { "id": 18311, "year": 2024, "is_wenli": 1, "score": 510, "ranking": 31936, "num": 604 }, { "id": 18312, "year": 2024, "is_wenli": 1, "score": 509, "ranking": 32551, "num": 615 }, { "id": 18313, "year": 2024, "is_wenli": 1, "score": 508, "ranking": 33183, "num": 632 }, { "id": 18314, "year": 2024, "is_wenli": 1, "score": 507, "ranking": 33787, "num": 604 }, { "id": 18315, "year": 2024, "is_wenli": 1, "score": 506, "ranking": 34448, "num": 661 }, { "id": 18316, "year": 2024, "is_wenli": 1, "score": 505, "ranking": 35107, "num": 659 }, { "id": 18317, "year": 2024, "is_wenli": 1, "score": 504, "ranking": 35743, "num": 636 }, { "id": 18318, "year": 2024, "is_wenli": 1, "score": 503, "ranking": 36361, "num": 618 }, { "id": 18319, "year": 2024, "is_wenli": 1, "score": 502, "ranking": 37018, "num": 657 }, { "id": 18320, "year": 2024, "is_wenli": 1, "score": 501, "ranking": 37674, "num": 656 }, { "id": 18321, "year": 2024, "is_wenli": 1, "score": 500, "ranking": 38365, "num": 691 }, { "id": 18322, "year": 2024, "is_wenli": 1, "score": 499, "ranking": 38998, "num": 633 }, { "id": 18323, "year": 2024, "is_wenli": 1, "score": 498, "ranking": 39680, "num": 682 }, { "id": 18324, "year": 2024, "is_wenli": 1, "score": 497, "ranking": 40367, "num": 687 }, { "id": 18325, "year": 2024, "is_wenli": 1, "score": 496, "ranking": 41047, "num": 680 }, { "id": 18326, "year": 2024, "is_wenli": 1, "score": 495, "ranking": 41702, "num": 655 }, { "id": 18327, "year": 2024, "is_wenli": 1, "score": 494, "ranking": 42359, "num": 657 }, { "id": 18328, "year": 2024, "is_wenli": 1, "score": 493, "ranking": 43048, "num": 689 }, { "id": 18329, "year": 2024, "is_wenli": 1, "score": 492, "ranking": 43733, "num": 685 }, { "id": 18330, "year": 2024, "is_wenli": 1, "score": 491, "ranking": 44425, "num": 692 }, { "id": 18331, "year": 2024, "is_wenli": 1, "score": 490, "ranking": 45184, "num": 759 }, { "id": 18332, "year": 2024, "is_wenli": 1, "score": 489, "ranking": 45924, "num": 740 }, { "id": 18333, "year": 2024, "is_wenli": 1, "score": 488, "ranking": 46648, "num": 724 }, { "id": 18334, "year": 2024, "is_wenli": 1, "score": 487, "ranking": 47394, "num": 746 }, { "id": 18335, "year": 2024, "is_wenli": 1, "score": 486, "ranking": 48153, "num": 759 }, { "id": 18336, "year": 2024, "is_wenli": 1, "score": 485, "ranking": 48864, "num": 711 }, { "id": 18337, "year": 2024, "is_wenli": 1, "score": 484, "ranking": 49586, "num": 722 }, { "id": 18338, "year": 2024, "is_wenli": 1, "score": 483, "ranking": 50315, "num": 729 }, { "id": 18339, "year": 2024, "is_wenli": 1, "score": 482, "ranking": 51039, "num": 724 }, { "id": 18340, "year": 2024, "is_wenli": 1, "score": 481, "ranking": 51831, "num": 792 }, { "id": 18341, "year": 2024, "is_wenli": 1, "score": 480, "ranking": 52598, "num": 767 }, { "id": 18342, "year": 2024, "is_wenli": 1, "score": 479, "ranking": 53329, "num": 731 }, { "id": 18343, "year": 2024, "is_wenli": 1, "score": 478, "ranking": 54094, "num": 765 }, { "id": 18344, "year": 2024, "is_wenli": 1, "score": 477, "ranking": 54915, "num": 821 }, { "id": 18345, "year": 2024, "is_wenli": 1, "score": 476, "ranking": 55683, "num": 768 }, { "id": 18346, "year": 2024, "is_wenli": 1, "score": 475, "ranking": 56502, "num": 819 }, { "id": 18347, "year": 2024, "is_wenli": 1, "score": 474, "ranking": 57312, "num": 810 }, { "id": 18348, "year": 2024, "is_wenli": 1, "score": 473, "ranking": 58074, "num": 762 }, { "id": 18349, "year": 2024, "is_wenli": 1, "score": 472, "ranking": 58914, "num": 840 }, { "id": 18350, "year": 2024, "is_wenli": 1, "score": 471, "ranking": 59729, "num": 815 }, { "id": 18351, "year": 2024, "is_wenli": 1, "score": 470, "ranking": 60525, "num": 796 }, { "id": 18352, "year": 2024, "is_wenli": 1, "score": 469, "ranking": 61381, "num": 856 }, { "id": 18353, "year": 2024, "is_wenli": 1, "score": 468, "ranking": 62194, "num": 813 }, { "id": 18354, "year": 2024, "is_wenli": 1, "score": 467, "ranking": 63016, "num": 822 }, { "id": 18355, "year": 2024, "is_wenli": 1, "score": 466, "ranking": 63839, "num": 823 }, { "id": 18356, "year": 2024, "is_wenli": 1, "score": 465, "ranking": 64708, "num": 869 }, { "id": 18357, "year": 2024, "is_wenli": 1, "score": 464, "ranking": 65531, "num": 823 }, { "id": 18358, "year": 2024, "is_wenli": 1, "score": 463, "ranking": 66389, "num": 858 }, { "id": 18359, "year": 2024, "is_wenli": 1, "score": 462, "ranking": 67212, "num": 823 }, { "id": 18360, "year": 2024, "is_wenli": 1, "score": 461, "ranking": 68095, "num": 883 }, { "id": 18361, "year": 2024, "is_wenli": 1, "score": 460, "ranking": 68905, "num": 810 }, { "id": 18362, "year": 2024, "is_wenli": 1, "score": 459, "ranking": 69738, "num": 833 }, { "id": 18363, "year": 2024, "is_wenli": 1, "score": 458, "ranking": 70594, "num": 856 }, { "id": 18364, "year": 2024, "is_wenli": 1, "score": 457, "ranking": 71460, "num": 866 }, { "id": 18365, "year": 2024, "is_wenli": 1, "score": 456, "ranking": 72330, "num": 870 }, { "id": 18366, "year": 2024, "is_wenli": 1, "score": 455, "ranking": 73188, "num": 858 }, { "id": 18367, "year": 2024, "is_wenli": 1, "score": 454, "ranking": 74039, "num": 851 }, { "id": 18368, "year": 2024, "is_wenli": 1, "score": 453, "ranking": 74880, "num": 841 }, { "id": 18369, "year": 2024, "is_wenli": 1, "score": 452, "ranking": 75749, "num": 869 }, { "id": 18370, "year": 2024, "is_wenli": 1, "score": 451, "ranking": 76655, "num": 906 }, { "id": 18371, "year": 2024, "is_wenli": 1, "score": 450, "ranking": 77462, "num": 807 }, { "id": 18372, "year": 2024, "is_wenli": 1, "score": 449, "ranking": 78317, "num": 855 }, { "id": 18373, "year": 2024, "is_wenli": 1, "score": 448, "ranking": 79231, "num": 914 }, { "id": 18374, "year": 2024, "is_wenli": 1, "score": 447, "ranking": 80118, "num": 887 }, { "id": 18375, "year": 2024, "is_wenli": 1, "score": 446, "ranking": 80945, "num": 827 }, { "id": 18376, "year": 2024, "is_wenli": 1, "score": 445, "ranking": 81801, "num": 856 }, { "id": 18377, "year": 2024, "is_wenli": 1, "score": 444, "ranking": 82684, "num": 883 }, { "id": 18378, "year": 2024, "is_wenli": 1, "score": 443, "ranking": 83577, "num": 893 }, { "id": 18379, "year": 2024, "is_wenli": 1, "score": 442, "ranking": 84476, "num": 899 }, { "id": 18380, "year": 2024, "is_wenli": 1, "score": 441, "ranking": 85422, "num": 946 }, { "id": 18381, "year": 2024, "is_wenli": 1, "score": 440, "ranking": 86369, "num": 947 }, { "id": 18382, "year": 2024, "is_wenli": 1, "score": 439, "ranking": 87279, "num": 910 }, { "id": 18383, "year": 2024, "is_wenli": 1, "score": 438, "ranking": 88171, "num": 892 }, { "id": 18384, "year": 2024, "is_wenli": 1, "score": 437, "ranking": 89086, "num": 915 }, { "id": 18385, "year": 2024, "is_wenli": 1, "score": 436, "ranking": 89984, "num": 898 }, { "id": 18386, "year": 2024, "is_wenli": 1, "score": 435, "ranking": 90950, "num": 966 }, { "id": 18387, "year": 2024, "is_wenli": 1, "score": 434, "ranking": 91935, "num": 985 }, { "id": 18388, "year": 2024, "is_wenli": 1, "score": 433, "ranking": 92844, "num": 909 }, { "id": 18389, "year": 2024, "is_wenli": 1, "score": 432, "ranking": 93783, "num": 939 }, { "id": 18390, "year": 2024, "is_wenli": 1, "score": 431, "ranking": 94756, "num": 973 }, { "id": 18391, "year": 2024, "is_wenli": 1, "score": 430, "ranking": 95716, "num": 960 }, { "id": 18392, "year": 2024, "is_wenli": 1, "score": 429, "ranking": 96702, "num": 986 }, { "id": 18393, "year": 2024, "is_wenli": 1, "score": 428, "ranking": 97632, "num": 930 }, { "id": 18394, "year": 2024, "is_wenli": 1, "score": 427, "ranking": 98536, "num": 904 }, { "id": 18395, "year": 2024, "is_wenli": 1, "score": 426, "ranking": 99502, "num": 966 }, { "id": 18396, "year": 2024, "is_wenli": 1, "score": 425, "ranking": 100480, "num": 978 }, { "id": 18397, "year": 2024, "is_wenli": 1, "score": 424, "ranking": 101443, "num": 963 }, { "id": 18398, "year": 2024, "is_wenli": 1, "score": 423, "ranking": 102361, "num": 918 }, { "id": 18399, "year": 2024, "is_wenli": 1, "score": 422, "ranking": 103279, "num": 918 }, { "id": 18400, "year": 2024, "is_wenli": 1, "score": 421, "ranking": 104214, "num": 935 }, { "id": 18401, "year": 2024, "is_wenli": 1, "score": 420, "ranking": 105172, "num": 958 }, { "id": 18402, "year": 2024, "is_wenli": 1, "score": 419, "ranking": 106137, "num": 965 }, { "id": 18403, "year": 2024, "is_wenli": 1, "score": 418, "ranking": 107145, "num": 1008 }, { "id": 18404, "year": 2024, "is_wenli": 1, "score": 417, "ranking": 108140, "num": 995 }, { "id": 18405, "year": 2024, "is_wenli": 1, "score": 416, "ranking": 109100, "num": 960 }, { "id": 18406, "year": 2024, "is_wenli": 1, "score": 415, "ranking": 110064, "num": 964 }, { "id": 18407, "year": 2024, "is_wenli": 1, "score": 414, "ranking": 111032, "num": 968 }, { "id": 18408, "year": 2024, "is_wenli": 1, "score": 413, "ranking": 112018, "num": 986 }, { "id": 18409, "year": 2024, "is_wenli": 1, "score": 412, "ranking": 113010, "num": 992 }, { "id": 18410, "year": 2024, "is_wenli": 1, "score": 411, "ranking": 113991, "num": 981 }, { "id": 18411, "year": 2024, "is_wenli": 1, "score": 410, "ranking": 115062, "num": 1071 }, { "id": 18412, "year": 2024, "is_wenli": 1, "score": 409, "ranking": 116073, "num": 1011 }, { "id": 18413, "year": 2024, "is_wenli": 1, "score": 408, "ranking": 117061, "num": 988 }, { "id": 18414, "year": 2024, "is_wenli": 1, "score": 407, "ranking": 118080, "num": 1019 }, { "id": 18415, "year": 2024, "is_wenli": 1, "score": 406, "ranking": 119130, "num": 1050 }, { "id": 18416, "year": 2024, "is_wenli": 1, "score": 405, "ranking": 120171, "num": 1041 }, { "id": 18417, "year": 2024, "is_wenli": 1, "score": 404, "ranking": 121224, "num": 1053 }, { "id": 18418, "year": 2024, "is_wenli": 1, "score": 403, "ranking": 122317, "num": 1093 }, { "id": 18419, "year": 2024, "is_wenli": 1, "score": 402, "ranking": 123355, "num": 1038 }, { "id": 18420, "year": 2024, "is_wenli": 1, "score": 401, "ranking": 124423, "num": 1068 }, { "id": 18421, "year": 2024, "is_wenli": 1, "score": 400, "ranking": 125470, "num": 1047 }, { "id": 18422, "year": 2024, "is_wenli": 1, "score": 399, "ranking": 126542, "num": 1072 }, { "id": 18423, "year": 2024, "is_wenli": 1, "score": 398, "ranking": 127595, "num": 1053 }, { "id": 18424, "year": 2024, "is_wenli": 1, "score": 397, "ranking": 128701, "num": 1106 }, { "id": 18425, "year": 2024, "is_wenli": 1, "score": 396, "ranking": 129734, "num": 1033 }, { "id": 18426, "year": 2024, "is_wenli": 1, "score": 395, "ranking": 130725, "num": 991 }, { "id": 18427, "year": 2024, "is_wenli": 1, "score": 394, "ranking": 131835, "num": 1110 }, { "id": 18428, "year": 2024, "is_wenli": 1, "score": 393, "ranking": 132909, "num": 1074 }, { "id": 18429, "year": 2024, "is_wenli": 1, "score": 392, "ranking": 133921, "num": 1012 }, { "id": 18430, "year": 2024, "is_wenli": 1, "score": 391, "ranking": 135035, "num": 1114 }, { "id": 18431, "year": 2024, "is_wenli": 1, "score": 390, "ranking": 136143, "num": 1108 }, { "id": 18432, "year": 2024, "is_wenli": 1, "score": 389, "ranking": 137189, "num": 1046 }, { "id": 18433, "year": 2024, "is_wenli": 1, "score": 388, "ranking": 138265, "num": 1076 }, { "id": 18434, "year": 2024, "is_wenli": 1, "score": 387, "ranking": 139363, "num": 1098 }, { "id": 18435, "year": 2024, "is_wenli": 1, "score": 386, "ranking": 140480, "num": 1117 }, { "id": 18436, "year": 2024, "is_wenli": 1, "score": 385, "ranking": 141559, "num": 1079 }, { "id": 18437, "year": 2024, "is_wenli": 1, "score": 384, "ranking": 142688, "num": 1129 }, { "id": 18438, "year": 2024, "is_wenli": 1, "score": 383, "ranking": 143815, "num": 1127 }, { "id": 18439, "year": 2024, "is_wenli": 1, "score": 382, "ranking": 144946, "num": 1131 }, { "id": 18440, "year": 2024, "is_wenli": 1, "score": 381, "ranking": 146084, "num": 1138 }, { "id": 18441, "year": 2024, "is_wenli": 1, "score": 380, "ranking": 147230, "num": 1146 }, { "id": 18442, "year": 2024, "is_wenli": 1, "score": 379, "ranking": 148347, "num": 1117 }, { "id": 18443, "year": 2024, "is_wenli": 1, "score": 378, "ranking": 149468, "num": 1121 }, { "id": 18444, "year": 2024, "is_wenli": 1, "score": 377, "ranking": 150585, "num": 1117 }, { "id": 18445, "year": 2024, "is_wenli": 1, "score": 376, "ranking": 151664, "num": 1079 }, { "id": 18446, "year": 2024, "is_wenli": 1, "score": 375, "ranking": 152758, "num": 1094 }, { "id": 18447, "year": 2024, "is_wenli": 1, "score": 374, "ranking": 153894, "num": 1136 }, { "id": 18448, "year": 2024, "is_wenli": 1, "score": 373, "ranking": 155055, "num": 1161 }, { "id": 18449, "year": 2024, "is_wenli": 1, "score": 372, "ranking": 156165, "num": 1110 }, { "id": 18450, "year": 2024, "is_wenli": 1, "score": 371, "ranking": 157276, "num": 1111 }, { "id": 18451, "year": 2024, "is_wenli": 1, "score": 370, "ranking": 158445, "num": 1169 }, { "id": 18452, "year": 2024, "is_wenli": 1, "score": 369, "ranking": 159575, "num": 1130 }, { "id": 18453, "year": 2024, "is_wenli": 1, "score": 368, "ranking": 160737, "num": 1162 }, { "id": 18454, "year": 2024, "is_wenli": 1, "score": 367, "ranking": 161929, "num": 1192 }, { "id": 18455, "year": 2024, "is_wenli": 1, "score": 366, "ranking": 163100, "num": 1171 }, { "id": 18456, "year": 2024, "is_wenli": 1, "score": 365, "ranking": 164357, "num": 1257 }, { "id": 18457, "year": 2024, "is_wenli": 1, "score": 364, "ranking": 165477, "num": 1120 }, { "id": 18458, "year": 2024, "is_wenli": 1, "score": 363, "ranking": 166696, "num": 1219 }, { "id": 18459, "year": 2024, "is_wenli": 1, "score": 362, "ranking": 167884, "num": 1188 }, { "id": 18460, "year": 2024, "is_wenli": 1, "score": 361, "ranking": 169090, "num": 1206 }, { "id": 18461, "year": 2024, "is_wenli": 1, "score": 360, "ranking": 170278, "num": 1188 }, { "id": 18462, "year": 2024, "is_wenli": 1, "score": 359, "ranking": 171475, "num": 1197 }, { "id": 18463, "year": 2024, "is_wenli": 1, "score": 358, "ranking": 172653, "num": 1178 }, { "id": 18464, "year": 2024, "is_wenli": 1, "score": 357, "ranking": 173834, "num": 1181 }, { "id": 18465, "year": 2024, "is_wenli": 1, "score": 356, "ranking": 175097, "num": 1263 }, { "id": 18466, "year": 2024, "is_wenli": 1, "score": 355, "ranking": 176357, "num": 1260 }, { "id": 18467, "year": 2024, "is_wenli": 1, "score": 354, "ranking": 177584, "num": 1227 }, { "id": 18468, "year": 2024, "is_wenli": 1, "score": 353, "ranking": 178774, "num": 1190 }, { "id": 18469, "year": 2024, "is_wenli": 1, "score": 352, "ranking": 179942, "num": 1168 }, { "id": 18470, "year": 2024, "is_wenli": 1, "score": 351, "ranking": 181104, "num": 1162 }, { "id": 18471, "year": 2024, "is_wenli": 1, "score": 350, "ranking": 182257, "num": 1153 }, { "id": 18472, "year": 2024, "is_wenli": 1, "score": 349, "ranking": 183468, "num": 1211 }, { "id": 18473, "year": 2024, "is_wenli": 1, "score": 348, "ranking": 184634, "num": 1166 }, { "id": 18474, "year": 2024, "is_wenli": 1, "score": 347, "ranking": 185940, "num": 1306 }, { "id": 18475, "year": 2024, "is_wenli": 1, "score": 346, "ranking": 187140, "num": 1200 }, { "id": 18476, "year": 2024, "is_wenli": 1, "score": 345, "ranking": 188463, "num": 1323 }, { "id": 18477, "year": 2024, "is_wenli": 1, "score": 344, "ranking": 189699, "num": 1236 }, { "id": 18478, "year": 2024, "is_wenli": 1, "score": 343, "ranking": 190897, "num": 1198 }, { "id": 18479, "year": 2024, "is_wenli": 1, "score": 342, "ranking": 192108, "num": 1211 }, { "id": 18480, "year": 2024, "is_wenli": 1, "score": 341, "ranking": 193331, "num": 1223 }, { "id": 18481, "year": 2024, "is_wenli": 1, "score": 340, "ranking": 194558, "num": 1227 }, { "id": 18482, "year": 2024, "is_wenli": 1, "score": 339, "ranking": 195775, "num": 1217 }, { "id": 18483, "year": 2024, "is_wenli": 1, "score": 338, "ranking": 197027, "num": 1252 }, { "id": 18484, "year": 2024, "is_wenli": 1, "score": 337, "ranking": 198241, "num": 1214 }, { "id": 18485, "year": 2024, "is_wenli": 1, "score": 336, "ranking": 199480, "num": 1239 }, { "id": 18486, "year": 2024, "is_wenli": 1, "score": 335, "ranking": 200717, "num": 1237 }, { "id": 18487, "year": 2024, "is_wenli": 1, "score": 334, "ranking": 202002, "num": 1285 }, { "id": 18488, "year": 2024, "is_wenli": 1, "score": 333, "ranking": 203234, "num": 1232 }, { "id": 18489, "year": 2024, "is_wenli": 1, "score": 332, "ranking": 204486, "num": 1252 }, { "id": 18490, "year": 2024, "is_wenli": 1, "score": 331, "ranking": 205713, "num": 1227 }, { "id": 18491, "year": 2024, "is_wenli": 1, "score": 330, "ranking": 206957, "num": 1244 }, { "id": 18492, "year": 2024, "is_wenli": 1, "score": 329, "ranking": 208211, "num": 1254 }, { "id": 18493, "year": 2024, "is_wenli": 1, "score": 328, "ranking": 209403, "num": 1192 }, { "id": 18494, "year": 2024, "is_wenli": 1, "score": 327, "ranking": 210592, "num": 1189 }, { "id": 18495, "year": 2024, "is_wenli": 1, "score": 326, "ranking": 211760, "num": 1168 }, { "id": 18496, "year": 2024, "is_wenli": 1, "score": 325, "ranking": 213040, "num": 1280 }, { "id": 18497, "year": 2024, "is_wenli": 1, "score": 324, "ranking": 214351, "num": 1311 }, { "id": 18498, "year": 2024, "is_wenli": 1, "score": 323, "ranking": 215623, "num": 1272 }, { "id": 18499, "year": 2024, "is_wenli": 1, "score": 322, "ranking": 216878, "num": 1255 }, { "id": 18500, "year": 2024, "is_wenli": 1, "score": 321, "ranking": 218174, "num": 1296 }, { "id": 18501, "year": 2024, "is_wenli": 1, "score": 320, "ranking": 219452, "num": 1278 }, { "id": 18502, "year": 2024, "is_wenli": 1, "score": 319, "ranking": 220718, "num": 1266 }, { "id": 18503, "year": 2024, "is_wenli": 1, "score": 318, "ranking": 221992, "num": 1274 }, { "id": 18504, "year": 2024, "is_wenli": 1, "score": 317, "ranking": 223287, "num": 1295 }, { "id": 18505, "year": 2024, "is_wenli": 1, "score": 316, "ranking": 224523, "num": 1236 }, { "id": 18506, "year": 2024, "is_wenli": 1, "score": 315, "ranking": 225815, "num": 1292 }, { "id": 18507, "year": 2024, "is_wenli": 1, "score": 314, "ranking": 227080, "num": 1265 }, { "id": 18508, "year": 2024, "is_wenli": 1, "score": 313, "ranking": 228379, "num": 1299 }, { "id": 18509, "year": 2024, "is_wenli": 1, "score": 312, "ranking": 229627, "num": 1248 }, { "id": 18510, "year": 2024, "is_wenli": 1, "score": 311, "ranking": 230920, "num": 1293 }, { "id": 18511, "year": 2024, "is_wenli": 1, "score": 310, "ranking": 232209, "num": 1289 }, { "id": 18512, "year": 2024, "is_wenli": 1, "score": 309, "ranking": 233498, "num": 1289 }, { "id": 18513, "year": 2024, "is_wenli": 1, "score": 308, "ranking": 234756, "num": 1258 }, { "id": 18514, "year": 2024, "is_wenli": 1, "score": 307, "ranking": 236020, "num": 1264 }, { "id": 18515, "year": 2024, "is_wenli": 1, "score": 306, "ranking": 237327, "num": 1307 }, { "id": 18516, "year": 2024, "is_wenli": 1, "score": 305, "ranking": 238627, "num": 1300 }, { "id": 18517, "year": 2024, "is_wenli": 1, "score": 304, "ranking": 239914, "num": 1287 }, { "id": 18518, "year": 2024, "is_wenli": 1, "score": 303, "ranking": 241204, "num": 1290 }, { "id": 18519, "year": 2024, "is_wenli": 1, "score": 302, "ranking": 242461, "num": 1257 }, { "id": 18520, "year": 2024, "is_wenli": 1, "score": 301, "ranking": 243749, "num": 1288 }, { "id": 18521, "year": 2024, "is_wenli": 1, "score": 300, "ranking": 244976, "num": 1227 }, { "id": 18522, "year": 2024, "is_wenli": 1, "score": 299, "ranking": 246202, "num": 1226 }, { "id": 18523, "year": 2024, "is_wenli": 1, "score": 298, "ranking": 247438, "num": 1236 }, { "id": 18524, "year": 2024, "is_wenli": 1, "score": 297, "ranking": 248530, "num": 1092 }, { "id": 18525, "year": 2024, "is_wenli": 1, "score": 296, "ranking": 249886, "num": 1356 }, { "id": 18526, "year": 2024, "is_wenli": 1, "score": 295, "ranking": 251120, "num": 1234 }, { "id": 18527, "year": 2024, "is_wenli": 1, "score": 294, "ranking": 252368, "num": 1248 }, { "id": 18528, "year": 2024, "is_wenli": 1, "score": 293, "ranking": 253640, "num": 1272 }, { "id": 18529, "year": 2024, "is_wenli": 1, "score": 292, "ranking": 254911, "num": 1271 }, { "id": 18530, "year": 2024, "is_wenli": 1, "score": 291, "ranking": 256092, "num": 1181 }, { "id": 18531, "year": 2024, "is_wenli": 1, "score": 290, "ranking": 257358, "num": 1266 }, { "id": 18532, "year": 2024, "is_wenli": 1, "score": 289, "ranking": 258571, "num": 1213 }, { "id": 18533, "year": 2024, "is_wenli": 1, "score": 288, "ranking": 259838, "num": 1267 }, { "id": 18534, "year": 2024, "is_wenli": 1, "score": 287, "ranking": 261047, "num": 1209 }, { "id": 18535, "year": 2024, "is_wenli": 1, "score": 286, "ranking": 262255, "num": 1208 }, { "id": 18536, "year": 2024, "is_wenli": 1, "score": 285, "ranking": 263497, "num": 1242 }, { "id": 18537, "year": 2024, "is_wenli": 1, "score": 284, "ranking": 264738, "num": 1241 }, { "id": 18538, "year": 2024, "is_wenli": 1, "score": 283, "ranking": 265935, "num": 1197 }, { "id": 18539, "year": 2024, "is_wenli": 1, "score": 282, "ranking": 267117, "num": 1182 }, { "id": 18540, "year": 2024, "is_wenli": 1, "score": 281, "ranking": 268309, "num": 1192 }, { "id": 18541, "year": 2024, "is_wenli": 1, "score": 280, "ranking": 269551, "num": 1242 }, { "id": 18542, "year": 2024, "is_wenli": 1, "score": 279, "ranking": 270820, "num": 1269 }, { "id": 18543, "year": 2024, "is_wenli": 1, "score": 278, "ranking": 272001, "num": 1181 }, { "id": 18544, "year": 2024, "is_wenli": 1, "score": 277, "ranking": 273234, "num": 1233 }, { "id": 18545, "year": 2024, "is_wenli": 1, "score": 276, "ranking": 274439, "num": 1205 }, { "id": 18546, "year": 2024, "is_wenli": 1, "score": 275, "ranking": 275628, "num": 1189 }, { "id": 18547, "year": 2024, "is_wenli": 1, "score": 274, "ranking": 276828, "num": 1200 }, { "id": 18548, "year": 2024, "is_wenli": 1, "score": 273, "ranking": 278008, "num": 1180 }, { "id": 18549, "year": 2024, "is_wenli": 1, "score": 272, "ranking": 279162, "num": 1154 }, { "id": 18550, "year": 2024, "is_wenli": 1, "score": 271, "ranking": 280373, "num": 1211 }, { "id": 18551, "year": 2024, "is_wenli": 1, "score": 270, "ranking": 281528, "num": 1155 }, { "id": 18552, "year": 2024, "is_wenli": 1, "score": 269, "ranking": 282658, "num": 1130 }, { "id": 18553, "year": 2024, "is_wenli": 1, "score": 268, "ranking": 283843, "num": 1185 }, { "id": 18554, "year": 2024, "is_wenli": 1, "score": 267, "ranking": 284997, "num": 1154 }, { "id": 18555, "year": 2024, "is_wenli": 1, "score": 266, "ranking": 286103, "num": 1106 }, { "id": 18556, "year": 2024, "is_wenli": 1, "score": 265, "ranking": 287210, "num": 1107 }, { "id": 18557, "year": 2024, "is_wenli": 1, "score": 264, "ranking": 288348, "num": 1138 }, { "id": 18558, "year": 2024, "is_wenli": 1, "score": 263, "ranking": 289491, "num": 1143 }, { "id": 18559, "year": 2024, "is_wenli": 1, "score": 262, "ranking": 290595, "num": 1104 }, { "id": 18560, "year": 2024, "is_wenli": 1, "score": 261, "ranking": 291722, "num": 1127 }, { "id": 18561, "year": 2024, "is_wenli": 1, "score": 260, "ranking": 292896, "num": 1174 }, { "id": 18562, "year": 2024, "is_wenli": 1, "score": 259, "ranking": 294037, "num": 1141 }, { "id": 18563, "year": 2024, "is_wenli": 1, "score": 258, "ranking": 295137, "num": 1100 }, { "id": 18564, "year": 2024, "is_wenli": 1, "score": 257, "ranking": 296255, "num": 1118 }, { "id": 18565, "year": 2024, "is_wenli": 1, "score": 256, "ranking": 297318, "num": 1063 }, { "id": 18566, "year": 2024, "is_wenli": 1, "score": 255, "ranking": 298370, "num": 1052 }, { "id": 18567, "year": 2024, "is_wenli": 1, "score": 254, "ranking": 299463, "num": 1093 }, { "id": 18568, "year": 2024, "is_wenli": 1, "score": 253, "ranking": 300495, "num": 1032 }, { "id": 18569, "year": 2024, "is_wenli": 1, "score": 252, "ranking": 301559, "num": 1064 }, { "id": 18570, "year": 2024, "is_wenli": 1, "score": 251, "ranking": 302622, "num": 1063 }, { "id": 18571, "year": 2024, "is_wenli": 1, "score": 250, "ranking": 303652, "num": 1030 }, { "id": 18572, "year": 2024, "is_wenli": 1, "score": 249, "ranking": 304651, "num": 999 }, { "id": 18573, "year": 2024, "is_wenli": 1, "score": 248, "ranking": 305676, "num": 1025 }, { "id": 18574, "year": 2024, "is_wenli": 1, "score": 247, "ranking": 306767, "num": 1091 }, { "id": 18575, "year": 2024, "is_wenli": 1, "score": 246, "ranking": 307795, "num": 1028 }, { "id": 18576, "year": 2024, "is_wenli": 1, "score": 245, "ranking": 308785, "num": 990 }, { "id": 18577, "year": 2024, "is_wenli": 1, "score": 244, "ranking": 309696, "num": 911 }, { "id": 18578, "year": 2024, "is_wenli": 1, "score": 243, "ranking": 310681, "num": 985 }, { "id": 18579, "year": 2024, "is_wenli": 1, "score": 242, "ranking": 311614, "num": 933 }, { "id": 18580, "year": 2024, "is_wenli": 1, "score": 241, "ranking": 312567, "num": 953 }, { "id": 18581, "year": 2024, "is_wenli": 1, "score": 240, "ranking": 313531, "num": 964 }, { "id": 18582, "year": 2024, "is_wenli": 1, "score": 239, "ranking": 314516, "num": 985 }, { "id": 18583, "year": 2024, "is_wenli": 1, "score": 238, "ranking": 315422, "num": 906 }, { "id": 18584, "year": 2024, "is_wenli": 1, "score": 237, "ranking": 316372, "num": 950 }, { "id": 18585, "year": 2024, "is_wenli": 1, "score": 236, "ranking": 317293, "num": 921 }, { "id": 18586, "year": 2024, "is_wenli": 1, "score": 235, "ranking": 318180, "num": 887 }, { "id": 18587, "year": 2024, "is_wenli": 1, "score": 234, "ranking": 319122, "num": 942 }, { "id": 18588, "year": 2024, "is_wenli": 1, "score": 233, "ranking": 319989, "num": 867 }, { "id": 18589, "year": 2024, "is_wenli": 1, "score": 232, "ranking": 320871, "num": 882 }, { "id": 18590, "year": 2024, "is_wenli": 1, "score": 231, "ranking": 321726, "num": 855 }, { "id": 18591, "year": 2024, "is_wenli": 1, "score": 230, "ranking": 322590, "num": 864 }, { "id": 18592, "year": 2024, "is_wenli": 1, "score": 229, "ranking": 323482, "num": 892 }, { "id": 18593, "year": 2024, "is_wenli": 1, "score": 228, "ranking": 324346, "num": 864 }, { "id": 18594, "year": 2024, "is_wenli": 1, "score": 227, "ranking": 325157, "num": 811 }, { "id": 18595, "year": 2024, "is_wenli": 1, "score": 226, "ranking": 325997, "num": 840 }, { "id": 18596, "year": 2024, "is_wenli": 1, "score": 225, "ranking": 326841, "num": 844 }, { "id": 18597, "year": 2024, "is_wenli": 1, "score": 224, "ranking": 327615, "num": 774 }, { "id": 18598, "year": 2024, "is_wenli": 1, "score": 223, "ranking": 328423, "num": 808 }, { "id": 18599, "year": 2024, "is_wenli": 1, "score": 222, "ranking": 329178, "num": 755 }, { "id": 18600, "year": 2024, "is_wenli": 1, "score": 221, "ranking": 329979, "num": 801 }, { "id": 18601, "year": 2024, "is_wenli": 1, "score": 220, "ranking": 330738, "num": 759 }, { "id": 18602, "year": 2024, "is_wenli": 1, "score": 219, "ranking": 331470, "num": 732 }, { "id": 18603, "year": 2024, "is_wenli": 1, "score": 218, "ranking": 332192, "num": 722 }, { "id": 18604, "year": 2024, "is_wenli": 1, "score": 217, "ranking": 332875, "num": 683 }, { "id": 18605, "year": 2024, "is_wenli": 1, "score": 216, "ranking": 333579, "num": 704 }, { "id": 18606, "year": 2024, "is_wenli": 1, "score": 215, "ranking": 334254, "num": 675 }, { "id": 18607, "year": 2024, "is_wenli": 1, "score": 214, "ranking": 334890, "num": 636 }, { "id": 18608, "year": 2024, "is_wenli": 1, "score": 213, "ranking": 335553, "num": 663 }, { "id": 18609, "year": 2024, "is_wenli": 1, "score": 212, "ranking": 336258, "num": 705 }, { "id": 18610, "year": 2024, "is_wenli": 1, "score": 211, "ranking": 336911, "num": 653 }, { "id": 18611, "year": 2024, "is_wenli": 1, "score": 210, "ranking": 337551, "num": 640 }, { "id": 18612, "year": 2024, "is_wenli": 1, "score": 209, "ranking": 338195, "num": 644 }, { "id": 18613, "year": 2024, "is_wenli": 1, "score": 208, "ranking": 338782, "num": 587 }, { "id": 18614, "year": 2024, "is_wenli": 1, "score": 207, "ranking": 339422, "num": 640 }, { "id": 18615, "year": 2024, "is_wenli": 1, "score": 206, "ranking": 340007, "num": 585 }, { "id": 18616, "year": 2024, "is_wenli": 1, "score": 205, "ranking": 340559, "num": 552 }, { "id": 18617, "year": 2024, "is_wenli": 1, "score": 204, "ranking": 341143, "num": 584 }, { "id": 18618, "year": 2024, "is_wenli": 1, "score": 203, "ranking": 341691, "num": 548 }, { "id": 18619, "year": 2024, "is_wenli": 1, "score": 202, "ranking": 342249, "num": 558 }, { "id": 18620, "year": 2024, "is_wenli": 1, "score": 201, "ranking": 342810, "num": 561 }, { "id": 18621, "year": 2024, "is_wenli": 1, "score": 200, "ranking": 343308, "num": 498 }, { "id": 18622, "year": 2024, "is_wenli": 1, "score": 199, "ranking": 343848, "num": 540 }, { "id": 18623, "year": 2024, "is_wenli": 1, "score": 198, "ranking": 344345, "num": 497 }, { "id": 18624, "year": 2024, "is_wenli": 1, "score": 197, "ranking": 344806, "num": 461 }, { "id": 18625, "year": 2024, "is_wenli": 1, "score": 196, "ranking": 345303, "num": 497 }, { "id": 18626, "year": 2024, "is_wenli": 1, "score": 195, "ranking": 345807, "num": 504 }, { "id": 18627, "year": 2024, "is_wenli": 1, "score": 194, "ranking": 346227, "num": 420 }, { "id": 18628, "year": 2024, "is_wenli": 1, "score": 193, "ranking": 346661, "num": 434 }, { "id": 18629, "year": 2024, "is_wenli": 1, "score": 192, "ranking": 347091, "num": 430 }, { "id": 18630, "year": 2024, "is_wenli": 1, "score": 191, "ranking": 347496, "num": 405 }, { "id": 18631, "year": 2024, "is_wenli": 1, "score": 190, "ranking": 347886, "num": 390 }, { "id": 18632, "year": 2024, "is_wenli": 1, "score": 189, "ranking": 348302, "num": 416 }, { "id": 18633, "year": 2024, "is_wenli": 1, "score": 188, "ranking": 348714, "num": 412 }, { "id": 18634, "year": 2024, "is_wenli": 1, "score": 187, "ranking": 349099, "num": 385 }, { "id": 18635, "year": 2024, "is_wenli": 1, "score": 186, "ranking": 349491, "num": 392 }, { "id": 18636, "year": 2024, "is_wenli": 1, "score": 185, "ranking": 349859, "num": 368 }, { "id": 18637, "year": 2024, "is_wenli": 1, "score": 184, "ranking": 350200, "num": 341 }, { "id": 18638, "year": 2024, "is_wenli": 1, "score": 183, "ranking": 350542, "num": 342 }, { "id": 18639, "year": 2024, "is_wenli": 1, "score": 182, "ranking": 350864, "num": 322 }, { "id": 18640, "year": 2024, "is_wenli": 1, "score": 181, "ranking": 351158, "num": 294 }, { "id": 18641, "year": 2024, "is_wenli": 1, "score": 180, "ranking": 351432, "num": 274 }, { "id": 18642, "year": 2024, "is_wenli": 1, "score": 179, "ranking": 351716, "num": 284 }, { "id": 18643, "year": 2024, "is_wenli": 1, "score": 178, "ranking": 352012, "num": 296 }, { "id": 18644, "year": 2024, "is_wenli": 1, "score": 177, "ranking": 352305, "num": 293 }, { "id": 18645, "year": 2024, "is_wenli": 1, "score": 176, "ranking": 352540, "num": 235 }, { "id": 18646, "year": 2024, "is_wenli": 1, "score": 175, "ranking": 352789, "num": 249 }, { "id": 18647, "year": 2024, "is_wenli": 1, "score": 174, "ranking": 353020, "num": 231 }, { "id": 18648, "year": 2024, "is_wenli": 1, "score": 173, "ranking": 353282, "num": 262 }, { "id": 18649, "year": 2024, "is_wenli": 1, "score": 172, "ranking": 353501, "num": 219 }, { "id": 18650, "year": 2024, "is_wenli": 1, "score": 171, "ranking": 353697, "num": 196 }, { "id": 18651, "year": 2024, "is_wenli": 1, "score": 170, "ranking": 353871, "num": 174 }, { "id": 18652, "year": 2024, "is_wenli": 1, "score": 169, "ranking": 354094, "num": 223 }, { "id": 18653, "year": 2024, "is_wenli": 1, "score": 168, "ranking": 354310, "num": 216 }, { "id": 18654, "year": 2024, "is_wenli": 1, "score": 167, "ranking": 354483, "num": 173 }, { "id": 18655, "year": 2024, "is_wenli": 1, "score": 166, "ranking": 354660, "num": 177 }, { "id": 18656, "year": 2024, "is_wenli": 1, "score": 165, "ranking": 354835, "num": 175 }, { "id": 18657, "year": 2024, "is_wenli": 1, "score": 164, "ranking": 354994, "num": 159 }, { "id": 18658, "year": 2024, "is_wenli": 1, "score": 163, "ranking": 355167, "num": 173 }, { "id": 18659, "year": 2024, "is_wenli": 1, "score": 162, "ranking": 355337, "num": 170 }, { "id": 18660, "year": 2024, "is_wenli": 1, "score": 161, "ranking": 355519, "num": 182 }, { "id": 18661, "year": 2024, "is_wenli": 1, "score": 160, "ranking": 355683, "num": 164 }, { "id": 18662, "year": 2024, "is_wenli": 1, "score": 159, "ranking": 355839, "num": 156 }, { "id": 18663, "year": 2024, "is_wenli": 1, "score": 158, "ranking": 355933, "num": 94 }, { "id": 18664, "year": 2024, "is_wenli": 1, "score": 157, "ranking": 356112, "num": 179 }, { "id": 18665, "year": 2024, "is_wenli": 1, "score": 156, "ranking": 356236, "num": 124 }, { "id": 18666, "year": 2024, "is_wenli": 1, "score": 155, "ranking": 356354, "num": 118 }, { "id": 18667, "year": 2024, "is_wenli": 1, "score": 154, "ranking": 356467, "num": 113 }, { "id": 18668, "year": 2024, "is_wenli": 1, "score": 153, "ranking": 356568, "num": 101 }, { "id": 18669, "year": 2024, "is_wenli": 1, "score": 152, "ranking": 356659, "num": 91 }, { "id": 18670, "year": 2024, "is_wenli": 1, "score": 151, "ranking": 356763, "num": 104 }, { "id": 18671, "year": 2024, "is_wenli": 1, "score": 150, "ranking": 356856, "num": 93 }, { "id": 18672, "year": 2024, "is_wenli": 1, "score": 149, "ranking": 356970, "num": 114 }, { "id": 18673, "year": 2024, "is_wenli": 1, "score": 148, "ranking": 357043, "num": 73 }, { "id": 18674, "year": 2024, "is_wenli": 1, "score": 147, "ranking": 357122, "num": 79 }, { "id": 18675, "year": 2024, "is_wenli": 1, "score": 146, "ranking": 357201, "num": 79 }, { "id": 18676, "year": 2024, "is_wenli": 1, "score": 145, "ranking": 357290, "num": 89 }, { "id": 18677, "year": 2024, "is_wenli": 1, "score": 144, "ranking": 357374, "num": 84 }, { "id": 18678, "year": 2024, "is_wenli": 1, "score": 143, "ranking": 357447, "num": 73 }, { "id": 18679, "year": 2024, "is_wenli": 1, "score": 142, "ranking": 357503, "num": 56 }, { "id": 18680, "year": 2024, "is_wenli": 1, "score": 141, "ranking": 357567, "num": 64 }, { "id": 18681, "year": 2024, "is_wenli": 1, "score": 140, "ranking": 357631, "num": 64 }, { "id": 18682, "year": 2024, "is_wenli": 1, "score": 139, "ranking": 357685, "num": 54 }, { "id": 18683, "year": 2024, "is_wenli": 1, "score": 138, "ranking": 357753, "num": 68 }, { "id": 18684, "year": 2024, "is_wenli": 1, "score": 137, "ranking": 357801, "num": 48 }, { "id": 18685, "year": 2024, "is_wenli": 1, "score": 136, "ranking": 357863, "num": 62 }, { "id": 18686, "year": 2024, "is_wenli": 1, "score": 135, "ranking": 357923, "num": 60 }, { "id": 18687, "year": 2024, "is_wenli": 1, "score": 134, "ranking": 357973, "num": 50 }, { "id": 18688, "year": 2024, "is_wenli": 1, "score": 133, "ranking": 358015, "num": 42 }, { "id": 18689, "year": 2024, "is_wenli": 1, "score": 132, "ranking": 358063, "num": 48 }, { "id": 18690, "year": 2024, "is_wenli": 1, "score": 131, "ranking": 358107, "num": 44 }, { "id": 18691, "year": 2024, "is_wenli": 1, "score": 130, "ranking": 358150, "num": 43 }, { "id": 18692, "year": 2024, "is_wenli": 1, "score": 129, "ranking": 358180, "num": 30 }, { "id": 18693, "year": 2024, "is_wenli": 1, "score": 128, "ranking": 358231, "num": 51 }, { "id": 18694, "year": 2024, "is_wenli": 1, "score": 127, "ranking": 358262, "num": 31 }, { "id": 18695, "year": 2024, "is_wenli": 1, "score": 126, "ranking": 358295, "num": 33 }, { "id": 18696, "year": 2024, "is_wenli": 1, "score": 125, "ranking": 358331, "num": 36 }, { "id": 18697, "year": 2024, "is_wenli": 1, "score": 124, "ranking": 358361, "num": 30 }, { "id": 18698, "year": 2024, "is_wenli": 1, "score": 123, "ranking": 358386, "num": 25 }, { "id": 18699, "year": 2024, "is_wenli": 1, "score": 122, "ranking": 358420, "num": 34 }, { "id": 18700, "year": 2024, "is_wenli": 1, "score": 121, "ranking": 358450, "num": 30 }, { "id": 18701, "year": 2024, "is_wenli": 1, "score": 120, "ranking": 358482, "num": 32 }, { "id": 18702, "year": 2024, "is_wenli": 1, "score": 119, "ranking": 358508, "num": 26 }, { "id": 18703, "year": 2024, "is_wenli": 1, "score": 118, "ranking": 358544, "num": 36 }, { "id": 18704, "year": 2024, "is_wenli": 1, "score": 117, "ranking": 358571, "num": 27 }, { "id": 18705, "year": 2024, "is_wenli": 1, "score": 116, "ranking": 358605, "num": 34 }, { "id": 18706, "year": 2024, "is_wenli": 1, "score": 115, "ranking": 358637, "num": 32 }, { "id": 18707, "year": 2024, "is_wenli": 1, "score": 114, "ranking": 358667, "num": 30 }, { "id": 18708, "year": 2024, "is_wenli": 1, "score": 113, "ranking": 358685, "num": 18 }, { "id": 18709, "year": 2024, "is_wenli": 1, "score": 112, "ranking": 358705, "num": 20 }, { "id": 18710, "year": 2024, "is_wenli": 1, "score": 111, "ranking": 358732, "num": 27 }, { "id": 18711, "year": 2024, "is_wenli": 1, "score": 110, "ranking": 358758, "num": 26 }, { "id": 18712, "year": 2024, "is_wenli": 1, "score": 109, "ranking": 358782, "num": 24 }, { "id": 18713, "year": 2024, "is_wenli": 1, "score": 108, "ranking": 358801, "num": 19 }, { "id": 18714, "year": 2024, "is_wenli": 1, "score": 107, "ranking": 358825, "num": 24 }, { "id": 18715, "year": 2024, "is_wenli": 1, "score": 106, "ranking": 358847, "num": 22 }, { "id": 18716, "year": 2024, "is_wenli": 1, "score": 105, "ranking": 358863, "num": 16 }, { "id": 18717, "year": 2024, "is_wenli": 1, "score": 104, "ranking": 358889, "num": 26 }, { "id": 18718, "year": 2024, "is_wenli": 1, "score": 103, "ranking": 358901, "num": 12 }, { "id": 18719, "year": 2024, "is_wenli": 1, "score": 102, "ranking": 358925, "num": 24 }, { "id": 18720, "year": 2024, "is_wenli": 1, "score": 101, "ranking": 358941, "num": 16 }, { "id": 18721, "year": 2024, "is_wenli": 1, "score": 100, "ranking": 358962, "num": 21 }]
    ,
    2023: [{ "id": 16961, "year": 2023, "is_wenli": 1, "score": 685, "ranking": 10, "num": 10 }, { "id": 16962, "year": 2023, "is_wenli": 1, "score": 681, "ranking": 15, "num": 5 }, { "id": 16963, "year": 2023, "is_wenli": 1, "score": 679, "ranking": 19, "num": 4 }, { "id": 16964, "year": 2023, "is_wenli": 1, "score": 678, "ranking": 21, "num": 2 }, { "id": 16965, "year": 2023, "is_wenli": 1, "score": 677, "ranking": 24, "num": 3 }, { "id": 16966, "year": 2023, "is_wenli": 1, "score": 676, "ranking": 26, "num": 2 }, { "id": 16967, "year": 2023, "is_wenli": 1, "score": 675, "ranking": 32, "num": 6 }, { "id": 16968, "year": 2023, "is_wenli": 1, "score": 674, "ranking": 35, "num": 3 }, { "id": 16969, "year": 2023, "is_wenli": 1, "score": 673, "ranking": 41, "num": 6 }, { "id": 16970, "year": 2023, "is_wenli": 1, "score": 672, "ranking": 46, "num": 5 }, { "id": 16971, "year": 2023, "is_wenli": 1, "score": 671, "ranking": 49, "num": 3 }, { "id": 16972, "year": 2023, "is_wenli": 1, "score": 670, "ranking": 57, "num": 8 }, { "id": 16973, "year": 2023, "is_wenli": 1, "score": 669, "ranking": 67, "num": 10 }, { "id": 16974, "year": 2023, "is_wenli": 1, "score": 668, "ranking": 76, "num": 9 }, { "id": 16975, "year": 2023, "is_wenli": 1, "score": 667, "ranking": 85, "num": 9 }, { "id": 16976, "year": 2023, "is_wenli": 1, "score": 666, "ranking": 94, "num": 9 }, { "id": 16977, "year": 2023, "is_wenli": 1, "score": 665, "ranking": 108, "num": 14 }, { "id": 16978, "year": 2023, "is_wenli": 1, "score": 664, "ranking": 115, "num": 7 }, { "id": 16979, "year": 2023, "is_wenli": 1, "score": 663, "ranking": 129, "num": 14 }, { "id": 16980, "year": 2023, "is_wenli": 1, "score": 662, "ranking": 140, "num": 11 }, { "id": 16981, "year": 2023, "is_wenli": 1, "score": 661, "ranking": 162, "num": 22 }, { "id": 16982, "year": 2023, "is_wenli": 1, "score": 660, "ranking": 169, "num": 7 }, { "id": 16983, "year": 2023, "is_wenli": 1, "score": 659, "ranking": 181, "num": 12 }, { "id": 16984, "year": 2023, "is_wenli": 1, "score": 658, "ranking": 194, "num": 13 }, { "id": 16985, "year": 2023, "is_wenli": 1, "score": 657, "ranking": 213, "num": 19 }, { "id": 16986, "year": 2023, "is_wenli": 1, "score": 656, "ranking": 232, "num": 19 }, { "id": 16987, "year": 2023, "is_wenli": 1, "score": 655, "ranking": 254, "num": 22 }, { "id": 16988, "year": 2023, "is_wenli": 1, "score": 654, "ranking": 273, "num": 19 }, { "id": 16989, "year": 2023, "is_wenli": 1, "score": 653, "ranking": 295, "num": 22 }, { "id": 16990, "year": 2023, "is_wenli": 1, "score": 652, "ranking": 312, "num": 17 }, { "id": 16991, "year": 2023, "is_wenli": 1, "score": 651, "ranking": 339, "num": 27 }, { "id": 16992, "year": 2023, "is_wenli": 1, "score": 650, "ranking": 358, "num": 19 }, { "id": 16993, "year": 2023, "is_wenli": 1, "score": 649, "ranking": 375, "num": 17 }, { "id": 16994, "year": 2023, "is_wenli": 1, "score": 648, "ranking": 396, "num": 21 }, { "id": 16995, "year": 2023, "is_wenli": 1, "score": 647, "ranking": 424, "num": 28 }, { "id": 16996, "year": 2023, "is_wenli": 1, "score": 646, "ranking": 453, "num": 29 }, { "id": 16997, "year": 2023, "is_wenli": 1, "score": 645, "ranking": 480, "num": 27 }, { "id": 16998, "year": 2023, "is_wenli": 1, "score": 644, "ranking": 515, "num": 35 }, { "id": 16999, "year": 2023, "is_wenli": 1, "score": 643, "ranking": 544, "num": 29 }, { "id": 17000, "year": 2023, "is_wenli": 1, "score": 642, "ranking": 573, "num": 29 }, { "id": 17001, "year": 2023, "is_wenli": 1, "score": 641, "ranking": 619, "num": 46 }, { "id": 17002, "year": 2023, "is_wenli": 1, "score": 640, "ranking": 652, "num": 33 }, { "id": 17003, "year": 2023, "is_wenli": 1, "score": 639, "ranking": 700, "num": 48 }, { "id": 17004, "year": 2023, "is_wenli": 1, "score": 638, "ranking": 744, "num": 44 }, { "id": 17005, "year": 2023, "is_wenli": 1, "score": 637, "ranking": 793, "num": 49 }, { "id": 17006, "year": 2023, "is_wenli": 1, "score": 636, "ranking": 839, "num": 46 }, { "id": 17007, "year": 2023, "is_wenli": 1, "score": 635, "ranking": 886, "num": 47 }, { "id": 17008, "year": 2023, "is_wenli": 1, "score": 634, "ranking": 927, "num": 41 }, { "id": 17009, "year": 2023, "is_wenli": 1, "score": 633, "ranking": 989, "num": 62 }, { "id": 17010, "year": 2023, "is_wenli": 1, "score": 632, "ranking": 1041, "num": 52 }, { "id": 17011, "year": 2023, "is_wenli": 1, "score": 631, "ranking": 1103, "num": 62 }, { "id": 17012, "year": 2023, "is_wenli": 1, "score": 630, "ranking": 1168, "num": 65 }, { "id": 17013, "year": 2023, "is_wenli": 1, "score": 629, "ranking": 1233, "num": 65 }, { "id": 17014, "year": 2023, "is_wenli": 1, "score": 628, "ranking": 1310, "num": 77 }, { "id": 17015, "year": 2023, "is_wenli": 1, "score": 627, "ranking": 1386, "num": 76 }, { "id": 17016, "year": 2023, "is_wenli": 1, "score": 626, "ranking": 1451, "num": 65 }, { "id": 17017, "year": 2023, "is_wenli": 1, "score": 625, "ranking": 1528, "num": 77 }, { "id": 17018, "year": 2023, "is_wenli": 1, "score": 624, "ranking": 1595, "num": 67 }, { "id": 17019, "year": 2023, "is_wenli": 1, "score": 623, "ranking": 1676, "num": 81 }, { "id": 17020, "year": 2023, "is_wenli": 1, "score": 622, "ranking": 1767, "num": 91 }, { "id": 17021, "year": 2023, "is_wenli": 1, "score": 621, "ranking": 1861, "num": 94 }, { "id": 17022, "year": 2023, "is_wenli": 1, "score": 620, "ranking": 1954, "num": 93 }, { "id": 17023, "year": 2023, "is_wenli": 1, "score": 619, "ranking": 2053, "num": 99 }, { "id": 17024, "year": 2023, "is_wenli": 1, "score": 618, "ranking": 2147, "num": 94 }, { "id": 17025, "year": 2023, "is_wenli": 1, "score": 617, "ranking": 2240, "num": 93 }, { "id": 17026, "year": 2023, "is_wenli": 1, "score": 616, "ranking": 2356, "num": 116 }, { "id": 17027, "year": 2023, "is_wenli": 1, "score": 615, "ranking": 2482, "num": 126 }, { "id": 17028, "year": 2023, "is_wenli": 1, "score": 614, "ranking": 2600, "num": 118 }, { "id": 17029, "year": 2023, "is_wenli": 1, "score": 613, "ranking": 2720, "num": 120 }, { "id": 17030, "year": 2023, "is_wenli": 1, "score": 612, "ranking": 2853, "num": 133 }, { "id": 17031, "year": 2023, "is_wenli": 1, "score": 611, "ranking": 2985, "num": 132 }, { "id": 17032, "year": 2023, "is_wenli": 1, "score": 610, "ranking": 3112, "num": 127 }, { "id": 17033, "year": 2023, "is_wenli": 1, "score": 609, "ranking": 3260, "num": 148 }, { "id": 17034, "year": 2023, "is_wenli": 1, "score": 608, "ranking": 3394, "num": 134 }, { "id": 17035, "year": 2023, "is_wenli": 1, "score": 607, "ranking": 3541, "num": 147 }, { "id": 17036, "year": 2023, "is_wenli": 1, "score": 606, "ranking": 3681, "num": 140 }, { "id": 17037, "year": 2023, "is_wenli": 1, "score": 605, "ranking": 3838, "num": 157 }, { "id": 17038, "year": 2023, "is_wenli": 1, "score": 604, "ranking": 3990, "num": 152 }, { "id": 17039, "year": 2023, "is_wenli": 1, "score": 603, "ranking": 4164, "num": 174 }, { "id": 17040, "year": 2023, "is_wenli": 1, "score": 602, "ranking": 4335, "num": 171 }, { "id": 17041, "year": 2023, "is_wenli": 1, "score": 601, "ranking": 4492, "num": 157 }, { "id": 17042, "year": 2023, "is_wenli": 1, "score": 600, "ranking": 4685, "num": 193 }, { "id": 17043, "year": 2023, "is_wenli": 1, "score": 599, "ranking": 4867, "num": 182 }, { "id": 17044, "year": 2023, "is_wenli": 1, "score": 598, "ranking": 5035, "num": 168 }, { "id": 17045, "year": 2023, "is_wenli": 1, "score": 597, "ranking": 5216, "num": 181 }, { "id": 17046, "year": 2023, "is_wenli": 1, "score": 596, "ranking": 5430, "num": 214 }, { "id": 17047, "year": 2023, "is_wenli": 1, "score": 595, "ranking": 5618, "num": 188 }, { "id": 17048, "year": 2023, "is_wenli": 1, "score": 594, "ranking": 5816, "num": 198 }, { "id": 17049, "year": 2023, "is_wenli": 1, "score": 593, "ranking": 6067, "num": 251 }, { "id": 17050, "year": 2023, "is_wenli": 1, "score": 592, "ranking": 6256, "num": 189 }, { "id": 17051, "year": 2023, "is_wenli": 1, "score": 591, "ranking": 6468, "num": 212 }, { "id": 17052, "year": 2023, "is_wenli": 1, "score": 590, "ranking": 6734, "num": 266 }, { "id": 17053, "year": 2023, "is_wenli": 1, "score": 589, "ranking": 6955, "num": 221 }, { "id": 17054, "year": 2023, "is_wenli": 1, "score": 588, "ranking": 7217, "num": 262 }, { "id": 17055, "year": 2023, "is_wenli": 1, "score": 587, "ranking": 7495, "num": 278 }, { "id": 17056, "year": 2023, "is_wenli": 1, "score": 586, "ranking": 7755, "num": 260 }, { "id": 17057, "year": 2023, "is_wenli": 1, "score": 585, "ranking": 8045, "num": 290 }, { "id": 17058, "year": 2023, "is_wenli": 1, "score": 584, "ranking": 8335, "num": 290 }, { "id": 17059, "year": 2023, "is_wenli": 1, "score": 583, "ranking": 8647, "num": 312 }, { "id": 17060, "year": 2023, "is_wenli": 1, "score": 582, "ranking": 8929, "num": 282 }, { "id": 17061, "year": 2023, "is_wenli": 1, "score": 581, "ranking": 9252, "num": 323 }, { "id": 17062, "year": 2023, "is_wenli": 1, "score": 580, "ranking": 9567, "num": 315 }, { "id": 17063, "year": 2023, "is_wenli": 1, "score": 579, "ranking": 9919, "num": 352 }, { "id": 17064, "year": 2023, "is_wenli": 1, "score": 578, "ranking": 10258, "num": 339 }, { "id": 17065, "year": 2023, "is_wenli": 1, "score": 577, "ranking": 10636, "num": 378 }, { "id": 17066, "year": 2023, "is_wenli": 1, "score": 576, "ranking": 10980, "num": 344 }, { "id": 17067, "year": 2023, "is_wenli": 1, "score": 575, "ranking": 11312, "num": 332 }, { "id": 17068, "year": 2023, "is_wenli": 1, "score": 574, "ranking": 11649, "num": 337 }, { "id": 17069, "year": 2023, "is_wenli": 1, "score": 573, "ranking": 11988, "num": 339 }, { "id": 17070, "year": 2023, "is_wenli": 1, "score": 572, "ranking": 12361, "num": 373 }, { "id": 17071, "year": 2023, "is_wenli": 1, "score": 571, "ranking": 12758, "num": 397 }, { "id": 17072, "year": 2023, "is_wenli": 1, "score": 570, "ranking": 13130, "num": 372 }, { "id": 17073, "year": 2023, "is_wenli": 1, "score": 569, "ranking": 13524, "num": 394 }, { "id": 17074, "year": 2023, "is_wenli": 1, "score": 568, "ranking": 13933, "num": 409 }, { "id": 17075, "year": 2023, "is_wenli": 1, "score": 567, "ranking": 14300, "num": 367 }, { "id": 17076, "year": 2023, "is_wenli": 1, "score": 566, "ranking": 14694, "num": 394 }, { "id": 17077, "year": 2023, "is_wenli": 1, "score": 565, "ranking": 15078, "num": 384 }, { "id": 17078, "year": 2023, "is_wenli": 1, "score": 564, "ranking": 15484, "num": 406 }, { "id": 17079, "year": 2023, "is_wenli": 1, "score": 563, "ranking": 15937, "num": 453 }, { "id": 17080, "year": 2023, "is_wenli": 1, "score": 562, "ranking": 16394, "num": 457 }, { "id": 17081, "year": 2023, "is_wenli": 1, "score": 561, "ranking": 16864, "num": 470 }, { "id": 17082, "year": 2023, "is_wenli": 1, "score": 560, "ranking": 17388, "num": 524 }, { "id": 17083, "year": 2023, "is_wenli": 1, "score": 559, "ranking": 17865, "num": 477 }, { "id": 17084, "year": 2023, "is_wenli": 1, "score": 558, "ranking": 18371, "num": 506 }, { "id": 17085, "year": 2023, "is_wenli": 1, "score": 557, "ranking": 18861, "num": 490 }, { "id": 17086, "year": 2023, "is_wenli": 1, "score": 556, "ranking": 19379, "num": 518 }, { "id": 17087, "year": 2023, "is_wenli": 1, "score": 555, "ranking": 19907, "num": 528 }, { "id": 17088, "year": 2023, "is_wenli": 1, "score": 554, "ranking": 20464, "num": 557 }, { "id": 17089, "year": 2023, "is_wenli": 1, "score": 553, "ranking": 21011, "num": 547 }, { "id": 17090, "year": 2023, "is_wenli": 1, "score": 552, "ranking": 21540, "num": 529 }, { "id": 17091, "year": 2023, "is_wenli": 1, "score": 551, "ranking": 22132, "num": 592 }, { "id": 17092, "year": 2023, "is_wenli": 1, "score": 550, "ranking": 22698, "num": 566 }, { "id": 17093, "year": 2023, "is_wenli": 1, "score": 549, "ranking": 23282, "num": 584 }, { "id": 17094, "year": 2023, "is_wenli": 1, "score": 548, "ranking": 23831, "num": 549 }, { "id": 17095, "year": 2023, "is_wenli": 1, "score": 547, "ranking": 24386, "num": 555 }, { "id": 17096, "year": 2023, "is_wenli": 1, "score": 546, "ranking": 24938, "num": 552 }, { "id": 17097, "year": 2023, "is_wenli": 1, "score": 545, "ranking": 25536, "num": 598 }, { "id": 17098, "year": 2023, "is_wenli": 1, "score": 544, "ranking": 26174, "num": 638 }, { "id": 17099, "year": 2023, "is_wenli": 1, "score": 543, "ranking": 26791, "num": 617 }, { "id": 17100, "year": 2023, "is_wenli": 1, "score": 542, "ranking": 27428, "num": 637 }, { "id": 17101, "year": 2023, "is_wenli": 1, "score": 541, "ranking": 28035, "num": 607 }, { "id": 17102, "year": 2023, "is_wenli": 1, "score": 540, "ranking": 28646, "num": 611 }, { "id": 17103, "year": 2023, "is_wenli": 1, "score": 539, "ranking": 29286, "num": 640 }, { "id": 17104, "year": 2023, "is_wenli": 1, "score": 538, "ranking": 29932, "num": 646 }, { "id": 17105, "year": 2023, "is_wenli": 1, "score": 537, "ranking": 30602, "num": 670 }, { "id": 17106, "year": 2023, "is_wenli": 1, "score": 536, "ranking": 31297, "num": 695 }, { "id": 17107, "year": 2023, "is_wenli": 1, "score": 535, "ranking": 31980, "num": 683 }, { "id": 17108, "year": 2023, "is_wenli": 1, "score": 534, "ranking": 32697, "num": 717 }, { "id": 17109, "year": 2023, "is_wenli": 1, "score": 533, "ranking": 33412, "num": 715 }, { "id": 17110, "year": 2023, "is_wenli": 1, "score": 532, "ranking": 34153, "num": 741 }, { "id": 17111, "year": 2023, "is_wenli": 1, "score": 531, "ranking": 34873, "num": 720 }, { "id": 17112, "year": 2023, "is_wenli": 1, "score": 530, "ranking": 35614, "num": 741 }, { "id": 17113, "year": 2023, "is_wenli": 1, "score": 529, "ranking": 36366, "num": 752 }, { "id": 17114, "year": 2023, "is_wenli": 1, "score": 528, "ranking": 37150, "num": 784 }, { "id": 17115, "year": 2023, "is_wenli": 1, "score": 527, "ranking": 37925, "num": 775 }, { "id": 17116, "year": 2023, "is_wenli": 1, "score": 526, "ranking": 38692, "num": 767 }, { "id": 17117, "year": 2023, "is_wenli": 1, "score": 525, "ranking": 39465, "num": 773 }, { "id": 17118, "year": 2023, "is_wenli": 1, "score": 524, "ranking": 40213, "num": 748 }, { "id": 17119, "year": 2023, "is_wenli": 1, "score": 523, "ranking": 41006, "num": 793 }, { "id": 17120, "year": 2023, "is_wenli": 1, "score": 522, "ranking": 41762, "num": 756 }, { "id": 17121, "year": 2023, "is_wenli": 1, "score": 521, "ranking": 42606, "num": 844 }, { "id": 17122, "year": 2023, "is_wenli": 1, "score": 520, "ranking": 43401, "num": 795 }, { "id": 17123, "year": 2023, "is_wenli": 1, "score": 519, "ranking": 44191, "num": 790 }, { "id": 17124, "year": 2023, "is_wenli": 1, "score": 518, "ranking": 45001, "num": 810 }, { "id": 17125, "year": 2023, "is_wenli": 1, "score": 517, "ranking": 45874, "num": 873 }, { "id": 17126, "year": 2023, "is_wenli": 1, "score": 516, "ranking": 46681, "num": 807 }, { "id": 17127, "year": 2023, "is_wenli": 1, "score": 515, "ranking": 47550, "num": 869 }, { "id": 17128, "year": 2023, "is_wenli": 1, "score": 514, "ranking": 48434, "num": 884 }, { "id": 17129, "year": 2023, "is_wenli": 1, "score": 513, "ranking": 49322, "num": 888 }, { "id": 17130, "year": 2023, "is_wenli": 1, "score": 512, "ranking": 50271, "num": 949 }, { "id": 17131, "year": 2023, "is_wenli": 1, "score": 511, "ranking": 51170, "num": 899 }, { "id": 17132, "year": 2023, "is_wenli": 1, "score": 510, "ranking": 52072, "num": 902 }, { "id": 17133, "year": 2023, "is_wenli": 1, "score": 509, "ranking": 52940, "num": 868 }, { "id": 17134, "year": 2023, "is_wenli": 1, "score": 508, "ranking": 53842, "num": 902 }, { "id": 17135, "year": 2023, "is_wenli": 1, "score": 507, "ranking": 54739, "num": 897 }, { "id": 17136, "year": 2023, "is_wenli": 1, "score": 506, "ranking": 55694, "num": 955 }, { "id": 17137, "year": 2023, "is_wenli": 1, "score": 505, "ranking": 56660, "num": 966 }, { "id": 17138, "year": 2023, "is_wenli": 1, "score": 504, "ranking": 57594, "num": 934 }, { "id": 17139, "year": 2023, "is_wenli": 1, "score": 503, "ranking": 58552, "num": 958 }, { "id": 17140, "year": 2023, "is_wenli": 1, "score": 502, "ranking": 59523, "num": 971 }, { "id": 17141, "year": 2023, "is_wenli": 1, "score": 501, "ranking": 60463, "num": 940 }, { "id": 17142, "year": 2023, "is_wenli": 1, "score": 500, "ranking": 61450, "num": 987 }, { "id": 17143, "year": 2023, "is_wenli": 1, "score": 499, "ranking": 62431, "num": 981 }, { "id": 17144, "year": 2023, "is_wenli": 1, "score": 498, "ranking": 63418, "num": 987 }, { "id": 17145, "year": 2023, "is_wenli": 1, "score": 497, "ranking": 64494, "num": 1076 }, { "id": 17146, "year": 2023, "is_wenli": 1, "score": 496, "ranking": 65488, "num": 994 }, { "id": 17147, "year": 2023, "is_wenli": 1, "score": 495, "ranking": 66442, "num": 954 }, { "id": 17148, "year": 2023, "is_wenli": 1, "score": 494, "ranking": 67461, "num": 1019 }, { "id": 17149, "year": 2023, "is_wenli": 1, "score": 493, "ranking": 68466, "num": 1005 }, { "id": 17150, "year": 2023, "is_wenli": 1, "score": 492, "ranking": 69544, "num": 1078 }, { "id": 17151, "year": 2023, "is_wenli": 1, "score": 491, "ranking": 70584, "num": 1040 }, { "id": 17152, "year": 2023, "is_wenli": 1, "score": 490, "ranking": 71671, "num": 1087 }, { "id": 17153, "year": 2023, "is_wenli": 1, "score": 489, "ranking": 72712, "num": 1041 }, { "id": 17154, "year": 2023, "is_wenli": 1, "score": 488, "ranking": 73795, "num": 1083 }, { "id": 17155, "year": 2023, "is_wenli": 1, "score": 487, "ranking": 74845, "num": 1050 }, { "id": 17156, "year": 2023, "is_wenli": 1, "score": 486, "ranking": 75936, "num": 1091 }, { "id": 17157, "year": 2023, "is_wenli": 1, "score": 485, "ranking": 76959, "num": 1023 }, { "id": 17158, "year": 2023, "is_wenli": 1, "score": 484, "ranking": 78045, "num": 1086 }, { "id": 17159, "year": 2023, "is_wenli": 1, "score": 483, "ranking": 79190, "num": 1145 }, { "id": 17160, "year": 2023, "is_wenli": 1, "score": 482, "ranking": 80259, "num": 1069 }, { "id": 17161, "year": 2023, "is_wenli": 1, "score": 481, "ranking": 81310, "num": 1051 }, { "id": 17162, "year": 2023, "is_wenli": 1, "score": 480, "ranking": 82422, "num": 1112 }, { "id": 17163, "year": 2023, "is_wenli": 1, "score": 479, "ranking": 83482, "num": 1060 }, { "id": 17164, "year": 2023, "is_wenli": 1, "score": 478, "ranking": 84597, "num": 1115 }, { "id": 17165, "year": 2023, "is_wenli": 1, "score": 477, "ranking": 85701, "num": 1104 }, { "id": 17166, "year": 2023, "is_wenli": 1, "score": 476, "ranking": 86775, "num": 1074 }, { "id": 17167, "year": 2023, "is_wenli": 1, "score": 475, "ranking": 87898, "num": 1123 }, { "id": 17168, "year": 2023, "is_wenli": 1, "score": 474, "ranking": 88985, "num": 1087 }, { "id": 17169, "year": 2023, "is_wenli": 1, "score": 473, "ranking": 90113, "num": 1128 }, { "id": 17170, "year": 2023, "is_wenli": 1, "score": 472, "ranking": 91243, "num": 1130 }, { "id": 17171, "year": 2023, "is_wenli": 1, "score": 471, "ranking": 92333, "num": 1090 }, { "id": 17172, "year": 2023, "is_wenli": 1, "score": 470, "ranking": 93542, "num": 1209 }, { "id": 17173, "year": 2023, "is_wenli": 1, "score": 469, "ranking": 94646, "num": 1104 }, { "id": 17174, "year": 2023, "is_wenli": 1, "score": 468, "ranking": 95805, "num": 1159 }, { "id": 17175, "year": 2023, "is_wenli": 1, "score": 467, "ranking": 96864, "num": 1059 }, { "id": 17176, "year": 2023, "is_wenli": 1, "score": 466, "ranking": 97978, "num": 1114 }, { "id": 17177, "year": 2023, "is_wenli": 1, "score": 465, "ranking": 99108, "num": 1130 }, { "id": 17178, "year": 2023, "is_wenli": 1, "score": 464, "ranking": 100297, "num": 1189 }, { "id": 17179, "year": 2023, "is_wenli": 1, "score": 463, "ranking": 101517, "num": 1220 }, { "id": 17180, "year": 2023, "is_wenli": 1, "score": 462, "ranking": 102655, "num": 1138 }, { "id": 17181, "year": 2023, "is_wenli": 1, "score": 461, "ranking": 103791, "num": 1136 }, { "id": 17182, "year": 2023, "is_wenli": 1, "score": 460, "ranking": 104927, "num": 1136 }, { "id": 17183, "year": 2023, "is_wenli": 1, "score": 459, "ranking": 106020, "num": 1093 }, { "id": 17184, "year": 2023, "is_wenli": 1, "score": 458, "ranking": 107202, "num": 1182 }, { "id": 17185, "year": 2023, "is_wenli": 1, "score": 457, "ranking": 108390, "num": 1188 }, { "id": 17186, "year": 2023, "is_wenli": 1, "score": 456, "ranking": 109532, "num": 1142 }, { "id": 17187, "year": 2023, "is_wenli": 1, "score": 455, "ranking": 110654, "num": 1122 }, { "id": 17188, "year": 2023, "is_wenli": 1, "score": 454, "ranking": 111789, "num": 1135 }, { "id": 17189, "year": 2023, "is_wenli": 1, "score": 453, "ranking": 112978, "num": 1189 }, { "id": 17190, "year": 2023, "is_wenli": 1, "score": 452, "ranking": 114130, "num": 1152 }, { "id": 17191, "year": 2023, "is_wenli": 1, "score": 451, "ranking": 115265, "num": 1135 }, { "id": 17192, "year": 2023, "is_wenli": 1, "score": 450, "ranking": 116405, "num": 1140 }, { "id": 17193, "year": 2023, "is_wenli": 1, "score": 449, "ranking": 117595, "num": 1190 }, { "id": 17194, "year": 2023, "is_wenli": 1, "score": 448, "ranking": 118801, "num": 1206 }, { "id": 17195, "year": 2023, "is_wenli": 1, "score": 447, "ranking": 119898, "num": 1097 }, { "id": 17196, "year": 2023, "is_wenli": 1, "score": 446, "ranking": 121113, "num": 1215 }, { "id": 17197, "year": 2023, "is_wenli": 1, "score": 445, "ranking": 122345, "num": 1232 }, { "id": 17198, "year": 2023, "is_wenli": 1, "score": 444, "ranking": 123458, "num": 1113 }, { "id": 17199, "year": 2023, "is_wenli": 1, "score": 443, "ranking": 124654, "num": 1196 }, { "id": 17200, "year": 2023, "is_wenli": 1, "score": 442, "ranking": 125906, "num": 1252 }, { "id": 17201, "year": 2023, "is_wenli": 1, "score": 441, "ranking": 127094, "num": 1188 }, { "id": 17202, "year": 2023, "is_wenli": 1, "score": 440, "ranking": 128308, "num": 1214 }, { "id": 17203, "year": 2023, "is_wenli": 1, "score": 439, "ranking": 129475, "num": 1167 }, { "id": 17204, "year": 2023, "is_wenli": 1, "score": 438, "ranking": 130654, "num": 1179 }, { "id": 17205, "year": 2023, "is_wenli": 1, "score": 437, "ranking": 131894, "num": 1240 }, { "id": 17206, "year": 2023, "is_wenli": 1, "score": 436, "ranking": 133115, "num": 1221 }, { "id": 17207, "year": 2023, "is_wenli": 1, "score": 435, "ranking": 134299, "num": 1184 }, { "id": 17208, "year": 2023, "is_wenli": 1, "score": 434, "ranking": 135448, "num": 1149 }, { "id": 17209, "year": 2023, "is_wenli": 1, "score": 433, "ranking": 136675, "num": 1227 }, { "id": 17210, "year": 2023, "is_wenli": 1, "score": 432, "ranking": 137873, "num": 1198 }, { "id": 17211, "year": 2023, "is_wenli": 1, "score": 431, "ranking": 139080, "num": 1207 }, { "id": 17212, "year": 2023, "is_wenli": 1, "score": 430, "ranking": 140306, "num": 1226 }, { "id": 17213, "year": 2023, "is_wenli": 1, "score": 429, "ranking": 141493, "num": 1187 }, { "id": 17214, "year": 2023, "is_wenli": 1, "score": 428, "ranking": 142725, "num": 1232 }, { "id": 17215, "year": 2023, "is_wenli": 1, "score": 427, "ranking": 143971, "num": 1246 }, { "id": 17216, "year": 2023, "is_wenli": 1, "score": 426, "ranking": 145227, "num": 1256 }, { "id": 17217, "year": 2023, "is_wenli": 1, "score": 425, "ranking": 146502, "num": 1275 }, { "id": 17218, "year": 2023, "is_wenli": 1, "score": 424, "ranking": 147725, "num": 1223 }, { "id": 17219, "year": 2023, "is_wenli": 1, "score": 423, "ranking": 148995, "num": 1270 }, { "id": 17220, "year": 2023, "is_wenli": 1, "score": 422, "ranking": 150250, "num": 1255 }, { "id": 17221, "year": 2023, "is_wenli": 1, "score": 421, "ranking": 151474, "num": 1224 }, { "id": 17222, "year": 2023, "is_wenli": 1, "score": 420, "ranking": 152745, "num": 1271 }, { "id": 17223, "year": 2023, "is_wenli": 1, "score": 419, "ranking": 153957, "num": 1212 }, { "id": 17224, "year": 2023, "is_wenli": 1, "score": 418, "ranking": 155283, "num": 1326 }, { "id": 17225, "year": 2023, "is_wenli": 1, "score": 417, "ranking": 156562, "num": 1279 }, { "id": 17226, "year": 2023, "is_wenli": 1, "score": 416, "ranking": 157785, "num": 1223 }, { "id": 17227, "year": 2023, "is_wenli": 1, "score": 415, "ranking": 159063, "num": 1278 }, { "id": 17228, "year": 2023, "is_wenli": 1, "score": 414, "ranking": 160357, "num": 1294 }, { "id": 17229, "year": 2023, "is_wenli": 1, "score": 413, "ranking": 161623, "num": 1266 }, { "id": 17230, "year": 2023, "is_wenli": 1, "score": 412, "ranking": 162865, "num": 1242 }, { "id": 17231, "year": 2023, "is_wenli": 1, "score": 411, "ranking": 164134, "num": 1269 }, { "id": 17232, "year": 2023, "is_wenli": 1, "score": 410, "ranking": 165444, "num": 1310 }, { "id": 17233, "year": 2023, "is_wenli": 1, "score": 409, "ranking": 166736, "num": 1292 }, { "id": 17234, "year": 2023, "is_wenli": 1, "score": 408, "ranking": 168065, "num": 1329 }, { "id": 17235, "year": 2023, "is_wenli": 1, "score": 407, "ranking": 169328, "num": 1263 }, { "id": 17236, "year": 2023, "is_wenli": 1, "score": 406, "ranking": 170660, "num": 1332 }, { "id": 17237, "year": 2023, "is_wenli": 1, "score": 405, "ranking": 171943, "num": 1283 }, { "id": 17238, "year": 2023, "is_wenli": 1, "score": 404, "ranking": 173248, "num": 1305 }, { "id": 17239, "year": 2023, "is_wenli": 1, "score": 403, "ranking": 174536, "num": 1288 }, { "id": 17240, "year": 2023, "is_wenli": 1, "score": 402, "ranking": 175852, "num": 1316 }, { "id": 17241, "year": 2023, "is_wenli": 1, "score": 401, "ranking": 177111, "num": 1259 }, { "id": 17242, "year": 2023, "is_wenli": 1, "score": 400, "ranking": 178434, "num": 1323 }, { "id": 17243, "year": 2023, "is_wenli": 1, "score": 399, "ranking": 179820, "num": 1386 }, { "id": 17244, "year": 2023, "is_wenli": 1, "score": 398, "ranking": 181139, "num": 1319 }, { "id": 17245, "year": 2023, "is_wenli": 1, "score": 397, "ranking": 182460, "num": 1321 }, { "id": 17246, "year": 2023, "is_wenli": 1, "score": 396, "ranking": 183754, "num": 1294 }, { "id": 17247, "year": 2023, "is_wenli": 1, "score": 395, "ranking": 185100, "num": 1346 }, { "id": 17248, "year": 2023, "is_wenli": 1, "score": 394, "ranking": 186477, "num": 1377 }, { "id": 17249, "year": 2023, "is_wenli": 1, "score": 393, "ranking": 187797, "num": 1320 }, { "id": 17250, "year": 2023, "is_wenli": 1, "score": 392, "ranking": 189214, "num": 1417 }, { "id": 17251, "year": 2023, "is_wenli": 1, "score": 391, "ranking": 190558, "num": 1344 }, { "id": 17252, "year": 2023, "is_wenli": 1, "score": 390, "ranking": 191943, "num": 1385 }, { "id": 17253, "year": 2023, "is_wenli": 1, "score": 389, "ranking": 193284, "num": 1341 }, { "id": 17254, "year": 2023, "is_wenli": 1, "score": 388, "ranking": 194640, "num": 1356 }, { "id": 17255, "year": 2023, "is_wenli": 1, "score": 387, "ranking": 196005, "num": 1365 }, { "id": 17256, "year": 2023, "is_wenli": 1, "score": 386, "ranking": 197345, "num": 1340 }, { "id": 17257, "year": 2023, "is_wenli": 1, "score": 385, "ranking": 198652, "num": 1307 }, { "id": 17258, "year": 2023, "is_wenli": 1, "score": 384, "ranking": 199984, "num": 1332 }, { "id": 17259, "year": 2023, "is_wenli": 1, "score": 383, "ranking": 201264, "num": 1280 }, { "id": 17260, "year": 2023, "is_wenli": 1, "score": 382, "ranking": 202583, "num": 1319 }, { "id": 17261, "year": 2023, "is_wenli": 1, "score": 381, "ranking": 203916, "num": 1333 }, { "id": 17262, "year": 2023, "is_wenli": 1, "score": 380, "ranking": 205239, "num": 1323 }, { "id": 17263, "year": 2023, "is_wenli": 1, "score": 379, "ranking": 206583, "num": 1344 }, { "id": 17264, "year": 2023, "is_wenli": 1, "score": 378, "ranking": 207914, "num": 1331 }, { "id": 17265, "year": 2023, "is_wenli": 1, "score": 377, "ranking": 209209, "num": 1295 }, { "id": 17266, "year": 2023, "is_wenli": 1, "score": 376, "ranking": 210559, "num": 1350 }, { "id": 17267, "year": 2023, "is_wenli": 1, "score": 375, "ranking": 211891, "num": 1332 }, { "id": 17268, "year": 2023, "is_wenli": 1, "score": 374, "ranking": 213206, "num": 1315 }, { "id": 17269, "year": 2023, "is_wenli": 1, "score": 373, "ranking": 214507, "num": 1301 }, { "id": 17270, "year": 2023, "is_wenli": 1, "score": 372, "ranking": 215832, "num": 1325 }, { "id": 17271, "year": 2023, "is_wenli": 1, "score": 371, "ranking": 217121, "num": 1289 }, { "id": 17272, "year": 2023, "is_wenli": 1, "score": 370, "ranking": 218443, "num": 1322 }, { "id": 17273, "year": 2023, "is_wenli": 1, "score": 369, "ranking": 219711, "num": 1268 }, { "id": 17274, "year": 2023, "is_wenli": 1, "score": 368, "ranking": 220999, "num": 1288 }, { "id": 17275, "year": 2023, "is_wenli": 1, "score": 367, "ranking": 222315, "num": 1316 }, { "id": 17276, "year": 2023, "is_wenli": 1, "score": 366, "ranking": 223574, "num": 1259 }, { "id": 17277, "year": 2023, "is_wenli": 1, "score": 365, "ranking": 224869, "num": 1295 }, { "id": 17278, "year": 2023, "is_wenli": 1, "score": 364, "ranking": 226162, "num": 1293 }, { "id": 17279, "year": 2023, "is_wenli": 1, "score": 363, "ranking": 227429, "num": 1267 }, { "id": 17280, "year": 2023, "is_wenli": 1, "score": 362, "ranking": 228689, "num": 1260 }, { "id": 17281, "year": 2023, "is_wenli": 1, "score": 361, "ranking": 229911, "num": 1222 }, { "id": 17282, "year": 2023, "is_wenli": 1, "score": 360, "ranking": 231159, "num": 1248 }, { "id": 17283, "year": 2023, "is_wenli": 1, "score": 359, "ranking": 232440, "num": 1281 }, { "id": 17284, "year": 2023, "is_wenli": 1, "score": 358, "ranking": 233689, "num": 1249 }, { "id": 17285, "year": 2023, "is_wenli": 1, "score": 357, "ranking": 234943, "num": 1254 }, { "id": 17286, "year": 2023, "is_wenli": 1, "score": 356, "ranking": 236095, "num": 1152 }, { "id": 17287, "year": 2023, "is_wenli": 1, "score": 355, "ranking": 237324, "num": 1229 }, { "id": 17288, "year": 2023, "is_wenli": 1, "score": 354, "ranking": 238579, "num": 1255 }, { "id": 17289, "year": 2023, "is_wenli": 1, "score": 353, "ranking": 239828, "num": 1249 }, { "id": 17290, "year": 2023, "is_wenli": 1, "score": 352, "ranking": 241061, "num": 1233 }, { "id": 17291, "year": 2023, "is_wenli": 1, "score": 351, "ranking": 242281, "num": 1220 }, { "id": 17292, "year": 2023, "is_wenli": 1, "score": 350, "ranking": 243584, "num": 1303 }, { "id": 17293, "year": 2023, "is_wenli": 1, "score": 349, "ranking": 244771, "num": 1187 }, { "id": 17294, "year": 2023, "is_wenli": 1, "score": 348, "ranking": 245973, "num": 1202 }, { "id": 17295, "year": 2023, "is_wenli": 1, "score": 347, "ranking": 247219, "num": 1246 }, { "id": 17296, "year": 2023, "is_wenli": 1, "score": 346, "ranking": 248351, "num": 1132 }, { "id": 17297, "year": 2023, "is_wenli": 1, "score": 345, "ranking": 249469, "num": 1118 }, { "id": 17298, "year": 2023, "is_wenli": 1, "score": 344, "ranking": 250621, "num": 1152 }, { "id": 17299, "year": 2023, "is_wenli": 1, "score": 343, "ranking": 251783, "num": 1162 }, { "id": 17300, "year": 2023, "is_wenli": 1, "score": 342, "ranking": 252894, "num": 1111 }, { "id": 17301, "year": 2023, "is_wenli": 1, "score": 341, "ranking": 254008, "num": 1114 }, { "id": 17302, "year": 2023, "is_wenli": 1, "score": 340, "ranking": 255134, "num": 1126 }, { "id": 17303, "year": 2023, "is_wenli": 1, "score": 339, "ranking": 256217, "num": 1083 }, { "id": 17304, "year": 2023, "is_wenli": 1, "score": 338, "ranking": 257373, "num": 1156 }, { "id": 17305, "year": 2023, "is_wenli": 1, "score": 337, "ranking": 258458, "num": 1085 }, { "id": 17306, "year": 2023, "is_wenli": 1, "score": 336, "ranking": 259630, "num": 1172 }, { "id": 17307, "year": 2023, "is_wenli": 1, "score": 335, "ranking": 260713, "num": 1083 }, { "id": 17308, "year": 2023, "is_wenli": 1, "score": 334, "ranking": 261813, "num": 1100 }, { "id": 17309, "year": 2023, "is_wenli": 1, "score": 333, "ranking": 262871, "num": 1058 }, { "id": 17310, "year": 2023, "is_wenli": 1, "score": 332, "ranking": 263914, "num": 1043 }, { "id": 17311, "year": 2023, "is_wenli": 1, "score": 331, "ranking": 264952, "num": 1038 }, { "id": 17312, "year": 2023, "is_wenli": 1, "score": 330, "ranking": 266002, "num": 1050 }, { "id": 17313, "year": 2023, "is_wenli": 1, "score": 329, "ranking": 267093, "num": 1091 }, { "id": 17314, "year": 2023, "is_wenli": 1, "score": 328, "ranking": 268112, "num": 1019 }, { "id": 17315, "year": 2023, "is_wenli": 1, "score": 327, "ranking": 269133, "num": 1021 }, { "id": 17316, "year": 2023, "is_wenli": 1, "score": 326, "ranking": 270193, "num": 1060 }, { "id": 17317, "year": 2023, "is_wenli": 1, "score": 325, "ranking": 271196, "num": 1003 }, { "id": 17318, "year": 2023, "is_wenli": 1, "score": 324, "ranking": 272157, "num": 961 }, { "id": 17319, "year": 2023, "is_wenli": 1, "score": 323, "ranking": 273153, "num": 996 }, { "id": 17320, "year": 2023, "is_wenli": 1, "score": 322, "ranking": 274142, "num": 989 }, { "id": 17321, "year": 2023, "is_wenli": 1, "score": 321, "ranking": 275109, "num": 967 }, { "id": 17322, "year": 2023, "is_wenli": 1, "score": 320, "ranking": 276103, "num": 994 }, { "id": 17323, "year": 2023, "is_wenli": 1, "score": 319, "ranking": 277078, "num": 975 }, { "id": 17324, "year": 2023, "is_wenli": 1, "score": 318, "ranking": 278025, "num": 947 }, { "id": 17325, "year": 2023, "is_wenli": 1, "score": 317, "ranking": 279034, "num": 1009 }, { "id": 17326, "year": 2023, "is_wenli": 1, "score": 316, "ranking": 279987, "num": 953 }, { "id": 17327, "year": 2023, "is_wenli": 1, "score": 315, "ranking": 280954, "num": 967 }, { "id": 17328, "year": 2023, "is_wenli": 1, "score": 314, "ranking": 281891, "num": 937 }, { "id": 17329, "year": 2023, "is_wenli": 1, "score": 313, "ranking": 282829, "num": 938 }, { "id": 17330, "year": 2023, "is_wenli": 1, "score": 312, "ranking": 283727, "num": 898 }, { "id": 17331, "year": 2023, "is_wenli": 1, "score": 311, "ranking": 284664, "num": 937 }, { "id": 17332, "year": 2023, "is_wenli": 1, "score": 310, "ranking": 285565, "num": 901 }, { "id": 17333, "year": 2023, "is_wenli": 1, "score": 309, "ranking": 286447, "num": 882 }, { "id": 17334, "year": 2023, "is_wenli": 1, "score": 308, "ranking": 287421, "num": 974 }, { "id": 17335, "year": 2023, "is_wenli": 1, "score": 307, "ranking": 288352, "num": 931 }, { "id": 17336, "year": 2023, "is_wenli": 1, "score": 306, "ranking": 289261, "num": 909 }, { "id": 17337, "year": 2023, "is_wenli": 1, "score": 305, "ranking": 290140, "num": 879 }, { "id": 17338, "year": 2023, "is_wenli": 1, "score": 304, "ranking": 291017, "num": 877 }, { "id": 17339, "year": 2023, "is_wenli": 1, "score": 303, "ranking": 291846, "num": 829 }, { "id": 17340, "year": 2023, "is_wenli": 1, "score": 302, "ranking": 292712, "num": 866 }, { "id": 17341, "year": 2023, "is_wenli": 1, "score": 301, "ranking": 293564, "num": 852 }, { "id": 17342, "year": 2023, "is_wenli": 1, "score": 300, "ranking": 294427, "num": 863 }, { "id": 17343, "year": 2023, "is_wenli": 1, "score": 299, "ranking": 295243, "num": 816 }, { "id": 17344, "year": 2023, "is_wenli": 1, "score": 298, "ranking": 296108, "num": 865 }, { "id": 17345, "year": 2023, "is_wenli": 1, "score": 297, "ranking": 296883, "num": 775 }, { "id": 17346, "year": 2023, "is_wenli": 1, "score": 296, "ranking": 297691, "num": 808 }, { "id": 17347, "year": 2023, "is_wenli": 1, "score": 295, "ranking": 298525, "num": 834 }, { "id": 17348, "year": 2023, "is_wenli": 1, "score": 294, "ranking": 299282, "num": 757 }, { "id": 17349, "year": 2023, "is_wenli": 1, "score": 293, "ranking": 300077, "num": 795 }, { "id": 17350, "year": 2023, "is_wenli": 1, "score": 292, "ranking": 300811, "num": 734 }, { "id": 17351, "year": 2023, "is_wenli": 1, "score": 291, "ranking": 301572, "num": 761 }, { "id": 17352, "year": 2023, "is_wenli": 1, "score": 290, "ranking": 302313, "num": 741 }, { "id": 17353, "year": 2023, "is_wenli": 1, "score": 289, "ranking": 303061, "num": 748 }, { "id": 17354, "year": 2023, "is_wenli": 1, "score": 288, "ranking": 303865, "num": 804 }, { "id": 17355, "year": 2023, "is_wenli": 1, "score": 287, "ranking": 304624, "num": 759 }, { "id": 17356, "year": 2023, "is_wenli": 1, "score": 286, "ranking": 305339, "num": 715 }, { "id": 17357, "year": 2023, "is_wenli": 1, "score": 285, "ranking": 306064, "num": 725 }, { "id": 17358, "year": 2023, "is_wenli": 1, "score": 284, "ranking": 306803, "num": 739 }, { "id": 17359, "year": 2023, "is_wenli": 1, "score": 283, "ranking": 307453, "num": 650 }, { "id": 17360, "year": 2023, "is_wenli": 1, "score": 282, "ranking": 308168, "num": 715 }, { "id": 17361, "year": 2023, "is_wenli": 1, "score": 281, "ranking": 308831, "num": 663 }, { "id": 17362, "year": 2023, "is_wenli": 1, "score": 280, "ranking": 309529, "num": 698 }, { "id": 17363, "year": 2023, "is_wenli": 1, "score": 279, "ranking": 310201, "num": 672 }, { "id": 17364, "year": 2023, "is_wenli": 1, "score": 278, "ranking": 310840, "num": 639 }, { "id": 17365, "year": 2023, "is_wenli": 1, "score": 277, "ranking": 311481, "num": 641 }, { "id": 17366, "year": 2023, "is_wenli": 1, "score": 276, "ranking": 312125, "num": 644 }, { "id": 17367, "year": 2023, "is_wenli": 1, "score": 275, "ranking": 312751, "num": 626 }, { "id": 17368, "year": 2023, "is_wenli": 1, "score": 274, "ranking": 313381, "num": 630 }, { "id": 17369, "year": 2023, "is_wenli": 1, "score": 273, "ranking": 313997, "num": 616 }, { "id": 17370, "year": 2023, "is_wenli": 1, "score": 272, "ranking": 314610, "num": 613 }, { "id": 17371, "year": 2023, "is_wenli": 1, "score": 271, "ranking": 315244, "num": 634 }, { "id": 17372, "year": 2023, "is_wenli": 1, "score": 270, "ranking": 315842, "num": 598 }, { "id": 17373, "year": 2023, "is_wenli": 1, "score": 269, "ranking": 316465, "num": 623 }, { "id": 17374, "year": 2023, "is_wenli": 1, "score": 268, "ranking": 317075, "num": 610 }, { "id": 17375, "year": 2023, "is_wenli": 1, "score": 267, "ranking": 317683, "num": 608 }, { "id": 17376, "year": 2023, "is_wenli": 1, "score": 266, "ranking": 318222, "num": 539 }, { "id": 17377, "year": 2023, "is_wenli": 1, "score": 265, "ranking": 318787, "num": 565 }, { "id": 17378, "year": 2023, "is_wenli": 1, "score": 264, "ranking": 319406, "num": 619 }, { "id": 17379, "year": 2023, "is_wenli": 1, "score": 263, "ranking": 319949, "num": 543 }, { "id": 17380, "year": 2023, "is_wenli": 1, "score": 262, "ranking": 320550, "num": 601 }, { "id": 17381, "year": 2023, "is_wenli": 1, "score": 261, "ranking": 321075, "num": 525 }, { "id": 17382, "year": 2023, "is_wenli": 1, "score": 260, "ranking": 321622, "num": 547 }, { "id": 17383, "year": 2023, "is_wenli": 1, "score": 259, "ranking": 322183, "num": 561 }, { "id": 17384, "year": 2023, "is_wenli": 1, "score": 258, "ranking": 322708, "num": 525 }, { "id": 17385, "year": 2023, "is_wenli": 1, "score": 257, "ranking": 323278, "num": 570 }, { "id": 17386, "year": 2023, "is_wenli": 1, "score": 256, "ranking": 323832, "num": 554 }, { "id": 17387, "year": 2023, "is_wenli": 1, "score": 255, "ranking": 324297, "num": 465 }, { "id": 17388, "year": 2023, "is_wenli": 1, "score": 254, "ranking": 324835, "num": 538 }, { "id": 17389, "year": 2023, "is_wenli": 1, "score": 253, "ranking": 325337, "num": 502 }, { "id": 17390, "year": 2023, "is_wenli": 1, "score": 252, "ranking": 325854, "num": 517 }, { "id": 17391, "year": 2023, "is_wenli": 1, "score": 251, "ranking": 326393, "num": 539 }, { "id": 17392, "year": 2023, "is_wenli": 1, "score": 250, "ranking": 326831, "num": 438 }, { "id": 17393, "year": 2023, "is_wenli": 1, "score": 249, "ranking": 327304, "num": 473 }, { "id": 17394, "year": 2023, "is_wenli": 1, "score": 248, "ranking": 327786, "num": 482 }, { "id": 17395, "year": 2023, "is_wenli": 1, "score": 247, "ranking": 328273, "num": 487 }, { "id": 17396, "year": 2023, "is_wenli": 1, "score": 246, "ranking": 328768, "num": 495 }, { "id": 17397, "year": 2023, "is_wenli": 1, "score": 245, "ranking": 329247, "num": 479 }, { "id": 17398, "year": 2023, "is_wenli": 1, "score": 244, "ranking": 329703, "num": 456 }, { "id": 17399, "year": 2023, "is_wenli": 1, "score": 243, "ranking": 330173, "num": 470 }, { "id": 17400, "year": 2023, "is_wenli": 1, "score": 242, "ranking": 330655, "num": 482 }, { "id": 17401, "year": 2023, "is_wenli": 1, "score": 241, "ranking": 331091, "num": 436 }, { "id": 17402, "year": 2023, "is_wenli": 1, "score": 240, "ranking": 331522, "num": 431 }, { "id": 17403, "year": 2023, "is_wenli": 1, "score": 239, "ranking": 331913, "num": 391 }, { "id": 17404, "year": 2023, "is_wenli": 1, "score": 238, "ranking": 332380, "num": 467 }, { "id": 17405, "year": 2023, "is_wenli": 1, "score": 237, "ranking": 332799, "num": 419 }, { "id": 17406, "year": 2023, "is_wenli": 1, "score": 236, "ranking": 333220, "num": 421 }, { "id": 17407, "year": 2023, "is_wenli": 1, "score": 235, "ranking": 333619, "num": 399 }, { "id": 17408, "year": 2023, "is_wenli": 1, "score": 234, "ranking": 334052, "num": 433 }, { "id": 17409, "year": 2023, "is_wenli": 1, "score": 233, "ranking": 334475, "num": 423 }, { "id": 17410, "year": 2023, "is_wenli": 1, "score": 232, "ranking": 334909, "num": 434 }, { "id": 17411, "year": 2023, "is_wenli": 1, "score": 231, "ranking": 335292, "num": 383 }, { "id": 17412, "year": 2023, "is_wenli": 1, "score": 230, "ranking": 335679, "num": 387 }, { "id": 17413, "year": 2023, "is_wenli": 1, "score": 229, "ranking": 336090, "num": 411 }, { "id": 17414, "year": 2023, "is_wenli": 1, "score": 228, "ranking": 336483, "num": 393 }, { "id": 17415, "year": 2023, "is_wenli": 1, "score": 227, "ranking": 336865, "num": 382 }, { "id": 17416, "year": 2023, "is_wenli": 1, "score": 226, "ranking": 337264, "num": 399 }, { "id": 17417, "year": 2023, "is_wenli": 1, "score": 225, "ranking": 337610, "num": 346 }, { "id": 17418, "year": 2023, "is_wenli": 1, "score": 224, "ranking": 337987, "num": 377 }, { "id": 17419, "year": 2023, "is_wenli": 1, "score": 223, "ranking": 338339, "num": 352 }, { "id": 17420, "year": 2023, "is_wenli": 1, "score": 222, "ranking": 338673, "num": 334 }, { "id": 17421, "year": 2023, "is_wenli": 1, "score": 221, "ranking": 339034, "num": 361 }, { "id": 17422, "year": 2023, "is_wenli": 1, "score": 220, "ranking": 339374, "num": 340 }, { "id": 17423, "year": 2023, "is_wenli": 1, "score": 219, "ranking": 339711, "num": 337 }, { "id": 17424, "year": 2023, "is_wenli": 1, "score": 218, "ranking": 340058, "num": 347 }, { "id": 17425, "year": 2023, "is_wenli": 1, "score": 217, "ranking": 340393, "num": 335 }, { "id": 17426, "year": 2023, "is_wenli": 1, "score": 216, "ranking": 340727, "num": 334 }, { "id": 17427, "year": 2023, "is_wenli": 1, "score": 215, "ranking": 341080, "num": 353 }, { "id": 17428, "year": 2023, "is_wenli": 1, "score": 214, "ranking": 341377, "num": 297 }, { "id": 17429, "year": 2023, "is_wenli": 1, "score": 213, "ranking": 341693, "num": 316 }, { "id": 17430, "year": 2023, "is_wenli": 1, "score": 212, "ranking": 342006, "num": 313 }, { "id": 17431, "year": 2023, "is_wenli": 1, "score": 211, "ranking": 342309, "num": 303 }, { "id": 17432, "year": 2023, "is_wenli": 1, "score": 210, "ranking": 342617, "num": 308 }, { "id": 17433, "year": 2023, "is_wenli": 1, "score": 209, "ranking": 342907, "num": 290 }, { "id": 17434, "year": 2023, "is_wenli": 1, "score": 208, "ranking": 343196, "num": 289 }, { "id": 17435, "year": 2023, "is_wenli": 1, "score": 207, "ranking": 343507, "num": 311 }, { "id": 17436, "year": 2023, "is_wenli": 1, "score": 206, "ranking": 343795, "num": 288 }, { "id": 17437, "year": 2023, "is_wenli": 1, "score": 205, "ranking": 344075, "num": 280 }, { "id": 17438, "year": 2023, "is_wenli": 1, "score": 204, "ranking": 344368, "num": 293 }, { "id": 17439, "year": 2023, "is_wenli": 1, "score": 203, "ranking": 344643, "num": 275 }, { "id": 17440, "year": 2023, "is_wenli": 1, "score": 202, "ranking": 344934, "num": 291 }, { "id": 17441, "year": 2023, "is_wenli": 1, "score": 201, "ranking": 345222, "num": 288 }, { "id": 17442, "year": 2023, "is_wenli": 1, "score": 200, "ranking": 345490, "num": 268 }, { "id": 17443, "year": 2023, "is_wenli": 1, "score": 199, "ranking": 345733, "num": 243 }, { "id": 17444, "year": 2023, "is_wenli": 1, "score": 198, "ranking": 345989, "num": 256 }, { "id": 17445, "year": 2023, "is_wenli": 1, "score": 197, "ranking": 346243, "num": 254 }, { "id": 17446, "year": 2023, "is_wenli": 1, "score": 196, "ranking": 346452, "num": 209 }, { "id": 17447, "year": 2023, "is_wenli": 1, "score": 195, "ranking": 346687, "num": 235 }, { "id": 17448, "year": 2023, "is_wenli": 1, "score": 194, "ranking": 346918, "num": 231 }, { "id": 17449, "year": 2023, "is_wenli": 1, "score": 193, "ranking": 347157, "num": 239 }, { "id": 17450, "year": 2023, "is_wenli": 1, "score": 192, "ranking": 347380, "num": 223 }, { "id": 17451, "year": 2023, "is_wenli": 1, "score": 191, "ranking": 347602, "num": 222 }, { "id": 17452, "year": 2023, "is_wenli": 1, "score": 190, "ranking": 347808, "num": 206 }, { "id": 17453, "year": 2023, "is_wenli": 1, "score": 189, "ranking": 348021, "num": 213 }, { "id": 17454, "year": 2023, "is_wenli": 1, "score": 188, "ranking": 348189, "num": 168 }, { "id": 17455, "year": 2023, "is_wenli": 1, "score": 187, "ranking": 348391, "num": 202 }, { "id": 17456, "year": 2023, "is_wenli": 1, "score": 186, "ranking": 348600, "num": 209 }, { "id": 17457, "year": 2023, "is_wenli": 1, "score": 185, "ranking": 348796, "num": 196 }, { "id": 17458, "year": 2023, "is_wenli": 1, "score": 184, "ranking": 348984, "num": 188 }, { "id": 17459, "year": 2023, "is_wenli": 1, "score": 183, "ranking": 349161, "num": 177 }, { "id": 17460, "year": 2023, "is_wenli": 1, "score": 182, "ranking": 349346, "num": 185 }, { "id": 17461, "year": 2023, "is_wenli": 1, "score": 181, "ranking": 349528, "num": 182 }, { "id": 17462, "year": 2023, "is_wenli": 1, "score": 180, "ranking": 349722, "num": 194 }, { "id": 17463, "year": 2023, "is_wenli": 1, "score": 179, "ranking": 349881, "num": 159 }, { "id": 17464, "year": 2023, "is_wenli": 1, "score": 178, "ranking": 350045, "num": 164 }, { "id": 17465, "year": 2023, "is_wenli": 1, "score": 177, "ranking": 350219, "num": 174 }, { "id": 17466, "year": 2023, "is_wenli": 1, "score": 176, "ranking": 350398, "num": 179 }, { "id": 17467, "year": 2023, "is_wenli": 1, "score": 175, "ranking": 350560, "num": 162 }, { "id": 17468, "year": 2023, "is_wenli": 1, "score": 174, "ranking": 350712, "num": 152 }, { "id": 17469, "year": 2023, "is_wenli": 1, "score": 173, "ranking": 350838, "num": 126 }, { "id": 17470, "year": 2023, "is_wenli": 1, "score": 172, "ranking": 350992, "num": 154 }, { "id": 17471, "year": 2023, "is_wenli": 1, "score": 171, "ranking": 351130, "num": 138 }, { "id": 17472, "year": 2023, "is_wenli": 1, "score": 170, "ranking": 351287, "num": 157 }, { "id": 17473, "year": 2023, "is_wenli": 1, "score": 169, "ranking": 351399, "num": 112 }, { "id": 17474, "year": 2023, "is_wenli": 1, "score": 168, "ranking": 351530, "num": 131 }, { "id": 17475, "year": 2023, "is_wenli": 1, "score": 167, "ranking": 351646, "num": 116 }, { "id": 17476, "year": 2023, "is_wenli": 1, "score": 166, "ranking": 351785, "num": 139 }, { "id": 17477, "year": 2023, "is_wenli": 1, "score": 165, "ranking": 351906, "num": 121 }, { "id": 17478, "year": 2023, "is_wenli": 1, "score": 164, "ranking": 352015, "num": 109 }, { "id": 17479, "year": 2023, "is_wenli": 1, "score": 163, "ranking": 352159, "num": 144 }, { "id": 17480, "year": 2023, "is_wenli": 1, "score": 162, "ranking": 352260, "num": 101 }, { "id": 17481, "year": 2023, "is_wenli": 1, "score": 161, "ranking": 352375, "num": 115 }, { "id": 17482, "year": 2023, "is_wenli": 1, "score": 160, "ranking": 352489, "num": 114 }, { "id": 17483, "year": 2023, "is_wenli": 1, "score": 159, "ranking": 352595, "num": 106 }, { "id": 17484, "year": 2023, "is_wenli": 1, "score": 158, "ranking": 352694, "num": 99 }, { "id": 17485, "year": 2023, "is_wenli": 1, "score": 157, "ranking": 352785, "num": 91 }, { "id": 17486, "year": 2023, "is_wenli": 1, "score": 156, "ranking": 352886, "num": 101 }, { "id": 17487, "year": 2023, "is_wenli": 1, "score": 155, "ranking": 352971, "num": 85 }, { "id": 17488, "year": 2023, "is_wenli": 1, "score": 154, "ranking": 353055, "num": 84 }, { "id": 17489, "year": 2023, "is_wenli": 1, "score": 153, "ranking": 353163, "num": 108 }, { "id": 17490, "year": 2023, "is_wenli": 1, "score": 152, "ranking": 353246, "num": 83 }, { "id": 17491, "year": 2023, "is_wenli": 1, "score": 151, "ranking": 353349, "num": 103 }, { "id": 17492, "year": 2023, "is_wenli": 1, "score": 150, "ranking": 353424, "num": 75 }, { "id": 17493, "year": 2023, "is_wenli": 1, "score": 149, "ranking": 353505, "num": 81 }, { "id": 17494, "year": 2023, "is_wenli": 1, "score": 148, "ranking": 353560, "num": 55 }, { "id": 17495, "year": 2023, "is_wenli": 1, "score": 147, "ranking": 353628, "num": 68 }, { "id": 17496, "year": 2023, "is_wenli": 1, "score": 146, "ranking": 353692, "num": 64 }, { "id": 17497, "year": 2023, "is_wenli": 1, "score": 145, "ranking": 353751, "num": 59 }, { "id": 17498, "year": 2023, "is_wenli": 1, "score": 144, "ranking": 353811, "num": 60 }, { "id": 17499, "year": 2023, "is_wenli": 1, "score": 143, "ranking": 353868, "num": 57 }, { "id": 17500, "year": 2023, "is_wenli": 1, "score": 142, "ranking": 353939, "num": 71 }, { "id": 17501, "year": 2023, "is_wenli": 1, "score": 141, "ranking": 353994, "num": 55 }, { "id": 17502, "year": 2023, "is_wenli": 1, "score": 140, "ranking": 354048, "num": 54 }, { "id": 17503, "year": 2023, "is_wenli": 1, "score": 139, "ranking": 354107, "num": 59 }, { "id": 17504, "year": 2023, "is_wenli": 1, "score": 138, "ranking": 354154, "num": 47 }, { "id": 17505, "year": 2023, "is_wenli": 1, "score": 137, "ranking": 354219, "num": 65 }, { "id": 17506, "year": 2023, "is_wenli": 1, "score": 136, "ranking": 354266, "num": 47 }, { "id": 17507, "year": 2023, "is_wenli": 1, "score": 135, "ranking": 354320, "num": 54 }, { "id": 17508, "year": 2023, "is_wenli": 1, "score": 134, "ranking": 354365, "num": 45 }, { "id": 17509, "year": 2023, "is_wenli": 1, "score": 133, "ranking": 354424, "num": 59 }, { "id": 17510, "year": 2023, "is_wenli": 1, "score": 132, "ranking": 354471, "num": 47 }, { "id": 17511, "year": 2023, "is_wenli": 1, "score": 131, "ranking": 354517, "num": 46 }, { "id": 17512, "year": 2023, "is_wenli": 1, "score": 130, "ranking": 354561, "num": 44 }, { "id": 17513, "year": 2023, "is_wenli": 1, "score": 129, "ranking": 354606, "num": 45 }, { "id": 17514, "year": 2023, "is_wenli": 1, "score": 128, "ranking": 354649, "num": 43 }, { "id": 17515, "year": 2023, "is_wenli": 1, "score": 127, "ranking": 354690, "num": 41 }, { "id": 17516, "year": 2023, "is_wenli": 1, "score": 126, "ranking": 354728, "num": 38 }, { "id": 17517, "year": 2023, "is_wenli": 1, "score": 125, "ranking": 354766, "num": 38 }, { "id": 17518, "year": 2023, "is_wenli": 1, "score": 124, "ranking": 354798, "num": 32 }, { "id": 17519, "year": 2023, "is_wenli": 1, "score": 123, "ranking": 354828, "num": 30 }, { "id": 17520, "year": 2023, "is_wenli": 1, "score": 122, "ranking": 354857, "num": 29 }, { "id": 17521, "year": 2023, "is_wenli": 1, "score": 121, "ranking": 354890, "num": 33 }, { "id": 17522, "year": 2023, "is_wenli": 1, "score": 120, "ranking": 354924, "num": 34 }, { "id": 17523, "year": 2023, "is_wenli": 1, "score": 119, "ranking": 354960, "num": 36 }, { "id": 17524, "year": 2023, "is_wenli": 1, "score": 118, "ranking": 354985, "num": 25 }, { "id": 17525, "year": 2023, "is_wenli": 1, "score": 117, "ranking": 355020, "num": 35 }, { "id": 17526, "year": 2023, "is_wenli": 1, "score": 116, "ranking": 355042, "num": 22 }, { "id": 17527, "year": 2023, "is_wenli": 1, "score": 115, "ranking": 355065, "num": 23 }, { "id": 17528, "year": 2023, "is_wenli": 1, "score": 114, "ranking": 355095, "num": 30 }, { "id": 17529, "year": 2023, "is_wenli": 1, "score": 113, "ranking": 355128, "num": 33 }, { "id": 17530, "year": 2023, "is_wenli": 1, "score": 112, "ranking": 355149, "num": 21 }, { "id": 17531, "year": 2023, "is_wenli": 1, "score": 111, "ranking": 355176, "num": 27 }, { "id": 17532, "year": 2023, "is_wenli": 1, "score": 110, "ranking": 355201, "num": 25 }, { "id": 17533, "year": 2023, "is_wenli": 1, "score": 109, "ranking": 355223, "num": 22 }, { "id": 17534, "year": 2023, "is_wenli": 1, "score": 108, "ranking": 355252, "num": 29 }, { "id": 17535, "year": 2023, "is_wenli": 1, "score": 107, "ranking": 355271, "num": 19 }, { "id": 17536, "year": 2023, "is_wenli": 1, "score": 106, "ranking": 355288, "num": 17 }, { "id": 17537, "year": 2023, "is_wenli": 1, "score": 105, "ranking": 355308, "num": 20 }, { "id": 17538, "year": 2023, "is_wenli": 1, "score": 104, "ranking": 355334, "num": 26 }, { "id": 17539, "year": 2023, "is_wenli": 1, "score": 103, "ranking": 355353, "num": 19 }, { "id": 17540, "year": 2023, "is_wenli": 1, "score": 102, "ranking": 355371, "num": 18 }, { "id": 17541, "year": 2023, "is_wenli": 1, "score": 101, "ranking": 355389, "num": 18 }, { "id": 17542, "year": 2023, "is_wenli": 1, "score": 100, "ranking": 355412, "num": 23 }],
    2022: [
        {
            "id": 14588,
            "year": 2022,
            "is_wenli": 1,
            "score": 652,
            "ranking": 11,
            "num": 11
        },
        {
            "id": 14589,
            "year": 2022,
            "is_wenli": 1,
            "score": 651,
            "ranking": 13,
            "num": 2
        },
        {
            "id": 14590,
            "year": 2022,
            "is_wenli": 1,
            "score": 650,
            "ranking": 15,
            "num": 2
        },
        {
            "id": 14591,
            "year": 2022,
            "is_wenli": 1,
            "score": 649,
            "ranking": 17,
            "num": 2
        },
        {
            "id": 14592,
            "year": 2022,
            "is_wenli": 1,
            "score": 648,
            "ranking": 21,
            "num": 4
        },
        {
            "id": 14593,
            "year": 2022,
            "is_wenli": 1,
            "score": 647,
            "ranking": 28,
            "num": 7
        },
        {
            "id": 14594,
            "year": 2022,
            "is_wenli": 1,
            "score": 646,
            "ranking": 30,
            "num": 2
        },
        {
            "id": 14595,
            "year": 2022,
            "is_wenli": 1,
            "score": 645,
            "ranking": 33,
            "num": 3
        },
        {
            "id": 14596,
            "year": 2022,
            "is_wenli": 1,
            "score": 644,
            "ranking": 35,
            "num": 2
        },
        {
            "id": 14597,
            "year": 2022,
            "is_wenli": 1,
            "score": 643,
            "ranking": 39,
            "num": 4
        },
        {
            "id": 14598,
            "year": 2022,
            "is_wenli": 1,
            "score": 642,
            "ranking": 40,
            "num": 1
        },
        {
            "id": 14599,
            "year": 2022,
            "is_wenli": 1,
            "score": 641,
            "ranking": 46,
            "num": 6
        },
        {
            "id": 14600,
            "year": 2022,
            "is_wenli": 1,
            "score": 640,
            "ranking": 54,
            "num": 8
        },
        {
            "id": 14601,
            "year": 2022,
            "is_wenli": 1,
            "score": 639,
            "ranking": 59,
            "num": 5
        },
        {
            "id": 14602,
            "year": 2022,
            "is_wenli": 1,
            "score": 638,
            "ranking": 68,
            "num": 9
        },
        {
            "id": 14603,
            "year": 2022,
            "is_wenli": 1,
            "score": 637,
            "ranking": 78,
            "num": 10
        },
        {
            "id": 14604,
            "year": 2022,
            "is_wenli": 1,
            "score": 636,
            "ranking": 85,
            "num": 7
        },
        {
            "id": 14605,
            "year": 2022,
            "is_wenli": 1,
            "score": 635,
            "ranking": 93,
            "num": 8
        },
        {
            "id": 14606,
            "year": 2022,
            "is_wenli": 1,
            "score": 634,
            "ranking": 101,
            "num": 8
        },
        {
            "id": 14607,
            "year": 2022,
            "is_wenli": 1,
            "score": 633,
            "ranking": 110,
            "num": 9
        },
        {
            "id": 14608,
            "year": 2022,
            "is_wenli": 1,
            "score": 632,
            "ranking": 118,
            "num": 8
        },
        {
            "id": 14609,
            "year": 2022,
            "is_wenli": 1,
            "score": 631,
            "ranking": 129,
            "num": 11
        },
        {
            "id": 14610,
            "year": 2022,
            "is_wenli": 1,
            "score": 630,
            "ranking": 137,
            "num": 8
        },
        {
            "id": 14611,
            "year": 2022,
            "is_wenli": 1,
            "score": 629,
            "ranking": 152,
            "num": 15
        },
        {
            "id": 14612,
            "year": 2022,
            "is_wenli": 1,
            "score": 628,
            "ranking": 177,
            "num": 25
        },
        {
            "id": 14613,
            "year": 2022,
            "is_wenli": 1,
            "score": 627,
            "ranking": 187,
            "num": 10
        },
        {
            "id": 14614,
            "year": 2022,
            "is_wenli": 1,
            "score": 626,
            "ranking": 200,
            "num": 13
        },
        {
            "id": 14615,
            "year": 2022,
            "is_wenli": 1,
            "score": 625,
            "ranking": 231,
            "num": 31
        },
        {
            "id": 14616,
            "year": 2022,
            "is_wenli": 1,
            "score": 624,
            "ranking": 245,
            "num": 14
        },
        {
            "id": 14617,
            "year": 2022,
            "is_wenli": 1,
            "score": 623,
            "ranking": 259,
            "num": 14
        },
        {
            "id": 14618,
            "year": 2022,
            "is_wenli": 1,
            "score": 622,
            "ranking": 283,
            "num": 24
        },
        {
            "id": 14619,
            "year": 2022,
            "is_wenli": 1,
            "score": 621,
            "ranking": 308,
            "num": 25
        },
        {
            "id": 14620,
            "year": 2022,
            "is_wenli": 1,
            "score": 620,
            "ranking": 328,
            "num": 20
        },
        {
            "id": 14621,
            "year": 2022,
            "is_wenli": 1,
            "score": 619,
            "ranking": 345,
            "num": 17
        },
        {
            "id": 14622,
            "year": 2022,
            "is_wenli": 1,
            "score": 618,
            "ranking": 378,
            "num": 33
        },
        {
            "id": 14623,
            "year": 2022,
            "is_wenli": 1,
            "score": 617,
            "ranking": 407,
            "num": 29
        },
        {
            "id": 14624,
            "year": 2022,
            "is_wenli": 1,
            "score": 616,
            "ranking": 434,
            "num": 27
        },
        {
            "id": 14625,
            "year": 2022,
            "is_wenli": 1,
            "score": 615,
            "ranking": 458,
            "num": 24
        },
        {
            "id": 14626,
            "year": 2022,
            "is_wenli": 1,
            "score": 614,
            "ranking": 487,
            "num": 29
        },
        {
            "id": 14627,
            "year": 2022,
            "is_wenli": 1,
            "score": 613,
            "ranking": 521,
            "num": 34
        },
        {
            "id": 14628,
            "year": 2022,
            "is_wenli": 1,
            "score": 612,
            "ranking": 554,
            "num": 33
        },
        {
            "id": 14629,
            "year": 2022,
            "is_wenli": 1,
            "score": 611,
            "ranking": 588,
            "num": 34
        },
        {
            "id": 14630,
            "year": 2022,
            "is_wenli": 1,
            "score": 610,
            "ranking": 628,
            "num": 40
        },
        {
            "id": 14631,
            "year": 2022,
            "is_wenli": 1,
            "score": 609,
            "ranking": 669,
            "num": 41
        },
        {
            "id": 14632,
            "year": 2022,
            "is_wenli": 1,
            "score": 608,
            "ranking": 720,
            "num": 51
        },
        {
            "id": 14633,
            "year": 2022,
            "is_wenli": 1,
            "score": 607,
            "ranking": 759,
            "num": 39
        },
        {
            "id": 14634,
            "year": 2022,
            "is_wenli": 1,
            "score": 606,
            "ranking": 804,
            "num": 45
        },
        {
            "id": 14635,
            "year": 2022,
            "is_wenli": 1,
            "score": 605,
            "ranking": 883,
            "num": 79
        },
        {
            "id": 14636,
            "year": 2022,
            "is_wenli": 1,
            "score": 604,
            "ranking": 946,
            "num": 63
        },
        {
            "id": 14637,
            "year": 2022,
            "is_wenli": 1,
            "score": 603,
            "ranking": 996,
            "num": 50
        },
        {
            "id": 14638,
            "year": 2022,
            "is_wenli": 1,
            "score": 602,
            "ranking": 1051,
            "num": 55
        },
        {
            "id": 14639,
            "year": 2022,
            "is_wenli": 1,
            "score": 601,
            "ranking": 1118,
            "num": 67
        },
        {
            "id": 14640,
            "year": 2022,
            "is_wenli": 1,
            "score": 600,
            "ranking": 1179,
            "num": 61
        },
        {
            "id": 14641,
            "year": 2022,
            "is_wenli": 1,
            "score": 599,
            "ranking": 1260,
            "num": 81
        },
        {
            "id": 14642,
            "year": 2022,
            "is_wenli": 1,
            "score": 598,
            "ranking": 1331,
            "num": 71
        },
        {
            "id": 14643,
            "year": 2022,
            "is_wenli": 1,
            "score": 597,
            "ranking": 1415,
            "num": 84
        },
        {
            "id": 14644,
            "year": 2022,
            "is_wenli": 1,
            "score": 596,
            "ranking": 1493,
            "num": 78
        },
        {
            "id": 14645,
            "year": 2022,
            "is_wenli": 1,
            "score": 595,
            "ranking": 1573,
            "num": 80
        },
        {
            "id": 14646,
            "year": 2022,
            "is_wenli": 1,
            "score": 594,
            "ranking": 1666,
            "num": 93
        },
        {
            "id": 14647,
            "year": 2022,
            "is_wenli": 1,
            "score": 593,
            "ranking": 1750,
            "num": 84
        },
        {
            "id": 14648,
            "year": 2022,
            "is_wenli": 1,
            "score": 592,
            "ranking": 1853,
            "num": 103
        },
        {
            "id": 14649,
            "year": 2022,
            "is_wenli": 1,
            "score": 591,
            "ranking": 1979,
            "num": 126
        },
        {
            "id": 14650,
            "year": 2022,
            "is_wenli": 1,
            "score": 590,
            "ranking": 2097,
            "num": 118
        },
        {
            "id": 14651,
            "year": 2022,
            "is_wenli": 1,
            "score": 589,
            "ranking": 2203,
            "num": 106
        },
        {
            "id": 14652,
            "year": 2022,
            "is_wenli": 1,
            "score": 588,
            "ranking": 2334,
            "num": 131
        },
        {
            "id": 14653,
            "year": 2022,
            "is_wenli": 1,
            "score": 587,
            "ranking": 2452,
            "num": 118
        },
        {
            "id": 14654,
            "year": 2022,
            "is_wenli": 1,
            "score": 586,
            "ranking": 2572,
            "num": 120
        },
        {
            "id": 14655,
            "year": 2022,
            "is_wenli": 1,
            "score": 585,
            "ranking": 2693,
            "num": 121
        },
        {
            "id": 14656,
            "year": 2022,
            "is_wenli": 1,
            "score": 584,
            "ranking": 2836,
            "num": 143
        },
        {
            "id": 14657,
            "year": 2022,
            "is_wenli": 1,
            "score": 583,
            "ranking": 2997,
            "num": 161
        },
        {
            "id": 14658,
            "year": 2022,
            "is_wenli": 1,
            "score": 582,
            "ranking": 3138,
            "num": 141
        },
        {
            "id": 14659,
            "year": 2022,
            "is_wenli": 1,
            "score": 581,
            "ranking": 3294,
            "num": 156
        },
        {
            "id": 14660,
            "year": 2022,
            "is_wenli": 1,
            "score": 580,
            "ranking": 3451,
            "num": 157
        },
        {
            "id": 14661,
            "year": 2022,
            "is_wenli": 1,
            "score": 579,
            "ranking": 3609,
            "num": 158
        },
        {
            "id": 14662,
            "year": 2022,
            "is_wenli": 1,
            "score": 578,
            "ranking": 3783,
            "num": 174
        },
        {
            "id": 14663,
            "year": 2022,
            "is_wenli": 1,
            "score": 577,
            "ranking": 3958,
            "num": 175
        },
        {
            "id": 14664,
            "year": 2022,
            "is_wenli": 1,
            "score": 576,
            "ranking": 4149,
            "num": 191
        },
        {
            "id": 14665,
            "year": 2022,
            "is_wenli": 1,
            "score": 575,
            "ranking": 4339,
            "num": 190
        },
        {
            "id": 14666,
            "year": 2022,
            "is_wenli": 1,
            "score": 574,
            "ranking": 4515,
            "num": 176
        },
        {
            "id": 14667,
            "year": 2022,
            "is_wenli": 1,
            "score": 573,
            "ranking": 4713,
            "num": 198
        },
        {
            "id": 14668,
            "year": 2022,
            "is_wenli": 1,
            "score": 572,
            "ranking": 4934,
            "num": 221
        },
        {
            "id": 14669,
            "year": 2022,
            "is_wenli": 1,
            "score": 571,
            "ranking": 5159,
            "num": 225
        },
        {
            "id": 14670,
            "year": 2022,
            "is_wenli": 1,
            "score": 570,
            "ranking": 5373,
            "num": 214
        },
        {
            "id": 14671,
            "year": 2022,
            "is_wenli": 1,
            "score": 569,
            "ranking": 5617,
            "num": 244
        },
        {
            "id": 14672,
            "year": 2022,
            "is_wenli": 1,
            "score": 568,
            "ranking": 5830,
            "num": 213
        },
        {
            "id": 14673,
            "year": 2022,
            "is_wenli": 1,
            "score": 567,
            "ranking": 6099,
            "num": 269
        },
        {
            "id": 14674,
            "year": 2022,
            "is_wenli": 1,
            "score": 566,
            "ranking": 6352,
            "num": 253
        },
        {
            "id": 14675,
            "year": 2022,
            "is_wenli": 1,
            "score": 565,
            "ranking": 6625,
            "num": 273
        },
        {
            "id": 14676,
            "year": 2022,
            "is_wenli": 1,
            "score": 564,
            "ranking": 6902,
            "num": 277
        },
        {
            "id": 14677,
            "year": 2022,
            "is_wenli": 1,
            "score": 563,
            "ranking": 7157,
            "num": 255
        },
        {
            "id": 14678,
            "year": 2022,
            "is_wenli": 1,
            "score": 562,
            "ranking": 7464,
            "num": 307
        },
        {
            "id": 14679,
            "year": 2022,
            "is_wenli": 1,
            "score": 561,
            "ranking": 7749,
            "num": 285
        },
        {
            "id": 14680,
            "year": 2022,
            "is_wenli": 1,
            "score": 560,
            "ranking": 8055,
            "num": 306
        },
        {
            "id": 14681,
            "year": 2022,
            "is_wenli": 1,
            "score": 559,
            "ranking": 8379,
            "num": 324
        },
        {
            "id": 14682,
            "year": 2022,
            "is_wenli": 1,
            "score": 558,
            "ranking": 8687,
            "num": 308
        },
        {
            "id": 14683,
            "year": 2022,
            "is_wenli": 1,
            "score": 557,
            "ranking": 9039,
            "num": 352
        },
        {
            "id": 14684,
            "year": 2022,
            "is_wenli": 1,
            "score": 556,
            "ranking": 9374,
            "num": 335
        },
        {
            "id": 14685,
            "year": 2022,
            "is_wenli": 1,
            "score": 555,
            "ranking": 9721,
            "num": 347
        },
        {
            "id": 14686,
            "year": 2022,
            "is_wenli": 1,
            "score": 554,
            "ranking": 10083,
            "num": 362
        },
        {
            "id": 14687,
            "year": 2022,
            "is_wenli": 1,
            "score": 553,
            "ranking": 10473,
            "num": 390
        },
        {
            "id": 14688,
            "year": 2022,
            "is_wenli": 1,
            "score": 552,
            "ranking": 10832,
            "num": 359
        },
        {
            "id": 14689,
            "year": 2022,
            "is_wenli": 1,
            "score": 551,
            "ranking": 11198,
            "num": 366
        },
        {
            "id": 14690,
            "year": 2022,
            "is_wenli": 1,
            "score": 550,
            "ranking": 11606,
            "num": 408
        },
        {
            "id": 14691,
            "year": 2022,
            "is_wenli": 1,
            "score": 549,
            "ranking": 12022,
            "num": 416
        },
        {
            "id": 14692,
            "year": 2022,
            "is_wenli": 1,
            "score": 548,
            "ranking": 12452,
            "num": 430
        },
        {
            "id": 14693,
            "year": 2022,
            "is_wenli": 1,
            "score": 547,
            "ranking": 12892,
            "num": 440
        },
        {
            "id": 14694,
            "year": 2022,
            "is_wenli": 1,
            "score": 546,
            "ranking": 13354,
            "num": 462
        },
        {
            "id": 14695,
            "year": 2022,
            "is_wenli": 1,
            "score": 545,
            "ranking": 13783,
            "num": 429
        },
        {
            "id": 14696,
            "year": 2022,
            "is_wenli": 1,
            "score": 544,
            "ranking": 14280,
            "num": 497
        },
        {
            "id": 14697,
            "year": 2022,
            "is_wenli": 1,
            "score": 543,
            "ranking": 14743,
            "num": 463
        },
        {
            "id": 14698,
            "year": 2022,
            "is_wenli": 1,
            "score": 542,
            "ranking": 15204,
            "num": 461
        },
        {
            "id": 14699,
            "year": 2022,
            "is_wenli": 1,
            "score": 541,
            "ranking": 15679,
            "num": 475
        },
        {
            "id": 14700,
            "year": 2022,
            "is_wenli": 1,
            "score": 540,
            "ranking": 16182,
            "num": 503
        },
        {
            "id": 14701,
            "year": 2022,
            "is_wenli": 1,
            "score": 539,
            "ranking": 16677,
            "num": 495
        },
        {
            "id": 14702,
            "year": 2022,
            "is_wenli": 1,
            "score": 538,
            "ranking": 17210,
            "num": 533
        },
        {
            "id": 14703,
            "year": 2022,
            "is_wenli": 1,
            "score": 537,
            "ranking": 17699,
            "num": 489
        },
        {
            "id": 14704,
            "year": 2022,
            "is_wenli": 1,
            "score": 536,
            "ranking": 18232,
            "num": 533
        },
        {
            "id": 14705,
            "year": 2022,
            "is_wenli": 1,
            "score": 535,
            "ranking": 18792,
            "num": 560
        },
        {
            "id": 14706,
            "year": 2022,
            "is_wenli": 1,
            "score": 534,
            "ranking": 19375,
            "num": 583
        },
        {
            "id": 14707,
            "year": 2022,
            "is_wenli": 1,
            "score": 533,
            "ranking": 19938,
            "num": 563
        },
        {
            "id": 14708,
            "year": 2022,
            "is_wenli": 1,
            "score": 532,
            "ranking": 20478,
            "num": 540
        },
        {
            "id": 14709,
            "year": 2022,
            "is_wenli": 1,
            "score": 531,
            "ranking": 21061,
            "num": 583
        },
        {
            "id": 14710,
            "year": 2022,
            "is_wenli": 1,
            "score": 530,
            "ranking": 21635,
            "num": 574
        },
        {
            "id": 14711,
            "year": 2022,
            "is_wenli": 1,
            "score": 529,
            "ranking": 22242,
            "num": 607
        },
        {
            "id": 14712,
            "year": 2022,
            "is_wenli": 1,
            "score": 528,
            "ranking": 22832,
            "num": 590
        },
        {
            "id": 14713,
            "year": 2022,
            "is_wenli": 1,
            "score": 527,
            "ranking": 23432,
            "num": 600
        },
        {
            "id": 14714,
            "year": 2022,
            "is_wenli": 1,
            "score": 526,
            "ranking": 24075,
            "num": 643
        },
        {
            "id": 14715,
            "year": 2022,
            "is_wenli": 1,
            "score": 525,
            "ranking": 24695,
            "num": 620
        },
        {
            "id": 14716,
            "year": 2022,
            "is_wenli": 1,
            "score": 524,
            "ranking": 25322,
            "num": 627
        },
        {
            "id": 14717,
            "year": 2022,
            "is_wenli": 1,
            "score": 523,
            "ranking": 25960,
            "num": 638
        },
        {
            "id": 14718,
            "year": 2022,
            "is_wenli": 1,
            "score": 522,
            "ranking": 26589,
            "num": 629
        },
        {
            "id": 14719,
            "year": 2022,
            "is_wenli": 1,
            "score": 521,
            "ranking": 27264,
            "num": 675
        },
        {
            "id": 14720,
            "year": 2022,
            "is_wenli": 1,
            "score": 520,
            "ranking": 27943,
            "num": 679
        },
        {
            "id": 14721,
            "year": 2022,
            "is_wenli": 1,
            "score": 519,
            "ranking": 28595,
            "num": 652
        },
        {
            "id": 14722,
            "year": 2022,
            "is_wenli": 1,
            "score": 518,
            "ranking": 29283,
            "num": 688
        },
        {
            "id": 14723,
            "year": 2022,
            "is_wenli": 1,
            "score": 517,
            "ranking": 30019,
            "num": 736
        },
        {
            "id": 14724,
            "year": 2022,
            "is_wenli": 1,
            "score": 516,
            "ranking": 30778,
            "num": 759
        },
        {
            "id": 14725,
            "year": 2022,
            "is_wenli": 1,
            "score": 515,
            "ranking": 31505,
            "num": 727
        },
        {
            "id": 14726,
            "year": 2022,
            "is_wenli": 1,
            "score": 514,
            "ranking": 32268,
            "num": 763
        },
        {
            "id": 14727,
            "year": 2022,
            "is_wenli": 1,
            "score": 513,
            "ranking": 32998,
            "num": 730
        },
        {
            "id": 14728,
            "year": 2022,
            "is_wenli": 1,
            "score": 512,
            "ranking": 33818,
            "num": 820
        },
        {
            "id": 14729,
            "year": 2022,
            "is_wenli": 1,
            "score": 511,
            "ranking": 34631,
            "num": 813
        },
        {
            "id": 14730,
            "year": 2022,
            "is_wenli": 1,
            "score": 510,
            "ranking": 35431,
            "num": 800
        },
        {
            "id": 14731,
            "year": 2022,
            "is_wenli": 1,
            "score": 509,
            "ranking": 36213,
            "num": 782
        },
        {
            "id": 14732,
            "year": 2022,
            "is_wenli": 1,
            "score": 508,
            "ranking": 36969,
            "num": 756
        },
        {
            "id": 14733,
            "year": 2022,
            "is_wenli": 1,
            "score": 507,
            "ranking": 37767,
            "num": 798
        },
        {
            "id": 14734,
            "year": 2022,
            "is_wenli": 1,
            "score": 506,
            "ranking": 38592,
            "num": 825
        },
        {
            "id": 14735,
            "year": 2022,
            "is_wenli": 1,
            "score": 505,
            "ranking": 39414,
            "num": 822
        },
        {
            "id": 14736,
            "year": 2022,
            "is_wenli": 1,
            "score": 504,
            "ranking": 40236,
            "num": 822
        },
        {
            "id": 14737,
            "year": 2022,
            "is_wenli": 1,
            "score": 503,
            "ranking": 41009,
            "num": 773
        },
        {
            "id": 14738,
            "year": 2022,
            "is_wenli": 1,
            "score": 502,
            "ranking": 41865,
            "num": 856
        },
        {
            "id": 14739,
            "year": 2022,
            "is_wenli": 1,
            "score": 501,
            "ranking": 42740,
            "num": 875
        },
        {
            "id": 14740,
            "year": 2022,
            "is_wenli": 1,
            "score": 500,
            "ranking": 43646,
            "num": 906
        },
        {
            "id": 14741,
            "year": 2022,
            "is_wenli": 1,
            "score": 499,
            "ranking": 44536,
            "num": 890
        },
        {
            "id": 14742,
            "year": 2022,
            "is_wenli": 1,
            "score": 498,
            "ranking": 45402,
            "num": 866
        },
        {
            "id": 14743,
            "year": 2022,
            "is_wenli": 1,
            "score": 497,
            "ranking": 46291,
            "num": 889
        },
        {
            "id": 14744,
            "year": 2022,
            "is_wenli": 1,
            "score": 496,
            "ranking": 47205,
            "num": 914
        },
        {
            "id": 14745,
            "year": 2022,
            "is_wenli": 1,
            "score": 495,
            "ranking": 48113,
            "num": 908
        },
        {
            "id": 14746,
            "year": 2022,
            "is_wenli": 1,
            "score": 494,
            "ranking": 48998,
            "num": 885
        },
        {
            "id": 14747,
            "year": 2022,
            "is_wenli": 1,
            "score": 493,
            "ranking": 49917,
            "num": 919
        },
        {
            "id": 14748,
            "year": 2022,
            "is_wenli": 1,
            "score": 492,
            "ranking": 50820,
            "num": 903
        },
        {
            "id": 14749,
            "year": 2022,
            "is_wenli": 1,
            "score": 491,
            "ranking": 51788,
            "num": 968
        },
        {
            "id": 14750,
            "year": 2022,
            "is_wenli": 1,
            "score": 490,
            "ranking": 52692,
            "num": 904
        },
        {
            "id": 14751,
            "year": 2022,
            "is_wenli": 1,
            "score": 489,
            "ranking": 53630,
            "num": 938
        },
        {
            "id": 14752,
            "year": 2022,
            "is_wenli": 1,
            "score": 488,
            "ranking": 54646,
            "num": 1016
        },
        {
            "id": 14753,
            "year": 2022,
            "is_wenli": 1,
            "score": 487,
            "ranking": 55616,
            "num": 970
        },
        {
            "id": 14754,
            "year": 2022,
            "is_wenli": 1,
            "score": 486,
            "ranking": 56565,
            "num": 949
        },
        {
            "id": 14755,
            "year": 2022,
            "is_wenli": 1,
            "score": 485,
            "ranking": 57598,
            "num": 1033
        },
        {
            "id": 14756,
            "year": 2022,
            "is_wenli": 1,
            "score": 484,
            "ranking": 58561,
            "num": 963
        },
        {
            "id": 14757,
            "year": 2022,
            "is_wenli": 1,
            "score": 483,
            "ranking": 59583,
            "num": 1022
        },
        {
            "id": 14758,
            "year": 2022,
            "is_wenli": 1,
            "score": 482,
            "ranking": 60563,
            "num": 980
        },
        {
            "id": 14759,
            "year": 2022,
            "is_wenli": 1,
            "score": 481,
            "ranking": 61568,
            "num": 1005
        },
        {
            "id": 14760,
            "year": 2022,
            "is_wenli": 1,
            "score": 480,
            "ranking": 62599,
            "num": 1031
        },
        {
            "id": 14761,
            "year": 2022,
            "is_wenli": 1,
            "score": 479,
            "ranking": 63579,
            "num": 980
        },
        {
            "id": 14762,
            "year": 2022,
            "is_wenli": 1,
            "score": 478,
            "ranking": 64636,
            "num": 1057
        },
        {
            "id": 14763,
            "year": 2022,
            "is_wenli": 1,
            "score": 477,
            "ranking": 65677,
            "num": 1041
        },
        {
            "id": 14764,
            "year": 2022,
            "is_wenli": 1,
            "score": 476,
            "ranking": 66739,
            "num": 1062
        },
        {
            "id": 14765,
            "year": 2022,
            "is_wenli": 1,
            "score": 475,
            "ranking": 67740,
            "num": 1001
        },
        {
            "id": 14766,
            "year": 2022,
            "is_wenli": 1,
            "score": 474,
            "ranking": 68793,
            "num": 1053
        },
        {
            "id": 14767,
            "year": 2022,
            "is_wenli": 1,
            "score": 473,
            "ranking": 69846,
            "num": 1053
        },
        {
            "id": 14768,
            "year": 2022,
            "is_wenli": 1,
            "score": 472,
            "ranking": 70900,
            "num": 1054
        },
        {
            "id": 14769,
            "year": 2022,
            "is_wenli": 1,
            "score": 471,
            "ranking": 71940,
            "num": 1040
        },
        {
            "id": 14770,
            "year": 2022,
            "is_wenli": 1,
            "score": 470,
            "ranking": 72970,
            "num": 1030
        },
        {
            "id": 14771,
            "year": 2022,
            "is_wenli": 1,
            "score": 469,
            "ranking": 74062,
            "num": 1092
        },
        {
            "id": 14772,
            "year": 2022,
            "is_wenli": 1,
            "score": 468,
            "ranking": 75194,
            "num": 1132
        },
        {
            "id": 14773,
            "year": 2022,
            "is_wenli": 1,
            "score": 467,
            "ranking": 76258,
            "num": 1064
        },
        {
            "id": 14774,
            "year": 2022,
            "is_wenli": 1,
            "score": 466,
            "ranking": 77310,
            "num": 1052
        },
        {
            "id": 14775,
            "year": 2022,
            "is_wenli": 1,
            "score": 465,
            "ranking": 78388,
            "num": 1078
        },
        {
            "id": 14776,
            "year": 2022,
            "is_wenli": 1,
            "score": 464,
            "ranking": 79496,
            "num": 1108
        },
        {
            "id": 14777,
            "year": 2022,
            "is_wenli": 1,
            "score": 463,
            "ranking": 80605,
            "num": 1109
        },
        {
            "id": 14778,
            "year": 2022,
            "is_wenli": 1,
            "score": 462,
            "ranking": 81692,
            "num": 1087
        },
        {
            "id": 14779,
            "year": 2022,
            "is_wenli": 1,
            "score": 461,
            "ranking": 82819,
            "num": 1127
        },
        {
            "id": 14780,
            "year": 2022,
            "is_wenli": 1,
            "score": 460,
            "ranking": 83883,
            "num": 1064
        },
        {
            "id": 14781,
            "year": 2022,
            "is_wenli": 1,
            "score": 459,
            "ranking": 84968,
            "num": 1085
        },
        {
            "id": 14782,
            "year": 2022,
            "is_wenli": 1,
            "score": 458,
            "ranking": 86120,
            "num": 1152
        },
        {
            "id": 14783,
            "year": 2022,
            "is_wenli": 1,
            "score": 457,
            "ranking": 87224,
            "num": 1104
        },
        {
            "id": 14784,
            "year": 2022,
            "is_wenli": 1,
            "score": 456,
            "ranking": 88323,
            "num": 1099
        },
        {
            "id": 14785,
            "year": 2022,
            "is_wenli": 1,
            "score": 455,
            "ranking": 89426,
            "num": 1103
        },
        {
            "id": 14786,
            "year": 2022,
            "is_wenli": 1,
            "score": 454,
            "ranking": 90557,
            "num": 1131
        },
        {
            "id": 14787,
            "year": 2022,
            "is_wenli": 1,
            "score": 453,
            "ranking": 91756,
            "num": 1199
        },
        {
            "id": 14788,
            "year": 2022,
            "is_wenli": 1,
            "score": 452,
            "ranking": 92856,
            "num": 1100
        },
        {
            "id": 14789,
            "year": 2022,
            "is_wenli": 1,
            "score": 451,
            "ranking": 93931,
            "num": 1075
        },
        {
            "id": 14790,
            "year": 2022,
            "is_wenli": 1,
            "score": 450,
            "ranking": 95097,
            "num": 1166
        },
        {
            "id": 14791,
            "year": 2022,
            "is_wenli": 1,
            "score": 449,
            "ranking": 96236,
            "num": 1139
        },
        {
            "id": 14792,
            "year": 2022,
            "is_wenli": 1,
            "score": 448,
            "ranking": 97409,
            "num": 1173
        },
        {
            "id": 14793,
            "year": 2022,
            "is_wenli": 1,
            "score": 447,
            "ranking": 98565,
            "num": 1156
        },
        {
            "id": 14794,
            "year": 2022,
            "is_wenli": 1,
            "score": 446,
            "ranking": 99663,
            "num": 1098
        },
        {
            "id": 14795,
            "year": 2022,
            "is_wenli": 1,
            "score": 445,
            "ranking": 100731,
            "num": 1068
        },
        {
            "id": 14796,
            "year": 2022,
            "is_wenli": 1,
            "score": 444,
            "ranking": 101832,
            "num": 1101
        },
        {
            "id": 14797,
            "year": 2022,
            "is_wenli": 1,
            "score": 443,
            "ranking": 103008,
            "num": 1176
        },
        {
            "id": 14798,
            "year": 2022,
            "is_wenli": 1,
            "score": 442,
            "ranking": 104144,
            "num": 1136
        },
        {
            "id": 14799,
            "year": 2022,
            "is_wenli": 1,
            "score": 441,
            "ranking": 105250,
            "num": 1106
        },
        {
            "id": 14800,
            "year": 2022,
            "is_wenli": 1,
            "score": 440,
            "ranking": 106377,
            "num": 1127
        },
        {
            "id": 14801,
            "year": 2022,
            "is_wenli": 1,
            "score": 439,
            "ranking": 107491,
            "num": 1114
        },
        {
            "id": 14802,
            "year": 2022,
            "is_wenli": 1,
            "score": 438,
            "ranking": 108627,
            "num": 1136
        },
        {
            "id": 14803,
            "year": 2022,
            "is_wenli": 1,
            "score": 437,
            "ranking": 109822,
            "num": 1195
        },
        {
            "id": 14804,
            "year": 2022,
            "is_wenli": 1,
            "score": 436,
            "ranking": 111016,
            "num": 1194
        },
        {
            "id": 14805,
            "year": 2022,
            "is_wenli": 1,
            "score": 435,
            "ranking": 112168,
            "num": 1152
        },
        {
            "id": 14806,
            "year": 2022,
            "is_wenli": 1,
            "score": 434,
            "ranking": 113361,
            "num": 1193
        },
        {
            "id": 14807,
            "year": 2022,
            "is_wenli": 1,
            "score": 433,
            "ranking": 114528,
            "num": 1167
        },
        {
            "id": 14808,
            "year": 2022,
            "is_wenli": 1,
            "score": 432,
            "ranking": 115660,
            "num": 1132
        },
        {
            "id": 14809,
            "year": 2022,
            "is_wenli": 1,
            "score": 431,
            "ranking": 116853,
            "num": 1193
        },
        {
            "id": 14810,
            "year": 2022,
            "is_wenli": 1,
            "score": 430,
            "ranking": 117990,
            "num": 1137
        },
        {
            "id": 14811,
            "year": 2022,
            "is_wenli": 1,
            "score": 429,
            "ranking": 119088,
            "num": 1098
        },
        {
            "id": 14812,
            "year": 2022,
            "is_wenli": 1,
            "score": 428,
            "ranking": 120198,
            "num": 1110
        },
        {
            "id": 14813,
            "year": 2022,
            "is_wenli": 1,
            "score": 427,
            "ranking": 121335,
            "num": 1137
        },
        {
            "id": 14814,
            "year": 2022,
            "is_wenli": 1,
            "score": 426,
            "ranking": 122482,
            "num": 1147
        },
        {
            "id": 14815,
            "year": 2022,
            "is_wenli": 1,
            "score": 425,
            "ranking": 123654,
            "num": 1172
        },
        {
            "id": 14816,
            "year": 2022,
            "is_wenli": 1,
            "score": 424,
            "ranking": 124827,
            "num": 1173
        },
        {
            "id": 14817,
            "year": 2022,
            "is_wenli": 1,
            "score": 423,
            "ranking": 126057,
            "num": 1230
        },
        {
            "id": 14818,
            "year": 2022,
            "is_wenli": 1,
            "score": 422,
            "ranking": 127212,
            "num": 1155
        },
        {
            "id": 14819,
            "year": 2022,
            "is_wenli": 1,
            "score": 421,
            "ranking": 128366,
            "num": 1154
        },
        {
            "id": 14820,
            "year": 2022,
            "is_wenli": 1,
            "score": 420,
            "ranking": 129540,
            "num": 1174
        },
        {
            "id": 14821,
            "year": 2022,
            "is_wenli": 1,
            "score": 419,
            "ranking": 130688,
            "num": 1148
        },
        {
            "id": 14822,
            "year": 2022,
            "is_wenli": 1,
            "score": 418,
            "ranking": 131868,
            "num": 1180
        },
        {
            "id": 14823,
            "year": 2022,
            "is_wenli": 1,
            "score": 417,
            "ranking": 133019,
            "num": 1151
        },
        {
            "id": 14824,
            "year": 2022,
            "is_wenli": 1,
            "score": 416,
            "ranking": 134202,
            "num": 1183
        },
        {
            "id": 14825,
            "year": 2022,
            "is_wenli": 1,
            "score": 415,
            "ranking": 135408,
            "num": 1206
        },
        {
            "id": 14826,
            "year": 2022,
            "is_wenli": 1,
            "score": 414,
            "ranking": 136619,
            "num": 1211
        },
        {
            "id": 14827,
            "year": 2022,
            "is_wenli": 1,
            "score": 413,
            "ranking": 137807,
            "num": 1188
        },
        {
            "id": 14828,
            "year": 2022,
            "is_wenli": 1,
            "score": 412,
            "ranking": 138987,
            "num": 1180
        },
        {
            "id": 14829,
            "year": 2022,
            "is_wenli": 1,
            "score": 411,
            "ranking": 140180,
            "num": 1193
        },
        {
            "id": 14830,
            "year": 2022,
            "is_wenli": 1,
            "score": 410,
            "ranking": 141459,
            "num": 1279
        },
        {
            "id": 14831,
            "year": 2022,
            "is_wenli": 1,
            "score": 409,
            "ranking": 142616,
            "num": 1157
        },
        {
            "id": 14832,
            "year": 2022,
            "is_wenli": 1,
            "score": 408,
            "ranking": 143782,
            "num": 1166
        },
        {
            "id": 14833,
            "year": 2022,
            "is_wenli": 1,
            "score": 407,
            "ranking": 144945,
            "num": 1163
        },
        {
            "id": 14834,
            "year": 2022,
            "is_wenli": 1,
            "score": 406,
            "ranking": 146124,
            "num": 1179
        },
        {
            "id": 14835,
            "year": 2022,
            "is_wenli": 1,
            "score": 405,
            "ranking": 147350,
            "num": 1226
        },
        {
            "id": 14836,
            "year": 2022,
            "is_wenli": 1,
            "score": 404,
            "ranking": 148523,
            "num": 1173
        },
        {
            "id": 14837,
            "year": 2022,
            "is_wenli": 1,
            "score": 403,
            "ranking": 149776,
            "num": 1253
        },
        {
            "id": 14838,
            "year": 2022,
            "is_wenli": 1,
            "score": 402,
            "ranking": 150967,
            "num": 1191
        },
        {
            "id": 14839,
            "year": 2022,
            "is_wenli": 1,
            "score": 401,
            "ranking": 152254,
            "num": 1287
        },
        {
            "id": 14840,
            "year": 2022,
            "is_wenli": 1,
            "score": 400,
            "ranking": 153482,
            "num": 1228
        },
        {
            "id": 14841,
            "year": 2022,
            "is_wenli": 1,
            "score": 399,
            "ranking": 154667,
            "num": 1185
        },
        {
            "id": 14842,
            "year": 2022,
            "is_wenli": 1,
            "score": 398,
            "ranking": 155967,
            "num": 1300
        },
        {
            "id": 14843,
            "year": 2022,
            "is_wenli": 1,
            "score": 397,
            "ranking": 157219,
            "num": 1252
        },
        {
            "id": 14844,
            "year": 2022,
            "is_wenli": 1,
            "score": 396,
            "ranking": 158380,
            "num": 1161
        },
        {
            "id": 14845,
            "year": 2022,
            "is_wenli": 1,
            "score": 395,
            "ranking": 159626,
            "num": 1246
        },
        {
            "id": 14846,
            "year": 2022,
            "is_wenli": 1,
            "score": 394,
            "ranking": 160821,
            "num": 1195
        },
        {
            "id": 14847,
            "year": 2022,
            "is_wenli": 1,
            "score": 393,
            "ranking": 162042,
            "num": 1221
        },
        {
            "id": 14848,
            "year": 2022,
            "is_wenli": 1,
            "score": 392,
            "ranking": 163301,
            "num": 1259
        },
        {
            "id": 14849,
            "year": 2022,
            "is_wenli": 1,
            "score": 391,
            "ranking": 164511,
            "num": 1210
        },
        {
            "id": 14850,
            "year": 2022,
            "is_wenli": 1,
            "score": 390,
            "ranking": 165716,
            "num": 1205
        },
        {
            "id": 14851,
            "year": 2022,
            "is_wenli": 1,
            "score": 389,
            "ranking": 166977,
            "num": 1261
        },
        {
            "id": 14852,
            "year": 2022,
            "is_wenli": 1,
            "score": 388,
            "ranking": 168250,
            "num": 1273
        },
        {
            "id": 14853,
            "year": 2022,
            "is_wenli": 1,
            "score": 387,
            "ranking": 169538,
            "num": 1288
        },
        {
            "id": 14854,
            "year": 2022,
            "is_wenli": 1,
            "score": 386,
            "ranking": 170772,
            "num": 1234
        },
        {
            "id": 14855,
            "year": 2022,
            "is_wenli": 1,
            "score": 385,
            "ranking": 171983,
            "num": 1211
        },
        {
            "id": 14856,
            "year": 2022,
            "is_wenli": 1,
            "score": 384,
            "ranking": 173213,
            "num": 1230
        },
        {
            "id": 14857,
            "year": 2022,
            "is_wenli": 1,
            "score": 383,
            "ranking": 174502,
            "num": 1289
        },
        {
            "id": 14858,
            "year": 2022,
            "is_wenli": 1,
            "score": 382,
            "ranking": 175731,
            "num": 1229
        },
        {
            "id": 14859,
            "year": 2022,
            "is_wenli": 1,
            "score": 381,
            "ranking": 176992,
            "num": 1261
        },
        {
            "id": 14860,
            "year": 2022,
            "is_wenli": 1,
            "score": 380,
            "ranking": 178265,
            "num": 1273
        },
        {
            "id": 14861,
            "year": 2022,
            "is_wenli": 1,
            "score": 379,
            "ranking": 179514,
            "num": 1249
        },
        {
            "id": 14862,
            "year": 2022,
            "is_wenli": 1,
            "score": 378,
            "ranking": 180776,
            "num": 1262
        },
        {
            "id": 14863,
            "year": 2022,
            "is_wenli": 1,
            "score": 377,
            "ranking": 182033,
            "num": 1257
        },
        {
            "id": 14864,
            "year": 2022,
            "is_wenli": 1,
            "score": 376,
            "ranking": 183359,
            "num": 1326
        },
        {
            "id": 14865,
            "year": 2022,
            "is_wenli": 1,
            "score": 375,
            "ranking": 184700,
            "num": 1341
        },
        {
            "id": 14866,
            "year": 2022,
            "is_wenli": 1,
            "score": 374,
            "ranking": 185932,
            "num": 1232
        },
        {
            "id": 14867,
            "year": 2022,
            "is_wenli": 1,
            "score": 373,
            "ranking": 187202,
            "num": 1270
        },
        {
            "id": 14868,
            "year": 2022,
            "is_wenli": 1,
            "score": 372,
            "ranking": 188409,
            "num": 1207
        },
        {
            "id": 14869,
            "year": 2022,
            "is_wenli": 1,
            "score": 371,
            "ranking": 189738,
            "num": 1329
        },
        {
            "id": 14870,
            "year": 2022,
            "is_wenli": 1,
            "score": 370,
            "ranking": 191033,
            "num": 1295
        },
        {
            "id": 14871,
            "year": 2022,
            "is_wenli": 1,
            "score": 369,
            "ranking": 192336,
            "num": 1303
        },
        {
            "id": 14872,
            "year": 2022,
            "is_wenli": 1,
            "score": 368,
            "ranking": 193690,
            "num": 1354
        },
        {
            "id": 14873,
            "year": 2022,
            "is_wenli": 1,
            "score": 367,
            "ranking": 194991,
            "num": 1301
        },
        {
            "id": 14874,
            "year": 2022,
            "is_wenli": 1,
            "score": 366,
            "ranking": 196341,
            "num": 1350
        },
        {
            "id": 14875,
            "year": 2022,
            "is_wenli": 1,
            "score": 365,
            "ranking": 197614,
            "num": 1273
        },
        {
            "id": 14876,
            "year": 2022,
            "is_wenli": 1,
            "score": 364,
            "ranking": 198903,
            "num": 1289
        },
        {
            "id": 14877,
            "year": 2022,
            "is_wenli": 1,
            "score": 363,
            "ranking": 200249,
            "num": 1346
        },
        {
            "id": 14878,
            "year": 2022,
            "is_wenli": 1,
            "score": 362,
            "ranking": 201549,
            "num": 1300
        },
        {
            "id": 14879,
            "year": 2022,
            "is_wenli": 1,
            "score": 361,
            "ranking": 202778,
            "num": 1229
        },
        {
            "id": 14880,
            "year": 2022,
            "is_wenli": 1,
            "score": 360,
            "ranking": 203976,
            "num": 1198
        },
        {
            "id": 14881,
            "year": 2022,
            "is_wenli": 1,
            "score": 359,
            "ranking": 205212,
            "num": 1236
        },
        {
            "id": 14882,
            "year": 2022,
            "is_wenli": 1,
            "score": 358,
            "ranking": 206465,
            "num": 1253
        },
        {
            "id": 14883,
            "year": 2022,
            "is_wenli": 1,
            "score": 357,
            "ranking": 207684,
            "num": 1219
        },
        {
            "id": 14884,
            "year": 2022,
            "is_wenli": 1,
            "score": 356,
            "ranking": 208977,
            "num": 1293
        },
        {
            "id": 14885,
            "year": 2022,
            "is_wenli": 1,
            "score": 355,
            "ranking": 210272,
            "num": 1295
        },
        {
            "id": 14886,
            "year": 2022,
            "is_wenli": 1,
            "score": 354,
            "ranking": 211551,
            "num": 1279
        },
        {
            "id": 14887,
            "year": 2022,
            "is_wenli": 1,
            "score": 353,
            "ranking": 212838,
            "num": 1287
        },
        {
            "id": 14888,
            "year": 2022,
            "is_wenli": 1,
            "score": 352,
            "ranking": 214108,
            "num": 1270
        },
        {
            "id": 14889,
            "year": 2022,
            "is_wenli": 1,
            "score": 351,
            "ranking": 215285,
            "num": 1177
        },
        {
            "id": 14890,
            "year": 2022,
            "is_wenli": 1,
            "score": 350,
            "ranking": 216616,
            "num": 1331
        },
        {
            "id": 14891,
            "year": 2022,
            "is_wenli": 1,
            "score": 349,
            "ranking": 217891,
            "num": 1275
        },
        {
            "id": 14892,
            "year": 2022,
            "is_wenli": 1,
            "score": 348,
            "ranking": 219108,
            "num": 1217
        },
        {
            "id": 14893,
            "year": 2022,
            "is_wenli": 1,
            "score": 347,
            "ranking": 220343,
            "num": 1235
        },
        {
            "id": 14894,
            "year": 2022,
            "is_wenli": 1,
            "score": 346,
            "ranking": 221594,
            "num": 1251
        },
        {
            "id": 14895,
            "year": 2022,
            "is_wenli": 1,
            "score": 345,
            "ranking": 222771,
            "num": 1177
        },
        {
            "id": 14896,
            "year": 2022,
            "is_wenli": 1,
            "score": 344,
            "ranking": 223998,
            "num": 1227
        },
        {
            "id": 14897,
            "year": 2022,
            "is_wenli": 1,
            "score": 343,
            "ranking": 225217,
            "num": 1219
        },
        {
            "id": 14898,
            "year": 2022,
            "is_wenli": 1,
            "score": 342,
            "ranking": 226413,
            "num": 1196
        },
        {
            "id": 14899,
            "year": 2022,
            "is_wenli": 1,
            "score": 341,
            "ranking": 227655,
            "num": 1242
        },
        {
            "id": 14900,
            "year": 2022,
            "is_wenli": 1,
            "score": 340,
            "ranking": 228855,
            "num": 1200
        },
        {
            "id": 14901,
            "year": 2022,
            "is_wenli": 1,
            "score": 339,
            "ranking": 230003,
            "num": 1148
        },
        {
            "id": 14902,
            "year": 2022,
            "is_wenli": 1,
            "score": 338,
            "ranking": 231258,
            "num": 1255
        },
        {
            "id": 14903,
            "year": 2022,
            "is_wenli": 1,
            "score": 337,
            "ranking": 232452,
            "num": 1194
        },
        {
            "id": 14904,
            "year": 2022,
            "is_wenli": 1,
            "score": 336,
            "ranking": 233659,
            "num": 1207
        },
        {
            "id": 14905,
            "year": 2022,
            "is_wenli": 1,
            "score": 335,
            "ranking": 234908,
            "num": 1249
        },
        {
            "id": 14906,
            "year": 2022,
            "is_wenli": 1,
            "score": 334,
            "ranking": 236069,
            "num": 1161
        },
        {
            "id": 14907,
            "year": 2022,
            "is_wenli": 1,
            "score": 333,
            "ranking": 237232,
            "num": 1163
        },
        {
            "id": 14908,
            "year": 2022,
            "is_wenli": 1,
            "score": 332,
            "ranking": 238394,
            "num": 1162
        },
        {
            "id": 14909,
            "year": 2022,
            "is_wenli": 1,
            "score": 331,
            "ranking": 239549,
            "num": 1155
        },
        {
            "id": 14910,
            "year": 2022,
            "is_wenli": 1,
            "score": 330,
            "ranking": 240679,
            "num": 1130
        },
        {
            "id": 14911,
            "year": 2022,
            "is_wenli": 1,
            "score": 329,
            "ranking": 241860,
            "num": 1181
        },
        {
            "id": 14912,
            "year": 2022,
            "is_wenli": 1,
            "score": 328,
            "ranking": 243008,
            "num": 1148
        },
        {
            "id": 14913,
            "year": 2022,
            "is_wenli": 1,
            "score": 327,
            "ranking": 244191,
            "num": 1183
        },
        {
            "id": 14914,
            "year": 2022,
            "is_wenli": 1,
            "score": 326,
            "ranking": 245366,
            "num": 1175
        },
        {
            "id": 14915,
            "year": 2022,
            "is_wenli": 1,
            "score": 325,
            "ranking": 246476,
            "num": 1110
        },
        {
            "id": 14916,
            "year": 2022,
            "is_wenli": 1,
            "score": 324,
            "ranking": 247558,
            "num": 1082
        },
        {
            "id": 14917,
            "year": 2022,
            "is_wenli": 1,
            "score": 323,
            "ranking": 248623,
            "num": 1065
        },
        {
            "id": 14918,
            "year": 2022,
            "is_wenli": 1,
            "score": 322,
            "ranking": 249651,
            "num": 1028
        },
        {
            "id": 14919,
            "year": 2022,
            "is_wenli": 1,
            "score": 321,
            "ranking": 250730,
            "num": 1079
        },
        {
            "id": 14920,
            "year": 2022,
            "is_wenli": 1,
            "score": 320,
            "ranking": 251735,
            "num": 1005
        },
        {
            "id": 14921,
            "year": 2022,
            "is_wenli": 1,
            "score": 319,
            "ranking": 252795,
            "num": 1060
        },
        {
            "id": 14922,
            "year": 2022,
            "is_wenli": 1,
            "score": 318,
            "ranking": 253881,
            "num": 1086
        },
        {
            "id": 14923,
            "year": 2022,
            "is_wenli": 1,
            "score": 317,
            "ranking": 254941,
            "num": 1060
        },
        {
            "id": 14924,
            "year": 2022,
            "is_wenli": 1,
            "score": 316,
            "ranking": 255946,
            "num": 1005
        },
        {
            "id": 14925,
            "year": 2022,
            "is_wenli": 1,
            "score": 315,
            "ranking": 256955,
            "num": 1009
        },
        {
            "id": 14926,
            "year": 2022,
            "is_wenli": 1,
            "score": 314,
            "ranking": 257977,
            "num": 1022
        },
        {
            "id": 14927,
            "year": 2022,
            "is_wenli": 1,
            "score": 313,
            "ranking": 258966,
            "num": 989
        },
        {
            "id": 14928,
            "year": 2022,
            "is_wenli": 1,
            "score": 312,
            "ranking": 259938,
            "num": 972
        },
        {
            "id": 14929,
            "year": 2022,
            "is_wenli": 1,
            "score": 311,
            "ranking": 260906,
            "num": 968
        },
        {
            "id": 14930,
            "year": 2022,
            "is_wenli": 1,
            "score": 310,
            "ranking": 261916,
            "num": 1010
        },
        {
            "id": 14931,
            "year": 2022,
            "is_wenli": 1,
            "score": 309,
            "ranking": 262872,
            "num": 956
        },
        {
            "id": 14932,
            "year": 2022,
            "is_wenli": 1,
            "score": 308,
            "ranking": 263856,
            "num": 984
        },
        {
            "id": 14933,
            "year": 2022,
            "is_wenli": 1,
            "score": 307,
            "ranking": 264800,
            "num": 944
        },
        {
            "id": 14934,
            "year": 2022,
            "is_wenli": 1,
            "score": 306,
            "ranking": 265721,
            "num": 921
        },
        {
            "id": 14935,
            "year": 2022,
            "is_wenli": 1,
            "score": 305,
            "ranking": 266678,
            "num": 957
        },
        {
            "id": 14936,
            "year": 2022,
            "is_wenli": 1,
            "score": 304,
            "ranking": 267637,
            "num": 959
        },
        {
            "id": 14937,
            "year": 2022,
            "is_wenli": 1,
            "score": 303,
            "ranking": 268568,
            "num": 931
        },
        {
            "id": 14938,
            "year": 2022,
            "is_wenli": 1,
            "score": 302,
            "ranking": 269455,
            "num": 887
        },
        {
            "id": 14939,
            "year": 2022,
            "is_wenli": 1,
            "score": 301,
            "ranking": 270308,
            "num": 853
        },
        {
            "id": 14940,
            "year": 2022,
            "is_wenli": 1,
            "score": 300,
            "ranking": 271196,
            "num": 888
        },
        {
            "id": 14941,
            "year": 2022,
            "is_wenli": 1,
            "score": 299,
            "ranking": 272104,
            "num": 908
        },
        {
            "id": 14942,
            "year": 2022,
            "is_wenli": 1,
            "score": 298,
            "ranking": 272996,
            "num": 892
        },
        {
            "id": 14943,
            "year": 2022,
            "is_wenli": 1,
            "score": 297,
            "ranking": 273902,
            "num": 906
        },
        {
            "id": 14944,
            "year": 2022,
            "is_wenli": 1,
            "score": 296,
            "ranking": 274752,
            "num": 850
        },
        {
            "id": 14945,
            "year": 2022,
            "is_wenli": 1,
            "score": 295,
            "ranking": 275590,
            "num": 838
        },
        {
            "id": 14946,
            "year": 2022,
            "is_wenli": 1,
            "score": 294,
            "ranking": 276477,
            "num": 887
        },
        {
            "id": 14947,
            "year": 2022,
            "is_wenli": 1,
            "score": 293,
            "ranking": 277351,
            "num": 874
        },
        {
            "id": 14948,
            "year": 2022,
            "is_wenli": 1,
            "score": 292,
            "ranking": 278159,
            "num": 808
        },
        {
            "id": 14949,
            "year": 2022,
            "is_wenli": 1,
            "score": 291,
            "ranking": 279014,
            "num": 855
        },
        {
            "id": 14950,
            "year": 2022,
            "is_wenli": 1,
            "score": 290,
            "ranking": 279816,
            "num": 802
        },
        {
            "id": 14951,
            "year": 2022,
            "is_wenli": 1,
            "score": 289,
            "ranking": 280646,
            "num": 830
        },
        {
            "id": 14952,
            "year": 2022,
            "is_wenli": 1,
            "score": 288,
            "ranking": 281438,
            "num": 792
        },
        {
            "id": 14953,
            "year": 2022,
            "is_wenli": 1,
            "score": 287,
            "ranking": 282184,
            "num": 746
        },
        {
            "id": 14954,
            "year": 2022,
            "is_wenli": 1,
            "score": 286,
            "ranking": 282971,
            "num": 787
        },
        {
            "id": 14955,
            "year": 2022,
            "is_wenli": 1,
            "score": 285,
            "ranking": 283733,
            "num": 762
        },
        {
            "id": 14956,
            "year": 2022,
            "is_wenli": 1,
            "score": 284,
            "ranking": 284502,
            "num": 769
        },
        {
            "id": 14957,
            "year": 2022,
            "is_wenli": 1,
            "score": 283,
            "ranking": 285208,
            "num": 706
        },
        {
            "id": 14958,
            "year": 2022,
            "is_wenli": 1,
            "score": 282,
            "ranking": 285971,
            "num": 763
        },
        {
            "id": 14959,
            "year": 2022,
            "is_wenli": 1,
            "score": 281,
            "ranking": 286747,
            "num": 776
        },
        {
            "id": 14960,
            "year": 2022,
            "is_wenli": 1,
            "score": 280,
            "ranking": 287461,
            "num": 714
        },
        {
            "id": 14961,
            "year": 2022,
            "is_wenli": 1,
            "score": 279,
            "ranking": 288237,
            "num": 776
        },
        {
            "id": 14962,
            "year": 2022,
            "is_wenli": 1,
            "score": 278,
            "ranking": 288965,
            "num": 728
        },
        {
            "id": 14963,
            "year": 2022,
            "is_wenli": 1,
            "score": 277,
            "ranking": 289663,
            "num": 698
        },
        {
            "id": 14964,
            "year": 2022,
            "is_wenli": 1,
            "score": 276,
            "ranking": 290325,
            "num": 662
        },
        {
            "id": 14965,
            "year": 2022,
            "is_wenli": 1,
            "score": 275,
            "ranking": 291038,
            "num": 713
        },
        {
            "id": 14966,
            "year": 2022,
            "is_wenli": 1,
            "score": 274,
            "ranking": 291736,
            "num": 698
        },
        {
            "id": 14967,
            "year": 2022,
            "is_wenli": 1,
            "score": 273,
            "ranking": 292397,
            "num": 661
        },
        {
            "id": 14968,
            "year": 2022,
            "is_wenli": 1,
            "score": 272,
            "ranking": 293019,
            "num": 622
        },
        {
            "id": 14969,
            "year": 2022,
            "is_wenli": 1,
            "score": 271,
            "ranking": 293664,
            "num": 645
        },
        {
            "id": 14970,
            "year": 2022,
            "is_wenli": 1,
            "score": 270,
            "ranking": 294338,
            "num": 674
        },
        {
            "id": 14971,
            "year": 2022,
            "is_wenli": 1,
            "score": 269,
            "ranking": 295011,
            "num": 673
        },
        {
            "id": 14972,
            "year": 2022,
            "is_wenli": 1,
            "score": 268,
            "ranking": 295644,
            "num": 633
        },
        {
            "id": 14973,
            "year": 2022,
            "is_wenli": 1,
            "score": 267,
            "ranking": 296286,
            "num": 642
        },
        {
            "id": 14974,
            "year": 2022,
            "is_wenli": 1,
            "score": 266,
            "ranking": 296917,
            "num": 631
        },
        {
            "id": 14975,
            "year": 2022,
            "is_wenli": 1,
            "score": 265,
            "ranking": 297529,
            "num": 612
        },
        {
            "id": 14976,
            "year": 2022,
            "is_wenli": 1,
            "score": 264,
            "ranking": 298130,
            "num": 601
        },
        {
            "id": 14977,
            "year": 2022,
            "is_wenli": 1,
            "score": 263,
            "ranking": 298750,
            "num": 620
        },
        {
            "id": 14978,
            "year": 2022,
            "is_wenli": 1,
            "score": 262,
            "ranking": 299366,
            "num": 616
        },
        {
            "id": 14979,
            "year": 2022,
            "is_wenli": 1,
            "score": 261,
            "ranking": 299962,
            "num": 596
        },
        {
            "id": 14980,
            "year": 2022,
            "is_wenli": 1,
            "score": 260,
            "ranking": 300485,
            "num": 523
        },
        {
            "id": 14981,
            "year": 2022,
            "is_wenli": 1,
            "score": 259,
            "ranking": 301039,
            "num": 554
        },
        {
            "id": 14982,
            "year": 2022,
            "is_wenli": 1,
            "score": 258,
            "ranking": 301602,
            "num": 563
        },
        {
            "id": 14983,
            "year": 2022,
            "is_wenli": 1,
            "score": 257,
            "ranking": 302142,
            "num": 540
        },
        {
            "id": 14984,
            "year": 2022,
            "is_wenli": 1,
            "score": 256,
            "ranking": 302727,
            "num": 585
        },
        {
            "id": 14985,
            "year": 2022,
            "is_wenli": 1,
            "score": 255,
            "ranking": 303277,
            "num": 550
        },
        {
            "id": 14986,
            "year": 2022,
            "is_wenli": 1,
            "score": 254,
            "ranking": 303807,
            "num": 530
        },
        {
            "id": 14987,
            "year": 2022,
            "is_wenli": 1,
            "score": 253,
            "ranking": 304335,
            "num": 528
        },
        {
            "id": 14988,
            "year": 2022,
            "is_wenli": 1,
            "score": 252,
            "ranking": 304888,
            "num": 553
        },
        {
            "id": 14989,
            "year": 2022,
            "is_wenli": 1,
            "score": 251,
            "ranking": 305420,
            "num": 532
        },
        {
            "id": 14990,
            "year": 2022,
            "is_wenli": 1,
            "score": 250,
            "ranking": 305941,
            "num": 521
        },
        {
            "id": 14991,
            "year": 2022,
            "is_wenli": 1,
            "score": 249,
            "ranking": 306433,
            "num": 492
        },
        {
            "id": 14992,
            "year": 2022,
            "is_wenli": 1,
            "score": 248,
            "ranking": 306948,
            "num": 515
        },
        {
            "id": 14993,
            "year": 2022,
            "is_wenli": 1,
            "score": 247,
            "ranking": 307431,
            "num": 483
        },
        {
            "id": 14994,
            "year": 2022,
            "is_wenli": 1,
            "score": 246,
            "ranking": 307941,
            "num": 510
        },
        {
            "id": 14995,
            "year": 2022,
            "is_wenli": 1,
            "score": 245,
            "ranking": 308427,
            "num": 486
        },
        {
            "id": 14996,
            "year": 2022,
            "is_wenli": 1,
            "score": 244,
            "ranking": 308909,
            "num": 482
        },
        {
            "id": 14997,
            "year": 2022,
            "is_wenli": 1,
            "score": 243,
            "ranking": 309326,
            "num": 417
        },
        {
            "id": 14998,
            "year": 2022,
            "is_wenli": 1,
            "score": 242,
            "ranking": 309785,
            "num": 459
        },
        {
            "id": 14999,
            "year": 2022,
            "is_wenli": 1,
            "score": 241,
            "ranking": 310258,
            "num": 473
        },
        {
            "id": 15000,
            "year": 2022,
            "is_wenli": 1,
            "score": 240,
            "ranking": 310704,
            "num": 446
        },
        {
            "id": 15001,
            "year": 2022,
            "is_wenli": 1,
            "score": 239,
            "ranking": 311141,
            "num": 437
        },
        {
            "id": 15002,
            "year": 2022,
            "is_wenli": 1,
            "score": 238,
            "ranking": 311580,
            "num": 439
        },
        {
            "id": 15003,
            "year": 2022,
            "is_wenli": 1,
            "score": 237,
            "ranking": 311993,
            "num": 413
        },
        {
            "id": 15004,
            "year": 2022,
            "is_wenli": 1,
            "score": 236,
            "ranking": 312390,
            "num": 397
        },
        {
            "id": 15005,
            "year": 2022,
            "is_wenli": 1,
            "score": 235,
            "ranking": 312809,
            "num": 419
        },
        {
            "id": 15006,
            "year": 2022,
            "is_wenli": 1,
            "score": 234,
            "ranking": 313230,
            "num": 421
        },
        {
            "id": 15007,
            "year": 2022,
            "is_wenli": 1,
            "score": 233,
            "ranking": 313623,
            "num": 393
        },
        {
            "id": 15008,
            "year": 2022,
            "is_wenli": 1,
            "score": 232,
            "ranking": 314023,
            "num": 400
        },
        {
            "id": 15009,
            "year": 2022,
            "is_wenli": 1,
            "score": 231,
            "ranking": 314420,
            "num": 397
        },
        {
            "id": 15010,
            "year": 2022,
            "is_wenli": 1,
            "score": 230,
            "ranking": 314788,
            "num": 368
        },
        {
            "id": 15011,
            "year": 2022,
            "is_wenli": 1,
            "score": 229,
            "ranking": 315163,
            "num": 375
        },
        {
            "id": 15012,
            "year": 2022,
            "is_wenli": 1,
            "score": 228,
            "ranking": 315547,
            "num": 384
        },
        {
            "id": 15013,
            "year": 2022,
            "is_wenli": 1,
            "score": 227,
            "ranking": 315901,
            "num": 354
        },
        {
            "id": 15014,
            "year": 2022,
            "is_wenli": 1,
            "score": 226,
            "ranking": 316258,
            "num": 357
        },
        {
            "id": 15015,
            "year": 2022,
            "is_wenli": 1,
            "score": 225,
            "ranking": 316574,
            "num": 316
        },
        {
            "id": 15016,
            "year": 2022,
            "is_wenli": 1,
            "score": 224,
            "ranking": 316954,
            "num": 380
        },
        {
            "id": 15017,
            "year": 2022,
            "is_wenli": 1,
            "score": 223,
            "ranking": 317282,
            "num": 328
        },
        {
            "id": 15018,
            "year": 2022,
            "is_wenli": 1,
            "score": 222,
            "ranking": 317649,
            "num": 367
        },
        {
            "id": 15019,
            "year": 2022,
            "is_wenli": 1,
            "score": 221,
            "ranking": 317995,
            "num": 346
        },
        {
            "id": 15020,
            "year": 2022,
            "is_wenli": 1,
            "score": 220,
            "ranking": 318301,
            "num": 306
        },
        {
            "id": 15021,
            "year": 2022,
            "is_wenli": 1,
            "score": 219,
            "ranking": 318639,
            "num": 338
        },
        {
            "id": 15022,
            "year": 2022,
            "is_wenli": 1,
            "score": 218,
            "ranking": 318986,
            "num": 347
        },
        {
            "id": 15023,
            "year": 2022,
            "is_wenli": 1,
            "score": 217,
            "ranking": 319306,
            "num": 320
        },
        {
            "id": 15024,
            "year": 2022,
            "is_wenli": 1,
            "score": 216,
            "ranking": 319617,
            "num": 311
        },
        {
            "id": 15025,
            "year": 2022,
            "is_wenli": 1,
            "score": 215,
            "ranking": 319881,
            "num": 264
        },
        {
            "id": 15026,
            "year": 2022,
            "is_wenli": 1,
            "score": 214,
            "ranking": 320163,
            "num": 282
        },
        {
            "id": 15027,
            "year": 2022,
            "is_wenli": 1,
            "score": 213,
            "ranking": 320454,
            "num": 291
        },
        {
            "id": 15028,
            "year": 2022,
            "is_wenli": 1,
            "score": 212,
            "ranking": 320744,
            "num": 290
        },
        {
            "id": 15029,
            "year": 2022,
            "is_wenli": 1,
            "score": 211,
            "ranking": 321053,
            "num": 309
        },
        {
            "id": 15030,
            "year": 2022,
            "is_wenli": 1,
            "score": 210,
            "ranking": 321356,
            "num": 303
        },
        {
            "id": 15031,
            "year": 2022,
            "is_wenli": 1,
            "score": 209,
            "ranking": 321611,
            "num": 255
        },
        {
            "id": 15032,
            "year": 2022,
            "is_wenli": 1,
            "score": 208,
            "ranking": 321867,
            "num": 256
        },
        {
            "id": 15033,
            "year": 2022,
            "is_wenli": 1,
            "score": 207,
            "ranking": 322146,
            "num": 279
        },
        {
            "id": 15034,
            "year": 2022,
            "is_wenli": 1,
            "score": 206,
            "ranking": 322397,
            "num": 251
        },
        {
            "id": 15035,
            "year": 2022,
            "is_wenli": 1,
            "score": 205,
            "ranking": 322647,
            "num": 250
        },
        {
            "id": 15036,
            "year": 2022,
            "is_wenli": 1,
            "score": 204,
            "ranking": 322900,
            "num": 253
        },
        {
            "id": 15037,
            "year": 2022,
            "is_wenli": 1,
            "score": 203,
            "ranking": 323151,
            "num": 251
        },
        {
            "id": 15038,
            "year": 2022,
            "is_wenli": 1,
            "score": 202,
            "ranking": 323382,
            "num": 231
        },
        {
            "id": 15039,
            "year": 2022,
            "is_wenli": 1,
            "score": 201,
            "ranking": 323633,
            "num": 251
        },
        {
            "id": 15040,
            "year": 2022,
            "is_wenli": 1,
            "score": 200,
            "ranking": 323854,
            "num": 221
        },
        {
            "id": 15041,
            "year": 2022,
            "is_wenli": 1,
            "score": 199,
            "ranking": 324109,
            "num": 255
        },
        {
            "id": 15042,
            "year": 2022,
            "is_wenli": 1,
            "score": 198,
            "ranking": 324323,
            "num": 214
        },
        {
            "id": 15043,
            "year": 2022,
            "is_wenli": 1,
            "score": 197,
            "ranking": 324543,
            "num": 220
        },
        {
            "id": 15044,
            "year": 2022,
            "is_wenli": 1,
            "score": 196,
            "ranking": 324775,
            "num": 232
        },
        {
            "id": 15045,
            "year": 2022,
            "is_wenli": 1,
            "score": 195,
            "ranking": 324979,
            "num": 204
        },
        {
            "id": 15046,
            "year": 2022,
            "is_wenli": 1,
            "score": 194,
            "ranking": 325188,
            "num": 209
        },
        {
            "id": 15047,
            "year": 2022,
            "is_wenli": 1,
            "score": 193,
            "ranking": 325398,
            "num": 210
        },
        {
            "id": 15048,
            "year": 2022,
            "is_wenli": 1,
            "score": 192,
            "ranking": 325611,
            "num": 213
        },
        {
            "id": 15049,
            "year": 2022,
            "is_wenli": 1,
            "score": 191,
            "ranking": 325829,
            "num": 218
        },
        {
            "id": 15050,
            "year": 2022,
            "is_wenli": 1,
            "score": 190,
            "ranking": 326041,
            "num": 212
        },
        {
            "id": 15051,
            "year": 2022,
            "is_wenli": 1,
            "score": 189,
            "ranking": 326238,
            "num": 197
        },
        {
            "id": 15052,
            "year": 2022,
            "is_wenli": 1,
            "score": 188,
            "ranking": 326427,
            "num": 189
        },
        {
            "id": 15053,
            "year": 2022,
            "is_wenli": 1,
            "score": 187,
            "ranking": 326622,
            "num": 195
        },
        {
            "id": 15054,
            "year": 2022,
            "is_wenli": 1,
            "score": 186,
            "ranking": 326788,
            "num": 166
        },
        {
            "id": 15055,
            "year": 2022,
            "is_wenli": 1,
            "score": 185,
            "ranking": 326976,
            "num": 188
        },
        {
            "id": 15056,
            "year": 2022,
            "is_wenli": 1,
            "score": 184,
            "ranking": 327151,
            "num": 175
        },
        {
            "id": 15057,
            "year": 2022,
            "is_wenli": 1,
            "score": 183,
            "ranking": 327332,
            "num": 181
        },
        {
            "id": 15058,
            "year": 2022,
            "is_wenli": 1,
            "score": 182,
            "ranking": 327493,
            "num": 161
        },
        {
            "id": 15059,
            "year": 2022,
            "is_wenli": 1,
            "score": 181,
            "ranking": 327668,
            "num": 175
        },
        {
            "id": 15060,
            "year": 2022,
            "is_wenli": 1,
            "score": 180,
            "ranking": 327813,
            "num": 145
        },
        {
            "id": 15061,
            "year": 2022,
            "is_wenli": 1,
            "score": 179,
            "ranking": 327981,
            "num": 168
        },
        {
            "id": 15062,
            "year": 2022,
            "is_wenli": 1,
            "score": 178,
            "ranking": 328139,
            "num": 158
        },
        {
            "id": 15063,
            "year": 2022,
            "is_wenli": 1,
            "score": 177,
            "ranking": 328305,
            "num": 166
        },
        {
            "id": 15064,
            "year": 2022,
            "is_wenli": 1,
            "score": 176,
            "ranking": 328471,
            "num": 166
        },
        {
            "id": 15065,
            "year": 2022,
            "is_wenli": 1,
            "score": 175,
            "ranking": 328628,
            "num": 157
        },
        {
            "id": 15066,
            "year": 2022,
            "is_wenli": 1,
            "score": 174,
            "ranking": 328776,
            "num": 148
        },
        {
            "id": 15067,
            "year": 2022,
            "is_wenli": 1,
            "score": 173,
            "ranking": 328910,
            "num": 134
        },
        {
            "id": 15068,
            "year": 2022,
            "is_wenli": 1,
            "score": 172,
            "ranking": 329036,
            "num": 126
        },
        {
            "id": 15069,
            "year": 2022,
            "is_wenli": 1,
            "score": 171,
            "ranking": 329154,
            "num": 118
        },
        {
            "id": 15070,
            "year": 2022,
            "is_wenli": 1,
            "score": 170,
            "ranking": 329295,
            "num": 141
        },
        {
            "id": 15071,
            "year": 2022,
            "is_wenli": 1,
            "score": 169,
            "ranking": 329431,
            "num": 136
        },
        {
            "id": 15072,
            "year": 2022,
            "is_wenli": 1,
            "score": 168,
            "ranking": 329529,
            "num": 98
        },
        {
            "id": 15073,
            "year": 2022,
            "is_wenli": 1,
            "score": 167,
            "ranking": 329644,
            "num": 115
        },
        {
            "id": 15074,
            "year": 2022,
            "is_wenli": 1,
            "score": 166,
            "ranking": 329761,
            "num": 117
        },
        {
            "id": 15075,
            "year": 2022,
            "is_wenli": 1,
            "score": 165,
            "ranking": 329902,
            "num": 141
        },
        {
            "id": 15076,
            "year": 2022,
            "is_wenli": 1,
            "score": 164,
            "ranking": 330019,
            "num": 117
        },
        {
            "id": 15077,
            "year": 2022,
            "is_wenli": 1,
            "score": 163,
            "ranking": 330112,
            "num": 93
        },
        {
            "id": 15078,
            "year": 2022,
            "is_wenli": 1,
            "score": 162,
            "ranking": 330217,
            "num": 105
        },
        {
            "id": 15079,
            "year": 2022,
            "is_wenli": 1,
            "score": 161,
            "ranking": 330333,
            "num": 116
        },
        {
            "id": 15080,
            "year": 2022,
            "is_wenli": 1,
            "score": 160,
            "ranking": 330442,
            "num": 109
        },
        {
            "id": 15081,
            "year": 2022,
            "is_wenli": 1,
            "score": 159,
            "ranking": 330562,
            "num": 120
        },
        {
            "id": 15082,
            "year": 2022,
            "is_wenli": 1,
            "score": 158,
            "ranking": 330645,
            "num": 83
        },
        {
            "id": 15083,
            "year": 2022,
            "is_wenli": 1,
            "score": 157,
            "ranking": 330734,
            "num": 89
        },
        {
            "id": 15084,
            "year": 2022,
            "is_wenli": 1,
            "score": 156,
            "ranking": 330808,
            "num": 74
        },
        {
            "id": 15085,
            "year": 2022,
            "is_wenli": 1,
            "score": 155,
            "ranking": 330886,
            "num": 78
        },
        {
            "id": 15086,
            "year": 2022,
            "is_wenli": 1,
            "score": 154,
            "ranking": 330947,
            "num": 61
        },
        {
            "id": 15087,
            "year": 2022,
            "is_wenli": 1,
            "score": 153,
            "ranking": 331021,
            "num": 74
        },
        {
            "id": 15088,
            "year": 2022,
            "is_wenli": 1,
            "score": 152,
            "ranking": 331096,
            "num": 75
        },
        {
            "id": 15089,
            "year": 2022,
            "is_wenli": 1,
            "score": 151,
            "ranking": 331148,
            "num": 52
        },
        {
            "id": 15090,
            "year": 2022,
            "is_wenli": 1,
            "score": 150,
            "ranking": 331226,
            "num": 78
        },
        {
            "id": 15091,
            "year": 2022,
            "is_wenli": 1,
            "score": 149,
            "ranking": 331297,
            "num": 71
        },
        {
            "id": 15092,
            "year": 2022,
            "is_wenli": 1,
            "score": 148,
            "ranking": 331361,
            "num": 64
        },
        {
            "id": 15093,
            "year": 2022,
            "is_wenli": 1,
            "score": 147,
            "ranking": 331416,
            "num": 55
        },
        {
            "id": 15094,
            "year": 2022,
            "is_wenli": 1,
            "score": 146,
            "ranking": 331482,
            "num": 66
        },
        {
            "id": 15095,
            "year": 2022,
            "is_wenli": 1,
            "score": 145,
            "ranking": 331531,
            "num": 49
        },
        {
            "id": 15096,
            "year": 2022,
            "is_wenli": 1,
            "score": 144,
            "ranking": 331593,
            "num": 62
        },
        {
            "id": 15097,
            "year": 2022,
            "is_wenli": 1,
            "score": 143,
            "ranking": 331655,
            "num": 62
        },
        {
            "id": 15098,
            "year": 2022,
            "is_wenli": 1,
            "score": 142,
            "ranking": 331712,
            "num": 57
        },
        {
            "id": 15099,
            "year": 2022,
            "is_wenli": 1,
            "score": 141,
            "ranking": 331754,
            "num": 42
        },
        {
            "id": 15100,
            "year": 2022,
            "is_wenli": 1,
            "score": 140,
            "ranking": 331796,
            "num": 42
        },
        {
            "id": 15101,
            "year": 2022,
            "is_wenli": 1,
            "score": 139,
            "ranking": 331843,
            "num": 47
        },
        {
            "id": 15102,
            "year": 2022,
            "is_wenli": 1,
            "score": 138,
            "ranking": 331892,
            "num": 49
        },
        {
            "id": 15103,
            "year": 2022,
            "is_wenli": 1,
            "score": 137,
            "ranking": 331932,
            "num": 40
        },
        {
            "id": 15104,
            "year": 2022,
            "is_wenli": 1,
            "score": 136,
            "ranking": 331981,
            "num": 49
        },
        {
            "id": 15105,
            "year": 2022,
            "is_wenli": 1,
            "score": 135,
            "ranking": 332025,
            "num": 44
        },
        {
            "id": 15106,
            "year": 2022,
            "is_wenli": 1,
            "score": 134,
            "ranking": 332072,
            "num": 47
        },
        {
            "id": 15107,
            "year": 2022,
            "is_wenli": 1,
            "score": 133,
            "ranking": 332108,
            "num": 36
        },
        {
            "id": 15108,
            "year": 2022,
            "is_wenli": 1,
            "score": 132,
            "ranking": 332141,
            "num": 33
        },
        {
            "id": 15109,
            "year": 2022,
            "is_wenli": 1,
            "score": 131,
            "ranking": 332175,
            "num": 34
        },
        {
            "id": 15110,
            "year": 2022,
            "is_wenli": 1,
            "score": 130,
            "ranking": 332206,
            "num": 31
        },
        {
            "id": 15111,
            "year": 2022,
            "is_wenli": 1,
            "score": 129,
            "ranking": 332239,
            "num": 33
        },
        {
            "id": 15112,
            "year": 2022,
            "is_wenli": 1,
            "score": 128,
            "ranking": 332281,
            "num": 42
        },
        {
            "id": 15113,
            "year": 2022,
            "is_wenli": 1,
            "score": 127,
            "ranking": 332313,
            "num": 32
        },
        {
            "id": 15114,
            "year": 2022,
            "is_wenli": 1,
            "score": 126,
            "ranking": 332346,
            "num": 33
        },
        {
            "id": 15115,
            "year": 2022,
            "is_wenli": 1,
            "score": 125,
            "ranking": 332365,
            "num": 19
        },
        {
            "id": 15116,
            "year": 2022,
            "is_wenli": 1,
            "score": 124,
            "ranking": 332389,
            "num": 24
        },
        {
            "id": 15117,
            "year": 2022,
            "is_wenli": 1,
            "score": 123,
            "ranking": 332416,
            "num": 27
        },
        {
            "id": 15118,
            "year": 2022,
            "is_wenli": 1,
            "score": 122,
            "ranking": 332442,
            "num": 26
        },
        {
            "id": 15119,
            "year": 2022,
            "is_wenli": 1,
            "score": 121,
            "ranking": 332467,
            "num": 25
        },
        {
            "id": 15120,
            "year": 2022,
            "is_wenli": 1,
            "score": 120,
            "ranking": 332492,
            "num": 25
        },
        {
            "id": 15121,
            "year": 2022,
            "is_wenli": 1,
            "score": 119,
            "ranking": 332511,
            "num": 19
        },
        {
            "id": 15122,
            "year": 2022,
            "is_wenli": 1,
            "score": 118,
            "ranking": 332524,
            "num": 13
        },
        {
            "id": 15123,
            "year": 2022,
            "is_wenli": 1,
            "score": 117,
            "ranking": 332542,
            "num": 18
        },
        {
            "id": 15124,
            "year": 2022,
            "is_wenli": 1,
            "score": 116,
            "ranking": 332558,
            "num": 16
        },
        {
            "id": 15125,
            "year": 2022,
            "is_wenli": 1,
            "score": 115,
            "ranking": 332583,
            "num": 25
        },
        {
            "id": 15126,
            "year": 2022,
            "is_wenli": 1,
            "score": 114,
            "ranking": 332609,
            "num": 26
        },
        {
            "id": 15127,
            "year": 2022,
            "is_wenli": 1,
            "score": 113,
            "ranking": 332628,
            "num": 19
        },
        {
            "id": 15128,
            "year": 2022,
            "is_wenli": 1,
            "score": 112,
            "ranking": 332642,
            "num": 14
        },
        {
            "id": 15129,
            "year": 2022,
            "is_wenli": 1,
            "score": 111,
            "ranking": 332658,
            "num": 16
        },
        {
            "id": 15130,
            "year": 2022,
            "is_wenli": 1,
            "score": 110,
            "ranking": 332678,
            "num": 20
        },
        {
            "id": 15131,
            "year": 2022,
            "is_wenli": 1,
            "score": 109,
            "ranking": 332693,
            "num": 15
        },
        {
            "id": 15132,
            "year": 2022,
            "is_wenli": 1,
            "score": 108,
            "ranking": 332712,
            "num": 19
        },
        {
            "id": 15133,
            "year": 2022,
            "is_wenli": 1,
            "score": 107,
            "ranking": 332724,
            "num": 12
        },
        {
            "id": 15134,
            "year": 2022,
            "is_wenli": 1,
            "score": 106,
            "ranking": 332740,
            "num": 16
        },
        {
            "id": 15135,
            "year": 2022,
            "is_wenli": 1,
            "score": 105,
            "ranking": 332759,
            "num": 19
        },
        {
            "id": 15136,
            "year": 2022,
            "is_wenli": 1,
            "score": 104,
            "ranking": 332774,
            "num": 15
        },
        {
            "id": 15137,
            "year": 2022,
            "is_wenli": 1,
            "score": 103,
            "ranking": 332783,
            "num": 9
        },
        {
            "id": 15138,
            "year": 2022,
            "is_wenli": 1,
            "score": 102,
            "ranking": 332796,
            "num": 13
        },
        {
            "id": 15139,
            "year": 2022,
            "is_wenli": 1,
            "score": 101,
            "ranking": 332813,
            "num": 17
        },
        {
            "id": 15140,
            "year": 2022,
            "is_wenli": 1,
            "score": 100,
            "ranking": 332823,
            "num": 10
        }
    ],
    2021: [
        {
            "id": 4539,
            "score": 675,
            "ranking": 10,
            "is_wenli": 1,
            "year": 2021,
            "num": 10
        },
        {
            "id": 4540,
            "score": 674,
            "ranking": 15,
            "is_wenli": 1,
            "year": 2021,
            "num": 5
        },
        {
            "id": 4541,
            "score": 673,
            "ranking": 16,
            "is_wenli": 1,
            "year": 2021,
            "num": 1
        },
        {
            "id": 4542,
            "score": 672,
            "ranking": 22,
            "is_wenli": 1,
            "year": 2021,
            "num": 6
        },
        {
            "id": 4543,
            "score": 671,
            "ranking": 26,
            "is_wenli": 1,
            "year": 2021,
            "num": 4
        },
        {
            "id": 4544,
            "score": 670,
            "ranking": 38,
            "is_wenli": 1,
            "year": 2021,
            "num": 12
        },
        {
            "id": 4545,
            "score": 669,
            "ranking": 52,
            "is_wenli": 1,
            "year": 2021,
            "num": 14
        },
        {
            "id": 4546,
            "score": 668,
            "ranking": 63,
            "is_wenli": 1,
            "year": 2021,
            "num": 11
        },
        {
            "id": 4547,
            "score": 667,
            "ranking": 70,
            "is_wenli": 1,
            "year": 2021,
            "num": 7
        },
        {
            "id": 4548,
            "score": 666,
            "ranking": 80,
            "is_wenli": 1,
            "year": 2021,
            "num": 10
        },
        {
            "id": 4549,
            "score": 665,
            "ranking": 90,
            "is_wenli": 1,
            "year": 2021,
            "num": 10
        },
        {
            "id": 4550,
            "score": 664,
            "ranking": 96,
            "is_wenli": 1,
            "year": 2021,
            "num": 6
        },
        {
            "id": 4551,
            "score": 663,
            "ranking": 108,
            "is_wenli": 1,
            "year": 2021,
            "num": 12
        },
        {
            "id": 4552,
            "score": 662,
            "ranking": 121,
            "is_wenli": 1,
            "year": 2021,
            "num": 13
        },
        {
            "id": 4553,
            "score": 661,
            "ranking": 138,
            "is_wenli": 1,
            "year": 2021,
            "num": 17
        },
        {
            "id": 4554,
            "score": 660,
            "ranking": 151,
            "is_wenli": 1,
            "year": 2021,
            "num": 13
        },
        {
            "id": 4555,
            "score": 659,
            "ranking": 174,
            "is_wenli": 1,
            "year": 2021,
            "num": 23
        },
        {
            "id": 4556,
            "score": 658,
            "ranking": 190,
            "is_wenli": 1,
            "year": 2021,
            "num": 16
        },
        {
            "id": 4557,
            "score": 657,
            "ranking": 209,
            "is_wenli": 1,
            "year": 2021,
            "num": 19
        },
        {
            "id": 4558,
            "score": 656,
            "ranking": 233,
            "is_wenli": 1,
            "year": 2021,
            "num": 24
        },
        {
            "id": 4559,
            "score": 655,
            "ranking": 251,
            "is_wenli": 1,
            "year": 2021,
            "num": 18
        },
        {
            "id": 4560,
            "score": 654,
            "ranking": 275,
            "is_wenli": 1,
            "year": 2021,
            "num": 24
        },
        {
            "id": 4561,
            "score": 653,
            "ranking": 300,
            "is_wenli": 1,
            "year": 2021,
            "num": 25
        },
        {
            "id": 4562,
            "score": 652,
            "ranking": 328,
            "is_wenli": 1,
            "year": 2021,
            "num": 28
        },
        {
            "id": 4563,
            "score": 651,
            "ranking": 354,
            "is_wenli": 1,
            "year": 2021,
            "num": 26
        },
        {
            "id": 4564,
            "score": 650,
            "ranking": 383,
            "is_wenli": 1,
            "year": 2021,
            "num": 29
        },
        {
            "id": 4565,
            "score": 649,
            "ranking": 422,
            "is_wenli": 1,
            "year": 2021,
            "num": 39
        },
        {
            "id": 4566,
            "score": 648,
            "ranking": 454,
            "is_wenli": 1,
            "year": 2021,
            "num": 32
        },
        {
            "id": 4567,
            "score": 647,
            "ranking": 507,
            "is_wenli": 1,
            "year": 2021,
            "num": 53
        },
        {
            "id": 4568,
            "score": 646,
            "ranking": 561,
            "is_wenli": 1,
            "year": 2021,
            "num": 54
        },
        {
            "id": 4569,
            "score": 645,
            "ranking": 617,
            "is_wenli": 1,
            "year": 2021,
            "num": 56
        },
        {
            "id": 4570,
            "score": 644,
            "ranking": 667,
            "is_wenli": 1,
            "year": 2021,
            "num": 50
        },
        {
            "id": 4571,
            "score": 643,
            "ranking": 720,
            "is_wenli": 1,
            "year": 2021,
            "num": 53
        },
        {
            "id": 4572,
            "score": 642,
            "ranking": 785,
            "is_wenli": 1,
            "year": 2021,
            "num": 65
        },
        {
            "id": 4573,
            "score": 641,
            "ranking": 840,
            "is_wenli": 1,
            "year": 2021,
            "num": 55
        },
        {
            "id": 4574,
            "score": 640,
            "ranking": 896,
            "is_wenli": 1,
            "year": 2021,
            "num": 56
        },
        {
            "id": 4575,
            "score": 639,
            "ranking": 966,
            "is_wenli": 1,
            "year": 2021,
            "num": 70
        },
        {
            "id": 4576,
            "score": 638,
            "ranking": 1031,
            "is_wenli": 1,
            "year": 2021,
            "num": 65
        },
        {
            "id": 4577,
            "score": 637,
            "ranking": 1109,
            "is_wenli": 1,
            "year": 2021,
            "num": 78
        },
        {
            "id": 4578,
            "score": 636,
            "ranking": 1195,
            "is_wenli": 1,
            "year": 2021,
            "num": 86
        },
        {
            "id": 4579,
            "score": 635,
            "ranking": 1273,
            "is_wenli": 1,
            "year": 2021,
            "num": 78
        },
        {
            "id": 4580,
            "score": 634,
            "ranking": 1351,
            "is_wenli": 1,
            "year": 2021,
            "num": 78
        },
        {
            "id": 4581,
            "score": 633,
            "ranking": 1425,
            "is_wenli": 1,
            "year": 2021,
            "num": 74
        },
        {
            "id": 4582,
            "score": 632,
            "ranking": 1511,
            "is_wenli": 1,
            "year": 2021,
            "num": 86
        },
        {
            "id": 4583,
            "score": 631,
            "ranking": 1610,
            "is_wenli": 1,
            "year": 2021,
            "num": 99
        },
        {
            "id": 4584,
            "score": 630,
            "ranking": 1708,
            "is_wenli": 1,
            "year": 2021,
            "num": 98
        },
        {
            "id": 4585,
            "score": 629,
            "ranking": 1802,
            "is_wenli": 1,
            "year": 2021,
            "num": 94
        },
        {
            "id": 4586,
            "score": 628,
            "ranking": 1917,
            "is_wenli": 1,
            "year": 2021,
            "num": 115
        },
        {
            "id": 4587,
            "score": 627,
            "ranking": 2026,
            "is_wenli": 1,
            "year": 2021,
            "num": 109
        },
        {
            "id": 4588,
            "score": 626,
            "ranking": 2133,
            "is_wenli": 1,
            "year": 2021,
            "num": 107
        },
        {
            "id": 4589,
            "score": 625,
            "ranking": 2250,
            "is_wenli": 1,
            "year": 2021,
            "num": 117
        },
        {
            "id": 4590,
            "score": 624,
            "ranking": 2380,
            "is_wenli": 1,
            "year": 2021,
            "num": 130
        },
        {
            "id": 4591,
            "score": 623,
            "ranking": 2519,
            "is_wenli": 1,
            "year": 2021,
            "num": 139
        },
        {
            "id": 4592,
            "score": 622,
            "ranking": 2650,
            "is_wenli": 1,
            "year": 2021,
            "num": 131
        },
        {
            "id": 4593,
            "score": 621,
            "ranking": 2798,
            "is_wenli": 1,
            "year": 2021,
            "num": 148
        },
        {
            "id": 4594,
            "score": 620,
            "ranking": 2955,
            "is_wenli": 1,
            "year": 2021,
            "num": 157
        },
        {
            "id": 4595,
            "score": 619,
            "ranking": 3125,
            "is_wenli": 1,
            "year": 2021,
            "num": 170
        },
        {
            "id": 4596,
            "score": 618,
            "ranking": 3294,
            "is_wenli": 1,
            "year": 2021,
            "num": 169
        },
        {
            "id": 4597,
            "score": 617,
            "ranking": 3477,
            "is_wenli": 1,
            "year": 2021,
            "num": 183
        },
        {
            "id": 4598,
            "score": 616,
            "ranking": 3636,
            "is_wenli": 1,
            "year": 2021,
            "num": 159
        },
        {
            "id": 4599,
            "score": 615,
            "ranking": 3798,
            "is_wenli": 1,
            "year": 2021,
            "num": 162
        },
        {
            "id": 4600,
            "score": 614,
            "ranking": 3948,
            "is_wenli": 1,
            "year": 2021,
            "num": 150
        },
        {
            "id": 4601,
            "score": 613,
            "ranking": 4108,
            "is_wenli": 1,
            "year": 2021,
            "num": 160
        },
        {
            "id": 4602,
            "score": 612,
            "ranking": 4295,
            "is_wenli": 1,
            "year": 2021,
            "num": 187
        },
        {
            "id": 4603,
            "score": 611,
            "ranking": 4474,
            "is_wenli": 1,
            "year": 2021,
            "num": 179
        },
        {
            "id": 4604,
            "score": 610,
            "ranking": 4672,
            "is_wenli": 1,
            "year": 2021,
            "num": 198
        },
        {
            "id": 4605,
            "score": 609,
            "ranking": 4834,
            "is_wenli": 1,
            "year": 2021,
            "num": 162
        },
        {
            "id": 4606,
            "score": 608,
            "ranking": 5050,
            "is_wenli": 1,
            "year": 2021,
            "num": 216
        },
        {
            "id": 4607,
            "score": 607,
            "ranking": 5241,
            "is_wenli": 1,
            "year": 2021,
            "num": 191
        },
        {
            "id": 4608,
            "score": 606,
            "ranking": 5444,
            "is_wenli": 1,
            "year": 2021,
            "num": 203
        },
        {
            "id": 4609,
            "score": 605,
            "ranking": 5658,
            "is_wenli": 1,
            "year": 2021,
            "num": 214
        },
        {
            "id": 4610,
            "score": 604,
            "ranking": 5874,
            "is_wenli": 1,
            "year": 2021,
            "num": 216
        },
        {
            "id": 4611,
            "score": 603,
            "ranking": 6107,
            "is_wenli": 1,
            "year": 2021,
            "num": 233
        },
        {
            "id": 4612,
            "score": 602,
            "ranking": 6319,
            "is_wenli": 1,
            "year": 2021,
            "num": 212
        },
        {
            "id": 4613,
            "score": 601,
            "ranking": 6544,
            "is_wenli": 1,
            "year": 2021,
            "num": 225
        },
        {
            "id": 4614,
            "score": 600,
            "ranking": 6776,
            "is_wenli": 1,
            "year": 2021,
            "num": 232
        },
        {
            "id": 4615,
            "score": 599,
            "ranking": 7011,
            "is_wenli": 1,
            "year": 2021,
            "num": 235
        },
        {
            "id": 4616,
            "score": 598,
            "ranking": 7239,
            "is_wenli": 1,
            "year": 2021,
            "num": 228
        },
        {
            "id": 4617,
            "score": 597,
            "ranking": 7506,
            "is_wenli": 1,
            "year": 2021,
            "num": 267
        },
        {
            "id": 4618,
            "score": 596,
            "ranking": 7782,
            "is_wenli": 1,
            "year": 2021,
            "num": 276
        },
        {
            "id": 4619,
            "score": 595,
            "ranking": 8043,
            "is_wenli": 1,
            "year": 2021,
            "num": 261
        },
        {
            "id": 4620,
            "score": 594,
            "ranking": 8313,
            "is_wenli": 1,
            "year": 2021,
            "num": 270
        },
        {
            "id": 4621,
            "score": 593,
            "ranking": 8604,
            "is_wenli": 1,
            "year": 2021,
            "num": 291
        },
        {
            "id": 4622,
            "score": 592,
            "ranking": 8893,
            "is_wenli": 1,
            "year": 2021,
            "num": 289
        },
        {
            "id": 4623,
            "score": 591,
            "ranking": 9192,
            "is_wenli": 1,
            "year": 2021,
            "num": 299
        },
        {
            "id": 4624,
            "score": 590,
            "ranking": 9516,
            "is_wenli": 1,
            "year": 2021,
            "num": 324
        },
        {
            "id": 4625,
            "score": 589,
            "ranking": 9839,
            "is_wenli": 1,
            "year": 2021,
            "num": 323
        },
        {
            "id": 4626,
            "score": 588,
            "ranking": 10158,
            "is_wenli": 1,
            "year": 2021,
            "num": 319
        },
        {
            "id": 4627,
            "score": 587,
            "ranking": 10498,
            "is_wenli": 1,
            "year": 2021,
            "num": 340
        },
        {
            "id": 4628,
            "score": 586,
            "ranking": 10825,
            "is_wenli": 1,
            "year": 2021,
            "num": 327
        },
        {
            "id": 4629,
            "score": 585,
            "ranking": 11165,
            "is_wenli": 1,
            "year": 2021,
            "num": 340
        },
        {
            "id": 4630,
            "score": 584,
            "ranking": 11502,
            "is_wenli": 1,
            "year": 2021,
            "num": 337
        },
        {
            "id": 4631,
            "score": 583,
            "ranking": 11833,
            "is_wenli": 1,
            "year": 2021,
            "num": 331
        },
        {
            "id": 4632,
            "score": 582,
            "ranking": 12151,
            "is_wenli": 1,
            "year": 2021,
            "num": 318
        },
        {
            "id": 4633,
            "score": 581,
            "ranking": 12520,
            "is_wenli": 1,
            "year": 2021,
            "num": 369
        },
        {
            "id": 4634,
            "score": 580,
            "ranking": 12890,
            "is_wenli": 1,
            "year": 2021,
            "num": 370
        },
        {
            "id": 4635,
            "score": 579,
            "ranking": 13277,
            "is_wenli": 1,
            "year": 2021,
            "num": 387
        },
        {
            "id": 4636,
            "score": 578,
            "ranking": 13628,
            "is_wenli": 1,
            "year": 2021,
            "num": 351
        },
        {
            "id": 4637,
            "score": 577,
            "ranking": 14016,
            "is_wenli": 1,
            "year": 2021,
            "num": 388
        },
        {
            "id": 4638,
            "score": 576,
            "ranking": 14388,
            "is_wenli": 1,
            "year": 2021,
            "num": 372
        },
        {
            "id": 4639,
            "score": 575,
            "ranking": 14815,
            "is_wenli": 1,
            "year": 2021,
            "num": 427
        },
        {
            "id": 4640,
            "score": 574,
            "ranking": 15227,
            "is_wenli": 1,
            "year": 2021,
            "num": 412
        },
        {
            "id": 4641,
            "score": 573,
            "ranking": 15646,
            "is_wenli": 1,
            "year": 2021,
            "num": 419
        },
        {
            "id": 4642,
            "score": 572,
            "ranking": 16090,
            "is_wenli": 1,
            "year": 2021,
            "num": 444
        },
        {
            "id": 4643,
            "score": 571,
            "ranking": 16517,
            "is_wenli": 1,
            "year": 2021,
            "num": 427
        },
        {
            "id": 4644,
            "score": 570,
            "ranking": 17000,
            "is_wenli": 1,
            "year": 2021,
            "num": 483
        },
        {
            "id": 4645,
            "score": 569,
            "ranking": 17492,
            "is_wenli": 1,
            "year": 2021,
            "num": 492
        },
        {
            "id": 4646,
            "score": 568,
            "ranking": 17951,
            "is_wenli": 1,
            "year": 2021,
            "num": 459
        },
        {
            "id": 4647,
            "score": 567,
            "ranking": 18414,
            "is_wenli": 1,
            "year": 2021,
            "num": 463
        },
        {
            "id": 4648,
            "score": 566,
            "ranking": 18908,
            "is_wenli": 1,
            "year": 2021,
            "num": 494
        },
        {
            "id": 4649,
            "score": 565,
            "ranking": 19410,
            "is_wenli": 1,
            "year": 2021,
            "num": 502
        },
        {
            "id": 4650,
            "score": 564,
            "ranking": 19891,
            "is_wenli": 1,
            "year": 2021,
            "num": 481
        },
        {
            "id": 4651,
            "score": 563,
            "ranking": 20389,
            "is_wenli": 1,
            "year": 2021,
            "num": 498
        },
        {
            "id": 4652,
            "score": 562,
            "ranking": 20879,
            "is_wenli": 1,
            "year": 2021,
            "num": 490
        },
        {
            "id": 4653,
            "score": 561,
            "ranking": 21385,
            "is_wenli": 1,
            "year": 2021,
            "num": 506
        },
        {
            "id": 4654,
            "score": 560,
            "ranking": 21943,
            "is_wenli": 1,
            "year": 2021,
            "num": 558
        },
        {
            "id": 4655,
            "score": 559,
            "ranking": 22467,
            "is_wenli": 1,
            "year": 2021,
            "num": 524
        },
        {
            "id": 4656,
            "score": 558,
            "ranking": 22987,
            "is_wenli": 1,
            "year": 2021,
            "num": 520
        },
        {
            "id": 4657,
            "score": 557,
            "ranking": 23563,
            "is_wenli": 1,
            "year": 2021,
            "num": 576
        },
        {
            "id": 4658,
            "score": 556,
            "ranking": 24136,
            "is_wenli": 1,
            "year": 2021,
            "num": 573
        },
        {
            "id": 4659,
            "score": 555,
            "ranking": 24689,
            "is_wenli": 1,
            "year": 2021,
            "num": 553
        },
        {
            "id": 4660,
            "score": 554,
            "ranking": 25301,
            "is_wenli": 1,
            "year": 2021,
            "num": 612
        },
        {
            "id": 4661,
            "score": 553,
            "ranking": 25867,
            "is_wenli": 1,
            "year": 2021,
            "num": 566
        },
        {
            "id": 4662,
            "score": 552,
            "ranking": 26451,
            "is_wenli": 1,
            "year": 2021,
            "num": 584
        },
        {
            "id": 4663,
            "score": 551,
            "ranking": 27046,
            "is_wenli": 1,
            "year": 2021,
            "num": 595
        },
        {
            "id": 4664,
            "score": 550,
            "ranking": 27622,
            "is_wenli": 1,
            "year": 2021,
            "num": 576
        },
        {
            "id": 4665,
            "score": 549,
            "ranking": 28244,
            "is_wenli": 1,
            "year": 2021,
            "num": 622
        },
        {
            "id": 4666,
            "score": 548,
            "ranking": 28836,
            "is_wenli": 1,
            "year": 2021,
            "num": 592
        },
        {
            "id": 4667,
            "score": 547,
            "ranking": 29417,
            "is_wenli": 1,
            "year": 2021,
            "num": 581
        },
        {
            "id": 4668,
            "score": 546,
            "ranking": 30047,
            "is_wenli": 1,
            "year": 2021,
            "num": 630
        },
        {
            "id": 4669,
            "score": 545,
            "ranking": 30649,
            "is_wenli": 1,
            "year": 2021,
            "num": 602
        },
        {
            "id": 4670,
            "score": 544,
            "ranking": 31286,
            "is_wenli": 1,
            "year": 2021,
            "num": 637
        },
        {
            "id": 4671,
            "score": 543,
            "ranking": 31926,
            "is_wenli": 1,
            "year": 2021,
            "num": 640
        },
        {
            "id": 4672,
            "score": 542,
            "ranking": 32574,
            "is_wenli": 1,
            "year": 2021,
            "num": 648
        },
        {
            "id": 4673,
            "score": 541,
            "ranking": 33219,
            "is_wenli": 1,
            "year": 2021,
            "num": 645
        },
        {
            "id": 4674,
            "score": 540,
            "ranking": 33915,
            "is_wenli": 1,
            "year": 2021,
            "num": 696
        },
        {
            "id": 4675,
            "score": 539,
            "ranking": 34627,
            "is_wenli": 1,
            "year": 2021,
            "num": 712
        },
        {
            "id": 4676,
            "score": 538,
            "ranking": 35289,
            "is_wenli": 1,
            "year": 2021,
            "num": 662
        },
        {
            "id": 4677,
            "score": 537,
            "ranking": 36000,
            "is_wenli": 1,
            "year": 2021,
            "num": 711
        },
        {
            "id": 4678,
            "score": 536,
            "ranking": 36701,
            "is_wenli": 1,
            "year": 2021,
            "num": 701
        },
        {
            "id": 4679,
            "score": 535,
            "ranking": 37377,
            "is_wenli": 1,
            "year": 2021,
            "num": 676
        },
        {
            "id": 4680,
            "score": 534,
            "ranking": 38026,
            "is_wenli": 1,
            "year": 2021,
            "num": 649
        },
        {
            "id": 4681,
            "score": 533,
            "ranking": 38698,
            "is_wenli": 1,
            "year": 2021,
            "num": 672
        },
        {
            "id": 4682,
            "score": 532,
            "ranking": 39426,
            "is_wenli": 1,
            "year": 2021,
            "num": 728
        },
        {
            "id": 4683,
            "score": 531,
            "ranking": 40157,
            "is_wenli": 1,
            "year": 2021,
            "num": 731
        },
        {
            "id": 4684,
            "score": 530,
            "ranking": 40857,
            "is_wenli": 1,
            "year": 2021,
            "num": 700
        },
        {
            "id": 4685,
            "score": 529,
            "ranking": 41562,
            "is_wenli": 1,
            "year": 2021,
            "num": 705
        },
        {
            "id": 4686,
            "score": 528,
            "ranking": 42273,
            "is_wenli": 1,
            "year": 2021,
            "num": 711
        },
        {
            "id": 4687,
            "score": 527,
            "ranking": 43003,
            "is_wenli": 1,
            "year": 2021,
            "num": 730
        },
        {
            "id": 4688,
            "score": 526,
            "ranking": 43777,
            "is_wenli": 1,
            "year": 2021,
            "num": 774
        },
        {
            "id": 4689,
            "score": 525,
            "ranking": 44512,
            "is_wenli": 1,
            "year": 2021,
            "num": 735
        },
        {
            "id": 4690,
            "score": 524,
            "ranking": 45291,
            "is_wenli": 1,
            "year": 2021,
            "num": 779
        },
        {
            "id": 4691,
            "score": 523,
            "ranking": 46101,
            "is_wenli": 1,
            "year": 2021,
            "num": 810
        },
        {
            "id": 4692,
            "score": 522,
            "ranking": 46841,
            "is_wenli": 1,
            "year": 2021,
            "num": 740
        },
        {
            "id": 4693,
            "score": 521,
            "ranking": 47608,
            "is_wenli": 1,
            "year": 2021,
            "num": 767
        },
        {
            "id": 4694,
            "score": 520,
            "ranking": 48420,
            "is_wenli": 1,
            "year": 2021,
            "num": 812
        },
        {
            "id": 4695,
            "score": 519,
            "ranking": 49184,
            "is_wenli": 1,
            "year": 2021,
            "num": 764
        },
        {
            "id": 4696,
            "score": 518,
            "ranking": 49952,
            "is_wenli": 1,
            "year": 2021,
            "num": 768
        },
        {
            "id": 4697,
            "score": 517,
            "ranking": 50796,
            "is_wenli": 1,
            "year": 2021,
            "num": 844
        },
        {
            "id": 4698,
            "score": 516,
            "ranking": 51641,
            "is_wenli": 1,
            "year": 2021,
            "num": 845
        },
        {
            "id": 4699,
            "score": 515,
            "ranking": 52443,
            "is_wenli": 1,
            "year": 2021,
            "num": 802
        },
        {
            "id": 4700,
            "score": 514,
            "ranking": 53242,
            "is_wenli": 1,
            "year": 2021,
            "num": 799
        },
        {
            "id": 4701,
            "score": 513,
            "ranking": 54068,
            "is_wenli": 1,
            "year": 2021,
            "num": 826
        },
        {
            "id": 4702,
            "score": 512,
            "ranking": 54859,
            "is_wenli": 1,
            "year": 2021,
            "num": 791
        },
        {
            "id": 4703,
            "score": 511,
            "ranking": 55670,
            "is_wenli": 1,
            "year": 2021,
            "num": 811
        },
        {
            "id": 4704,
            "score": 510,
            "ranking": 56491,
            "is_wenli": 1,
            "year": 2021,
            "num": 821
        },
        {
            "id": 4705,
            "score": 509,
            "ranking": 57325,
            "is_wenli": 1,
            "year": 2021,
            "num": 834
        },
        {
            "id": 4706,
            "score": 508,
            "ranking": 58200,
            "is_wenli": 1,
            "year": 2021,
            "num": 875
        },
        {
            "id": 4707,
            "score": 507,
            "ranking": 59025,
            "is_wenli": 1,
            "year": 2021,
            "num": 825
        },
        {
            "id": 4708,
            "score": 506,
            "ranking": 59906,
            "is_wenli": 1,
            "year": 2021,
            "num": 881
        },
        {
            "id": 4709,
            "score": 505,
            "ranking": 60750,
            "is_wenli": 1,
            "year": 2021,
            "num": 844
        },
        {
            "id": 4710,
            "score": 504,
            "ranking": 61580,
            "is_wenli": 1,
            "year": 2021,
            "num": 830
        },
        {
            "id": 4711,
            "score": 503,
            "ranking": 62413,
            "is_wenli": 1,
            "year": 2021,
            "num": 833
        },
        {
            "id": 4712,
            "score": 502,
            "ranking": 63254,
            "is_wenli": 1,
            "year": 2021,
            "num": 841
        },
        {
            "id": 4713,
            "score": 501,
            "ranking": 64100,
            "is_wenli": 1,
            "year": 2021,
            "num": 846
        },
        {
            "id": 4714,
            "score": 500,
            "ranking": 64927,
            "is_wenli": 1,
            "year": 2021,
            "num": 827
        },
        {
            "id": 4715,
            "score": 499,
            "ranking": 65834,
            "is_wenli": 1,
            "year": 2021,
            "num": 907
        },
        {
            "id": 4716,
            "score": 498,
            "ranking": 66708,
            "is_wenli": 1,
            "year": 2021,
            "num": 874
        },
        {
            "id": 4717,
            "score": 497,
            "ranking": 67589,
            "is_wenli": 1,
            "year": 2021,
            "num": 881
        },
        {
            "id": 4718,
            "score": 496,
            "ranking": 68472,
            "is_wenli": 1,
            "year": 2021,
            "num": 883
        },
        {
            "id": 4719,
            "score": 495,
            "ranking": 69370,
            "is_wenli": 1,
            "year": 2021,
            "num": 898
        },
        {
            "id": 4720,
            "score": 494,
            "ranking": 70291,
            "is_wenli": 1,
            "year": 2021,
            "num": 921
        },
        {
            "id": 4721,
            "score": 493,
            "ranking": 71190,
            "is_wenli": 1,
            "year": 2021,
            "num": 899
        },
        {
            "id": 4722,
            "score": 492,
            "ranking": 72125,
            "is_wenli": 1,
            "year": 2021,
            "num": 935
        },
        {
            "id": 4723,
            "score": 491,
            "ranking": 73024,
            "is_wenli": 1,
            "year": 2021,
            "num": 899
        },
        {
            "id": 4724,
            "score": 490,
            "ranking": 73919,
            "is_wenli": 1,
            "year": 2021,
            "num": 895
        },
        {
            "id": 4725,
            "score": 489,
            "ranking": 74794,
            "is_wenli": 1,
            "year": 2021,
            "num": 875
        },
        {
            "id": 4726,
            "score": 488,
            "ranking": 75691,
            "is_wenli": 1,
            "year": 2021,
            "num": 897
        },
        {
            "id": 4727,
            "score": 487,
            "ranking": 76616,
            "is_wenli": 1,
            "year": 2021,
            "num": 925
        },
        {
            "id": 4728,
            "score": 486,
            "ranking": 77519,
            "is_wenli": 1,
            "year": 2021,
            "num": 903
        },
        {
            "id": 4729,
            "score": 485,
            "ranking": 78405,
            "is_wenli": 1,
            "year": 2021,
            "num": 886
        },
        {
            "id": 4730,
            "score": 484,
            "ranking": 79316,
            "is_wenli": 1,
            "year": 2021,
            "num": 911
        },
        {
            "id": 4731,
            "score": 483,
            "ranking": 80250,
            "is_wenli": 1,
            "year": 2021,
            "num": 934
        },
        {
            "id": 4732,
            "score": 482,
            "ranking": 81132,
            "is_wenli": 1,
            "year": 2021,
            "num": 882
        },
        {
            "id": 4733,
            "score": 481,
            "ranking": 82022,
            "is_wenli": 1,
            "year": 2021,
            "num": 890
        },
        {
            "id": 4734,
            "score": 480,
            "ranking": 82978,
            "is_wenli": 1,
            "year": 2021,
            "num": 956
        },
        {
            "id": 4735,
            "score": 479,
            "ranking": 83858,
            "is_wenli": 1,
            "year": 2021,
            "num": 880
        },
        {
            "id": 4736,
            "score": 478,
            "ranking": 84787,
            "is_wenli": 1,
            "year": 2021,
            "num": 929
        },
        {
            "id": 4737,
            "score": 477,
            "ranking": 85681,
            "is_wenli": 1,
            "year": 2021,
            "num": 894
        },
        {
            "id": 4738,
            "score": 476,
            "ranking": 86581,
            "is_wenli": 1,
            "year": 2021,
            "num": 900
        },
        {
            "id": 4739,
            "score": 475,
            "ranking": 87514,
            "is_wenli": 1,
            "year": 2021,
            "num": 933
        },
        {
            "id": 4740,
            "score": 474,
            "ranking": 88448,
            "is_wenli": 1,
            "year": 2021,
            "num": 934
        },
        {
            "id": 4741,
            "score": 473,
            "ranking": 89423,
            "is_wenli": 1,
            "year": 2021,
            "num": 975
        },
        {
            "id": 4742,
            "score": 472,
            "ranking": 90400,
            "is_wenli": 1,
            "year": 2021,
            "num": 977
        },
        {
            "id": 4743,
            "score": 471,
            "ranking": 91379,
            "is_wenli": 1,
            "year": 2021,
            "num": 979
        },
        {
            "id": 4744,
            "score": 470,
            "ranking": 92392,
            "is_wenli": 1,
            "year": 2021,
            "num": 1013
        },
        {
            "id": 4745,
            "score": 469,
            "ranking": 93316,
            "is_wenli": 1,
            "year": 2021,
            "num": 924
        },
        {
            "id": 4746,
            "score": 468,
            "ranking": 94296,
            "is_wenli": 1,
            "year": 2021,
            "num": 980
        },
        {
            "id": 4747,
            "score": 467,
            "ranking": 95210,
            "is_wenli": 1,
            "year": 2021,
            "num": 914
        },
        {
            "id": 4748,
            "score": 466,
            "ranking": 96112,
            "is_wenli": 1,
            "year": 2021,
            "num": 902
        },
        {
            "id": 4749,
            "score": 465,
            "ranking": 97046,
            "is_wenli": 1,
            "year": 2021,
            "num": 934
        },
        {
            "id": 4750,
            "score": 464,
            "ranking": 97930,
            "is_wenli": 1,
            "year": 2021,
            "num": 884
        },
        {
            "id": 4751,
            "score": 463,
            "ranking": 98832,
            "is_wenli": 1,
            "year": 2021,
            "num": 902
        },
        {
            "id": 4752,
            "score": 462,
            "ranking": 99769,
            "is_wenli": 1,
            "year": 2021,
            "num": 937
        },
        {
            "id": 4753,
            "score": 461,
            "ranking": 100660,
            "is_wenli": 1,
            "year": 2021,
            "num": 891
        },
        {
            "id": 4754,
            "score": 460,
            "ranking": 101621,
            "is_wenli": 1,
            "year": 2021,
            "num": 961
        },
        {
            "id": 4755,
            "score": 459,
            "ranking": 102514,
            "is_wenli": 1,
            "year": 2021,
            "num": 893
        },
        {
            "id": 4756,
            "score": 458,
            "ranking": 103446,
            "is_wenli": 1,
            "year": 2021,
            "num": 932
        },
        {
            "id": 4757,
            "score": 457,
            "ranking": 104383,
            "is_wenli": 1,
            "year": 2021,
            "num": 937
        },
        {
            "id": 4758,
            "score": 456,
            "ranking": 105269,
            "is_wenli": 1,
            "year": 2021,
            "num": 886
        },
        {
            "id": 4759,
            "score": 455,
            "ranking": 106136,
            "is_wenli": 1,
            "year": 2021,
            "num": 867
        },
        {
            "id": 4760,
            "score": 454,
            "ranking": 107024,
            "is_wenli": 1,
            "year": 2021,
            "num": 888
        },
        {
            "id": 4761,
            "score": 453,
            "ranking": 107929,
            "is_wenli": 1,
            "year": 2021,
            "num": 905
        },
        {
            "id": 4762,
            "score": 452,
            "ranking": 108809,
            "is_wenli": 1,
            "year": 2021,
            "num": 880
        },
        {
            "id": 4763,
            "score": 451,
            "ranking": 109654,
            "is_wenli": 1,
            "year": 2021,
            "num": 845
        },
        {
            "id": 4764,
            "score": 450,
            "ranking": 110592,
            "is_wenli": 1,
            "year": 2021,
            "num": 938
        },
        {
            "id": 4765,
            "score": 449,
            "ranking": 111572,
            "is_wenli": 1,
            "year": 2021,
            "num": 980
        },
        {
            "id": 4766,
            "score": 448,
            "ranking": 112491,
            "is_wenli": 1,
            "year": 2021,
            "num": 919
        },
        {
            "id": 4767,
            "score": 447,
            "ranking": 113468,
            "is_wenli": 1,
            "year": 2021,
            "num": 977
        },
        {
            "id": 4768,
            "score": 446,
            "ranking": 114404,
            "is_wenli": 1,
            "year": 2021,
            "num": 936
        },
        {
            "id": 4769,
            "score": 445,
            "ranking": 115305,
            "is_wenli": 1,
            "year": 2021,
            "num": 901
        },
        {
            "id": 4770,
            "score": 444,
            "ranking": 116212,
            "is_wenli": 1,
            "year": 2021,
            "num": 907
        },
        {
            "id": 4771,
            "score": 443,
            "ranking": 117106,
            "is_wenli": 1,
            "year": 2021,
            "num": 894
        },
        {
            "id": 4772,
            "score": 442,
            "ranking": 118040,
            "is_wenli": 1,
            "year": 2021,
            "num": 934
        },
        {
            "id": 4773,
            "score": 441,
            "ranking": 118982,
            "is_wenli": 1,
            "year": 2021,
            "num": 942
        },
        {
            "id": 4774,
            "score": 440,
            "ranking": 119888,
            "is_wenli": 1,
            "year": 2021,
            "num": 906
        },
        {
            "id": 4775,
            "score": 439,
            "ranking": 120864,
            "is_wenli": 1,
            "year": 2021,
            "num": 976
        },
        {
            "id": 4776,
            "score": 438,
            "ranking": 121825,
            "is_wenli": 1,
            "year": 2021,
            "num": 961
        },
        {
            "id": 4777,
            "score": 437,
            "ranking": 122730,
            "is_wenli": 1,
            "year": 2021,
            "num": 905
        },
        {
            "id": 4778,
            "score": 436,
            "ranking": 123710,
            "is_wenli": 1,
            "year": 2021,
            "num": 980
        },
        {
            "id": 4779,
            "score": 435,
            "ranking": 124587,
            "is_wenli": 1,
            "year": 2021,
            "num": 877
        },
        {
            "id": 4780,
            "score": 434,
            "ranking": 125544,
            "is_wenli": 1,
            "year": 2021,
            "num": 957
        },
        {
            "id": 4781,
            "score": 433,
            "ranking": 126501,
            "is_wenli": 1,
            "year": 2021,
            "num": 957
        },
        {
            "id": 4782,
            "score": 432,
            "ranking": 127458,
            "is_wenli": 1,
            "year": 2021,
            "num": 957
        },
        {
            "id": 4783,
            "score": 431,
            "ranking": 128325,
            "is_wenli": 1,
            "year": 2021,
            "num": 867
        },
        {
            "id": 4784,
            "score": 430,
            "ranking": 129277,
            "is_wenli": 1,
            "year": 2021,
            "num": 952
        },
        {
            "id": 4785,
            "score": 429,
            "ranking": 130194,
            "is_wenli": 1,
            "year": 2021,
            "num": 917
        },
        {
            "id": 4786,
            "score": 428,
            "ranking": 131113,
            "is_wenli": 1,
            "year": 2021,
            "num": 919
        },
        {
            "id": 4787,
            "score": 427,
            "ranking": 132034,
            "is_wenli": 1,
            "year": 2021,
            "num": 921
        },
        {
            "id": 4788,
            "score": 426,
            "ranking": 132982,
            "is_wenli": 1,
            "year": 2021,
            "num": 948
        },
        {
            "id": 4789,
            "score": 425,
            "ranking": 133879,
            "is_wenli": 1,
            "year": 2021,
            "num": 897
        },
        {
            "id": 4790,
            "score": 424,
            "ranking": 134824,
            "is_wenli": 1,
            "year": 2021,
            "num": 945
        },
        {
            "id": 4791,
            "score": 423,
            "ranking": 135755,
            "is_wenli": 1,
            "year": 2021,
            "num": 931
        },
        {
            "id": 4792,
            "score": 422,
            "ranking": 136731,
            "is_wenli": 1,
            "year": 2021,
            "num": 976
        },
        {
            "id": 4793,
            "score": 421,
            "ranking": 137727,
            "is_wenli": 1,
            "year": 2021,
            "num": 996
        },
        {
            "id": 4794,
            "score": 420,
            "ranking": 138600,
            "is_wenli": 1,
            "year": 2021,
            "num": 873
        },
        {
            "id": 4795,
            "score": 419,
            "ranking": 139565,
            "is_wenli": 1,
            "year": 2021,
            "num": 965
        },
        {
            "id": 4796,
            "score": 418,
            "ranking": 140519,
            "is_wenli": 1,
            "year": 2021,
            "num": 954
        },
        {
            "id": 4797,
            "score": 417,
            "ranking": 141441,
            "is_wenli": 1,
            "year": 2021,
            "num": 922
        },
        {
            "id": 4798,
            "score": 416,
            "ranking": 142453,
            "is_wenli": 1,
            "year": 2021,
            "num": 1012
        },
        {
            "id": 4799,
            "score": 415,
            "ranking": 143362,
            "is_wenli": 1,
            "year": 2021,
            "num": 909
        },
        {
            "id": 4800,
            "score": 414,
            "ranking": 144294,
            "is_wenli": 1,
            "year": 2021,
            "num": 932
        },
        {
            "id": 4801,
            "score": 413,
            "ranking": 145244,
            "is_wenli": 1,
            "year": 2021,
            "num": 950
        },
        {
            "id": 4802,
            "score": 412,
            "ranking": 146199,
            "is_wenli": 1,
            "year": 2021,
            "num": 955
        },
        {
            "id": 4803,
            "score": 411,
            "ranking": 147175,
            "is_wenli": 1,
            "year": 2021,
            "num": 976
        },
        {
            "id": 4804,
            "score": 410,
            "ranking": 148109,
            "is_wenli": 1,
            "year": 2021,
            "num": 934
        },
        {
            "id": 4805,
            "score": 409,
            "ranking": 149040,
            "is_wenli": 1,
            "year": 2021,
            "num": 931
        },
        {
            "id": 4806,
            "score": 408,
            "ranking": 149994,
            "is_wenli": 1,
            "year": 2021,
            "num": 954
        },
        {
            "id": 4807,
            "score": 407,
            "ranking": 150941,
            "is_wenli": 1,
            "year": 2021,
            "num": 947
        },
        {
            "id": 4808,
            "score": 406,
            "ranking": 151882,
            "is_wenli": 1,
            "year": 2021,
            "num": 941
        },
        {
            "id": 4809,
            "score": 405,
            "ranking": 152895,
            "is_wenli": 1,
            "year": 2021,
            "num": 1013
        },
        {
            "id": 4810,
            "score": 404,
            "ranking": 153847,
            "is_wenli": 1,
            "year": 2021,
            "num": 952
        },
        {
            "id": 4811,
            "score": 403,
            "ranking": 154810,
            "is_wenli": 1,
            "year": 2021,
            "num": 963
        },
        {
            "id": 4812,
            "score": 402,
            "ranking": 155754,
            "is_wenli": 1,
            "year": 2021,
            "num": 944
        },
        {
            "id": 4813,
            "score": 401,
            "ranking": 156758,
            "is_wenli": 1,
            "year": 2021,
            "num": 1004
        },
        {
            "id": 4814,
            "score": 400,
            "ranking": 157726,
            "is_wenli": 1,
            "year": 2021,
            "num": 968
        },
        {
            "id": 4815,
            "score": 399,
            "ranking": 158709,
            "is_wenli": 1,
            "year": 2021,
            "num": 983
        },
        {
            "id": 4816,
            "score": 398,
            "ranking": 159706,
            "is_wenli": 1,
            "year": 2021,
            "num": 997
        },
        {
            "id": 4817,
            "score": 397,
            "ranking": 160697,
            "is_wenli": 1,
            "year": 2021,
            "num": 991
        },
        {
            "id": 4818,
            "score": 396,
            "ranking": 161619,
            "is_wenli": 1,
            "year": 2021,
            "num": 922
        },
        {
            "id": 4819,
            "score": 395,
            "ranking": 162625,
            "is_wenli": 1,
            "year": 2021,
            "num": 1006
        },
        {
            "id": 4820,
            "score": 394,
            "ranking": 163613,
            "is_wenli": 1,
            "year": 2021,
            "num": 988
        },
        {
            "id": 4821,
            "score": 393,
            "ranking": 164630,
            "is_wenli": 1,
            "year": 2021,
            "num": 1017
        },
        {
            "id": 4822,
            "score": 392,
            "ranking": 165608,
            "is_wenli": 1,
            "year": 2021,
            "num": 978
        },
        {
            "id": 4823,
            "score": 391,
            "ranking": 166551,
            "is_wenli": 1,
            "year": 2021,
            "num": 943
        },
        {
            "id": 4824,
            "score": 390,
            "ranking": 167526,
            "is_wenli": 1,
            "year": 2021,
            "num": 975
        },
        {
            "id": 4825,
            "score": 389,
            "ranking": 168512,
            "is_wenli": 1,
            "year": 2021,
            "num": 986
        },
        {
            "id": 4826,
            "score": 388,
            "ranking": 169516,
            "is_wenli": 1,
            "year": 2021,
            "num": 1004
        },
        {
            "id": 4827,
            "score": 387,
            "ranking": 170581,
            "is_wenli": 1,
            "year": 2021,
            "num": 1065
        },
        {
            "id": 4828,
            "score": 386,
            "ranking": 171586,
            "is_wenli": 1,
            "year": 2021,
            "num": 1005
        },
        {
            "id": 4829,
            "score": 385,
            "ranking": 172582,
            "is_wenli": 1,
            "year": 2021,
            "num": 996
        },
        {
            "id": 4830,
            "score": 384,
            "ranking": 173558,
            "is_wenli": 1,
            "year": 2021,
            "num": 976
        },
        {
            "id": 4831,
            "score": 383,
            "ranking": 174478,
            "is_wenli": 1,
            "year": 2021,
            "num": 920
        },
        {
            "id": 4832,
            "score": 382,
            "ranking": 175456,
            "is_wenli": 1,
            "year": 2021,
            "num": 978
        },
        {
            "id": 4833,
            "score": 381,
            "ranking": 176451,
            "is_wenli": 1,
            "year": 2021,
            "num": 995
        },
        {
            "id": 4834,
            "score": 380,
            "ranking": 177476,
            "is_wenli": 1,
            "year": 2021,
            "num": 1025
        },
        {
            "id": 4835,
            "score": 379,
            "ranking": 178501,
            "is_wenli": 1,
            "year": 2021,
            "num": 1025
        },
        {
            "id": 4836,
            "score": 378,
            "ranking": 179481,
            "is_wenli": 1,
            "year": 2021,
            "num": 980
        },
        {
            "id": 4837,
            "score": 377,
            "ranking": 180490,
            "is_wenli": 1,
            "year": 2021,
            "num": 1009
        },
        {
            "id": 4838,
            "score": 376,
            "ranking": 181478,
            "is_wenli": 1,
            "year": 2021,
            "num": 988
        },
        {
            "id": 4839,
            "score": 375,
            "ranking": 182464,
            "is_wenli": 1,
            "year": 2021,
            "num": 986
        },
        {
            "id": 4840,
            "score": 374,
            "ranking": 183484,
            "is_wenli": 1,
            "year": 2021,
            "num": 1020
        },
        {
            "id": 4841,
            "score": 373,
            "ranking": 184547,
            "is_wenli": 1,
            "year": 2021,
            "num": 1063
        },
        {
            "id": 4842,
            "score": 372,
            "ranking": 185479,
            "is_wenli": 1,
            "year": 2021,
            "num": 932
        },
        {
            "id": 4843,
            "score": 371,
            "ranking": 186460,
            "is_wenli": 1,
            "year": 2021,
            "num": 981
        },
        {
            "id": 4844,
            "score": 370,
            "ranking": 187469,
            "is_wenli": 1,
            "year": 2021,
            "num": 1009
        },
        {
            "id": 4845,
            "score": 369,
            "ranking": 188409,
            "is_wenli": 1,
            "year": 2021,
            "num": 940
        },
        {
            "id": 4846,
            "score": 368,
            "ranking": 189476,
            "is_wenli": 1,
            "year": 2021,
            "num": 1067
        },
        {
            "id": 4847,
            "score": 367,
            "ranking": 190485,
            "is_wenli": 1,
            "year": 2021,
            "num": 1009
        },
        {
            "id": 4848,
            "score": 366,
            "ranking": 191554,
            "is_wenli": 1,
            "year": 2021,
            "num": 1069
        },
        {
            "id": 4849,
            "score": 365,
            "ranking": 192572,
            "is_wenli": 1,
            "year": 2021,
            "num": 1018
        },
        {
            "id": 4850,
            "score": 364,
            "ranking": 193591,
            "is_wenli": 1,
            "year": 2021,
            "num": 1019
        },
        {
            "id": 4851,
            "score": 363,
            "ranking": 194637,
            "is_wenli": 1,
            "year": 2021,
            "num": 1046
        },
        {
            "id": 4852,
            "score": 362,
            "ranking": 195624,
            "is_wenli": 1,
            "year": 2021,
            "num": 987
        },
        {
            "id": 4853,
            "score": 361,
            "ranking": 196657,
            "is_wenli": 1,
            "year": 2021,
            "num": 1033
        },
        {
            "id": 4854,
            "score": 360,
            "ranking": 197624,
            "is_wenli": 1,
            "year": 2021,
            "num": 967
        },
        {
            "id": 4855,
            "score": 359,
            "ranking": 198650,
            "is_wenli": 1,
            "year": 2021,
            "num": 1026
        },
        {
            "id": 4856,
            "score": 358,
            "ranking": 199644,
            "is_wenli": 1,
            "year": 2021,
            "num": 994
        },
        {
            "id": 4857,
            "score": 357,
            "ranking": 200657,
            "is_wenli": 1,
            "year": 2021,
            "num": 1013
        },
        {
            "id": 4858,
            "score": 356,
            "ranking": 201669,
            "is_wenli": 1,
            "year": 2021,
            "num": 1012
        },
        {
            "id": 4859,
            "score": 355,
            "ranking": 202693,
            "is_wenli": 1,
            "year": 2021,
            "num": 1024
        },
        {
            "id": 4860,
            "score": 354,
            "ranking": 203694,
            "is_wenli": 1,
            "year": 2021,
            "num": 1001
        },
        {
            "id": 4861,
            "score": 353,
            "ranking": 204689,
            "is_wenli": 1,
            "year": 2021,
            "num": 995
        },
        {
            "id": 4862,
            "score": 352,
            "ranking": 205683,
            "is_wenli": 1,
            "year": 2021,
            "num": 994
        },
        {
            "id": 4863,
            "score": 351,
            "ranking": 206722,
            "is_wenli": 1,
            "year": 2021,
            "num": 1039
        },
        {
            "id": 4864,
            "score": 350,
            "ranking": 207734,
            "is_wenli": 1,
            "year": 2021,
            "num": 1012
        },
        {
            "id": 4865,
            "score": 349,
            "ranking": 208753,
            "is_wenli": 1,
            "year": 2021,
            "num": 1019
        },
        {
            "id": 4866,
            "score": 348,
            "ranking": 209758,
            "is_wenli": 1,
            "year": 2021,
            "num": 1005
        },
        {
            "id": 4867,
            "score": 347,
            "ranking": 210727,
            "is_wenli": 1,
            "year": 2021,
            "num": 969
        },
        {
            "id": 4868,
            "score": 346,
            "ranking": 211712,
            "is_wenli": 1,
            "year": 2021,
            "num": 985
        },
        {
            "id": 4869,
            "score": 345,
            "ranking": 212721,
            "is_wenli": 1,
            "year": 2021,
            "num": 1009
        },
        {
            "id": 4870,
            "score": 344,
            "ranking": 213717,
            "is_wenli": 1,
            "year": 2021,
            "num": 996
        },
        {
            "id": 4871,
            "score": 343,
            "ranking": 214731,
            "is_wenli": 1,
            "year": 2021,
            "num": 1014
        },
        {
            "id": 4872,
            "score": 342,
            "ranking": 215802,
            "is_wenli": 1,
            "year": 2021,
            "num": 1071
        },
        {
            "id": 4873,
            "score": 341,
            "ranking": 216793,
            "is_wenli": 1,
            "year": 2021,
            "num": 991
        },
        {
            "id": 4874,
            "score": 340,
            "ranking": 217789,
            "is_wenli": 1,
            "year": 2021,
            "num": 996
        },
        {
            "id": 4875,
            "score": 339,
            "ranking": 218794,
            "is_wenli": 1,
            "year": 2021,
            "num": 1005
        },
        {
            "id": 4876,
            "score": 338,
            "ranking": 219793,
            "is_wenli": 1,
            "year": 2021,
            "num": 999
        },
        {
            "id": 4877,
            "score": 337,
            "ranking": 220807,
            "is_wenli": 1,
            "year": 2021,
            "num": 1014
        },
        {
            "id": 4878,
            "score": 336,
            "ranking": 221808,
            "is_wenli": 1,
            "year": 2021,
            "num": 1001
        },
        {
            "id": 5724,
            "score": 335,
            "ranking": 222791,
            "is_wenli": 1,
            "year": 2021,
            "num": 983
        },
        {
            "id": 4880,
            "score": 334,
            "ranking": 223767,
            "is_wenli": 1,
            "year": 2021,
            "num": 976
        },
        {
            "id": 4881,
            "score": 333,
            "ranking": 224764,
            "is_wenli": 1,
            "year": 2021,
            "num": 997
        },
        {
            "id": 4882,
            "score": 332,
            "ranking": 225724,
            "is_wenli": 1,
            "year": 2021,
            "num": 960
        },
        {
            "id": 4883,
            "score": 331,
            "ranking": 226706,
            "is_wenli": 1,
            "year": 2021,
            "num": 982
        },
        {
            "id": 4884,
            "score": 330,
            "ranking": 227648,
            "is_wenli": 1,
            "year": 2021,
            "num": 942
        },
        {
            "id": 4885,
            "score": 329,
            "ranking": 228592,
            "is_wenli": 1,
            "year": 2021,
            "num": 944
        },
        {
            "id": 4886,
            "score": 328,
            "ranking": 229591,
            "is_wenli": 1,
            "year": 2021,
            "num": 999
        },
        {
            "id": 4887,
            "score": 327,
            "ranking": 230524,
            "is_wenli": 1,
            "year": 2021,
            "num": 933
        },
        {
            "id": 4888,
            "score": 326,
            "ranking": 231496,
            "is_wenli": 1,
            "year": 2021,
            "num": 972
        },
        {
            "id": 4889,
            "score": 325,
            "ranking": 232444,
            "is_wenli": 1,
            "year": 2021,
            "num": 948
        },
        {
            "id": 4890,
            "score": 324,
            "ranking": 233380,
            "is_wenli": 1,
            "year": 2021,
            "num": 936
        },
        {
            "id": 4891,
            "score": 323,
            "ranking": 234311,
            "is_wenli": 1,
            "year": 2021,
            "num": 931
        },
        {
            "id": 4892,
            "score": 322,
            "ranking": 235219,
            "is_wenli": 1,
            "year": 2021,
            "num": 908
        },
        {
            "id": 4893,
            "score": 321,
            "ranking": 236149,
            "is_wenli": 1,
            "year": 2021,
            "num": 930
        },
        {
            "id": 4894,
            "score": 320,
            "ranking": 237038,
            "is_wenli": 1,
            "year": 2021,
            "num": 889
        },
        {
            "id": 4895,
            "score": 319,
            "ranking": 237976,
            "is_wenli": 1,
            "year": 2021,
            "num": 938
        },
        {
            "id": 4896,
            "score": 318,
            "ranking": 238868,
            "is_wenli": 1,
            "year": 2021,
            "num": 892
        },
        {
            "id": 4897,
            "score": 317,
            "ranking": 239765,
            "is_wenli": 1,
            "year": 2021,
            "num": 897
        },
        {
            "id": 4898,
            "score": 316,
            "ranking": 240688,
            "is_wenli": 1,
            "year": 2021,
            "num": 923
        },
        {
            "id": 4899,
            "score": 315,
            "ranking": 241559,
            "is_wenli": 1,
            "year": 2021,
            "num": 871
        },
        {
            "id": 4900,
            "score": 314,
            "ranking": 242438,
            "is_wenli": 1,
            "year": 2021,
            "num": 879
        },
        {
            "id": 4901,
            "score": 313,
            "ranking": 243378,
            "is_wenli": 1,
            "year": 2021,
            "num": 940
        },
        {
            "id": 4902,
            "score": 312,
            "ranking": 244235,
            "is_wenli": 1,
            "year": 2021,
            "num": 857
        },
        {
            "id": 4903,
            "score": 311,
            "ranking": 245107,
            "is_wenli": 1,
            "year": 2021,
            "num": 872
        },
        {
            "id": 4904,
            "score": 310,
            "ranking": 245966,
            "is_wenli": 1,
            "year": 2021,
            "num": 859
        },
        {
            "id": 4905,
            "score": 309,
            "ranking": 246819,
            "is_wenli": 1,
            "year": 2021,
            "num": 853
        },
        {
            "id": 4906,
            "score": 308,
            "ranking": 247689,
            "is_wenli": 1,
            "year": 2021,
            "num": 870
        },
        {
            "id": 4907,
            "score": 307,
            "ranking": 248573,
            "is_wenli": 1,
            "year": 2021,
            "num": 884
        },
        {
            "id": 4908,
            "score": 306,
            "ranking": 249455,
            "is_wenli": 1,
            "year": 2021,
            "num": 882
        },
        {
            "id": 4909,
            "score": 305,
            "ranking": 250321,
            "is_wenli": 1,
            "year": 2021,
            "num": 866
        },
        {
            "id": 4910,
            "score": 304,
            "ranking": 251221,
            "is_wenli": 1,
            "year": 2021,
            "num": 900
        },
        {
            "id": 4911,
            "score": 303,
            "ranking": 252069,
            "is_wenli": 1,
            "year": 2021,
            "num": 848
        },
        {
            "id": 4912,
            "score": 302,
            "ranking": 252885,
            "is_wenli": 1,
            "year": 2021,
            "num": 816
        },
        {
            "id": 4913,
            "score": 301,
            "ranking": 253719,
            "is_wenli": 1,
            "year": 2021,
            "num": 834
        },
        {
            "id": 4914,
            "score": 300,
            "ranking": 254567,
            "is_wenli": 1,
            "year": 2021,
            "num": 848
        },
        {
            "id": 4915,
            "score": 299,
            "ranking": 255359,
            "is_wenli": 1,
            "year": 2021,
            "num": 792
        },
        {
            "id": 4916,
            "score": 298,
            "ranking": 256171,
            "is_wenli": 1,
            "year": 2021,
            "num": 812
        },
        {
            "id": 4917,
            "score": 297,
            "ranking": 256999,
            "is_wenli": 1,
            "year": 2021,
            "num": 828
        },
        {
            "id": 4918,
            "score": 296,
            "ranking": 257819,
            "is_wenli": 1,
            "year": 2021,
            "num": 820
        },
        {
            "id": 4919,
            "score": 295,
            "ranking": 258633,
            "is_wenli": 1,
            "year": 2021,
            "num": 814
        },
        {
            "id": 4920,
            "score": 294,
            "ranking": 259407,
            "is_wenli": 1,
            "year": 2021,
            "num": 774
        },
        {
            "id": 4921,
            "score": 293,
            "ranking": 260231,
            "is_wenli": 1,
            "year": 2021,
            "num": 824
        },
        {
            "id": 4922,
            "score": 292,
            "ranking": 260961,
            "is_wenli": 1,
            "year": 2021,
            "num": 730
        },
        {
            "id": 4923,
            "score": 291,
            "ranking": 261811,
            "is_wenli": 1,
            "year": 2021,
            "num": 850
        },
        {
            "id": 4924,
            "score": 290,
            "ranking": 262550,
            "is_wenli": 1,
            "year": 2021,
            "num": 739
        },
        {
            "id": 4925,
            "score": 289,
            "ranking": 263277,
            "is_wenli": 1,
            "year": 2021,
            "num": 727
        },
        {
            "id": 4926,
            "score": 288,
            "ranking": 264058,
            "is_wenli": 1,
            "year": 2021,
            "num": 781
        },
        {
            "id": 4927,
            "score": 287,
            "ranking": 264756,
            "is_wenli": 1,
            "year": 2021,
            "num": 698
        },
        {
            "id": 4928,
            "score": 286,
            "ranking": 265509,
            "is_wenli": 1,
            "year": 2021,
            "num": 753
        },
        {
            "id": 4929,
            "score": 285,
            "ranking": 266241,
            "is_wenli": 1,
            "year": 2021,
            "num": 732
        },
        {
            "id": 4930,
            "score": 284,
            "ranking": 266960,
            "is_wenli": 1,
            "year": 2021,
            "num": 719
        },
        {
            "id": 4931,
            "score": 283,
            "ranking": 267702,
            "is_wenli": 1,
            "year": 2021,
            "num": 742
        },
        {
            "id": 4932,
            "score": 282,
            "ranking": 268451,
            "is_wenli": 1,
            "year": 2021,
            "num": 749
        },
        {
            "id": 4933,
            "score": 281,
            "ranking": 269173,
            "is_wenli": 1,
            "year": 2021,
            "num": 722
        },
        {
            "id": 4934,
            "score": 280,
            "ranking": 269844,
            "is_wenli": 1,
            "year": 2021,
            "num": 671
        },
        {
            "id": 4935,
            "score": 279,
            "ranking": 270565,
            "is_wenli": 1,
            "year": 2021,
            "num": 721
        },
        {
            "id": 4936,
            "score": 278,
            "ranking": 271301,
            "is_wenli": 1,
            "year": 2021,
            "num": 736
        },
        {
            "id": 4937,
            "score": 277,
            "ranking": 271974,
            "is_wenli": 1,
            "year": 2021,
            "num": 673
        },
        {
            "id": 4938,
            "score": 276,
            "ranking": 272642,
            "is_wenli": 1,
            "year": 2021,
            "num": 668
        },
        {
            "id": 4939,
            "score": 275,
            "ranking": 273333,
            "is_wenli": 1,
            "year": 2021,
            "num": 691
        },
        {
            "id": 4940,
            "score": 274,
            "ranking": 274006,
            "is_wenli": 1,
            "year": 2021,
            "num": 673
        },
        {
            "id": 4941,
            "score": 273,
            "ranking": 274712,
            "is_wenli": 1,
            "year": 2021,
            "num": 706
        },
        {
            "id": 4942,
            "score": 272,
            "ranking": 275367,
            "is_wenli": 1,
            "year": 2021,
            "num": 655
        },
        {
            "id": 4943,
            "score": 271,
            "ranking": 275973,
            "is_wenli": 1,
            "year": 2021,
            "num": 606
        },
        {
            "id": 4944,
            "score": 270,
            "ranking": 276561,
            "is_wenli": 1,
            "year": 2021,
            "num": 588
        },
        {
            "id": 4945,
            "score": 269,
            "ranking": 277143,
            "is_wenli": 1,
            "year": 2021,
            "num": 582
        },
        {
            "id": 4946,
            "score": 268,
            "ranking": 277796,
            "is_wenli": 1,
            "year": 2021,
            "num": 653
        },
        {
            "id": 4947,
            "score": 267,
            "ranking": 278355,
            "is_wenli": 1,
            "year": 2021,
            "num": 559
        },
        {
            "id": 4948,
            "score": 266,
            "ranking": 278968,
            "is_wenli": 1,
            "year": 2021,
            "num": 613
        },
        {
            "id": 4949,
            "score": 265,
            "ranking": 279558,
            "is_wenli": 1,
            "year": 2021,
            "num": 590
        },
        {
            "id": 4950,
            "score": 264,
            "ranking": 280159,
            "is_wenli": 1,
            "year": 2021,
            "num": 601
        },
        {
            "id": 4951,
            "score": 263,
            "ranking": 280715,
            "is_wenli": 1,
            "year": 2021,
            "num": 556
        },
        {
            "id": 4952,
            "score": 262,
            "ranking": 281294,
            "is_wenli": 1,
            "year": 2021,
            "num": 579
        },
        {
            "id": 4953,
            "score": 261,
            "ranking": 281858,
            "is_wenli": 1,
            "year": 2021,
            "num": 564
        },
        {
            "id": 4954,
            "score": 260,
            "ranking": 282418,
            "is_wenli": 1,
            "year": 2021,
            "num": 560
        },
        {
            "id": 4955,
            "score": 259,
            "ranking": 282939,
            "is_wenli": 1,
            "year": 2021,
            "num": 521
        },
        {
            "id": 4956,
            "score": 258,
            "ranking": 283474,
            "is_wenli": 1,
            "year": 2021,
            "num": 535
        },
        {
            "id": 4957,
            "score": 257,
            "ranking": 284006,
            "is_wenli": 1,
            "year": 2021,
            "num": 532
        },
        {
            "id": 4958,
            "score": 256,
            "ranking": 284563,
            "is_wenli": 1,
            "year": 2021,
            "num": 557
        },
        {
            "id": 4959,
            "score": 255,
            "ranking": 285080,
            "is_wenli": 1,
            "year": 2021,
            "num": 517
        },
        {
            "id": 4960,
            "score": 254,
            "ranking": 285600,
            "is_wenli": 1,
            "year": 2021,
            "num": 520
        },
        {
            "id": 4961,
            "score": 253,
            "ranking": 286119,
            "is_wenli": 1,
            "year": 2021,
            "num": 519
        },
        {
            "id": 4962,
            "score": 252,
            "ranking": 286634,
            "is_wenli": 1,
            "year": 2021,
            "num": 515
        },
        {
            "id": 4963,
            "score": 251,
            "ranking": 287136,
            "is_wenli": 1,
            "year": 2021,
            "num": 502
        },
        {
            "id": 4964,
            "score": 250,
            "ranking": 287643,
            "is_wenli": 1,
            "year": 2021,
            "num": 507
        },
        {
            "id": 4965,
            "score": 249,
            "ranking": 288144,
            "is_wenli": 1,
            "year": 2021,
            "num": 501
        },
        {
            "id": 4966,
            "score": 248,
            "ranking": 288640,
            "is_wenli": 1,
            "year": 2021,
            "num": 496
        },
        {
            "id": 4967,
            "score": 247,
            "ranking": 289105,
            "is_wenli": 1,
            "year": 2021,
            "num": 465
        },
        {
            "id": 4968,
            "score": 246,
            "ranking": 289571,
            "is_wenli": 1,
            "year": 2021,
            "num": 466
        },
        {
            "id": 4969,
            "score": 245,
            "ranking": 290064,
            "is_wenli": 1,
            "year": 2021,
            "num": 493
        },
        {
            "id": 4970,
            "score": 244,
            "ranking": 290545,
            "is_wenli": 1,
            "year": 2021,
            "num": 481
        },
        {
            "id": 4971,
            "score": 243,
            "ranking": 291008,
            "is_wenli": 1,
            "year": 2021,
            "num": 463
        },
        {
            "id": 4972,
            "score": 242,
            "ranking": 291470,
            "is_wenli": 1,
            "year": 2021,
            "num": 462
        },
        {
            "id": 4973,
            "score": 241,
            "ranking": 291870,
            "is_wenli": 1,
            "year": 2021,
            "num": 400
        },
        {
            "id": 4974,
            "score": 240,
            "ranking": 292273,
            "is_wenli": 1,
            "year": 2021,
            "num": 403
        },
        {
            "id": 4975,
            "score": 239,
            "ranking": 292709,
            "is_wenli": 1,
            "year": 2021,
            "num": 436
        },
        {
            "id": 4976,
            "score": 238,
            "ranking": 293124,
            "is_wenli": 1,
            "year": 2021,
            "num": 415
        },
        {
            "id": 4977,
            "score": 237,
            "ranking": 293534,
            "is_wenli": 1,
            "year": 2021,
            "num": 410
        },
        {
            "id": 4978,
            "score": 236,
            "ranking": 293920,
            "is_wenli": 1,
            "year": 2021,
            "num": 386
        },
        {
            "id": 4979,
            "score": 235,
            "ranking": 294344,
            "is_wenli": 1,
            "year": 2021,
            "num": 424
        },
        {
            "id": 4980,
            "score": 234,
            "ranking": 294717,
            "is_wenli": 1,
            "year": 2021,
            "num": 373
        },
        {
            "id": 4981,
            "score": 233,
            "ranking": 295099,
            "is_wenli": 1,
            "year": 2021,
            "num": 382
        },
        {
            "id": 4982,
            "score": 232,
            "ranking": 295452,
            "is_wenli": 1,
            "year": 2021,
            "num": 353
        },
        {
            "id": 4983,
            "score": 231,
            "ranking": 295822,
            "is_wenli": 1,
            "year": 2021,
            "num": 370
        },
        {
            "id": 4984,
            "score": 230,
            "ranking": 296154,
            "is_wenli": 1,
            "year": 2021,
            "num": 332
        },
        {
            "id": 4985,
            "score": 229,
            "ranking": 296508,
            "is_wenli": 1,
            "year": 2021,
            "num": 354
        },
        {
            "id": 4986,
            "score": 228,
            "ranking": 296895,
            "is_wenli": 1,
            "year": 2021,
            "num": 387
        },
        {
            "id": 4987,
            "score": 227,
            "ranking": 297223,
            "is_wenli": 1,
            "year": 2021,
            "num": 328
        },
        {
            "id": 4988,
            "score": 226,
            "ranking": 297532,
            "is_wenli": 1,
            "year": 2021,
            "num": 309
        },
        {
            "id": 4989,
            "score": 225,
            "ranking": 297842,
            "is_wenli": 1,
            "year": 2021,
            "num": 310
        },
        {
            "id": 4990,
            "score": 224,
            "ranking": 298146,
            "is_wenli": 1,
            "year": 2021,
            "num": 304
        },
        {
            "id": 4991,
            "score": 223,
            "ranking": 298460,
            "is_wenli": 1,
            "year": 2021,
            "num": 314
        },
        {
            "id": 4992,
            "score": 222,
            "ranking": 298773,
            "is_wenli": 1,
            "year": 2021,
            "num": 313
        },
        {
            "id": 4993,
            "score": 221,
            "ranking": 299047,
            "is_wenli": 1,
            "year": 2021,
            "num": 274
        },
        {
            "id": 4994,
            "score": 220,
            "ranking": 299310,
            "is_wenli": 1,
            "year": 2021,
            "num": 263
        },
        {
            "id": 4995,
            "score": 219,
            "ranking": 299586,
            "is_wenli": 1,
            "year": 2021,
            "num": 276
        },
        {
            "id": 4996,
            "score": 218,
            "ranking": 299856,
            "is_wenli": 1,
            "year": 2021,
            "num": 270
        },
        {
            "id": 4997,
            "score": 217,
            "ranking": 300151,
            "is_wenli": 1,
            "year": 2021,
            "num": 295
        },
        {
            "id": 4998,
            "score": 216,
            "ranking": 300441,
            "is_wenli": 1,
            "year": 2021,
            "num": 290
        },
        {
            "id": 4999,
            "score": 215,
            "ranking": 300735,
            "is_wenli": 1,
            "year": 2021,
            "num": 294
        },
        {
            "id": 5000,
            "score": 214,
            "ranking": 301008,
            "is_wenli": 1,
            "year": 2021,
            "num": 273
        },
        {
            "id": 5001,
            "score": 213,
            "ranking": 301249,
            "is_wenli": 1,
            "year": 2021,
            "num": 241
        },
        {
            "id": 5002,
            "score": 212,
            "ranking": 301522,
            "is_wenli": 1,
            "year": 2021,
            "num": 273
        },
        {
            "id": 5003,
            "score": 211,
            "ranking": 301758,
            "is_wenli": 1,
            "year": 2021,
            "num": 236
        },
        {
            "id": 5004,
            "score": 210,
            "ranking": 301992,
            "is_wenli": 1,
            "year": 2021,
            "num": 234
        },
        {
            "id": 5005,
            "score": 209,
            "ranking": 302237,
            "is_wenli": 1,
            "year": 2021,
            "num": 245
        },
        {
            "id": 5006,
            "score": 208,
            "ranking": 302462,
            "is_wenli": 1,
            "year": 2021,
            "num": 225
        },
        {
            "id": 5007,
            "score": 207,
            "ranking": 302698,
            "is_wenli": 1,
            "year": 2021,
            "num": 236
        },
        {
            "id": 5008,
            "score": 206,
            "ranking": 302908,
            "is_wenli": 1,
            "year": 2021,
            "num": 210
        },
        {
            "id": 5009,
            "score": 205,
            "ranking": 303126,
            "is_wenli": 1,
            "year": 2021,
            "num": 218
        },
        {
            "id": 5010,
            "score": 204,
            "ranking": 303340,
            "is_wenli": 1,
            "year": 2021,
            "num": 214
        },
        {
            "id": 5011,
            "score": 203,
            "ranking": 303545,
            "is_wenli": 1,
            "year": 2021,
            "num": 205
        },
        {
            "id": 5012,
            "score": 202,
            "ranking": 303749,
            "is_wenli": 1,
            "year": 2021,
            "num": 204
        },
        {
            "id": 5013,
            "score": 201,
            "ranking": 303931,
            "is_wenli": 1,
            "year": 2021,
            "num": 182
        },
        {
            "id": 5014,
            "score": 200,
            "ranking": 304110,
            "is_wenli": 1,
            "year": 2021,
            "num": 179
        },
        {
            "id": 5015,
            "score": 199,
            "ranking": 304284,
            "is_wenli": 1,
            "year": 2021,
            "num": 174
        },
        {
            "id": 5016,
            "score": 198,
            "ranking": 304484,
            "is_wenli": 1,
            "year": 2021,
            "num": 200
        },
        {
            "id": 5017,
            "score": 197,
            "ranking": 304652,
            "is_wenli": 1,
            "year": 2021,
            "num": 168
        },
        {
            "id": 5018,
            "score": 196,
            "ranking": 304814,
            "is_wenli": 1,
            "year": 2021,
            "num": 162
        },
        {
            "id": 5019,
            "score": 195,
            "ranking": 304991,
            "is_wenli": 1,
            "year": 2021,
            "num": 177
        },
        {
            "id": 5020,
            "score": 194,
            "ranking": 305142,
            "is_wenli": 1,
            "year": 2021,
            "num": 151
        },
        {
            "id": 5021,
            "score": 193,
            "ranking": 305302,
            "is_wenli": 1,
            "year": 2021,
            "num": 160
        },
        {
            "id": 5022,
            "score": 192,
            "ranking": 305492,
            "is_wenli": 1,
            "year": 2021,
            "num": 190
        },
        {
            "id": 5023,
            "score": 191,
            "ranking": 305638,
            "is_wenli": 1,
            "year": 2021,
            "num": 146
        },
        {
            "id": 5024,
            "score": 190,
            "ranking": 305782,
            "is_wenli": 1,
            "year": 2021,
            "num": 144
        },
        {
            "id": 5025,
            "score": 189,
            "ranking": 305930,
            "is_wenli": 1,
            "year": 2021,
            "num": 148
        },
        {
            "id": 5026,
            "score": 188,
            "ranking": 306054,
            "is_wenli": 1,
            "year": 2021,
            "num": 124
        },
        {
            "id": 5027,
            "score": 187,
            "ranking": 306193,
            "is_wenli": 1,
            "year": 2021,
            "num": 139
        },
        {
            "id": 5028,
            "score": 186,
            "ranking": 306322,
            "is_wenli": 1,
            "year": 2021,
            "num": 129
        },
        {
            "id": 5029,
            "score": 185,
            "ranking": 306472,
            "is_wenli": 1,
            "year": 2021,
            "num": 150
        },
        {
            "id": 5030,
            "score": 184,
            "ranking": 306589,
            "is_wenli": 1,
            "year": 2021,
            "num": 117
        },
        {
            "id": 5031,
            "score": 183,
            "ranking": 306707,
            "is_wenli": 1,
            "year": 2021,
            "num": 118
        },
        {
            "id": 5032,
            "score": 182,
            "ranking": 306830,
            "is_wenli": 1,
            "year": 2021,
            "num": 123
        },
        {
            "id": 5033,
            "score": 181,
            "ranking": 306942,
            "is_wenli": 1,
            "year": 2021,
            "num": 112
        },
        {
            "id": 5034,
            "score": 180,
            "ranking": 307062,
            "is_wenli": 1,
            "year": 2021,
            "num": 120
        },
        {
            "id": 5035,
            "score": 179,
            "ranking": 307181,
            "is_wenli": 1,
            "year": 2021,
            "num": 119
        },
        {
            "id": 5036,
            "score": 178,
            "ranking": 307297,
            "is_wenli": 1,
            "year": 2021,
            "num": 116
        },
        {
            "id": 5037,
            "score": 177,
            "ranking": 307403,
            "is_wenli": 1,
            "year": 2021,
            "num": 106
        },
        {
            "id": 5038,
            "score": 176,
            "ranking": 307481,
            "is_wenli": 1,
            "year": 2021,
            "num": 78
        },
        {
            "id": 5039,
            "score": 175,
            "ranking": 307581,
            "is_wenli": 1,
            "year": 2021,
            "num": 100
        },
        {
            "id": 5040,
            "score": 174,
            "ranking": 307679,
            "is_wenli": 1,
            "year": 2021,
            "num": 98
        },
        {
            "id": 5041,
            "score": 173,
            "ranking": 307773,
            "is_wenli": 1,
            "year": 2021,
            "num": 94
        },
        {
            "id": 5042,
            "score": 172,
            "ranking": 307858,
            "is_wenli": 1,
            "year": 2021,
            "num": 85
        },
        {
            "id": 5043,
            "score": 171,
            "ranking": 307933,
            "is_wenli": 1,
            "year": 2021,
            "num": 75
        },
        {
            "id": 5044,
            "score": 170,
            "ranking": 308017,
            "is_wenli": 1,
            "year": 2021,
            "num": 84
        },
        {
            "id": 5045,
            "score": 169,
            "ranking": 308088,
            "is_wenli": 1,
            "year": 2021,
            "num": 71
        },
        {
            "id": 5046,
            "score": 168,
            "ranking": 308168,
            "is_wenli": 1,
            "year": 2021,
            "num": 80
        },
        {
            "id": 5047,
            "score": 167,
            "ranking": 308237,
            "is_wenli": 1,
            "year": 2021,
            "num": 69
        },
        {
            "id": 5048,
            "score": 166,
            "ranking": 308307,
            "is_wenli": 1,
            "year": 2021,
            "num": 70
        },
        {
            "id": 5049,
            "score": 165,
            "ranking": 308386,
            "is_wenli": 1,
            "year": 2021,
            "num": 79
        },
        {
            "id": 5050,
            "score": 164,
            "ranking": 308455,
            "is_wenli": 1,
            "year": 2021,
            "num": 69
        },
        {
            "id": 5051,
            "score": 163,
            "ranking": 308524,
            "is_wenli": 1,
            "year": 2021,
            "num": 69
        },
        {
            "id": 5052,
            "score": 162,
            "ranking": 308582,
            "is_wenli": 1,
            "year": 2021,
            "num": 58
        },
        {
            "id": 5053,
            "score": 161,
            "ranking": 308637,
            "is_wenli": 1,
            "year": 2021,
            "num": 55
        },
        {
            "id": 5054,
            "score": 160,
            "ranking": 308701,
            "is_wenli": 1,
            "year": 2021,
            "num": 64
        },
        {
            "id": 5055,
            "score": 159,
            "ranking": 308757,
            "is_wenli": 1,
            "year": 2021,
            "num": 56
        },
        {
            "id": 5056,
            "score": 158,
            "ranking": 308806,
            "is_wenli": 1,
            "year": 2021,
            "num": 49
        },
        {
            "id": 5057,
            "score": 157,
            "ranking": 308855,
            "is_wenli": 1,
            "year": 2021,
            "num": 49
        },
        {
            "id": 5058,
            "score": 156,
            "ranking": 308915,
            "is_wenli": 1,
            "year": 2021,
            "num": 60
        },
        {
            "id": 5059,
            "score": 155,
            "ranking": 308967,
            "is_wenli": 1,
            "year": 2021,
            "num": 52
        },
        {
            "id": 5060,
            "score": 154,
            "ranking": 309003,
            "is_wenli": 1,
            "year": 2021,
            "num": 36
        },
        {
            "id": 5061,
            "score": 153,
            "ranking": 309040,
            "is_wenli": 1,
            "year": 2021,
            "num": 37
        },
        {
            "id": 5062,
            "score": 152,
            "ranking": 309068,
            "is_wenli": 1,
            "year": 2021,
            "num": 28
        },
        {
            "id": 5063,
            "score": 151,
            "ranking": 309103,
            "is_wenli": 1,
            "year": 2021,
            "num": 35
        },
        {
            "id": 5064,
            "score": 150,
            "ranking": 309136,
            "is_wenli": 1,
            "year": 2021,
            "num": 33
        },
        {
            "id": 5065,
            "score": 149,
            "ranking": 309167,
            "is_wenli": 1,
            "year": 2021,
            "num": 31
        },
        {
            "id": 5066,
            "score": 148,
            "ranking": 309207,
            "is_wenli": 1,
            "year": 2021,
            "num": 40
        },
        {
            "id": 5067,
            "score": 147,
            "ranking": 309250,
            "is_wenli": 1,
            "year": 2021,
            "num": 43
        },
        {
            "id": 5068,
            "score": 146,
            "ranking": 309278,
            "is_wenli": 1,
            "year": 2021,
            "num": 28
        },
        {
            "id": 5069,
            "score": 145,
            "ranking": 309313,
            "is_wenli": 1,
            "year": 2021,
            "num": 35
        },
        {
            "id": 5070,
            "score": 144,
            "ranking": 309349,
            "is_wenli": 1,
            "year": 2021,
            "num": 36
        },
        {
            "id": 5071,
            "score": 143,
            "ranking": 309394,
            "is_wenli": 1,
            "year": 2021,
            "num": 45
        },
        {
            "id": 5072,
            "score": 142,
            "ranking": 309423,
            "is_wenli": 1,
            "year": 2021,
            "num": 29
        },
        {
            "id": 5073,
            "score": 141,
            "ranking": 309453,
            "is_wenli": 1,
            "year": 2021,
            "num": 30
        },
        {
            "id": 5074,
            "score": 140,
            "ranking": 309470,
            "is_wenli": 1,
            "year": 2021,
            "num": 17
        },
        {
            "id": 5075,
            "score": 139,
            "ranking": 309503,
            "is_wenli": 1,
            "year": 2021,
            "num": 33
        },
        {
            "id": 5076,
            "score": 138,
            "ranking": 309530,
            "is_wenli": 1,
            "year": 2021,
            "num": 27
        },
        {
            "id": 5077,
            "score": 137,
            "ranking": 309567,
            "is_wenli": 1,
            "year": 2021,
            "num": 37
        },
        {
            "id": 5078,
            "score": 136,
            "ranking": 309593,
            "is_wenli": 1,
            "year": 2021,
            "num": 26
        },
        {
            "id": 5079,
            "score": 135,
            "ranking": 309616,
            "is_wenli": 1,
            "year": 2021,
            "num": 23
        },
        {
            "id": 5080,
            "score": 134,
            "ranking": 309642,
            "is_wenli": 1,
            "year": 2021,
            "num": 26
        },
        {
            "id": 5081,
            "score": 133,
            "ranking": 309669,
            "is_wenli": 1,
            "year": 2021,
            "num": 27
        },
        {
            "id": 5082,
            "score": 132,
            "ranking": 309685,
            "is_wenli": 1,
            "year": 2021,
            "num": 16
        },
        {
            "id": 5083,
            "score": 131,
            "ranking": 309710,
            "is_wenli": 1,
            "year": 2021,
            "num": 25
        },
        {
            "id": 5084,
            "score": 130,
            "ranking": 309727,
            "is_wenli": 1,
            "year": 2021,
            "num": 17
        },
        {
            "id": 5085,
            "score": 129,
            "ranking": 309747,
            "is_wenli": 1,
            "year": 2021,
            "num": 20
        },
        {
            "id": 5086,
            "score": 128,
            "ranking": 309765,
            "is_wenli": 1,
            "year": 2021,
            "num": 18
        },
        {
            "id": 5087,
            "score": 127,
            "ranking": 309782,
            "is_wenli": 1,
            "year": 2021,
            "num": 17
        },
        {
            "id": 5088,
            "score": 126,
            "ranking": 309801,
            "is_wenli": 1,
            "year": 2021,
            "num": 19
        },
        {
            "id": 5089,
            "score": 125,
            "ranking": 309818,
            "is_wenli": 1,
            "year": 2021,
            "num": 17
        },
        {
            "id": 5090,
            "score": 124,
            "ranking": 309834,
            "is_wenli": 1,
            "year": 2021,
            "num": 16
        },
        {
            "id": 5091,
            "score": 123,
            "ranking": 309852,
            "is_wenli": 1,
            "year": 2021,
            "num": 18
        },
        {
            "id": 5092,
            "score": 122,
            "ranking": 309870,
            "is_wenli": 1,
            "year": 2021,
            "num": 18
        },
        {
            "id": 5093,
            "score": 121,
            "ranking": 309886,
            "is_wenli": 1,
            "year": 2021,
            "num": 16
        },
        {
            "id": 5094,
            "score": 120,
            "ranking": 309897,
            "is_wenli": 1,
            "year": 2021,
            "num": 11
        },
        {
            "id": 5096,
            "score": 118,
            "ranking": 309920,
            "is_wenli": 1,
            "year": 2021,
            "num": 23
        },
        {
            "id": 5097,
            "score": 117,
            "ranking": 309930,
            "is_wenli": 1,
            "year": 2021,
            "num": 10
        },
        {
            "id": 5098,
            "score": 116,
            "ranking": 309943,
            "is_wenli": 1,
            "year": 2021,
            "num": 13
        },
        {
            "id": 5099,
            "score": 115,
            "ranking": 309955,
            "is_wenli": 1,
            "year": 2021,
            "num": 12
        },
        {
            "id": 5100,
            "score": 114,
            "ranking": 309967,
            "is_wenli": 1,
            "year": 2021,
            "num": 12
        },
        {
            "id": 5101,
            "score": 113,
            "ranking": 309977,
            "is_wenli": 1,
            "year": 2021,
            "num": 10
        },
        {
            "id": 5102,
            "score": 112,
            "ranking": 309986,
            "is_wenli": 1,
            "year": 2021,
            "num": 9
        },
        {
            "id": 5103,
            "score": 111,
            "ranking": 309993,
            "is_wenli": 1,
            "year": 2021,
            "num": 7
        },
        {
            "id": 5104,
            "score": 110,
            "ranking": 309997,
            "is_wenli": 1,
            "year": 2021,
            "num": 4
        },
        {
            "id": 5105,
            "score": 109,
            "ranking": 310010,
            "is_wenli": 1,
            "year": 2021,
            "num": 13
        },
        {
            "id": 5106,
            "score": 108,
            "ranking": 310016,
            "is_wenli": 1,
            "year": 2021,
            "num": 6
        },
        {
            "id": 5107,
            "score": 107,
            "ranking": 310021,
            "is_wenli": 1,
            "year": 2021,
            "num": 5
        },
        {
            "id": 5108,
            "score": 106,
            "ranking": 310040,
            "is_wenli": 1,
            "year": 2021,
            "num": 19
        },
        {
            "id": 5109,
            "score": 105,
            "ranking": 310047,
            "is_wenli": 1,
            "year": 2021,
            "num": 7
        },
        {
            "id": 5110,
            "score": 104,
            "ranking": 310052,
            "is_wenli": 1,
            "year": 2021,
            "num": 5
        },
        {
            "id": 5111,
            "score": 103,
            "ranking": 310058,
            "is_wenli": 1,
            "year": 2021,
            "num": 6
        },
        {
            "id": 5112,
            "score": 102,
            "ranking": 310070,
            "is_wenli": 1,
            "year": 2021,
            "num": 12
        },
        {
            "id": 5113,
            "score": 101,
            "ranking": 310079,
            "is_wenli": 1,
            "year": 2021,
            "num": 9
        },
        {
            "id": 5114,
            "score": 100,
            "ranking": 310088,
            "is_wenli": 1,
            "year": 2021,
            "num": 9
        }
    ],
    2020: [
        {
            "score": 671,
            "ranking": 11,
            "num": 11
        },
        {
            "score": 670,
            "ranking": 13,
            "num": 2
        },
        {
            "score": 669,
            "ranking": 17,
            "num": 4
        },
        {
            "score": 668,
            "ranking": 18,
            "num": 1
        },
        {
            "score": 667,
            "ranking": 23,
            "num": 5
        },
        {
            "score": 666,
            "ranking": 28,
            "num": 5
        },
        {
            "score": 665,
            "ranking": 33,
            "num": 5
        },
        {
            "score": 664,
            "ranking": 34,
            "num": 1
        },
        {
            "score": 663,
            "ranking": 40,
            "num": 6
        },
        {
            "score": 662,
            "ranking": 46,
            "num": 6
        },
        {
            "score": 661,
            "ranking": 54,
            "num": 8
        },
        {
            "score": 660,
            "ranking": 59,
            "num": 5
        },
        {
            "score": 659,
            "ranking": 65,
            "num": 6
        },
        {
            "score": 658,
            "ranking": 75,
            "num": 10
        },
        {
            "score": 657,
            "ranking": 83,
            "num": 8
        },
        {
            "score": 656,
            "ranking": 92,
            "num": 9
        },
        {
            "score": 655,
            "ranking": 104,
            "num": 12
        },
        {
            "score": 654,
            "ranking": 116,
            "num": 12
        },
        {
            "score": 653,
            "ranking": 131,
            "num": 15
        },
        {
            "score": 652,
            "ranking": 147,
            "num": 16
        },
        {
            "score": 651,
            "ranking": 157,
            "num": 10
        },
        {
            "score": 650,
            "ranking": 175,
            "num": 18
        },
        {
            "score": 649,
            "ranking": 197,
            "num": 22
        },
        {
            "score": 648,
            "ranking": 212,
            "num": 15
        },
        {
            "score": 647,
            "ranking": 235,
            "num": 23
        },
        {
            "score": 646,
            "ranking": 259,
            "num": 24
        },
        {
            "score": 645,
            "ranking": 285,
            "num": 26
        },
        {
            "score": 644,
            "ranking": 316,
            "num": 31
        },
        {
            "score": 643,
            "ranking": 345,
            "num": 29
        },
        {
            "score": 642,
            "ranking": 370,
            "num": 25
        },
        {
            "score": 641,
            "ranking": 412,
            "num": 42
        },
        {
            "score": 640,
            "ranking": 449,
            "num": 37
        },
        {
            "score": 639,
            "ranking": 487,
            "num": 38
        },
        {
            "score": 638,
            "ranking": 528,
            "num": 41
        },
        {
            "score": 637,
            "ranking": 568,
            "num": 40
        },
        {
            "score": 636,
            "ranking": 625,
            "num": 57
        },
        {
            "score": 635,
            "ranking": 669,
            "num": 44
        },
        {
            "score": 634,
            "ranking": 719,
            "num": 50
        },
        {
            "score": 633,
            "ranking": 786,
            "num": 67
        },
        {
            "score": 632,
            "ranking": 840,
            "num": 54
        },
        {
            "score": 631,
            "ranking": 925,
            "num": 85
        },
        {
            "score": 630,
            "ranking": 989,
            "num": 64
        },
        {
            "score": 629,
            "ranking": 1077,
            "num": 88
        },
        {
            "score": 628,
            "ranking": 1146,
            "num": 69
        },
        {
            "score": 627,
            "ranking": 1221,
            "num": 75
        },
        {
            "score": 626,
            "ranking": 1298,
            "num": 77
        },
        {
            "score": 625,
            "ranking": 1401,
            "num": 103
        },
        {
            "score": 624,
            "ranking": 1479,
            "num": 78
        },
        {
            "score": 623,
            "ranking": 1563,
            "num": 84
        },
        {
            "score": 622,
            "ranking": 1657,
            "num": 94
        },
        {
            "score": 621,
            "ranking": 1757,
            "num": 100
        },
        {
            "score": 620,
            "ranking": 1856,
            "num": 99
        },
        {
            "score": 619,
            "ranking": 1981,
            "num": 125
        },
        {
            "score": 618,
            "ranking": 2080,
            "num": 99
        },
        {
            "score": 617,
            "ranking": 2213,
            "num": 133
        },
        {
            "score": 616,
            "ranking": 2360,
            "num": 147
        },
        {
            "score": 615,
            "ranking": 2509,
            "num": 149
        },
        {
            "score": 614,
            "ranking": 2635,
            "num": 126
        },
        {
            "score": 613,
            "ranking": 2756,
            "num": 121
        },
        {
            "score": 612,
            "ranking": 2903,
            "num": 147
        },
        {
            "score": 611,
            "ranking": 3072,
            "num": 169
        },
        {
            "score": 610,
            "ranking": 3216,
            "num": 144
        },
        {
            "score": 609,
            "ranking": 3375,
            "num": 159
        },
        {
            "score": 608,
            "ranking": 3546,
            "num": 171
        },
        {
            "score": 607,
            "ranking": 3712,
            "num": 166
        },
        {
            "score": 606,
            "ranking": 3880,
            "num": 168
        },
        {
            "score": 605,
            "ranking": 4047,
            "num": 167
        },
        {
            "score": 604,
            "ranking": 4240,
            "num": 193
        },
        {
            "score": 603,
            "ranking": 4444,
            "num": 204
        },
        {
            "score": 602,
            "ranking": 4631,
            "num": 187
        },
        {
            "score": 601,
            "ranking": 4835,
            "num": 204
        },
        {
            "score": 600,
            "ranking": 5041,
            "num": 206
        },
        {
            "score": 599,
            "ranking": 5253,
            "num": 212
        },
        {
            "score": 598,
            "ranking": 5502,
            "num": 249
        },
        {
            "score": 597,
            "ranking": 5757,
            "num": 255
        },
        {
            "score": 596,
            "ranking": 6006,
            "num": 249
        },
        {
            "score": 595,
            "ranking": 6277,
            "num": 271
        },
        {
            "score": 594,
            "ranking": 6558,
            "num": 281
        },
        {
            "score": 593,
            "ranking": 6823,
            "num": 265
        },
        {
            "score": 592,
            "ranking": 7135,
            "num": 312
        },
        {
            "score": 591,
            "ranking": 7416,
            "num": 281
        },
        {
            "score": 590,
            "ranking": 7699,
            "num": 283
        },
        {
            "score": 589,
            "ranking": 7989,
            "num": 290
        },
        {
            "score": 588,
            "ranking": 8305,
            "num": 316
        },
        {
            "score": 587,
            "ranking": 8623,
            "num": 318
        },
        {
            "score": 586,
            "ranking": 8914,
            "num": 291
        },
        {
            "score": 585,
            "ranking": 9226,
            "num": 312
        },
        {
            "score": 584,
            "ranking": 9521,
            "num": 295
        },
        {
            "score": 583,
            "ranking": 9896,
            "num": 375
        },
        {
            "score": 582,
            "ranking": 10223,
            "num": 327
        },
        {
            "score": 581,
            "ranking": 10573,
            "num": 350
        },
        {
            "score": 580,
            "ranking": 10935,
            "num": 362
        },
        {
            "score": 579,
            "ranking": 11327,
            "num": 392
        },
        {
            "score": 578,
            "ranking": 11728,
            "num": 401
        },
        {
            "score": 577,
            "ranking": 12113,
            "num": 385
        },
        {
            "score": 576,
            "ranking": 12523,
            "num": 410
        },
        {
            "score": 575,
            "ranking": 12939,
            "num": 416
        },
        {
            "score": 574,
            "ranking": 13354,
            "num": 415
        },
        {
            "score": 573,
            "ranking": 13776,
            "num": 422
        },
        {
            "score": 572,
            "ranking": 14212,
            "num": 436
        },
        {
            "score": 571,
            "ranking": 14622,
            "num": 410
        },
        {
            "score": 570,
            "ranking": 15089,
            "num": 467
        },
        {
            "score": 569,
            "ranking": 15522,
            "num": 433
        },
        {
            "score": 568,
            "ranking": 15995,
            "num": 473
        },
        {
            "score": 567,
            "ranking": 16461,
            "num": 466
        },
        {
            "score": 566,
            "ranking": 16955,
            "num": 494
        },
        {
            "score": 565,
            "ranking": 17463,
            "num": 508
        },
        {
            "score": 564,
            "ranking": 17959,
            "num": 496
        },
        {
            "score": 563,
            "ranking": 18448,
            "num": 489
        },
        {
            "score": 562,
            "ranking": 18922,
            "num": 474
        },
        {
            "score": 561,
            "ranking": 19417,
            "num": 495
        },
        {
            "score": 560,
            "ranking": 19958,
            "num": 541
        },
        {
            "score": 559,
            "ranking": 20516,
            "num": 558
        },
        {
            "score": 558,
            "ranking": 21036,
            "num": 520
        },
        {
            "score": 557,
            "ranking": 21554,
            "num": 518
        },
        {
            "score": 556,
            "ranking": 22087,
            "num": 533
        },
        {
            "score": 555,
            "ranking": 22667,
            "num": 580
        },
        {
            "score": 554,
            "ranking": 23278,
            "num": 611
        },
        {
            "score": 553,
            "ranking": 23819,
            "num": 541
        },
        {
            "score": 552,
            "ranking": 24442,
            "num": 623
        },
        {
            "score": 551,
            "ranking": 25030,
            "num": 588
        },
        {
            "score": 550,
            "ranking": 25620,
            "num": 590
        },
        {
            "score": 549,
            "ranking": 26203,
            "num": 583
        },
        {
            "score": 548,
            "ranking": 26807,
            "num": 604
        },
        {
            "score": 547,
            "ranking": 27436,
            "num": 629
        },
        {
            "score": 546,
            "ranking": 28075,
            "num": 639
        },
        {
            "score": 545,
            "ranking": 28679,
            "num": 604
        },
        {
            "score": 544,
            "ranking": 29350,
            "num": 671
        },
        {
            "score": 543,
            "ranking": 30010,
            "num": 660
        },
        {
            "score": 542,
            "ranking": 30668,
            "num": 658
        },
        {
            "score": 541,
            "ranking": 31333,
            "num": 665
        },
        {
            "score": 540,
            "ranking": 31965,
            "num": 632
        },
        {
            "score": 539,
            "ranking": 32593,
            "num": 628
        },
        {
            "score": 538,
            "ranking": 33302,
            "num": 709
        },
        {
            "score": 537,
            "ranking": 33976,
            "num": 674
        },
        {
            "score": 536,
            "ranking": 34661,
            "num": 685
        },
        {
            "score": 535,
            "ranking": 35387,
            "num": 726
        },
        {
            "score": 534,
            "ranking": 36096,
            "num": 709
        },
        {
            "score": 533,
            "ranking": 36818,
            "num": 722
        },
        {
            "score": 532,
            "ranking": 37527,
            "num": 709
        },
        {
            "score": 531,
            "ranking": 38285,
            "num": 758
        },
        {
            "score": 530,
            "ranking": 39072,
            "num": 787
        },
        {
            "score": 529,
            "ranking": 39782,
            "num": 710
        },
        {
            "score": 528,
            "ranking": 40496,
            "num": 714
        },
        {
            "score": 527,
            "ranking": 41219,
            "num": 723
        },
        {
            "score": 526,
            "ranking": 41943,
            "num": 724
        },
        {
            "score": 525,
            "ranking": 42716,
            "num": 773
        },
        {
            "score": 524,
            "ranking": 43484,
            "num": 768
        },
        {
            "score": 523,
            "ranking": 44287,
            "num": 803
        },
        {
            "score": 522,
            "ranking": 45097,
            "num": 810
        },
        {
            "score": 521,
            "ranking": 45874,
            "num": 777
        },
        {
            "score": 520,
            "ranking": 46713,
            "num": 839
        },
        {
            "score": 519,
            "ranking": 47502,
            "num": 789
        },
        {
            "score": 518,
            "ranking": 48340,
            "num": 838
        },
        {
            "score": 517,
            "ranking": 49174,
            "num": 834
        },
        {
            "score": 516,
            "ranking": 50004,
            "num": 830
        },
        {
            "score": 515,
            "ranking": 50859,
            "num": 855
        },
        {
            "score": 514,
            "ranking": 51662,
            "num": 803
        },
        {
            "score": 513,
            "ranking": 52560,
            "num": 898
        },
        {
            "score": 512,
            "ranking": 53447,
            "num": 887
        },
        {
            "score": 511,
            "ranking": 54267,
            "num": 820
        },
        {
            "score": 510,
            "ranking": 55140,
            "num": 873
        },
        {
            "score": 509,
            "ranking": 55983,
            "num": 843
        },
        {
            "score": 508,
            "ranking": 56870,
            "num": 887
        },
        {
            "score": 507,
            "ranking": 57786,
            "num": 916
        },
        {
            "score": 506,
            "ranking": 58638,
            "num": 852
        },
        {
            "score": 505,
            "ranking": 59518,
            "num": 880
        },
        {
            "score": 504,
            "ranking": 60432,
            "num": 914
        },
        {
            "score": 503,
            "ranking": 61327,
            "num": 895
        },
        {
            "score": 502,
            "ranking": 62281,
            "num": 954
        },
        {
            "score": 501,
            "ranking": 63123,
            "num": 842
        },
        {
            "score": 500,
            "ranking": 63994,
            "num": 871
        },
        {
            "score": 499,
            "ranking": 64955,
            "num": 961
        },
        {
            "score": 498,
            "ranking": 65884,
            "num": 929
        },
        {
            "score": 497,
            "ranking": 66799,
            "num": 915
        },
        {
            "score": 496,
            "ranking": 67788,
            "num": 989
        },
        {
            "score": 495,
            "ranking": 68747,
            "num": 959
        },
        {
            "score": 494,
            "ranking": 69685,
            "num": 938
        },
        {
            "score": 493,
            "ranking": 70609,
            "num": 924
        },
        {
            "score": 492,
            "ranking": 71597,
            "num": 988
        },
        {
            "score": 491,
            "ranking": 72538,
            "num": 941
        },
        {
            "score": 490,
            "ranking": 73446,
            "num": 908
        },
        {
            "score": 489,
            "ranking": 74425,
            "num": 979
        },
        {
            "score": 488,
            "ranking": 75350,
            "num": 925
        },
        {
            "score": 487,
            "ranking": 76341,
            "num": 991
        },
        {
            "score": 486,
            "ranking": 77287,
            "num": 946
        },
        {
            "score": 485,
            "ranking": 78230,
            "num": 943
        },
        {
            "score": 484,
            "ranking": 79205,
            "num": 975
        },
        {
            "score": 483,
            "ranking": 80203,
            "num": 998
        },
        {
            "score": 482,
            "ranking": 81118,
            "num": 915
        },
        {
            "score": 481,
            "ranking": 82115,
            "num": 997
        },
        {
            "score": 480,
            "ranking": 83122,
            "num": 1007
        },
        {
            "score": 479,
            "ranking": 84136,
            "num": 1014
        },
        {
            "score": 478,
            "ranking": 85132,
            "num": 996
        },
        {
            "score": 477,
            "ranking": 86190,
            "num": 1058
        },
        {
            "score": 476,
            "ranking": 87172,
            "num": 982
        },
        {
            "score": 475,
            "ranking": 88087,
            "num": 915
        },
        {
            "score": 474,
            "ranking": 89051,
            "num": 964
        },
        {
            "score": 473,
            "ranking": 90033,
            "num": 982
        },
        {
            "score": 472,
            "ranking": 91034,
            "num": 1001
        },
        {
            "score": 471,
            "ranking": 92059,
            "num": 1025
        },
        {
            "score": 470,
            "ranking": 93080,
            "num": 1021
        },
        {
            "score": 469,
            "ranking": 94118,
            "num": 1038
        },
        {
            "score": 468,
            "ranking": 95112,
            "num": 994
        },
        {
            "score": 467,
            "ranking": 96094,
            "num": 982
        },
        {
            "score": 466,
            "ranking": 97100,
            "num": 1006
        },
        {
            "score": 465,
            "ranking": 98090,
            "num": 990
        },
        {
            "score": 464,
            "ranking": 99115,
            "num": 1025
        },
        {
            "score": 463,
            "ranking": 100093,
            "num": 978
        },
        {
            "score": 462,
            "ranking": 101122,
            "num": 1029
        },
        {
            "score": 461,
            "ranking": 102138,
            "num": 1016
        },
        {
            "score": 460,
            "ranking": 103143,
            "num": 1005
        },
        {
            "score": 459,
            "ranking": 104203,
            "num": 1060
        },
        {
            "score": 458,
            "ranking": 105191,
            "num": 988
        },
        {
            "score": 457,
            "ranking": 106214,
            "num": 1023
        },
        {
            "score": 456,
            "ranking": 107245,
            "num": 1031
        },
        {
            "score": 455,
            "ranking": 108265,
            "num": 1020
        },
        {
            "score": 454,
            "ranking": 109277,
            "num": 1012
        },
        {
            "score": 453,
            "ranking": 110292,
            "num": 1015
        },
        {
            "score": 452,
            "ranking": 111286,
            "num": 994
        },
        {
            "score": 451,
            "ranking": 112345,
            "num": 1059
        },
        {
            "score": 450,
            "ranking": 113304,
            "num": 959
        },
        {
            "score": 449,
            "ranking": 114288,
            "num": 984
        },
        {
            "score": 448,
            "ranking": 115258,
            "num": 970
        },
        {
            "score": 447,
            "ranking": 116267,
            "num": 1009
        },
        {
            "score": 446,
            "ranking": 117304,
            "num": 1037
        },
        {
            "score": 445,
            "ranking": 118360,
            "num": 1056
        },
        {
            "score": 444,
            "ranking": 119398,
            "num": 1038
        },
        {
            "score": 443,
            "ranking": 120435,
            "num": 1037
        },
        {
            "score": 442,
            "ranking": 121493,
            "num": 1058
        },
        {
            "score": 441,
            "ranking": 122516,
            "num": 1023
        },
        {
            "score": 440,
            "ranking": 123509,
            "num": 993
        },
        {
            "score": 439,
            "ranking": 124531,
            "num": 1022
        },
        {
            "score": 438,
            "ranking": 125508,
            "num": 977
        },
        {
            "score": 437,
            "ranking": 126529,
            "num": 1021
        },
        {
            "score": 436,
            "ranking": 127544,
            "num": 1015
        },
        {
            "score": 435,
            "ranking": 128552,
            "num": 1008
        },
        {
            "score": 434,
            "ranking": 129575,
            "num": 1023
        },
        {
            "score": 433,
            "ranking": 130604,
            "num": 1029
        },
        {
            "score": 432,
            "ranking": 131624,
            "num": 1020
        },
        {
            "score": 431,
            "ranking": 132665,
            "num": 1041
        },
        {
            "score": 430,
            "ranking": 133668,
            "num": 1003
        },
        {
            "score": 429,
            "ranking": 134657,
            "num": 989
        },
        {
            "score": 428,
            "ranking": 135737,
            "num": 1080
        },
        {
            "score": 427,
            "ranking": 136727,
            "num": 990
        },
        {
            "score": 426,
            "ranking": 137768,
            "num": 1041
        },
        {
            "score": 425,
            "ranking": 138749,
            "num": 981
        },
        {
            "score": 424,
            "ranking": 139755,
            "num": 1006
        },
        {
            "score": 423,
            "ranking": 140776,
            "num": 1021
        },
        {
            "score": 422,
            "ranking": 141785,
            "num": 1009
        },
        {
            "score": 421,
            "ranking": 142768,
            "num": 983
        },
        {
            "score": 420,
            "ranking": 143812,
            "num": 1044
        },
        {
            "score": 419,
            "ranking": 144844,
            "num": 1032
        },
        {
            "score": 418,
            "ranking": 145887,
            "num": 1043
        },
        {
            "score": 417,
            "ranking": 146967,
            "num": 1080
        },
        {
            "score": 416,
            "ranking": 148017,
            "num": 1050
        },
        {
            "score": 415,
            "ranking": 149065,
            "num": 1048
        },
        {
            "score": 414,
            "ranking": 150098,
            "num": 1033
        },
        {
            "score": 413,
            "ranking": 151112,
            "num": 1014
        },
        {
            "score": 412,
            "ranking": 152087,
            "num": 975
        },
        {
            "score": 411,
            "ranking": 153134,
            "num": 1047
        },
        {
            "score": 410,
            "ranking": 154177,
            "num": 1043
        },
        {
            "score": 409,
            "ranking": 155199,
            "num": 1022
        },
        {
            "score": 408,
            "ranking": 156295,
            "num": 1096
        },
        {
            "score": 407,
            "ranking": 157407,
            "num": 1112
        },
        {
            "score": 406,
            "ranking": 158441,
            "num": 1034
        },
        {
            "score": 405,
            "ranking": 159470,
            "num": 1029
        },
        {
            "score": 404,
            "ranking": 160534,
            "num": 1064
        },
        {
            "score": 403,
            "ranking": 161586,
            "num": 1052
        },
        {
            "score": 402,
            "ranking": 162622,
            "num": 1036
        },
        {
            "score": 401,
            "ranking": 163644,
            "num": 1022
        },
        {
            "score": 400,
            "ranking": 164715,
            "num": 1071
        },
        {
            "score": 399,
            "ranking": 165734,
            "num": 1019
        },
        {
            "score": 398,
            "ranking": 166825,
            "num": 1091
        },
        {
            "score": 397,
            "ranking": 167851,
            "num": 1026
        },
        {
            "score": 396,
            "ranking": 168905,
            "num": 1054
        },
        {
            "score": 395,
            "ranking": 169981,
            "num": 1076
        },
        {
            "score": 394,
            "ranking": 171006,
            "num": 1025
        },
        {
            "score": 393,
            "ranking": 172081,
            "num": 1075
        },
        {
            "score": 392,
            "ranking": 173096,
            "num": 1015
        },
        {
            "score": 391,
            "ranking": 174167,
            "num": 1071
        },
        {
            "score": 390,
            "ranking": 175268,
            "num": 1101
        },
        {
            "score": 389,
            "ranking": 176296,
            "num": 1028
        },
        {
            "score": 388,
            "ranking": 177416,
            "num": 1120
        },
        {
            "score": 387,
            "ranking": 178550,
            "num": 1134
        },
        {
            "score": 386,
            "ranking": 179603,
            "num": 1053
        },
        {
            "score": 385,
            "ranking": 180620,
            "num": 1017
        },
        {
            "score": 384,
            "ranking": 181734,
            "num": 1114
        },
        {
            "score": 383,
            "ranking": 182820,
            "num": 1086
        },
        {
            "score": 382,
            "ranking": 183875,
            "num": 1055
        },
        {
            "score": 381,
            "ranking": 184983,
            "num": 1108
        },
        {
            "score": 380,
            "ranking": 186060,
            "num": 1077
        },
        {
            "score": 379,
            "ranking": 187124,
            "num": 1064
        },
        {
            "score": 378,
            "ranking": 188254,
            "num": 1130
        },
        {
            "score": 377,
            "ranking": 189307,
            "num": 1053
        },
        {
            "score": 376,
            "ranking": 190385,
            "num": 1078
        },
        {
            "score": 375,
            "ranking": 191483,
            "num": 1098
        },
        {
            "score": 374,
            "ranking": 192561,
            "num": 1078
        },
        {
            "score": 373,
            "ranking": 193652,
            "num": 1091
        },
        {
            "score": 372,
            "ranking": 194763,
            "num": 1111
        },
        {
            "score": 371,
            "ranking": 195875,
            "num": 1112
        },
        {
            "score": 370,
            "ranking": 196985,
            "num": 1110
        },
        {
            "score": 369,
            "ranking": 198119,
            "num": 1134
        },
        {
            "score": 368,
            "ranking": 199197,
            "num": 1078
        },
        {
            "score": 367,
            "ranking": 200314,
            "num": 1117
        },
        {
            "score": 366,
            "ranking": 201339,
            "num": 1025
        },
        {
            "score": 365,
            "ranking": 202429,
            "num": 1090
        },
        {
            "score": 364,
            "ranking": 203575,
            "num": 1146
        },
        {
            "score": 363,
            "ranking": 204711,
            "num": 1136
        },
        {
            "score": 362,
            "ranking": 205841,
            "num": 1130
        },
        {
            "score": 361,
            "ranking": 206979,
            "num": 1138
        },
        {
            "score": 360,
            "ranking": 208082,
            "num": 1103
        },
        {
            "score": 359,
            "ranking": 209168,
            "num": 1086
        },
        {
            "score": 358,
            "ranking": 210263,
            "num": 1095
        },
        {
            "score": 357,
            "ranking": 211372,
            "num": 1109
        },
        {
            "score": 356,
            "ranking": 212486,
            "num": 1114
        },
        {
            "score": 355,
            "ranking": 213600,
            "num": 1114
        },
        {
            "score": 354,
            "ranking": 214701,
            "num": 1101
        },
        {
            "score": 353,
            "ranking": 215813,
            "num": 1112
        },
        {
            "score": 352,
            "ranking": 216939,
            "num": 1126
        },
        {
            "score": 351,
            "ranking": 217993,
            "num": 1054
        },
        {
            "score": 350,
            "ranking": 219081,
            "num": 1088
        },
        {
            "score": 349,
            "ranking": 220158,
            "num": 1077
        },
        {
            "score": 348,
            "ranking": 221223,
            "num": 1065
        },
        {
            "score": 347,
            "ranking": 222243,
            "num": 1020
        },
        {
            "score": 346,
            "ranking": 223277,
            "num": 1034
        },
        {
            "score": 345,
            "ranking": 224343,
            "num": 1066
        },
        {
            "score": 344,
            "ranking": 225358,
            "num": 1015
        },
        {
            "score": 343,
            "ranking": 226396,
            "num": 1038
        },
        {
            "score": 342,
            "ranking": 227482,
            "num": 1086
        },
        {
            "score": 341,
            "ranking": 228530,
            "num": 1048
        },
        {
            "score": 340,
            "ranking": 229594,
            "num": 1064
        },
        {
            "score": 339,
            "ranking": 230666,
            "num": 1072
        },
        {
            "score": 338,
            "ranking": 231723,
            "num": 1057
        },
        {
            "score": 337,
            "ranking": 232767,
            "num": 1044
        },
        {
            "score": 336,
            "ranking": 233823,
            "num": 1056
        },
        {
            "score": 335,
            "ranking": 234890,
            "num": 1067
        },
        {
            "score": 334,
            "ranking": 235911,
            "num": 1021
        },
        {
            "score": 333,
            "ranking": 237013,
            "num": 1102
        },
        {
            "score": 332,
            "ranking": 238075,
            "num": 1062
        },
        {
            "score": 331,
            "ranking": 239163,
            "num": 1088
        },
        {
            "score": 330,
            "ranking": 240200,
            "num": 1037
        },
        {
            "score": 329,
            "ranking": 241241,
            "num": 1041
        },
        {
            "score": 328,
            "ranking": 242283,
            "num": 1042
        },
        {
            "score": 327,
            "ranking": 243353,
            "num": 1070
        },
        {
            "score": 326,
            "ranking": 244367,
            "num": 1014
        },
        {
            "score": 325,
            "ranking": 245461,
            "num": 1094
        },
        {
            "score": 324,
            "ranking": 246571,
            "num": 1110
        },
        {
            "score": 323,
            "ranking": 247603,
            "num": 1032
        },
        {
            "score": 322,
            "ranking": 248680,
            "num": 1077
        },
        {
            "score": 321,
            "ranking": 249700,
            "num": 1020
        },
        {
            "score": 320,
            "ranking": 250775,
            "num": 1075
        },
        {
            "score": 319,
            "ranking": 251853,
            "num": 1078
        },
        {
            "score": 318,
            "ranking": 252901,
            "num": 1048
        },
        {
            "score": 317,
            "ranking": 253934,
            "num": 1033
        },
        {
            "score": 316,
            "ranking": 254952,
            "num": 1018
        },
        {
            "score": 315,
            "ranking": 255990,
            "num": 1038
        },
        {
            "score": 314,
            "ranking": 257056,
            "num": 1066
        },
        {
            "score": 313,
            "ranking": 258061,
            "num": 1005
        },
        {
            "score": 312,
            "ranking": 259096,
            "num": 1035
        },
        {
            "score": 311,
            "ranking": 260118,
            "num": 1022
        },
        {
            "score": 310,
            "ranking": 261167,
            "num": 1049
        },
        {
            "score": 309,
            "ranking": 262221,
            "num": 1054
        },
        {
            "score": 308,
            "ranking": 263211,
            "num": 990
        },
        {
            "score": 307,
            "ranking": 264214,
            "num": 1003
        },
        {
            "score": 306,
            "ranking": 265265,
            "num": 1051
        },
        {
            "score": 305,
            "ranking": 266264,
            "num": 999
        },
        {
            "score": 304,
            "ranking": 267248,
            "num": 984
        },
        {
            "score": 303,
            "ranking": 268234,
            "num": 986
        },
        {
            "score": 302,
            "ranking": 269166,
            "num": 932
        },
        {
            "score": 301,
            "ranking": 270152,
            "num": 986
        },
        {
            "score": 300,
            "ranking": 271103,
            "num": 951
        },
        {
            "score": 299,
            "ranking": 272124,
            "num": 1021
        },
        {
            "score": 298,
            "ranking": 273026,
            "num": 902
        },
        {
            "score": 297,
            "ranking": 274020,
            "num": 994
        },
        {
            "score": 296,
            "ranking": 274994,
            "num": 974
        },
        {
            "score": 295,
            "ranking": 275919,
            "num": 925
        },
        {
            "score": 294,
            "ranking": 276857,
            "num": 938
        },
        {
            "score": 293,
            "ranking": 277851,
            "num": 994
        },
        {
            "score": 292,
            "ranking": 278796,
            "num": 945
        },
        {
            "score": 291,
            "ranking": 279751,
            "num": 955
        },
        {
            "score": 290,
            "ranking": 280648,
            "num": 897
        },
        {
            "score": 289,
            "ranking": 281525,
            "num": 877
        },
        {
            "score": 288,
            "ranking": 282382,
            "num": 857
        },
        {
            "score": 287,
            "ranking": 283328,
            "num": 946
        },
        {
            "score": 286,
            "ranking": 284255,
            "num": 927
        },
        {
            "score": 285,
            "ranking": 285151,
            "num": 896
        },
        {
            "score": 284,
            "ranking": 286131,
            "num": 980
        },
        {
            "score": 283,
            "ranking": 287062,
            "num": 931
        },
        {
            "score": 282,
            "ranking": 287969,
            "num": 907
        },
        {
            "score": 281,
            "ranking": 288880,
            "num": 911
        },
        {
            "score": 280,
            "ranking": 289840,
            "num": 960
        },
        {
            "score": 279,
            "ranking": 290701,
            "num": 861
        },
        {
            "score": 278,
            "ranking": 291580,
            "num": 879
        },
        {
            "score": 277,
            "ranking": 292459,
            "num": 879
        },
        {
            "score": 276,
            "ranking": 293302,
            "num": 843
        },
        {
            "score": 275,
            "ranking": 294169,
            "num": 867
        },
        {
            "score": 274,
            "ranking": 295026,
            "num": 857
        },
        {
            "score": 273,
            "ranking": 295840,
            "num": 814
        },
        {
            "score": 272,
            "ranking": 296665,
            "num": 825
        },
        {
            "score": 271,
            "ranking": 297473,
            "num": 808
        },
        {
            "score": 270,
            "ranking": 298283,
            "num": 810
        },
        {
            "score": 269,
            "ranking": 299093,
            "num": 810
        },
        {
            "score": 268,
            "ranking": 299928,
            "num": 835
        },
        {
            "score": 267,
            "ranking": 300758,
            "num": 830
        },
        {
            "score": 266,
            "ranking": 301525,
            "num": 767
        },
        {
            "score": 265,
            "ranking": 302342,
            "num": 817
        },
        {
            "score": 264,
            "ranking": 303147,
            "num": 805
        },
        {
            "score": 263,
            "ranking": 303966,
            "num": 819
        },
        {
            "score": 262,
            "ranking": 304696,
            "num": 730
        },
        {
            "score": 261,
            "ranking": 305513,
            "num": 817
        },
        {
            "score": 260,
            "ranking": 306296,
            "num": 783
        },
        {
            "score": 259,
            "ranking": 307090,
            "num": 794
        },
        {
            "score": 258,
            "ranking": 307901,
            "num": 811
        },
        {
            "score": 257,
            "ranking": 308659,
            "num": 758
        },
        {
            "score": 256,
            "ranking": 309431,
            "num": 772
        },
        {
            "score": 255,
            "ranking": 310194,
            "num": 763
        },
        {
            "score": 254,
            "ranking": 310932,
            "num": 738
        },
        {
            "score": 253,
            "ranking": 311744,
            "num": 812
        },
        {
            "score": 252,
            "ranking": 312492,
            "num": 748
        },
        {
            "score": 251,
            "ranking": 313212,
            "num": 720
        },
        {
            "score": 250,
            "ranking": 313921,
            "num": 709
        },
        {
            "score": 249,
            "ranking": 314650,
            "num": 729
        },
        {
            "score": 248,
            "ranking": 315404,
            "num": 754
        },
        {
            "score": 247,
            "ranking": 316137,
            "num": 733
        },
        {
            "score": 246,
            "ranking": 316821,
            "num": 684
        },
        {
            "score": 245,
            "ranking": 317537,
            "num": 716
        },
        {
            "score": 244,
            "ranking": 318230,
            "num": 693
        },
        {
            "score": 243,
            "ranking": 318910,
            "num": 680
        },
        {
            "score": 242,
            "ranking": 319599,
            "num": 689
        },
        {
            "score": 241,
            "ranking": 320236,
            "num": 637
        },
        {
            "score": 240,
            "ranking": 320855,
            "num": 619
        },
        {
            "score": 239,
            "ranking": 321518,
            "num": 663
        },
        {
            "score": 238,
            "ranking": 322187,
            "num": 669
        },
        {
            "score": 237,
            "ranking": 322860,
            "num": 673
        },
        {
            "score": 236,
            "ranking": 323473,
            "num": 613
        },
        {
            "score": 235,
            "ranking": 324103,
            "num": 630
        },
        {
            "score": 234,
            "ranking": 324767,
            "num": 664
        },
        {
            "score": 233,
            "ranking": 325378,
            "num": 611
        },
        {
            "score": 232,
            "ranking": 326034,
            "num": 656
        },
        {
            "score": 231,
            "ranking": 326617,
            "num": 583
        },
        {
            "score": 230,
            "ranking": 327216,
            "num": 599
        },
        {
            "score": 229,
            "ranking": 327819,
            "num": 603
        },
        {
            "score": 228,
            "ranking": 328414,
            "num": 595
        },
        {
            "score": 227,
            "ranking": 328948,
            "num": 534
        },
        {
            "score": 226,
            "ranking": 329528,
            "num": 580
        },
        {
            "score": 225,
            "ranking": 330044,
            "num": 516
        },
        {
            "score": 224,
            "ranking": 330572,
            "num": 528
        },
        {
            "score": 223,
            "ranking": 331092,
            "num": 520
        },
        {
            "score": 222,
            "ranking": 331646,
            "num": 554
        },
        {
            "score": 221,
            "ranking": 332173,
            "num": 527
        },
        {
            "score": 220,
            "ranking": 332687,
            "num": 514
        },
        {
            "score": 219,
            "ranking": 333203,
            "num": 516
        },
        {
            "score": 218,
            "ranking": 333708,
            "num": 505
        },
        {
            "score": 217,
            "ranking": 334175,
            "num": 467
        },
        {
            "score": 216,
            "ranking": 334629,
            "num": 454
        },
        {
            "score": 215,
            "ranking": 335100,
            "num": 471
        },
        {
            "score": 214,
            "ranking": 335578,
            "num": 478
        },
        {
            "score": 213,
            "ranking": 336011,
            "num": 433
        },
        {
            "score": 212,
            "ranking": 336464,
            "num": 453
        },
        {
            "score": 211,
            "ranking": 336931,
            "num": 467
        },
        {
            "score": 210,
            "ranking": 337374,
            "num": 443
        },
        {
            "score": 209,
            "ranking": 337792,
            "num": 418
        },
        {
            "score": 208,
            "ranking": 338252,
            "num": 460
        },
        {
            "score": 207,
            "ranking": 338657,
            "num": 405
        },
        {
            "score": 206,
            "ranking": 339081,
            "num": 424
        },
        {
            "score": 205,
            "ranking": 339518,
            "num": 437
        },
        {
            "score": 204,
            "ranking": 339925,
            "num": 407
        },
        {
            "score": 203,
            "ranking": 340306,
            "num": 381
        },
        {
            "score": 202,
            "ranking": 340668,
            "num": 362
        },
        {
            "score": 201,
            "ranking": 340997,
            "num": 329
        },
        {
            "score": 200,
            "ranking": 341345,
            "num": 348
        },
        {
            "score": 199,
            "ranking": 341698,
            "num": 353
        },
        {
            "score": 198,
            "ranking": 342040,
            "num": 342
        },
        {
            "score": 197,
            "ranking": 342387,
            "num": 347
        },
        {
            "score": 196,
            "ranking": 342748,
            "num": 361
        },
        {
            "score": 195,
            "ranking": 343072,
            "num": 324
        },
        {
            "score": 194,
            "ranking": 343428,
            "num": 356
        },
        {
            "score": 193,
            "ranking": 343756,
            "num": 328
        },
        {
            "score": 192,
            "ranking": 344073,
            "num": 317
        },
        {
            "score": 191,
            "ranking": 344399,
            "num": 326
        },
        {
            "score": 190,
            "ranking": 344703,
            "num": 304
        },
        {
            "score": 189,
            "ranking": 344966,
            "num": 263
        },
        {
            "score": 188,
            "ranking": 345210,
            "num": 244
        },
        {
            "score": 187,
            "ranking": 345483,
            "num": 273
        },
        {
            "score": 186,
            "ranking": 345764,
            "num": 281
        },
        {
            "score": 185,
            "ranking": 346050,
            "num": 286
        },
        {
            "score": 184,
            "ranking": 346324,
            "num": 274
        },
        {
            "score": 183,
            "ranking": 346569,
            "num": 245
        },
        {
            "score": 182,
            "ranking": 346844,
            "num": 275
        },
        {
            "score": 181,
            "ranking": 347059,
            "num": 215
        },
        {
            "score": 180,
            "ranking": 347337,
            "num": 278
        },
        {
            "score": 179,
            "ranking": 347565,
            "num": 228
        },
        {
            "score": 178,
            "ranking": 347815,
            "num": 250
        },
        {
            "score": 177,
            "ranking": 348042,
            "num": 227
        },
        {
            "score": 176,
            "ranking": 348257,
            "num": 215
        },
        {
            "score": 175,
            "ranking": 348481,
            "num": 224
        },
        {
            "score": 174,
            "ranking": 348711,
            "num": 230
        },
        {
            "score": 173,
            "ranking": 348915,
            "num": 204
        },
        {
            "score": 172,
            "ranking": 349110,
            "num": 195
        },
        {
            "score": 171,
            "ranking": 349291,
            "num": 181
        },
        {
            "score": 170,
            "ranking": 349470,
            "num": 179
        },
        {
            "score": 169,
            "ranking": 349658,
            "num": 188
        },
        {
            "score": 168,
            "ranking": 349864,
            "num": 206
        },
        {
            "score": 167,
            "ranking": 350063,
            "num": 199
        },
        {
            "score": 166,
            "ranking": 350221,
            "num": 158
        },
        {
            "score": 165,
            "ranking": 350413,
            "num": 192
        },
        {
            "score": 164,
            "ranking": 350570,
            "num": 157
        },
        {
            "score": 163,
            "ranking": 350739,
            "num": 169
        },
        {
            "score": 162,
            "ranking": 350901,
            "num": 162
        },
        {
            "score": 161,
            "ranking": 351053,
            "num": 152
        },
        {
            "score": 160,
            "ranking": 351199,
            "num": 146
        },
        {
            "score": 159,
            "ranking": 351340,
            "num": 141
        },
        {
            "score": 158,
            "ranking": 351460,
            "num": 120
        },
        {
            "score": 157,
            "ranking": 351598,
            "num": 138
        },
        {
            "score": 156,
            "ranking": 351702,
            "num": 104
        },
        {
            "score": 155,
            "ranking": 351833,
            "num": 131
        },
        {
            "score": 154,
            "ranking": 351947,
            "num": 114
        },
        {
            "score": 153,
            "ranking": 352057,
            "num": 110
        },
        {
            "score": 152,
            "ranking": 352170,
            "num": 113
        },
        {
            "score": 151,
            "ranking": 352268,
            "num": 98
        },
        {
            "score": 150,
            "ranking": 352368,
            "num": 100
        },
        {
            "score": 149,
            "ranking": 352478,
            "num": 110
        },
        {
            "score": 148,
            "ranking": 352569,
            "num": 91
        },
        {
            "score": 147,
            "ranking": 352668,
            "num": 99
        },
        {
            "score": 146,
            "ranking": 352762,
            "num": 94
        },
        {
            "score": 145,
            "ranking": 352861,
            "num": 99
        },
        {
            "score": 144,
            "ranking": 352950,
            "num": 89
        },
        {
            "score": 143,
            "ranking": 353030,
            "num": 80
        },
        {
            "score": 142,
            "ranking": 353112,
            "num": 82
        },
        {
            "score": 141,
            "ranking": 353185,
            "num": 73
        },
        {
            "score": 140,
            "ranking": 353260,
            "num": 75
        },
        {
            "score": 139,
            "ranking": 353334,
            "num": 74
        },
        {
            "score": 138,
            "ranking": 353414,
            "num": 80
        },
        {
            "score": 137,
            "ranking": 353497,
            "num": 83
        },
        {
            "score": 136,
            "ranking": 353580,
            "num": 83
        },
        {
            "score": 135,
            "ranking": 353649,
            "num": 69
        },
        {
            "score": 134,
            "ranking": 353714,
            "num": 65
        },
        {
            "score": 133,
            "ranking": 353793,
            "num": 79
        },
        {
            "score": 132,
            "ranking": 353845,
            "num": 52
        },
        {
            "score": 131,
            "ranking": 353907,
            "num": 62
        },
        {
            "score": 130,
            "ranking": 353976,
            "num": 69
        },
        {
            "score": 129,
            "ranking": 354033,
            "num": 57
        },
        {
            "score": 128,
            "ranking": 354098,
            "num": 65
        },
        {
            "score": 127,
            "ranking": 354150,
            "num": 52
        },
        {
            "score": 126,
            "ranking": 354209,
            "num": 59
        },
        {
            "score": 125,
            "ranking": 354253,
            "num": 44
        },
        {
            "score": 124,
            "ranking": 354298,
            "num": 45
        },
        {
            "score": 123,
            "ranking": 354342,
            "num": 44
        },
        {
            "score": 122,
            "ranking": 354385,
            "num": 43
        },
        {
            "score": 121,
            "ranking": 354429,
            "num": 44
        },
        {
            "score": 120,
            "ranking": 354473,
            "num": 44
        },
        {
            "score": 119,
            "ranking": 354513,
            "num": 40
        },
        {
            "score": 118,
            "ranking": 354566,
            "num": 53
        },
        {
            "score": 117,
            "ranking": 354609,
            "num": 43
        },
        {
            "score": 116,
            "ranking": 354648,
            "num": 39
        },
        {
            "score": 115,
            "ranking": 354689,
            "num": 41
        },
        {
            "score": 114,
            "ranking": 354720,
            "num": 31
        },
        {
            "score": 113,
            "ranking": 354755,
            "num": 35
        },
        {
            "score": 112,
            "ranking": 354790,
            "num": 35
        },
        {
            "score": 111,
            "ranking": 354814,
            "num": 24
        },
        {
            "score": 110,
            "ranking": 354853,
            "num": 39
        },
        {
            "score": 109,
            "ranking": 354892,
            "num": 39
        },
        {
            "score": 108,
            "ranking": 354920,
            "num": 28
        },
        {
            "score": 107,
            "ranking": 354944,
            "num": 24
        },
        {
            "score": 106,
            "ranking": 354975,
            "num": 31
        },
        {
            "score": 105,
            "ranking": 355005,
            "num": 30
        },
        {
            "score": 104,
            "ranking": 355031,
            "num": 26
        },
        {
            "score": 103,
            "ranking": 355071,
            "num": 40
        },
        {
            "score": 102,
            "ranking": 355098,
            "num": 27
        },
        {
            "score": 101,
            "ranking": 355127,
            "num": 29
        },
        {
            "score": 100,
            "ranking": 355150,
            "num": 23
        }
    ],
    2019: [
        {
            "score": 657,
            "ranking": 12,
            "num": 12
        },
        {
            "score": 656,
            "ranking": 14,
            "num": 2
        },
        {
            "score": 655,
            "ranking": 24,
            "num": 10
        },
        {
            "score": 654,
            "ranking": 27,
            "num": 3
        },
        {
            "score": 653,
            "ranking": 30,
            "num": 3
        },
        {
            "score": 652,
            "ranking": 31,
            "num": 1
        },
        {
            "score": 651,
            "ranking": 40,
            "num": 9
        },
        {
            "score": 650,
            "ranking": 41,
            "num": 1
        },
        {
            "score": 649,
            "ranking": 46,
            "num": 5
        },
        {
            "score": 648,
            "ranking": 51,
            "num": 5
        },
        {
            "score": 647,
            "ranking": 52,
            "num": 1
        },
        {
            "score": 646,
            "ranking": 57,
            "num": 5
        },
        {
            "score": 645,
            "ranking": 62,
            "num": 5
        },
        {
            "score": 644,
            "ranking": 65,
            "num": 3
        },
        {
            "score": 643,
            "ranking": 72,
            "num": 7
        },
        {
            "score": 642,
            "ranking": 78,
            "num": 6
        },
        {
            "score": 641,
            "ranking": 87,
            "num": 9
        },
        {
            "score": 640,
            "ranking": 94,
            "num": 7
        },
        {
            "score": 639,
            "ranking": 95,
            "num": 1
        },
        {
            "score": 638,
            "ranking": 112,
            "num": 17
        },
        {
            "score": 637,
            "ranking": 125,
            "num": 13
        },
        {
            "score": 636,
            "ranking": 143,
            "num": 18
        },
        {
            "score": 635,
            "ranking": 161,
            "num": 18
        },
        {
            "score": 634,
            "ranking": 181,
            "num": 20
        },
        {
            "score": 633,
            "ranking": 207,
            "num": 26
        },
        {
            "score": 632,
            "ranking": 224,
            "num": 17
        },
        {
            "score": 631,
            "ranking": 247,
            "num": 23
        },
        {
            "score": 630,
            "ranking": 263,
            "num": 16
        },
        {
            "score": 629,
            "ranking": 286,
            "num": 23
        },
        {
            "score": 628,
            "ranking": 309,
            "num": 23
        },
        {
            "score": 627,
            "ranking": 339,
            "num": 30
        },
        {
            "score": 626,
            "ranking": 366,
            "num": 27
        },
        {
            "score": 625,
            "ranking": 393,
            "num": 27
        },
        {
            "score": 624,
            "ranking": 431,
            "num": 38
        },
        {
            "score": 623,
            "ranking": 473,
            "num": 42
        },
        {
            "score": 622,
            "ranking": 523,
            "num": 50
        },
        {
            "score": 621,
            "ranking": 551,
            "num": 28
        },
        {
            "score": 620,
            "ranking": 593,
            "num": 42
        },
        {
            "score": 619,
            "ranking": 634,
            "num": 41
        },
        {
            "score": 618,
            "ranking": 677,
            "num": 43
        },
        {
            "score": 617,
            "ranking": 740,
            "num": 63
        },
        {
            "score": 616,
            "ranking": 786,
            "num": 46
        },
        {
            "score": 615,
            "ranking": 840,
            "num": 54
        },
        {
            "score": 614,
            "ranking": 893,
            "num": 53
        },
        {
            "score": 613,
            "ranking": 952,
            "num": 59
        },
        {
            "score": 612,
            "ranking": 1006,
            "num": 54
        },
        {
            "score": 611,
            "ranking": 1066,
            "num": 60
        },
        {
            "score": 610,
            "ranking": 1119,
            "num": 53
        },
        {
            "score": 609,
            "ranking": 1192,
            "num": 73
        },
        {
            "score": 608,
            "ranking": 1263,
            "num": 71
        },
        {
            "score": 607,
            "ranking": 1334,
            "num": 71
        },
        {
            "score": 606,
            "ranking": 1422,
            "num": 88
        },
        {
            "score": 605,
            "ranking": 1501,
            "num": 79
        },
        {
            "score": 604,
            "ranking": 1582,
            "num": 81
        },
        {
            "score": 603,
            "ranking": 1670,
            "num": 88
        },
        {
            "score": 602,
            "ranking": 1769,
            "num": 99
        },
        {
            "score": 601,
            "ranking": 1874,
            "num": 105
        },
        {
            "score": 600,
            "ranking": 1980,
            "num": 106
        },
        {
            "score": 599,
            "ranking": 2092,
            "num": 112
        },
        {
            "score": 598,
            "ranking": 2198,
            "num": 106
        },
        {
            "score": 597,
            "ranking": 2323,
            "num": 125
        },
        {
            "score": 596,
            "ranking": 2454,
            "num": 131
        },
        {
            "score": 595,
            "ranking": 2584,
            "num": 130
        },
        {
            "score": 594,
            "ranking": 2721,
            "num": 137
        },
        {
            "score": 593,
            "ranking": 2851,
            "num": 130
        },
        {
            "score": 592,
            "ranking": 2999,
            "num": 148
        },
        {
            "score": 591,
            "ranking": 3133,
            "num": 134
        },
        {
            "score": 590,
            "ranking": 3276,
            "num": 143
        },
        {
            "score": 589,
            "ranking": 3439,
            "num": 163
        },
        {
            "score": 588,
            "ranking": 3613,
            "num": 174
        },
        {
            "score": 587,
            "ranking": 3798,
            "num": 185
        },
        {
            "score": 586,
            "ranking": 3996,
            "num": 198
        },
        {
            "score": 585,
            "ranking": 4158,
            "num": 162
        },
        {
            "score": 584,
            "ranking": 4346,
            "num": 188
        },
        {
            "score": 583,
            "ranking": 4534,
            "num": 188
        },
        {
            "score": 582,
            "ranking": 4720,
            "num": 186
        },
        {
            "score": 581,
            "ranking": 4920,
            "num": 200
        },
        {
            "score": 580,
            "ranking": 5130,
            "num": 210
        },
        {
            "score": 579,
            "ranking": 5335,
            "num": 205
        },
        {
            "score": 578,
            "ranking": 5568,
            "num": 233
        },
        {
            "score": 577,
            "ranking": 5801,
            "num": 233
        },
        {
            "score": 576,
            "ranking": 6019,
            "num": 218
        },
        {
            "score": 575,
            "ranking": 6265,
            "num": 246
        },
        {
            "score": 574,
            "ranking": 6530,
            "num": 265
        },
        {
            "score": 573,
            "ranking": 6809,
            "num": 279
        },
        {
            "score": 572,
            "ranking": 7095,
            "num": 286
        },
        {
            "score": 571,
            "ranking": 7330,
            "num": 235
        },
        {
            "score": 570,
            "ranking": 7586,
            "num": 256
        },
        {
            "score": 569,
            "ranking": 7861,
            "num": 275
        },
        {
            "score": 568,
            "ranking": 8150,
            "num": 289
        },
        {
            "score": 567,
            "ranking": 8467,
            "num": 317
        },
        {
            "score": 566,
            "ranking": 8791,
            "num": 324
        },
        {
            "score": 565,
            "ranking": 9096,
            "num": 305
        },
        {
            "score": 564,
            "ranking": 9433,
            "num": 337
        },
        {
            "score": 563,
            "ranking": 9781,
            "num": 348
        },
        {
            "score": 562,
            "ranking": 10145,
            "num": 364
        },
        {
            "score": 561,
            "ranking": 10480,
            "num": 335
        },
        {
            "score": 560,
            "ranking": 10833,
            "num": 353
        },
        {
            "score": 559,
            "ranking": 11213,
            "num": 380
        },
        {
            "score": 558,
            "ranking": 11576,
            "num": 363
        },
        {
            "score": 557,
            "ranking": 11925,
            "num": 349
        },
        {
            "score": 556,
            "ranking": 12293,
            "num": 368
        },
        {
            "score": 555,
            "ranking": 12684,
            "num": 391
        },
        {
            "score": 554,
            "ranking": 13072,
            "num": 388
        },
        {
            "score": 553,
            "ranking": 13502,
            "num": 430
        },
        {
            "score": 552,
            "ranking": 13923,
            "num": 421
        },
        {
            "score": 551,
            "ranking": 14347,
            "num": 424
        },
        {
            "score": 550,
            "ranking": 14816,
            "num": 469
        },
        {
            "score": 549,
            "ranking": 15243,
            "num": 427
        },
        {
            "score": 548,
            "ranking": 15742,
            "num": 499
        },
        {
            "score": 547,
            "ranking": 16220,
            "num": 478
        },
        {
            "score": 546,
            "ranking": 16694,
            "num": 474
        },
        {
            "score": 545,
            "ranking": 17222,
            "num": 528
        },
        {
            "score": 544,
            "ranking": 17701,
            "num": 479
        },
        {
            "score": 543,
            "ranking": 18264,
            "num": 563
        },
        {
            "score": 542,
            "ranking": 18748,
            "num": 484
        },
        {
            "score": 541,
            "ranking": 19304,
            "num": 556
        },
        {
            "score": 540,
            "ranking": 19901,
            "num": 597
        },
        {
            "score": 539,
            "ranking": 20442,
            "num": 541
        },
        {
            "score": 538,
            "ranking": 21014,
            "num": 572
        },
        {
            "score": 537,
            "ranking": 21573,
            "num": 559
        },
        {
            "score": 536,
            "ranking": 22094,
            "num": 521
        },
        {
            "score": 535,
            "ranking": 22657,
            "num": 563
        },
        {
            "score": 534,
            "ranking": 23231,
            "num": 574
        },
        {
            "score": 533,
            "ranking": 23814,
            "num": 583
        },
        {
            "score": 532,
            "ranking": 24466,
            "num": 652
        },
        {
            "score": 531,
            "ranking": 25044,
            "num": 578
        },
        {
            "score": 530,
            "ranking": 25644,
            "num": 600
        },
        {
            "score": 529,
            "ranking": 26327,
            "num": 683
        },
        {
            "score": 528,
            "ranking": 26973,
            "num": 646
        },
        {
            "score": 527,
            "ranking": 27625,
            "num": 652
        },
        {
            "score": 526,
            "ranking": 28282,
            "num": 657
        },
        {
            "score": 525,
            "ranking": 28958,
            "num": 676
        },
        {
            "score": 524,
            "ranking": 29666,
            "num": 708
        },
        {
            "score": 523,
            "ranking": 30353,
            "num": 687
        },
        {
            "score": 522,
            "ranking": 31022,
            "num": 669
        },
        {
            "score": 521,
            "ranking": 31726,
            "num": 704
        },
        {
            "score": 520,
            "ranking": 32432,
            "num": 706
        },
        {
            "score": 519,
            "ranking": 33155,
            "num": 723
        },
        {
            "score": 518,
            "ranking": 33889,
            "num": 734
        },
        {
            "score": 517,
            "ranking": 34592,
            "num": 703
        },
        {
            "score": 516,
            "ranking": 35312,
            "num": 720
        },
        {
            "score": 515,
            "ranking": 36043,
            "num": 731
        },
        {
            "score": 514,
            "ranking": 36824,
            "num": 781
        },
        {
            "score": 513,
            "ranking": 37576,
            "num": 752
        },
        {
            "score": 512,
            "ranking": 38378,
            "num": 802
        },
        {
            "score": 511,
            "ranking": 39143,
            "num": 765
        },
        {
            "score": 510,
            "ranking": 39988,
            "num": 845
        },
        {
            "score": 509,
            "ranking": 40747,
            "num": 759
        },
        {
            "score": 508,
            "ranking": 41600,
            "num": 853
        },
        {
            "score": 507,
            "ranking": 42372,
            "num": 772
        },
        {
            "score": 506,
            "ranking": 43190,
            "num": 818
        },
        {
            "score": 505,
            "ranking": 44033,
            "num": 843
        },
        {
            "score": 504,
            "ranking": 44849,
            "num": 816
        },
        {
            "score": 503,
            "ranking": 45680,
            "num": 831
        },
        {
            "score": 502,
            "ranking": 46498,
            "num": 818
        },
        {
            "score": 501,
            "ranking": 47369,
            "num": 871
        },
        {
            "score": 500,
            "ranking": 48216,
            "num": 847
        },
        {
            "score": 499,
            "ranking": 49036,
            "num": 820
        },
        {
            "score": 498,
            "ranking": 49902,
            "num": 866
        },
        {
            "score": 497,
            "ranking": 50809,
            "num": 907
        },
        {
            "score": 496,
            "ranking": 51728,
            "num": 919
        },
        {
            "score": 495,
            "ranking": 52623,
            "num": 895
        },
        {
            "score": 494,
            "ranking": 53547,
            "num": 924
        },
        {
            "score": 493,
            "ranking": 54421,
            "num": 874
        },
        {
            "score": 492,
            "ranking": 55314,
            "num": 893
        },
        {
            "score": 491,
            "ranking": 56263,
            "num": 949
        },
        {
            "score": 490,
            "ranking": 57200,
            "num": 937
        },
        {
            "score": 489,
            "ranking": 58141,
            "num": 941
        },
        {
            "score": 488,
            "ranking": 59071,
            "num": 930
        },
        {
            "score": 487,
            "ranking": 59948,
            "num": 877
        },
        {
            "score": 486,
            "ranking": 60831,
            "num": 883
        },
        {
            "score": 485,
            "ranking": 61760,
            "num": 929
        },
        {
            "score": 484,
            "ranking": 62681,
            "num": 921
        },
        {
            "score": 483,
            "ranking": 63611,
            "num": 930
        },
        {
            "score": 482,
            "ranking": 64567,
            "num": 956
        },
        {
            "score": 481,
            "ranking": 65551,
            "num": 984
        },
        {
            "score": 480,
            "ranking": 66524,
            "num": 973
        },
        {
            "score": 479,
            "ranking": 67483,
            "num": 959
        },
        {
            "score": 478,
            "ranking": 68501,
            "num": 1018
        },
        {
            "score": 477,
            "ranking": 69468,
            "num": 967
        },
        {
            "score": 476,
            "ranking": 70457,
            "num": 989
        },
        {
            "score": 475,
            "ranking": 71426,
            "num": 969
        },
        {
            "score": 474,
            "ranking": 72400,
            "num": 974
        },
        {
            "score": 473,
            "ranking": 73356,
            "num": 956
        },
        {
            "score": 472,
            "ranking": 74353,
            "num": 997
        },
        {
            "score": 471,
            "ranking": 75322,
            "num": 969
        },
        {
            "score": 470,
            "ranking": 76314,
            "num": 992
        },
        {
            "score": 469,
            "ranking": 77312,
            "num": 998
        },
        {
            "score": 468,
            "ranking": 78368,
            "num": 1056
        },
        {
            "score": 467,
            "ranking": 79351,
            "num": 983
        },
        {
            "score": 466,
            "ranking": 80381,
            "num": 1030
        },
        {
            "score": 465,
            "ranking": 81393,
            "num": 1012
        },
        {
            "score": 464,
            "ranking": 82409,
            "num": 1016
        },
        {
            "score": 463,
            "ranking": 83390,
            "num": 981
        },
        {
            "score": 462,
            "ranking": 84369,
            "num": 979
        },
        {
            "score": 461,
            "ranking": 85360,
            "num": 991
        },
        {
            "score": 460,
            "ranking": 86358,
            "num": 998
        },
        {
            "score": 459,
            "ranking": 87350,
            "num": 992
        },
        {
            "score": 458,
            "ranking": 88309,
            "num": 959
        },
        {
            "score": 457,
            "ranking": 89311,
            "num": 1002
        },
        {
            "score": 456,
            "ranking": 90374,
            "num": 1063
        },
        {
            "score": 455,
            "ranking": 91397,
            "num": 1023
        },
        {
            "score": 454,
            "ranking": 92428,
            "num": 1031
        },
        {
            "score": 453,
            "ranking": 93423,
            "num": 995
        },
        {
            "score": 452,
            "ranking": 94382,
            "num": 959
        },
        {
            "score": 451,
            "ranking": 95426,
            "num": 1044
        },
        {
            "score": 450,
            "ranking": 96480,
            "num": 1054
        },
        {
            "score": 449,
            "ranking": 97560,
            "num": 1080
        },
        {
            "score": 448,
            "ranking": 98590,
            "num": 1030
        },
        {
            "score": 447,
            "ranking": 99577,
            "num": 987
        },
        {
            "score": 446,
            "ranking": 100550,
            "num": 973
        },
        {
            "score": 445,
            "ranking": 101558,
            "num": 1008
        },
        {
            "score": 444,
            "ranking": 102602,
            "num": 1044
        },
        {
            "score": 443,
            "ranking": 103623,
            "num": 1021
        },
        {
            "score": 442,
            "ranking": 104607,
            "num": 984
        },
        {
            "score": 441,
            "ranking": 105620,
            "num": 1013
        },
        {
            "score": 440,
            "ranking": 106634,
            "num": 1014
        },
        {
            "score": 439,
            "ranking": 107616,
            "num": 982
        },
        {
            "score": 438,
            "ranking": 108613,
            "num": 997
        },
        {
            "score": 437,
            "ranking": 109669,
            "num": 1056
        },
        {
            "score": 436,
            "ranking": 110683,
            "num": 1014
        },
        {
            "score": 435,
            "ranking": 111672,
            "num": 989
        },
        {
            "score": 434,
            "ranking": 112659,
            "num": 987
        },
        {
            "score": 433,
            "ranking": 113696,
            "num": 1037
        },
        {
            "score": 432,
            "ranking": 114752,
            "num": 1056
        },
        {
            "score": 431,
            "ranking": 115802,
            "num": 1050
        },
        {
            "score": 430,
            "ranking": 116845,
            "num": 1043
        },
        {
            "score": 429,
            "ranking": 117876,
            "num": 1031
        },
        {
            "score": 428,
            "ranking": 118883,
            "num": 1007
        },
        {
            "score": 427,
            "ranking": 119914,
            "num": 1031
        },
        {
            "score": 426,
            "ranking": 120925,
            "num": 1011
        },
        {
            "score": 425,
            "ranking": 121905,
            "num": 980
        },
        {
            "score": 424,
            "ranking": 122900,
            "num": 995
        },
        {
            "score": 423,
            "ranking": 123909,
            "num": 1009
        },
        {
            "score": 422,
            "ranking": 124956,
            "num": 1047
        },
        {
            "score": 421,
            "ranking": 125947,
            "num": 991
        },
        {
            "score": 420,
            "ranking": 126952,
            "num": 1005
        },
        {
            "score": 419,
            "ranking": 127939,
            "num": 987
        },
        {
            "score": 418,
            "ranking": 128874,
            "num": 935
        },
        {
            "score": 417,
            "ranking": 129889,
            "num": 1015
        },
        {
            "score": 416,
            "ranking": 130932,
            "num": 1043
        },
        {
            "score": 415,
            "ranking": 131947,
            "num": 1015
        },
        {
            "score": 414,
            "ranking": 132954,
            "num": 1007
        },
        {
            "score": 413,
            "ranking": 133965,
            "num": 1011
        },
        {
            "score": 412,
            "ranking": 135003,
            "num": 1038
        },
        {
            "score": 411,
            "ranking": 136032,
            "num": 1029
        },
        {
            "score": 410,
            "ranking": 137034,
            "num": 1002
        },
        {
            "score": 409,
            "ranking": 138055,
            "num": 1021
        },
        {
            "score": 408,
            "ranking": 139092,
            "num": 1037
        },
        {
            "score": 407,
            "ranking": 140093,
            "num": 1001
        },
        {
            "score": 406,
            "ranking": 141158,
            "num": 1065
        },
        {
            "score": 405,
            "ranking": 142142,
            "num": 984
        },
        {
            "score": 404,
            "ranking": 143191,
            "num": 1049
        },
        {
            "score": 403,
            "ranking": 144158,
            "num": 967
        },
        {
            "score": 402,
            "ranking": 145119,
            "num": 961
        },
        {
            "score": 401,
            "ranking": 146152,
            "num": 1033
        },
        {
            "score": 400,
            "ranking": 147244,
            "num": 1092
        },
        {
            "score": 399,
            "ranking": 148260,
            "num": 1016
        },
        {
            "score": 398,
            "ranking": 149329,
            "num": 1069
        },
        {
            "score": 397,
            "ranking": 150379,
            "num": 1050
        },
        {
            "score": 396,
            "ranking": 151420,
            "num": 1041
        },
        {
            "score": 395,
            "ranking": 152428,
            "num": 1008
        },
        {
            "score": 394,
            "ranking": 153487,
            "num": 1059
        },
        {
            "score": 393,
            "ranking": 154546,
            "num": 1059
        },
        {
            "score": 392,
            "ranking": 155583,
            "num": 1037
        },
        {
            "score": 391,
            "ranking": 156614,
            "num": 1031
        },
        {
            "score": 390,
            "ranking": 157627,
            "num": 1013
        },
        {
            "score": 389,
            "ranking": 158646,
            "num": 1019
        },
        {
            "score": 388,
            "ranking": 159614,
            "num": 968
        },
        {
            "score": 387,
            "ranking": 160632,
            "num": 1018
        },
        {
            "score": 386,
            "ranking": 161613,
            "num": 981
        },
        {
            "score": 385,
            "ranking": 162681,
            "num": 1068
        },
        {
            "score": 384,
            "ranking": 163719,
            "num": 1038
        },
        {
            "score": 383,
            "ranking": 164742,
            "num": 1023
        },
        {
            "score": 382,
            "ranking": 165832,
            "num": 1090
        },
        {
            "score": 381,
            "ranking": 166841,
            "num": 1009
        },
        {
            "score": 380,
            "ranking": 167784,
            "num": 943
        },
        {
            "score": 379,
            "ranking": 168832,
            "num": 1048
        },
        {
            "score": 378,
            "ranking": 169884,
            "num": 1052
        },
        {
            "score": 377,
            "ranking": 170913,
            "num": 1029
        },
        {
            "score": 376,
            "ranking": 171978,
            "num": 1065
        },
        {
            "score": 375,
            "ranking": 173025,
            "num": 1047
        },
        {
            "score": 374,
            "ranking": 174106,
            "num": 1081
        },
        {
            "score": 373,
            "ranking": 175153,
            "num": 1047
        },
        {
            "score": 372,
            "ranking": 176199,
            "num": 1046
        },
        {
            "score": 371,
            "ranking": 177235,
            "num": 1036
        },
        {
            "score": 370,
            "ranking": 178276,
            "num": 1041
        },
        {
            "score": 369,
            "ranking": 179323,
            "num": 1047
        },
        {
            "score": 368,
            "ranking": 180362,
            "num": 1039
        },
        {
            "score": 367,
            "ranking": 181331,
            "num": 969
        },
        {
            "score": 366,
            "ranking": 182362,
            "num": 1031
        },
        {
            "score": 365,
            "ranking": 183348,
            "num": 986
        },
        {
            "score": 364,
            "ranking": 184359,
            "num": 1011
        },
        {
            "score": 363,
            "ranking": 185320,
            "num": 961
        },
        {
            "score": 362,
            "ranking": 186386,
            "num": 1066
        },
        {
            "score": 361,
            "ranking": 187411,
            "num": 1025
        },
        {
            "score": 360,
            "ranking": 188433,
            "num": 1022
        },
        {
            "score": 359,
            "ranking": 189401,
            "num": 968
        },
        {
            "score": 358,
            "ranking": 190378,
            "num": 977
        },
        {
            "score": 357,
            "ranking": 191370,
            "num": 992
        },
        {
            "score": 356,
            "ranking": 192341,
            "num": 971
        },
        {
            "score": 355,
            "ranking": 193345,
            "num": 1004
        },
        {
            "score": 354,
            "ranking": 194316,
            "num": 971
        },
        {
            "score": 353,
            "ranking": 195332,
            "num": 1016
        },
        {
            "score": 352,
            "ranking": 196285,
            "num": 953
        },
        {
            "score": 351,
            "ranking": 197247,
            "num": 962
        },
        {
            "score": 350,
            "ranking": 198167,
            "num": 920
        },
        {
            "score": 349,
            "ranking": 199205,
            "num": 1038
        },
        {
            "score": 348,
            "ranking": 200175,
            "num": 970
        },
        {
            "score": 347,
            "ranking": 201147,
            "num": 972
        },
        {
            "score": 346,
            "ranking": 202126,
            "num": 979
        },
        {
            "score": 345,
            "ranking": 203107,
            "num": 981
        },
        {
            "score": 344,
            "ranking": 204072,
            "num": 965
        },
        {
            "score": 343,
            "ranking": 205051,
            "num": 979
        },
        {
            "score": 342,
            "ranking": 206006,
            "num": 955
        },
        {
            "score": 341,
            "ranking": 206978,
            "num": 972
        },
        {
            "score": 340,
            "ranking": 207948,
            "num": 970
        },
        {
            "score": 339,
            "ranking": 208898,
            "num": 950
        },
        {
            "score": 338,
            "ranking": 209789,
            "num": 891
        },
        {
            "score": 337,
            "ranking": 210702,
            "num": 913
        },
        {
            "score": 336,
            "ranking": 211594,
            "num": 892
        },
        {
            "score": 335,
            "ranking": 212500,
            "num": 906
        },
        {
            "score": 334,
            "ranking": 213352,
            "num": 852
        },
        {
            "score": 333,
            "ranking": 214302,
            "num": 950
        },
        {
            "score": 332,
            "ranking": 215204,
            "num": 902
        },
        {
            "score": 331,
            "ranking": 216079,
            "num": 875
        },
        {
            "score": 330,
            "ranking": 216956,
            "num": 877
        },
        {
            "score": 329,
            "ranking": 217835,
            "num": 879
        },
        {
            "score": 328,
            "ranking": 218728,
            "num": 893
        },
        {
            "score": 327,
            "ranking": 219607,
            "num": 879
        },
        {
            "score": 326,
            "ranking": 220478,
            "num": 871
        },
        {
            "score": 325,
            "ranking": 221332,
            "num": 854
        },
        {
            "score": 324,
            "ranking": 222170,
            "num": 838
        },
        {
            "score": 323,
            "ranking": 223022,
            "num": 852
        },
        {
            "score": 322,
            "ranking": 223850,
            "num": 828
        },
        {
            "score": 321,
            "ranking": 224683,
            "num": 833
        },
        {
            "score": 320,
            "ranking": 225516,
            "num": 833
        },
        {
            "score": 319,
            "ranking": 226339,
            "num": 823
        },
        {
            "score": 318,
            "ranking": 227206,
            "num": 867
        },
        {
            "score": 317,
            "ranking": 228050,
            "num": 844
        },
        {
            "score": 316,
            "ranking": 228868,
            "num": 818
        },
        {
            "score": 315,
            "ranking": 229677,
            "num": 809
        },
        {
            "score": 314,
            "ranking": 230455,
            "num": 778
        },
        {
            "score": 313,
            "ranking": 231234,
            "num": 779
        },
        {
            "score": 312,
            "ranking": 232010,
            "num": 776
        },
        {
            "score": 311,
            "ranking": 232762,
            "num": 752
        },
        {
            "score": 310,
            "ranking": 233501,
            "num": 739
        },
        {
            "score": 309,
            "ranking": 234262,
            "num": 761
        },
        {
            "score": 308,
            "ranking": 235044,
            "num": 782
        },
        {
            "score": 307,
            "ranking": 235831,
            "num": 787
        },
        {
            "score": 306,
            "ranking": 236561,
            "num": 730
        },
        {
            "score": 305,
            "ranking": 237291,
            "num": 730
        },
        {
            "score": 304,
            "ranking": 238011,
            "num": 720
        },
        {
            "score": 303,
            "ranking": 238765,
            "num": 754
        },
        {
            "score": 302,
            "ranking": 239472,
            "num": 707
        },
        {
            "score": 301,
            "ranking": 240177,
            "num": 705
        },
        {
            "score": 300,
            "ranking": 240893,
            "num": 716
        },
        {
            "score": 299,
            "ranking": 241605,
            "num": 712
        },
        {
            "score": 298,
            "ranking": 242282,
            "num": 677
        },
        {
            "score": 297,
            "ranking": 242998,
            "num": 716
        },
        {
            "score": 296,
            "ranking": 243684,
            "num": 686
        },
        {
            "score": 295,
            "ranking": 244320,
            "num": 636
        },
        {
            "score": 294,
            "ranking": 244964,
            "num": 644
        },
        {
            "score": 293,
            "ranking": 245662,
            "num": 698
        },
        {
            "score": 292,
            "ranking": 246275,
            "num": 613
        },
        {
            "score": 291,
            "ranking": 246881,
            "num": 606
        },
        {
            "score": 290,
            "ranking": 247480,
            "num": 599
        },
        {
            "score": 289,
            "ranking": 248065,
            "num": 585
        },
        {
            "score": 288,
            "ranking": 248721,
            "num": 656
        },
        {
            "score": 287,
            "ranking": 249350,
            "num": 629
        },
        {
            "score": 286,
            "ranking": 249968,
            "num": 618
        },
        {
            "score": 285,
            "ranking": 250518,
            "num": 550
        },
        {
            "score": 284,
            "ranking": 251092,
            "num": 574
        },
        {
            "score": 283,
            "ranking": 251741,
            "num": 649
        },
        {
            "score": 282,
            "ranking": 252303,
            "num": 562
        },
        {
            "score": 281,
            "ranking": 252867,
            "num": 564
        },
        {
            "score": 280,
            "ranking": 253432,
            "num": 565
        },
        {
            "score": 279,
            "ranking": 253990,
            "num": 558
        },
        {
            "score": 278,
            "ranking": 254542,
            "num": 552
        },
        {
            "score": 277,
            "ranking": 255078,
            "num": 536
        },
        {
            "score": 276,
            "ranking": 255646,
            "num": 568
        },
        {
            "score": 275,
            "ranking": 256108,
            "num": 462
        },
        {
            "score": 274,
            "ranking": 256628,
            "num": 520
        },
        {
            "score": 273,
            "ranking": 257128,
            "num": 500
        },
        {
            "score": 272,
            "ranking": 257659,
            "num": 531
        },
        {
            "score": 271,
            "ranking": 258207,
            "num": 548
        },
        {
            "score": 270,
            "ranking": 258722,
            "num": 515
        },
        {
            "score": 269,
            "ranking": 259205,
            "num": 483
        },
        {
            "score": 268,
            "ranking": 259665,
            "num": 460
        },
        {
            "score": 267,
            "ranking": 260147,
            "num": 482
        },
        {
            "score": 266,
            "ranking": 260606,
            "num": 459
        },
        {
            "score": 265,
            "ranking": 261070,
            "num": 464
        },
        {
            "score": 264,
            "ranking": 261549,
            "num": 479
        },
        {
            "score": 263,
            "ranking": 261995,
            "num": 446
        },
        {
            "score": 262,
            "ranking": 262451,
            "num": 456
        },
        {
            "score": 261,
            "ranking": 262936,
            "num": 485
        },
        {
            "score": 260,
            "ranking": 263364,
            "num": 428
        },
        {
            "score": 259,
            "ranking": 263774,
            "num": 410
        },
        {
            "score": 258,
            "ranking": 264234,
            "num": 460
        },
        {
            "score": 257,
            "ranking": 264655,
            "num": 421
        },
        {
            "score": 256,
            "ranking": 265084,
            "num": 429
        },
        {
            "score": 255,
            "ranking": 265494,
            "num": 410
        },
        {
            "score": 254,
            "ranking": 265882,
            "num": 388
        },
        {
            "score": 253,
            "ranking": 266297,
            "num": 415
        },
        {
            "score": 252,
            "ranking": 266669,
            "num": 372
        },
        {
            "score": 251,
            "ranking": 267054,
            "num": 385
        },
        {
            "score": 250,
            "ranking": 267433,
            "num": 379
        },
        {
            "score": 249,
            "ranking": 267780,
            "num": 347
        },
        {
            "score": 248,
            "ranking": 268133,
            "num": 353
        },
        {
            "score": 247,
            "ranking": 268469,
            "num": 336
        },
        {
            "score": 246,
            "ranking": 268809,
            "num": 340
        },
        {
            "score": 245,
            "ranking": 269154,
            "num": 345
        },
        {
            "score": 244,
            "ranking": 269520,
            "num": 366
        },
        {
            "score": 243,
            "ranking": 269872,
            "num": 352
        },
        {
            "score": 242,
            "ranking": 270218,
            "num": 346
        },
        {
            "score": 241,
            "ranking": 270567,
            "num": 349
        },
        {
            "score": 240,
            "ranking": 270867,
            "num": 300
        },
        {
            "score": 239,
            "ranking": 271209,
            "num": 342
        },
        {
            "score": 238,
            "ranking": 271545,
            "num": 336
        },
        {
            "score": 237,
            "ranking": 271837,
            "num": 292
        },
        {
            "score": 236,
            "ranking": 272139,
            "num": 302
        },
        {
            "score": 235,
            "ranking": 272410,
            "num": 271
        },
        {
            "score": 234,
            "ranking": 272683,
            "num": 273
        },
        {
            "score": 233,
            "ranking": 272963,
            "num": 280
        },
        {
            "score": 232,
            "ranking": 273264,
            "num": 301
        },
        {
            "score": 231,
            "ranking": 273531,
            "num": 267
        },
        {
            "score": 230,
            "ranking": 273807,
            "num": 276
        },
        {
            "score": 229,
            "ranking": 274055,
            "num": 248
        },
        {
            "score": 228,
            "ranking": 274324,
            "num": 269
        },
        {
            "score": 227,
            "ranking": 274592,
            "num": 268
        },
        {
            "score": 226,
            "ranking": 274836,
            "num": 244
        },
        {
            "score": 225,
            "ranking": 275091,
            "num": 255
        },
        {
            "score": 224,
            "ranking": 275348,
            "num": 257
        },
        {
            "score": 223,
            "ranking": 275578,
            "num": 230
        },
        {
            "score": 222,
            "ranking": 275827,
            "num": 249
        },
        {
            "score": 221,
            "ranking": 276051,
            "num": 224
        },
        {
            "score": 220,
            "ranking": 276261,
            "num": 210
        },
        {
            "score": 219,
            "ranking": 276482,
            "num": 221
        },
        {
            "score": 218,
            "ranking": 276706,
            "num": 224
        },
        {
            "score": 217,
            "ranking": 276917,
            "num": 211
        },
        {
            "score": 216,
            "ranking": 277148,
            "num": 231
        },
        {
            "score": 215,
            "ranking": 277382,
            "num": 234
        },
        {
            "score": 214,
            "ranking": 277594,
            "num": 212
        },
        {
            "score": 213,
            "ranking": 277813,
            "num": 219
        },
        {
            "score": 212,
            "ranking": 278016,
            "num": 203
        },
        {
            "score": 211,
            "ranking": 278206,
            "num": 190
        },
        {
            "score": 210,
            "ranking": 278414,
            "num": 208
        },
        {
            "score": 209,
            "ranking": 278600,
            "num": 186
        },
        {
            "score": 208,
            "ranking": 278779,
            "num": 179
        },
        {
            "score": 207,
            "ranking": 278965,
            "num": 186
        },
        {
            "score": 206,
            "ranking": 279136,
            "num": 171
        },
        {
            "score": 205,
            "ranking": 279325,
            "num": 189
        },
        {
            "score": 204,
            "ranking": 279466,
            "num": 141
        },
        {
            "score": 203,
            "ranking": 279634,
            "num": 168
        },
        {
            "score": 202,
            "ranking": 279801,
            "num": 167
        },
        {
            "score": 201,
            "ranking": 279953,
            "num": 152
        },
        {
            "score": 200,
            "ranking": 280105,
            "num": 152
        },
        {
            "score": 199,
            "ranking": 280237,
            "num": 132
        },
        {
            "score": 198,
            "ranking": 280375,
            "num": 138
        },
        {
            "score": 197,
            "ranking": 280491,
            "num": 116
        },
        {
            "score": 196,
            "ranking": 280647,
            "num": 156
        },
        {
            "score": 195,
            "ranking": 280767,
            "num": 120
        },
        {
            "score": 194,
            "ranking": 280924,
            "num": 157
        },
        {
            "score": 193,
            "ranking": 281058,
            "num": 134
        },
        {
            "score": 192,
            "ranking": 281178,
            "num": 120
        },
        {
            "score": 191,
            "ranking": 281288,
            "num": 110
        },
        {
            "score": 190,
            "ranking": 281418,
            "num": 130
        },
        {
            "score": 189,
            "ranking": 281541,
            "num": 123
        },
        {
            "score": 188,
            "ranking": 281642,
            "num": 101
        },
        {
            "score": 187,
            "ranking": 281762,
            "num": 120
        },
        {
            "score": 186,
            "ranking": 281881,
            "num": 119
        },
        {
            "score": 185,
            "ranking": 281978,
            "num": 97
        },
        {
            "score": 184,
            "ranking": 282084,
            "num": 106
        },
        {
            "score": 183,
            "ranking": 282174,
            "num": 90
        },
        {
            "score": 182,
            "ranking": 282278,
            "num": 104
        },
        {
            "score": 181,
            "ranking": 282375,
            "num": 97
        },
        {
            "score": 180,
            "ranking": 282471,
            "num": 96
        },
        {
            "score": 179,
            "ranking": 282561,
            "num": 90
        },
        {
            "score": 178,
            "ranking": 282665,
            "num": 104
        },
        {
            "score": 177,
            "ranking": 282753,
            "num": 88
        },
        {
            "score": 176,
            "ranking": 282847,
            "num": 94
        },
        {
            "score": 175,
            "ranking": 282920,
            "num": 73
        },
        {
            "score": 174,
            "ranking": 283013,
            "num": 93
        },
        {
            "score": 173,
            "ranking": 283089,
            "num": 76
        },
        {
            "score": 172,
            "ranking": 283162,
            "num": 73
        },
        {
            "score": 171,
            "ranking": 283237,
            "num": 75
        },
        {
            "score": 170,
            "ranking": 283308,
            "num": 71
        },
        {
            "score": 169,
            "ranking": 283382,
            "num": 74
        },
        {
            "score": 168,
            "ranking": 283445,
            "num": 63
        },
        {
            "score": 167,
            "ranking": 283506,
            "num": 61
        },
        {
            "score": 166,
            "ranking": 283570,
            "num": 64
        },
        {
            "score": 165,
            "ranking": 283635,
            "num": 65
        },
        {
            "score": 164,
            "ranking": 283700,
            "num": 65
        },
        {
            "score": 163,
            "ranking": 283761,
            "num": 61
        },
        {
            "score": 162,
            "ranking": 283818,
            "num": 57
        },
        {
            "score": 161,
            "ranking": 283858,
            "num": 40
        },
        {
            "score": 160,
            "ranking": 283907,
            "num": 49
        },
        {
            "score": 159,
            "ranking": 283952,
            "num": 45
        },
        {
            "score": 158,
            "ranking": 284002,
            "num": 50
        },
        {
            "score": 157,
            "ranking": 284064,
            "num": 62
        },
        {
            "score": 156,
            "ranking": 284111,
            "num": 47
        },
        {
            "score": 155,
            "ranking": 284153,
            "num": 42
        },
        {
            "score": 154,
            "ranking": 284205,
            "num": 52
        },
        {
            "score": 153,
            "ranking": 284248,
            "num": 43
        },
        {
            "score": 152,
            "ranking": 284275,
            "num": 27
        },
        {
            "score": 151,
            "ranking": 284313,
            "num": 38
        },
        {
            "score": 150,
            "ranking": 284351,
            "num": 38
        },
        {
            "score": 149,
            "ranking": 284389,
            "num": 38
        },
        {
            "score": 148,
            "ranking": 284414,
            "num": 25
        },
        {
            "score": 147,
            "ranking": 284445,
            "num": 31
        },
        {
            "score": 146,
            "ranking": 284481,
            "num": 36
        },
        {
            "score": 145,
            "ranking": 284514,
            "num": 33
        },
        {
            "score": 144,
            "ranking": 284546,
            "num": 32
        },
        {
            "score": 143,
            "ranking": 284572,
            "num": 26
        },
        {
            "score": 142,
            "ranking": 284606,
            "num": 34
        },
        {
            "score": 141,
            "ranking": 284624,
            "num": 18
        },
        {
            "score": 140,
            "ranking": 284657,
            "num": 33
        },
        {
            "score": 139,
            "ranking": 284687,
            "num": 30
        }
    ],
    2018: [
        {
            "score": 688,
            "ranking": 3,
            "num": 3
        },
        {
            "score": 685,
            "ranking": 4,
            "num": 1
        },
        {
            "score": 683,
            "ranking": 5,
            "num": 1
        },
        {
            "score": 679,
            "ranking": 6,
            "num": 1
        },
        {
            "score": 677,
            "ranking": 8,
            "num": 2
        },
        {
            "score": 676,
            "ranking": 10,
            "num": 2
        },
        {
            "score": 674,
            "ranking": 12,
            "num": 2
        },
        {
            "score": 673,
            "ranking": 16,
            "num": 4
        },
        {
            "score": 672,
            "ranking": 18,
            "num": 2
        },
        {
            "score": 671,
            "ranking": 20,
            "num": 2
        },
        {
            "score": 670,
            "ranking": 23,
            "num": 3
        },
        {
            "score": 669,
            "ranking": 27,
            "num": 4
        },
        {
            "score": 668,
            "ranking": 28,
            "num": 1
        },
        {
            "score": 667,
            "ranking": 38,
            "num": 10
        },
        {
            "score": 666,
            "ranking": 46,
            "num": 8
        },
        {
            "score": 665,
            "ranking": 53,
            "num": 7
        },
        {
            "score": 664,
            "ranking": 66,
            "num": 13
        },
        {
            "score": 663,
            "ranking": 76,
            "num": 10
        },
        {
            "score": 662,
            "ranking": 84,
            "num": 8
        },
        {
            "score": 661,
            "ranking": 104,
            "num": 20
        },
        {
            "score": 660,
            "ranking": 125,
            "num": 21
        },
        {
            "score": 659,
            "ranking": 133,
            "num": 8
        },
        {
            "score": 658,
            "ranking": 144,
            "num": 11
        },
        {
            "score": 657,
            "ranking": 151,
            "num": 7
        },
        {
            "score": 656,
            "ranking": 165,
            "num": 14
        },
        {
            "score": 655,
            "ranking": 190,
            "num": 25
        },
        {
            "score": 654,
            "ranking": 207,
            "num": 17
        },
        {
            "score": 653,
            "ranking": 228,
            "num": 21
        },
        {
            "score": 652,
            "ranking": 256,
            "num": 28
        },
        {
            "score": 651,
            "ranking": 282,
            "num": 26
        },
        {
            "score": 650,
            "ranking": 318,
            "num": 36
        },
        {
            "score": 649,
            "ranking": 350,
            "num": 32
        },
        {
            "score": 648,
            "ranking": 384,
            "num": 34
        },
        {
            "score": 647,
            "ranking": 428,
            "num": 44
        },
        {
            "score": 646,
            "ranking": 468,
            "num": 40
        },
        {
            "score": 645,
            "ranking": 506,
            "num": 38
        },
        {
            "score": 644,
            "ranking": 542,
            "num": 36
        },
        {
            "score": 643,
            "ranking": 571,
            "num": 29
        },
        {
            "score": 642,
            "ranking": 618,
            "num": 47
        },
        {
            "score": 641,
            "ranking": 653,
            "num": 35
        },
        {
            "score": 640,
            "ranking": 693,
            "num": 40
        },
        {
            "score": 639,
            "ranking": 746,
            "num": 53
        },
        {
            "score": 638,
            "ranking": 800,
            "num": 54
        },
        {
            "score": 637,
            "ranking": 849,
            "num": 49
        },
        {
            "score": 636,
            "ranking": 927,
            "num": 78
        },
        {
            "score": 635,
            "ranking": 979,
            "num": 52
        },
        {
            "score": 634,
            "ranking": 1044,
            "num": 65
        },
        {
            "score": 633,
            "ranking": 1098,
            "num": 54
        },
        {
            "score": 632,
            "ranking": 1174,
            "num": 76
        },
        {
            "score": 631,
            "ranking": 1266,
            "num": 92
        },
        {
            "score": 630,
            "ranking": 1341,
            "num": 75
        },
        {
            "score": 629,
            "ranking": 1415,
            "num": 74
        },
        {
            "score": 628,
            "ranking": 1496,
            "num": 81
        },
        {
            "score": 627,
            "ranking": 1582,
            "num": 86
        },
        {
            "score": 626,
            "ranking": 1662,
            "num": 80
        },
        {
            "score": 625,
            "ranking": 1761,
            "num": 99
        },
        {
            "score": 624,
            "ranking": 1836,
            "num": 75
        },
        {
            "score": 623,
            "ranking": 1919,
            "num": 83
        },
        {
            "score": 622,
            "ranking": 2011,
            "num": 92
        },
        {
            "score": 621,
            "ranking": 2097,
            "num": 86
        },
        {
            "score": 620,
            "ranking": 2197,
            "num": 100
        },
        {
            "score": 619,
            "ranking": 2343,
            "num": 146
        },
        {
            "score": 618,
            "ranking": 2441,
            "num": 98
        },
        {
            "score": 617,
            "ranking": 2562,
            "num": 121
        },
        {
            "score": 616,
            "ranking": 2693,
            "num": 131
        },
        {
            "score": 615,
            "ranking": 2801,
            "num": 108
        },
        {
            "score": 614,
            "ranking": 2927,
            "num": 126
        },
        {
            "score": 613,
            "ranking": 3045,
            "num": 118
        },
        {
            "score": 612,
            "ranking": 3169,
            "num": 124
        },
        {
            "score": 611,
            "ranking": 3297,
            "num": 128
        },
        {
            "score": 610,
            "ranking": 3437,
            "num": 140
        },
        {
            "score": 609,
            "ranking": 3596,
            "num": 159
        },
        {
            "score": 608,
            "ranking": 3752,
            "num": 156
        },
        {
            "score": 607,
            "ranking": 3912,
            "num": 160
        },
        {
            "score": 606,
            "ranking": 4073,
            "num": 161
        },
        {
            "score": 605,
            "ranking": 4254,
            "num": 181
        },
        {
            "score": 604,
            "ranking": 4423,
            "num": 169
        },
        {
            "score": 603,
            "ranking": 4574,
            "num": 151
        },
        {
            "score": 602,
            "ranking": 4718,
            "num": 144
        },
        {
            "score": 601,
            "ranking": 4905,
            "num": 187
        },
        {
            "score": 600,
            "ranking": 5089,
            "num": 184
        },
        {
            "score": 599,
            "ranking": 5282,
            "num": 193
        },
        {
            "score": 598,
            "ranking": 5469,
            "num": 187
        },
        {
            "score": 597,
            "ranking": 5642,
            "num": 173
        },
        {
            "score": 596,
            "ranking": 5874,
            "num": 232
        },
        {
            "score": 595,
            "ranking": 6071,
            "num": 197
        },
        {
            "score": 594,
            "ranking": 6301,
            "num": 230
        },
        {
            "score": 593,
            "ranking": 6485,
            "num": 184
        },
        {
            "score": 592,
            "ranking": 6688,
            "num": 203
        },
        {
            "score": 591,
            "ranking": 6913,
            "num": 225
        },
        {
            "score": 590,
            "ranking": 7122,
            "num": 209
        },
        {
            "score": 589,
            "ranking": 7332,
            "num": 210
        },
        {
            "score": 588,
            "ranking": 7575,
            "num": 243
        },
        {
            "score": 587,
            "ranking": 7823,
            "num": 248
        },
        {
            "score": 586,
            "ranking": 8067,
            "num": 244
        },
        {
            "score": 585,
            "ranking": 8346,
            "num": 279
        },
        {
            "score": 584,
            "ranking": 8565,
            "num": 219
        },
        {
            "score": 583,
            "ranking": 8825,
            "num": 260
        },
        {
            "score": 582,
            "ranking": 9086,
            "num": 261
        },
        {
            "score": 581,
            "ranking": 9342,
            "num": 256
        },
        {
            "score": 580,
            "ranking": 9633,
            "num": 291
        },
        {
            "score": 579,
            "ranking": 9905,
            "num": 272
        },
        {
            "score": 578,
            "ranking": 10192,
            "num": 287
        },
        {
            "score": 577,
            "ranking": 10474,
            "num": 282
        },
        {
            "score": 576,
            "ranking": 10788,
            "num": 314
        },
        {
            "score": 575,
            "ranking": 11112,
            "num": 324
        },
        {
            "score": 574,
            "ranking": 11428,
            "num": 316
        },
        {
            "score": 573,
            "ranking": 11698,
            "num": 270
        },
        {
            "score": 572,
            "ranking": 12003,
            "num": 305
        },
        {
            "score": 571,
            "ranking": 12332,
            "num": 329
        },
        {
            "score": 570,
            "ranking": 12654,
            "num": 322
        },
        {
            "score": 569,
            "ranking": 12983,
            "num": 329
        },
        {
            "score": 568,
            "ranking": 13302,
            "num": 319
        },
        {
            "score": 567,
            "ranking": 13662,
            "num": 360
        },
        {
            "score": 566,
            "ranking": 14018,
            "num": 356
        },
        {
            "score": 565,
            "ranking": 14401,
            "num": 383
        },
        {
            "score": 564,
            "ranking": 14785,
            "num": 384
        },
        {
            "score": 563,
            "ranking": 15188,
            "num": 403
        },
        {
            "score": 562,
            "ranking": 15581,
            "num": 393
        },
        {
            "score": 561,
            "ranking": 15929,
            "num": 348
        },
        {
            "score": 560,
            "ranking": 16337,
            "num": 408
        },
        {
            "score": 559,
            "ranking": 16708,
            "num": 371
        },
        {
            "score": 558,
            "ranking": 17091,
            "num": 383
        },
        {
            "score": 557,
            "ranking": 17500,
            "num": 409
        },
        {
            "score": 556,
            "ranking": 17891,
            "num": 391
        },
        {
            "score": 555,
            "ranking": 18319,
            "num": 428
        },
        {
            "score": 554,
            "ranking": 18786,
            "num": 467
        },
        {
            "score": 553,
            "ranking": 19215,
            "num": 429
        },
        {
            "score": 552,
            "ranking": 19630,
            "num": 415
        },
        {
            "score": 551,
            "ranking": 20054,
            "num": 424
        },
        {
            "score": 550,
            "ranking": 20481,
            "num": 427
        },
        {
            "score": 549,
            "ranking": 20959,
            "num": 478
        },
        {
            "score": 548,
            "ranking": 21437,
            "num": 478
        },
        {
            "score": 547,
            "ranking": 21887,
            "num": 450
        },
        {
            "score": 546,
            "ranking": 22368,
            "num": 481
        },
        {
            "score": 545,
            "ranking": 22826,
            "num": 458
        },
        {
            "score": 544,
            "ranking": 23311,
            "num": 485
        },
        {
            "score": 543,
            "ranking": 23777,
            "num": 466
        },
        {
            "score": 542,
            "ranking": 24238,
            "num": 461
        },
        {
            "score": 541,
            "ranking": 24734,
            "num": 496
        },
        {
            "score": 540,
            "ranking": 25209,
            "num": 475
        },
        {
            "score": 539,
            "ranking": 25711,
            "num": 502
        },
        {
            "score": 538,
            "ranking": 26182,
            "num": 471
        },
        {
            "score": 537,
            "ranking": 26704,
            "num": 522
        },
        {
            "score": 536,
            "ranking": 27280,
            "num": 576
        },
        {
            "score": 535,
            "ranking": 27832,
            "num": 552
        },
        {
            "score": 534,
            "ranking": 28372,
            "num": 540
        },
        {
            "score": 533,
            "ranking": 28913,
            "num": 541
        },
        {
            "score": 532,
            "ranking": 29468,
            "num": 555
        },
        {
            "score": 531,
            "ranking": 30026,
            "num": 558
        },
        {
            "score": 530,
            "ranking": 30539,
            "num": 513
        },
        {
            "score": 529,
            "ranking": 31098,
            "num": 559
        },
        {
            "score": 528,
            "ranking": 31669,
            "num": 571
        },
        {
            "score": 527,
            "ranking": 32212,
            "num": 543
        },
        {
            "score": 526,
            "ranking": 32798,
            "num": 586
        },
        {
            "score": 525,
            "ranking": 33378,
            "num": 580
        },
        {
            "score": 524,
            "ranking": 33927,
            "num": 549
        },
        {
            "score": 523,
            "ranking": 34513,
            "num": 586
        },
        {
            "score": 522,
            "ranking": 35121,
            "num": 608
        },
        {
            "score": 521,
            "ranking": 35739,
            "num": 618
        },
        {
            "score": 520,
            "ranking": 36331,
            "num": 592
        },
        {
            "score": 519,
            "ranking": 36906,
            "num": 575
        },
        {
            "score": 518,
            "ranking": 37515,
            "num": 609
        },
        {
            "score": 517,
            "ranking": 38114,
            "num": 599
        },
        {
            "score": 516,
            "ranking": 38708,
            "num": 594
        },
        {
            "score": 515,
            "ranking": 39352,
            "num": 644
        },
        {
            "score": 514,
            "ranking": 39996,
            "num": 644
        },
        {
            "score": 513,
            "ranking": 40635,
            "num": 639
        },
        {
            "score": 512,
            "ranking": 41319,
            "num": 684
        },
        {
            "score": 511,
            "ranking": 41982,
            "num": 663
        },
        {
            "score": 510,
            "ranking": 42640,
            "num": 658
        },
        {
            "score": 509,
            "ranking": 43313,
            "num": 673
        },
        {
            "score": 508,
            "ranking": 43981,
            "num": 668
        },
        {
            "score": 507,
            "ranking": 44618,
            "num": 637
        },
        {
            "score": 506,
            "ranking": 45254,
            "num": 636
        },
        {
            "score": 505,
            "ranking": 45868,
            "num": 614
        },
        {
            "score": 504,
            "ranking": 46531,
            "num": 663
        },
        {
            "score": 503,
            "ranking": 47187,
            "num": 656
        },
        {
            "score": 502,
            "ranking": 47854,
            "num": 667
        },
        {
            "score": 501,
            "ranking": 48526,
            "num": 672
        },
        {
            "score": 500,
            "ranking": 49188,
            "num": 662
        },
        {
            "score": 499,
            "ranking": 49865,
            "num": 677
        },
        {
            "score": 498,
            "ranking": 50549,
            "num": 684
        },
        {
            "score": 497,
            "ranking": 51228,
            "num": 679
        },
        {
            "score": 496,
            "ranking": 51955,
            "num": 727
        },
        {
            "score": 495,
            "ranking": 52647,
            "num": 692
        },
        {
            "score": 494,
            "ranking": 53320,
            "num": 673
        },
        {
            "score": 493,
            "ranking": 53996,
            "num": 676
        },
        {
            "score": 492,
            "ranking": 54647,
            "num": 651
        },
        {
            "score": 491,
            "ranking": 55331,
            "num": 684
        },
        {
            "score": 490,
            "ranking": 56045,
            "num": 714
        },
        {
            "score": 489,
            "ranking": 56804,
            "num": 759
        },
        {
            "score": 488,
            "ranking": 57511,
            "num": 707
        },
        {
            "score": 487,
            "ranking": 58227,
            "num": 716
        },
        {
            "score": 486,
            "ranking": 58933,
            "num": 706
        },
        {
            "score": 485,
            "ranking": 59667,
            "num": 734
        },
        {
            "score": 484,
            "ranking": 60440,
            "num": 773
        },
        {
            "score": 483,
            "ranking": 61193,
            "num": 753
        },
        {
            "score": 482,
            "ranking": 61880,
            "num": 687
        },
        {
            "score": 481,
            "ranking": 62634,
            "num": 754
        },
        {
            "score": 480,
            "ranking": 63351,
            "num": 717
        },
        {
            "score": 479,
            "ranking": 64067,
            "num": 716
        },
        {
            "score": 478,
            "ranking": 64827,
            "num": 760
        },
        {
            "score": 477,
            "ranking": 65574,
            "num": 747
        },
        {
            "score": 476,
            "ranking": 66294,
            "num": 720
        },
        {
            "score": 475,
            "ranking": 67058,
            "num": 764
        },
        {
            "score": 474,
            "ranking": 67802,
            "num": 744
        },
        {
            "score": 473,
            "ranking": 68512,
            "num": 710
        },
        {
            "score": 472,
            "ranking": 69257,
            "num": 745
        },
        {
            "score": 471,
            "ranking": 70005,
            "num": 748
        },
        {
            "score": 470,
            "ranking": 70750,
            "num": 745
        },
        {
            "score": 469,
            "ranking": 71512,
            "num": 762
        },
        {
            "score": 468,
            "ranking": 72281,
            "num": 769
        },
        {
            "score": 467,
            "ranking": 73081,
            "num": 800
        },
        {
            "score": 466,
            "ranking": 73798,
            "num": 717
        },
        {
            "score": 465,
            "ranking": 74610,
            "num": 812
        },
        {
            "score": 464,
            "ranking": 75376,
            "num": 766
        },
        {
            "score": 463,
            "ranking": 76182,
            "num": 806
        },
        {
            "score": 462,
            "ranking": 76960,
            "num": 778
        },
        {
            "score": 461,
            "ranking": 77745,
            "num": 785
        },
        {
            "score": 460,
            "ranking": 78520,
            "num": 775
        },
        {
            "score": 459,
            "ranking": 79328,
            "num": 808
        },
        {
            "score": 458,
            "ranking": 80122,
            "num": 794
        },
        {
            "score": 457,
            "ranking": 80901,
            "num": 779
        },
        {
            "score": 456,
            "ranking": 81721,
            "num": 820
        },
        {
            "score": 455,
            "ranking": 82462,
            "num": 741
        },
        {
            "score": 454,
            "ranking": 83231,
            "num": 769
        },
        {
            "score": 453,
            "ranking": 83990,
            "num": 759
        },
        {
            "score": 452,
            "ranking": 84759,
            "num": 769
        },
        {
            "score": 451,
            "ranking": 85611,
            "num": 852
        },
        {
            "score": 450,
            "ranking": 86413,
            "num": 802
        },
        {
            "score": 449,
            "ranking": 87186,
            "num": 773
        },
        {
            "score": 448,
            "ranking": 88006,
            "num": 820
        },
        {
            "score": 447,
            "ranking": 88824,
            "num": 818
        },
        {
            "score": 446,
            "ranking": 89606,
            "num": 782
        },
        {
            "score": 445,
            "ranking": 90426,
            "num": 820
        },
        {
            "score": 444,
            "ranking": 91205,
            "num": 779
        },
        {
            "score": 443,
            "ranking": 91983,
            "num": 778
        },
        {
            "score": 442,
            "ranking": 92768,
            "num": 785
        },
        {
            "score": 441,
            "ranking": 93553,
            "num": 785
        },
        {
            "score": 440,
            "ranking": 94354,
            "num": 801
        },
        {
            "score": 439,
            "ranking": 95168,
            "num": 814
        },
        {
            "score": 438,
            "ranking": 96002,
            "num": 834
        },
        {
            "score": 437,
            "ranking": 96814,
            "num": 812
        },
        {
            "score": 436,
            "ranking": 97621,
            "num": 807
        },
        {
            "score": 435,
            "ranking": 98444,
            "num": 823
        },
        {
            "score": 434,
            "ranking": 99278,
            "num": 834
        },
        {
            "score": 433,
            "ranking": 100080,
            "num": 802
        },
        {
            "score": 432,
            "ranking": 100900,
            "num": 820
        },
        {
            "score": 431,
            "ranking": 101660,
            "num": 760
        },
        {
            "score": 430,
            "ranking": 102477,
            "num": 817
        },
        {
            "score": 429,
            "ranking": 103285,
            "num": 808
        },
        {
            "score": 428,
            "ranking": 104094,
            "num": 809
        },
        {
            "score": 427,
            "ranking": 104911,
            "num": 817
        },
        {
            "score": 426,
            "ranking": 105709,
            "num": 798
        },
        {
            "score": 425,
            "ranking": 106517,
            "num": 808
        },
        {
            "score": 424,
            "ranking": 107355,
            "num": 838
        },
        {
            "score": 423,
            "ranking": 108192,
            "num": 837
        },
        {
            "score": 422,
            "ranking": 109026,
            "num": 834
        },
        {
            "score": 421,
            "ranking": 109838,
            "num": 812
        },
        {
            "score": 420,
            "ranking": 110664,
            "num": 826
        },
        {
            "score": 419,
            "ranking": 111521,
            "num": 857
        },
        {
            "score": 418,
            "ranking": 112332,
            "num": 811
        },
        {
            "score": 417,
            "ranking": 113208,
            "num": 876
        },
        {
            "score": 416,
            "ranking": 114013,
            "num": 805
        },
        {
            "score": 415,
            "ranking": 114839,
            "num": 826
        },
        {
            "score": 414,
            "ranking": 115660,
            "num": 821
        },
        {
            "score": 413,
            "ranking": 116527,
            "num": 867
        },
        {
            "score": 412,
            "ranking": 117383,
            "num": 856
        },
        {
            "score": 411,
            "ranking": 118248,
            "num": 865
        },
        {
            "score": 410,
            "ranking": 119063,
            "num": 815
        },
        {
            "score": 409,
            "ranking": 119864,
            "num": 801
        },
        {
            "score": 408,
            "ranking": 120726,
            "num": 862
        },
        {
            "score": 407,
            "ranking": 121547,
            "num": 821
        },
        {
            "score": 406,
            "ranking": 122368,
            "num": 821
        },
        {
            "score": 405,
            "ranking": 123199,
            "num": 831
        },
        {
            "score": 404,
            "ranking": 124029,
            "num": 830
        },
        {
            "score": 403,
            "ranking": 124854,
            "num": 825
        },
        {
            "score": 402,
            "ranking": 125701,
            "num": 847
        },
        {
            "score": 401,
            "ranking": 126531,
            "num": 830
        },
        {
            "score": 400,
            "ranking": 127393,
            "num": 862
        },
        {
            "score": 399,
            "ranking": 128244,
            "num": 851
        },
        {
            "score": 398,
            "ranking": 129102,
            "num": 858
        },
        {
            "score": 397,
            "ranking": 129970,
            "num": 868
        },
        {
            "score": 396,
            "ranking": 130790,
            "num": 820
        },
        {
            "score": 395,
            "ranking": 131652,
            "num": 862
        },
        {
            "score": 394,
            "ranking": 132539,
            "num": 887
        },
        {
            "score": 393,
            "ranking": 133371,
            "num": 832
        },
        {
            "score": 392,
            "ranking": 134233,
            "num": 862
        },
        {
            "score": 391,
            "ranking": 135145,
            "num": 912
        },
        {
            "score": 390,
            "ranking": 136013,
            "num": 868
        },
        {
            "score": 389,
            "ranking": 136883,
            "num": 870
        },
        {
            "score": 388,
            "ranking": 137728,
            "num": 845
        },
        {
            "score": 387,
            "ranking": 138595,
            "num": 867
        },
        {
            "score": 386,
            "ranking": 139437,
            "num": 842
        },
        {
            "score": 385,
            "ranking": 140332,
            "num": 895
        },
        {
            "score": 384,
            "ranking": 141205,
            "num": 873
        },
        {
            "score": 383,
            "ranking": 142082,
            "num": 877
        },
        {
            "score": 382,
            "ranking": 142982,
            "num": 900
        },
        {
            "score": 381,
            "ranking": 143856,
            "num": 874
        },
        {
            "score": 380,
            "ranking": 144730,
            "num": 874
        },
        {
            "score": 379,
            "ranking": 145626,
            "num": 896
        },
        {
            "score": 378,
            "ranking": 146517,
            "num": 891
        },
        {
            "score": 377,
            "ranking": 147419,
            "num": 902
        },
        {
            "score": 376,
            "ranking": 148308,
            "num": 889
        },
        {
            "score": 375,
            "ranking": 149160,
            "num": 852
        },
        {
            "score": 374,
            "ranking": 150065,
            "num": 905
        },
        {
            "score": 373,
            "ranking": 150940,
            "num": 875
        },
        {
            "score": 372,
            "ranking": 151829,
            "num": 889
        },
        {
            "score": 371,
            "ranking": 152812,
            "num": 983
        },
        {
            "score": 370,
            "ranking": 153739,
            "num": 927
        },
        {
            "score": 369,
            "ranking": 154637,
            "num": 898
        },
        {
            "score": 368,
            "ranking": 155579,
            "num": 942
        },
        {
            "score": 367,
            "ranking": 156467,
            "num": 888
        },
        {
            "score": 366,
            "ranking": 157353,
            "num": 886
        },
        {
            "score": 365,
            "ranking": 158271,
            "num": 918
        },
        {
            "score": 364,
            "ranking": 159167,
            "num": 896
        },
        {
            "score": 363,
            "ranking": 160139,
            "num": 972
        },
        {
            "score": 362,
            "ranking": 161035,
            "num": 896
        },
        {
            "score": 361,
            "ranking": 161903,
            "num": 868
        },
        {
            "score": 360,
            "ranking": 162819,
            "num": 916
        },
        {
            "score": 359,
            "ranking": 163746,
            "num": 927
        },
        {
            "score": 358,
            "ranking": 164625,
            "num": 879
        },
        {
            "score": 357,
            "ranking": 165523,
            "num": 898
        },
        {
            "score": 356,
            "ranking": 166461,
            "num": 938
        },
        {
            "score": 355,
            "ranking": 167399,
            "num": 938
        },
        {
            "score": 354,
            "ranking": 168369,
            "num": 970
        },
        {
            "score": 353,
            "ranking": 169319,
            "num": 950
        },
        {
            "score": 352,
            "ranking": 170221,
            "num": 902
        },
        {
            "score": 351,
            "ranking": 171110,
            "num": 889
        },
        {
            "score": 350,
            "ranking": 172013,
            "num": 903
        },
        {
            "score": 349,
            "ranking": 172908,
            "num": 895
        },
        {
            "score": 348,
            "ranking": 173851,
            "num": 943
        },
        {
            "score": 347,
            "ranking": 174787,
            "num": 936
        },
        {
            "score": 346,
            "ranking": 175670,
            "num": 883
        },
        {
            "score": 345,
            "ranking": 176549,
            "num": 879
        },
        {
            "score": 344,
            "ranking": 177423,
            "num": 874
        },
        {
            "score": 343,
            "ranking": 178281,
            "num": 858
        },
        {
            "score": 342,
            "ranking": 179203,
            "num": 922
        },
        {
            "score": 341,
            "ranking": 180065,
            "num": 862
        },
        {
            "score": 340,
            "ranking": 180920,
            "num": 855
        },
        {
            "score": 339,
            "ranking": 181853,
            "num": 933
        },
        {
            "score": 338,
            "ranking": 182832,
            "num": 979
        },
        {
            "score": 337,
            "ranking": 183755,
            "num": 923
        },
        {
            "score": 336,
            "ranking": 184622,
            "num": 867
        },
        {
            "score": 335,
            "ranking": 185486,
            "num": 864
        },
        {
            "score": 334,
            "ranking": 186442,
            "num": 956
        },
        {
            "score": 333,
            "ranking": 187338,
            "num": 896
        },
        {
            "score": 332,
            "ranking": 188235,
            "num": 897
        },
        {
            "score": 331,
            "ranking": 189123,
            "num": 888
        },
        {
            "score": 330,
            "ranking": 190021,
            "num": 898
        },
        {
            "score": 329,
            "ranking": 190924,
            "num": 903
        },
        {
            "score": 328,
            "ranking": 191794,
            "num": 870
        },
        {
            "score": 327,
            "ranking": 192640,
            "num": 846
        },
        {
            "score": 326,
            "ranking": 193525,
            "num": 885
        },
        {
            "score": 325,
            "ranking": 194394,
            "num": 869
        },
        {
            "score": 324,
            "ranking": 195315,
            "num": 921
        },
        {
            "score": 323,
            "ranking": 196192,
            "num": 877
        },
        {
            "score": 322,
            "ranking": 197082,
            "num": 890
        },
        {
            "score": 321,
            "ranking": 197973,
            "num": 891
        },
        {
            "score": 320,
            "ranking": 198846,
            "num": 873
        },
        {
            "score": 319,
            "ranking": 199731,
            "num": 885
        },
        {
            "score": 318,
            "ranking": 200579,
            "num": 848
        },
        {
            "score": 317,
            "ranking": 201456,
            "num": 877
        },
        {
            "score": 316,
            "ranking": 202256,
            "num": 800
        },
        {
            "score": 315,
            "ranking": 203085,
            "num": 829
        },
        {
            "score": 314,
            "ranking": 203983,
            "num": 898
        },
        {
            "score": 313,
            "ranking": 204830,
            "num": 847
        },
        {
            "score": 312,
            "ranking": 205687,
            "num": 857
        },
        {
            "score": 311,
            "ranking": 206543,
            "num": 856
        },
        {
            "score": 310,
            "ranking": 207340,
            "num": 797
        },
        {
            "score": 309,
            "ranking": 208215,
            "num": 875
        },
        {
            "score": 308,
            "ranking": 209043,
            "num": 828
        },
        {
            "score": 307,
            "ranking": 209846,
            "num": 803
        },
        {
            "score": 306,
            "ranking": 210670,
            "num": 824
        },
        {
            "score": 305,
            "ranking": 211428,
            "num": 758
        },
        {
            "score": 304,
            "ranking": 212226,
            "num": 798
        },
        {
            "score": 303,
            "ranking": 213047,
            "num": 821
        },
        {
            "score": 302,
            "ranking": 213867,
            "num": 820
        },
        {
            "score": 301,
            "ranking": 214719,
            "num": 852
        },
        {
            "score": 300,
            "ranking": 215498,
            "num": 779
        },
        {
            "score": 299,
            "ranking": 216308,
            "num": 810
        },
        {
            "score": 298,
            "ranking": 217132,
            "num": 824
        },
        {
            "score": 297,
            "ranking": 217919,
            "num": 787
        },
        {
            "score": 296,
            "ranking": 218721,
            "num": 802
        },
        {
            "score": 295,
            "ranking": 219484,
            "num": 763
        },
        {
            "score": 294,
            "ranking": 220235,
            "num": 751
        },
        {
            "score": 293,
            "ranking": 220960,
            "num": 725
        },
        {
            "score": 292,
            "ranking": 221684,
            "num": 724
        },
        {
            "score": 291,
            "ranking": 222430,
            "num": 746
        },
        {
            "score": 290,
            "ranking": 223175,
            "num": 745
        },
        {
            "score": 289,
            "ranking": 223915,
            "num": 740
        },
        {
            "score": 288,
            "ranking": 224654,
            "num": 739
        },
        {
            "score": 287,
            "ranking": 225418,
            "num": 764
        },
        {
            "score": 286,
            "ranking": 226105,
            "num": 687
        },
        {
            "score": 285,
            "ranking": 226834,
            "num": 729
        },
        {
            "score": 284,
            "ranking": 227539,
            "num": 705
        },
        {
            "score": 283,
            "ranking": 228239,
            "num": 700
        },
        {
            "score": 282,
            "ranking": 228952,
            "num": 713
        },
        {
            "score": 281,
            "ranking": 229639,
            "num": 687
        },
        {
            "score": 280,
            "ranking": 230323,
            "num": 684
        },
        {
            "score": 279,
            "ranking": 231006,
            "num": 683
        },
        {
            "score": 278,
            "ranking": 231605,
            "num": 599
        },
        {
            "score": 277,
            "ranking": 232296,
            "num": 691
        },
        {
            "score": 276,
            "ranking": 233009,
            "num": 713
        },
        {
            "score": 275,
            "ranking": 233657,
            "num": 648
        },
        {
            "score": 274,
            "ranking": 234300,
            "num": 643
        },
        {
            "score": 273,
            "ranking": 234962,
            "num": 662
        },
        {
            "score": 272,
            "ranking": 235610,
            "num": 648
        },
        {
            "score": 271,
            "ranking": 236231,
            "num": 621
        },
        {
            "score": 270,
            "ranking": 236905,
            "num": 674
        },
        {
            "score": 269,
            "ranking": 237516,
            "num": 611
        },
        {
            "score": 268,
            "ranking": 238128,
            "num": 612
        },
        {
            "score": 267,
            "ranking": 238777,
            "num": 649
        },
        {
            "score": 266,
            "ranking": 239328,
            "num": 551
        },
        {
            "score": 265,
            "ranking": 239921,
            "num": 593
        },
        {
            "score": 264,
            "ranking": 240539,
            "num": 618
        },
        {
            "score": 263,
            "ranking": 241161,
            "num": 622
        },
        {
            "score": 262,
            "ranking": 241761,
            "num": 600
        },
        {
            "score": 261,
            "ranking": 242363,
            "num": 602
        },
        {
            "score": 260,
            "ranking": 242942,
            "num": 579
        },
        {
            "score": 259,
            "ranking": 243479,
            "num": 537
        },
        {
            "score": 258,
            "ranking": 244062,
            "num": 583
        },
        {
            "score": 257,
            "ranking": 244605,
            "num": 543
        },
        {
            "score": 256,
            "ranking": 245132,
            "num": 527
        },
        {
            "score": 255,
            "ranking": 245687,
            "num": 555
        },
        {
            "score": 254,
            "ranking": 246251,
            "num": 564
        },
        {
            "score": 253,
            "ranking": 246733,
            "num": 482
        },
        {
            "score": 252,
            "ranking": 247231,
            "num": 498
        },
        {
            "score": 251,
            "ranking": 247707,
            "num": 476
        },
        {
            "score": 250,
            "ranking": 248186,
            "num": 479
        },
        {
            "score": 249,
            "ranking": 248713,
            "num": 527
        },
        {
            "score": 248,
            "ranking": 249205,
            "num": 492
        },
        {
            "score": 247,
            "ranking": 249701,
            "num": 496
        },
        {
            "score": 246,
            "ranking": 250174,
            "num": 473
        },
        {
            "score": 245,
            "ranking": 250610,
            "num": 436
        },
        {
            "score": 244,
            "ranking": 251051,
            "num": 441
        },
        {
            "score": 243,
            "ranking": 251510,
            "num": 459
        },
        {
            "score": 242,
            "ranking": 251970,
            "num": 460
        },
        {
            "score": 241,
            "ranking": 252440,
            "num": 470
        },
        {
            "score": 240,
            "ranking": 252835,
            "num": 395
        },
        {
            "score": 239,
            "ranking": 253272,
            "num": 437
        },
        {
            "score": 238,
            "ranking": 253691,
            "num": 419
        },
        {
            "score": 237,
            "ranking": 254102,
            "num": 411
        },
        {
            "score": 236,
            "ranking": 254511,
            "num": 409
        },
        {
            "score": 235,
            "ranking": 254926,
            "num": 415
        },
        {
            "score": 234,
            "ranking": 255344,
            "num": 418
        },
        {
            "score": 233,
            "ranking": 255765,
            "num": 421
        },
        {
            "score": 232,
            "ranking": 256163,
            "num": 398
        },
        {
            "score": 231,
            "ranking": 256498,
            "num": 335
        },
        {
            "score": 230,
            "ranking": 256845,
            "num": 347
        },
        {
            "score": 229,
            "ranking": 257200,
            "num": 355
        },
        {
            "score": 228,
            "ranking": 257551,
            "num": 351
        },
        {
            "score": 227,
            "ranking": 257923,
            "num": 372
        },
        {
            "score": 226,
            "ranking": 258248,
            "num": 325
        },
        {
            "score": 225,
            "ranking": 258598,
            "num": 350
        },
        {
            "score": 224,
            "ranking": 258899,
            "num": 301
        },
        {
            "score": 223,
            "ranking": 259209,
            "num": 310
        },
        {
            "score": 222,
            "ranking": 259542,
            "num": 333
        },
        {
            "score": 221,
            "ranking": 259860,
            "num": 318
        },
        {
            "score": 220,
            "ranking": 260198,
            "num": 338
        },
        {
            "score": 219,
            "ranking": 260496,
            "num": 298
        },
        {
            "score": 218,
            "ranking": 260820,
            "num": 324
        },
        {
            "score": 217,
            "ranking": 261145,
            "num": 325
        },
        {
            "score": 216,
            "ranking": 261465,
            "num": 320
        },
        {
            "score": 215,
            "ranking": 261758,
            "num": 293
        },
        {
            "score": 214,
            "ranking": 262018,
            "num": 260
        },
        {
            "score": 213,
            "ranking": 262315,
            "num": 297
        },
        {
            "score": 212,
            "ranking": 262561,
            "num": 246
        },
        {
            "score": 211,
            "ranking": 262811,
            "num": 250
        },
        {
            "score": 210,
            "ranking": 263058,
            "num": 247
        },
        {
            "score": 209,
            "ranking": 263316,
            "num": 258
        },
        {
            "score": 208,
            "ranking": 263592,
            "num": 276
        },
        {
            "score": 207,
            "ranking": 263820,
            "num": 228
        },
        {
            "score": 206,
            "ranking": 264060,
            "num": 240
        },
        {
            "score": 205,
            "ranking": 264294,
            "num": 234
        },
        {
            "score": 204,
            "ranking": 264522,
            "num": 228
        },
        {
            "score": 203,
            "ranking": 264760,
            "num": 238
        },
        {
            "score": 202,
            "ranking": 264982,
            "num": 222
        },
        {
            "score": 201,
            "ranking": 265223,
            "num": 241
        },
        {
            "score": 200,
            "ranking": 265412,
            "num": 189
        },
        {
            "score": 199,
            "ranking": 265602,
            "num": 190
        },
        {
            "score": 198,
            "ranking": 265785,
            "num": 183
        },
        {
            "score": 197,
            "ranking": 265988,
            "num": 203
        },
        {
            "score": 196,
            "ranking": 266180,
            "num": 192
        },
        {
            "score": 195,
            "ranking": 266359,
            "num": 179
        },
        {
            "score": 194,
            "ranking": 266542,
            "num": 183
        },
        {
            "score": 193,
            "ranking": 266700,
            "num": 158
        },
        {
            "score": 192,
            "ranking": 266902,
            "num": 202
        },
        {
            "score": 191,
            "ranking": 267091,
            "num": 189
        },
        {
            "score": 190,
            "ranking": 267268,
            "num": 177
        },
        {
            "score": 189,
            "ranking": 267430,
            "num": 162
        },
        {
            "score": 188,
            "ranking": 267588,
            "num": 158
        },
        {
            "score": 187,
            "ranking": 267755,
            "num": 167
        },
        {
            "score": 186,
            "ranking": 267895,
            "num": 140
        },
        {
            "score": 185,
            "ranking": 268034,
            "num": 139
        },
        {
            "score": 184,
            "ranking": 268157,
            "num": 123
        },
        {
            "score": 183,
            "ranking": 268301,
            "num": 144
        },
        {
            "score": 182,
            "ranking": 268452,
            "num": 151
        },
        {
            "score": 181,
            "ranking": 268586,
            "num": 134
        },
        {
            "score": 180,
            "ranking": 268708,
            "num": 122
        },
        {
            "score": 179,
            "ranking": 268838,
            "num": 130
        },
        {
            "score": 178,
            "ranking": 268958,
            "num": 120
        },
        {
            "score": 177,
            "ranking": 269056,
            "num": 98
        },
        {
            "score": 176,
            "ranking": 269179,
            "num": 123
        },
        {
            "score": 175,
            "ranking": 269303,
            "num": 124
        },
        {
            "score": 174,
            "ranking": 269408,
            "num": 105
        },
        {
            "score": 173,
            "ranking": 269515,
            "num": 107
        },
        {
            "score": 172,
            "ranking": 269614,
            "num": 99
        },
        {
            "score": 171,
            "ranking": 269708,
            "num": 94
        },
        {
            "score": 170,
            "ranking": 269819,
            "num": 111
        },
        {
            "score": 169,
            "ranking": 269929,
            "num": 110
        },
        {
            "score": 168,
            "ranking": 270018,
            "num": 89
        },
        {
            "score": 167,
            "ranking": 270100,
            "num": 82
        },
        {
            "score": 166,
            "ranking": 270175,
            "num": 75
        },
        {
            "score": 165,
            "ranking": 270238,
            "num": 63
        },
        {
            "score": 164,
            "ranking": 270310,
            "num": 72
        },
        {
            "score": 163,
            "ranking": 270387,
            "num": 77
        },
        {
            "score": 162,
            "ranking": 270447,
            "num": 60
        },
        {
            "score": 161,
            "ranking": 270514,
            "num": 67
        },
        {
            "score": 160,
            "ranking": 270583,
            "num": 69
        },
        {
            "score": 159,
            "ranking": 270645,
            "num": 62
        },
        {
            "score": 158,
            "ranking": 270705,
            "num": 60
        },
        {
            "score": 157,
            "ranking": 270756,
            "num": 51
        },
        {
            "score": 156,
            "ranking": 270828,
            "num": 72
        },
        {
            "score": 155,
            "ranking": 270886,
            "num": 58
        },
        {
            "score": 154,
            "ranking": 270952,
            "num": 66
        },
        {
            "score": 153,
            "ranking": 271004,
            "num": 52
        },
        {
            "score": 152,
            "ranking": 271061,
            "num": 57
        },
        {
            "score": 151,
            "ranking": 271102,
            "num": 41
        },
        {
            "score": 150,
            "ranking": 271152,
            "num": 50
        },
        {
            "score": 149,
            "ranking": 271194,
            "num": 42
        },
        {
            "score": 148,
            "ranking": 271237,
            "num": 43
        },
        {
            "score": 147,
            "ranking": 271265,
            "num": 28
        },
        {
            "score": 146,
            "ranking": 271307,
            "num": 42
        },
        {
            "score": 145,
            "ranking": 271363,
            "num": 56
        },
        {
            "score": 144,
            "ranking": 271397,
            "num": 34
        },
        {
            "score": 143,
            "ranking": 271422,
            "num": 25
        },
        {
            "score": 142,
            "ranking": 271473,
            "num": 51
        },
        {
            "score": 141,
            "ranking": 271511,
            "num": 38
        },
        {
            "score": 140,
            "ranking": 271535,
            "num": 24
        },
        {
            "score": 139,
            "ranking": 271579,
            "num": 44
        },
        {
            "score": 138,
            "ranking": 271617,
            "num": 38
        },
        {
            "score": 137,
            "ranking": 271636,
            "num": 19
        },
        {
            "score": 136,
            "ranking": 271667,
            "num": 31
        },
        {
            "score": 135,
            "ranking": 271701,
            "num": 34
        },
        {
            "score": 134,
            "ranking": 271724,
            "num": 23
        },
        {
            "score": 133,
            "ranking": 271754,
            "num": 30
        },
        {
            "score": 132,
            "ranking": 271780,
            "num": 26
        },
        {
            "score": 131,
            "ranking": 271802,
            "num": 22
        },
        {
            "score": 130,
            "ranking": 271820,
            "num": 18
        },
        {
            "score": 129,
            "ranking": 271843,
            "num": 23
        },
        {
            "score": 128,
            "ranking": 271864,
            "num": 21
        },
        {
            "score": 127,
            "ranking": 271889,
            "num": 25
        },
        {
            "score": 126,
            "ranking": 271910,
            "num": 21
        },
        {
            "score": 125,
            "ranking": 271934,
            "num": 24
        },
        {
            "score": 124,
            "ranking": 271952,
            "num": 18
        },
        {
            "score": 123,
            "ranking": 271970,
            "num": 18
        },
        {
            "score": 122,
            "ranking": 271982,
            "num": 12
        },
        {
            "score": 121,
            "ranking": 272005,
            "num": 23
        },
        {
            "score": 120,
            "ranking": 272021,
            "num": 16
        },
        {
            "score": 119,
            "ranking": 272034,
            "num": 13
        },
        {
            "score": 118,
            "ranking": 272053,
            "num": 19
        },
        {
            "score": 117,
            "ranking": 272064,
            "num": 11
        },
        {
            "score": 116,
            "ranking": 272073,
            "num": 9
        },
        {
            "score": 115,
            "ranking": 272079,
            "num": 6
        },
        {
            "score": 114,
            "ranking": 272093,
            "num": 14
        },
        {
            "score": 113,
            "ranking": 272106,
            "num": 13
        },
        {
            "score": 112,
            "ranking": 272114,
            "num": 8
        },
        {
            "score": 111,
            "ranking": 272123,
            "num": 9
        },
        {
            "score": 110,
            "ranking": 272137,
            "num": 14
        },
        {
            "score": 109,
            "ranking": 272150,
            "num": 13
        },
        {
            "score": 108,
            "ranking": 272160,
            "num": 10
        },
        {
            "score": 107,
            "ranking": 272176,
            "num": 16
        },
        {
            "score": 106,
            "ranking": 272181,
            "num": 5
        },
        {
            "score": 105,
            "ranking": 272192,
            "num": 11
        },
        {
            "score": 104,
            "ranking": 272199,
            "num": 7
        },
        {
            "score": 103,
            "ranking": 272210,
            "num": 11
        },
        {
            "score": 102,
            "ranking": 272223,
            "num": 13
        },
        {
            "score": 101,
            "ranking": 272237,
            "num": 14
        },
        {
            "score": 100,
            "ranking": 272251,
            "num": 14
        }
    ],
    2017: [
        {
            "score": 670,
            "ranking": 2,
            "num": 2
        },
        {
            "score": 669,
            "ranking": 4,
            "num": 2
        },
        {
            "score": 667,
            "ranking": 5,
            "num": 1
        },
        {
            "score": 666,
            "ranking": 6,
            "num": 1
        },
        {
            "score": 665,
            "ranking": 8,
            "num": 2
        },
        {
            "score": 663,
            "ranking": 9,
            "num": 1
        },
        {
            "score": 662,
            "ranking": 10,
            "num": 1
        },
        {
            "score": 658,
            "ranking": 11,
            "num": 1
        },
        {
            "score": 657,
            "ranking": 12,
            "num": 1
        },
        {
            "score": 656,
            "ranking": 14,
            "num": 2
        },
        {
            "score": 655,
            "ranking": 18,
            "num": 4
        },
        {
            "score": 654,
            "ranking": 21,
            "num": 3
        },
        {
            "score": 653,
            "ranking": 25,
            "num": 4
        },
        {
            "score": 652,
            "ranking": 26,
            "num": 1
        },
        {
            "score": 651,
            "ranking": 29,
            "num": 3
        },
        {
            "score": 650,
            "ranking": 31,
            "num": 2
        },
        {
            "score": 649,
            "ranking": 34,
            "num": 3
        },
        {
            "score": 648,
            "ranking": 36,
            "num": 2
        },
        {
            "score": 647,
            "ranking": 44,
            "num": 8
        },
        {
            "score": 646,
            "ranking": 45,
            "num": 1
        },
        {
            "score": 645,
            "ranking": 49,
            "num": 4
        },
        {
            "score": 644,
            "ranking": 55,
            "num": 6
        },
        {
            "score": 643,
            "ranking": 60,
            "num": 5
        },
        {
            "score": 642,
            "ranking": 64,
            "num": 4
        },
        {
            "score": 641,
            "ranking": 68,
            "num": 4
        },
        {
            "score": 640,
            "ranking": 76,
            "num": 8
        },
        {
            "score": 639,
            "ranking": 85,
            "num": 9
        },
        {
            "score": 638,
            "ranking": 93,
            "num": 8
        },
        {
            "score": 637,
            "ranking": 103,
            "num": 10
        },
        {
            "score": 636,
            "ranking": 110,
            "num": 7
        },
        {
            "score": 635,
            "ranking": 115,
            "num": 5
        },
        {
            "score": 634,
            "ranking": 129,
            "num": 14
        },
        {
            "score": 633,
            "ranking": 146,
            "num": 17
        },
        {
            "score": 632,
            "ranking": 161,
            "num": 15
        },
        {
            "score": 631,
            "ranking": 177,
            "num": 16
        },
        {
            "score": 630,
            "ranking": 191,
            "num": 14
        },
        {
            "score": 629,
            "ranking": 213,
            "num": 22
        },
        {
            "score": 628,
            "ranking": 234,
            "num": 21
        },
        {
            "score": 627,
            "ranking": 260,
            "num": 26
        },
        {
            "score": 626,
            "ranking": 281,
            "num": 21
        },
        {
            "score": 625,
            "ranking": 299,
            "num": 18
        },
        {
            "score": 624,
            "ranking": 334,
            "num": 35
        },
        {
            "score": 623,
            "ranking": 359,
            "num": 25
        },
        {
            "score": 622,
            "ranking": 385,
            "num": 26
        },
        {
            "score": 621,
            "ranking": 407,
            "num": 22
        },
        {
            "score": 620,
            "ranking": 442,
            "num": 35
        },
        {
            "score": 619,
            "ranking": 464,
            "num": 22
        },
        {
            "score": 618,
            "ranking": 494,
            "num": 30
        },
        {
            "score": 617,
            "ranking": 527,
            "num": 33
        },
        {
            "score": 616,
            "ranking": 562,
            "num": 35
        },
        {
            "score": 615,
            "ranking": 601,
            "num": 39
        },
        {
            "score": 614,
            "ranking": 632,
            "num": 31
        },
        {
            "score": 613,
            "ranking": 678,
            "num": 46
        },
        {
            "score": 612,
            "ranking": 721,
            "num": 43
        },
        {
            "score": 611,
            "ranking": 768,
            "num": 47
        },
        {
            "score": 610,
            "ranking": 807,
            "num": 39
        },
        {
            "score": 609,
            "ranking": 869,
            "num": 62
        },
        {
            "score": 608,
            "ranking": 911,
            "num": 42
        },
        {
            "score": 607,
            "ranking": 970,
            "num": 59
        },
        {
            "score": 606,
            "ranking": 1029,
            "num": 59
        },
        {
            "score": 605,
            "ranking": 1078,
            "num": 49
        },
        {
            "score": 604,
            "ranking": 1134,
            "num": 56
        },
        {
            "score": 603,
            "ranking": 1183,
            "num": 49
        },
        {
            "score": 602,
            "ranking": 1236,
            "num": 53
        },
        {
            "score": 601,
            "ranking": 1297,
            "num": 61
        },
        {
            "score": 600,
            "ranking": 1363,
            "num": 66
        },
        {
            "score": 599,
            "ranking": 1428,
            "num": 65
        },
        {
            "score": 598,
            "ranking": 1495,
            "num": 67
        },
        {
            "score": 596,
            "ranking": 1663,
            "num": 168
        },
        {
            "score": 595,
            "ranking": 1740,
            "num": 77
        },
        {
            "score": 594,
            "ranking": 1819,
            "num": 79
        },
        {
            "score": 593,
            "ranking": 1899,
            "num": 80
        },
        {
            "score": 592,
            "ranking": 1991,
            "num": 92
        },
        {
            "score": 591,
            "ranking": 2070,
            "num": 79
        },
        {
            "score": 590,
            "ranking": 2174,
            "num": 104
        },
        {
            "score": 589,
            "ranking": 2268,
            "num": 94
        },
        {
            "score": 588,
            "ranking": 2361,
            "num": 93
        },
        {
            "score": 587,
            "ranking": 2458,
            "num": 97
        },
        {
            "score": 586,
            "ranking": 2559,
            "num": 101
        },
        {
            "score": 585,
            "ranking": 2658,
            "num": 99
        },
        {
            "score": 584,
            "ranking": 2746,
            "num": 88
        },
        {
            "score": 583,
            "ranking": 2857,
            "num": 111
        },
        {
            "score": 582,
            "ranking": 2970,
            "num": 113
        },
        {
            "score": 581,
            "ranking": 3082,
            "num": 112
        },
        {
            "score": 580,
            "ranking": 3205,
            "num": 123
        },
        {
            "score": 579,
            "ranking": 3320,
            "num": 115
        },
        {
            "score": 578,
            "ranking": 3421,
            "num": 101
        },
        {
            "score": 577,
            "ranking": 3529,
            "num": 108
        },
        {
            "score": 576,
            "ranking": 3634,
            "num": 105
        },
        {
            "score": 575,
            "ranking": 3767,
            "num": 133
        },
        {
            "score": 574,
            "ranking": 3894,
            "num": 127
        },
        {
            "score": 573,
            "ranking": 4021,
            "num": 127
        },
        {
            "score": 572,
            "ranking": 4140,
            "num": 119
        },
        {
            "score": 571,
            "ranking": 4282,
            "num": 142
        },
        {
            "score": 570,
            "ranking": 4432,
            "num": 150
        },
        {
            "score": 569,
            "ranking": 4566,
            "num": 134
        },
        {
            "score": 568,
            "ranking": 4738,
            "num": 172
        },
        {
            "score": 567,
            "ranking": 4900,
            "num": 162
        },
        {
            "score": 566,
            "ranking": 5054,
            "num": 154
        },
        {
            "score": 565,
            "ranking": 5214,
            "num": 160
        },
        {
            "score": 564,
            "ranking": 5378,
            "num": 164
        },
        {
            "score": 563,
            "ranking": 5558,
            "num": 180
        },
        {
            "score": 562,
            "ranking": 5715,
            "num": 157
        },
        {
            "score": 561,
            "ranking": 5889,
            "num": 174
        },
        {
            "score": 560,
            "ranking": 6069,
            "num": 180
        },
        {
            "score": 559,
            "ranking": 6248,
            "num": 179
        },
        {
            "score": 558,
            "ranking": 6463,
            "num": 215
        },
        {
            "score": 557,
            "ranking": 6661,
            "num": 198
        },
        {
            "score": 556,
            "ranking": 6877,
            "num": 216
        },
        {
            "score": 555,
            "ranking": 7077,
            "num": 200
        },
        {
            "score": 554,
            "ranking": 7281,
            "num": 204
        },
        {
            "score": 553,
            "ranking": 7479,
            "num": 198
        },
        {
            "score": 552,
            "ranking": 7706,
            "num": 227
        },
        {
            "score": 551,
            "ranking": 7926,
            "num": 220
        },
        {
            "score": 550,
            "ranking": 8153,
            "num": 227
        },
        {
            "score": 549,
            "ranking": 8382,
            "num": 229
        },
        {
            "score": 548,
            "ranking": 8606,
            "num": 224
        },
        {
            "score": 547,
            "ranking": 8873,
            "num": 267
        },
        {
            "score": 546,
            "ranking": 9122,
            "num": 249
        },
        {
            "score": 545,
            "ranking": 9374,
            "num": 252
        },
        {
            "score": 544,
            "ranking": 9622,
            "num": 248
        },
        {
            "score": 543,
            "ranking": 9885,
            "num": 263
        },
        {
            "score": 542,
            "ranking": 10156,
            "num": 271
        },
        {
            "score": 541,
            "ranking": 10436,
            "num": 280
        },
        {
            "score": 540,
            "ranking": 10686,
            "num": 250
        },
        {
            "score": 539,
            "ranking": 10963,
            "num": 277
        },
        {
            "score": 538,
            "ranking": 11236,
            "num": 273
        },
        {
            "score": 537,
            "ranking": 11522,
            "num": 286
        },
        {
            "score": 536,
            "ranking": 11818,
            "num": 296
        },
        {
            "score": 535,
            "ranking": 12138,
            "num": 320
        },
        {
            "score": 534,
            "ranking": 12434,
            "num": 296
        },
        {
            "score": 533,
            "ranking": 12740,
            "num": 306
        },
        {
            "score": 532,
            "ranking": 13099,
            "num": 359
        },
        {
            "score": 531,
            "ranking": 13403,
            "num": 304
        },
        {
            "score": 530,
            "ranking": 13743,
            "num": 340
        },
        {
            "score": 529,
            "ranking": 14050,
            "num": 307
        },
        {
            "score": 528,
            "ranking": 14369,
            "num": 319
        },
        {
            "score": 527,
            "ranking": 14688,
            "num": 319
        },
        {
            "score": 526,
            "ranking": 15055,
            "num": 367
        },
        {
            "score": 525,
            "ranking": 15411,
            "num": 356
        },
        {
            "score": 524,
            "ranking": 15767,
            "num": 356
        },
        {
            "score": 523,
            "ranking": 16145,
            "num": 378
        },
        {
            "score": 522,
            "ranking": 16519,
            "num": 374
        },
        {
            "score": 521,
            "ranking": 16933,
            "num": 414
        },
        {
            "score": 520,
            "ranking": 17348,
            "num": 415
        },
        {
            "score": 519,
            "ranking": 17731,
            "num": 383
        },
        {
            "score": 517,
            "ranking": 18518,
            "num": 787
        },
        {
            "score": 516,
            "ranking": 18951,
            "num": 433
        },
        {
            "score": 515,
            "ranking": 19379,
            "num": 428
        },
        {
            "score": 514,
            "ranking": 19790,
            "num": 411
        },
        {
            "score": 513,
            "ranking": 20202,
            "num": 412
        },
        {
            "score": 512,
            "ranking": 20654,
            "num": 452
        },
        {
            "score": 510,
            "ranking": 21527,
            "num": 873
        },
        {
            "score": 509,
            "ranking": 21981,
            "num": 454
        },
        {
            "score": 508,
            "ranking": 22421,
            "num": 440
        },
        {
            "score": 507,
            "ranking": 22873,
            "num": 452
        },
        {
            "score": 506,
            "ranking": 23301,
            "num": 428
        },
        {
            "score": 505,
            "ranking": 23790,
            "num": 489
        },
        {
            "score": 504,
            "ranking": 24243,
            "num": 453
        },
        {
            "score": 503,
            "ranking": 24759,
            "num": 516
        },
        {
            "score": 502,
            "ranking": 25240,
            "num": 481
        },
        {
            "score": 501,
            "ranking": 25715,
            "num": 475
        },
        {
            "score": 500,
            "ranking": 26253,
            "num": 538
        },
        {
            "score": 499,
            "ranking": 26743,
            "num": 490
        },
        {
            "score": 498,
            "ranking": 27240,
            "num": 497
        },
        {
            "score": 497,
            "ranking": 27751,
            "num": 511
        },
        {
            "score": 496,
            "ranking": 28240,
            "num": 489
        },
        {
            "score": 495,
            "ranking": 28724,
            "num": 484
        },
        {
            "score": 494,
            "ranking": 29261,
            "num": 537
        },
        {
            "score": 493,
            "ranking": 29793,
            "num": 532
        },
        {
            "score": 492,
            "ranking": 30322,
            "num": 529
        },
        {
            "score": 491,
            "ranking": 30878,
            "num": 556
        },
        {
            "score": 490,
            "ranking": 31421,
            "num": 543
        },
        {
            "score": 489,
            "ranking": 31937,
            "num": 516
        },
        {
            "score": 488,
            "ranking": 32502,
            "num": 565
        },
        {
            "score": 487,
            "ranking": 33079,
            "num": 577
        },
        {
            "score": 486,
            "ranking": 33650,
            "num": 571
        },
        {
            "score": 485,
            "ranking": 34227,
            "num": 577
        },
        {
            "score": 484,
            "ranking": 34809,
            "num": 582
        },
        {
            "score": 483,
            "ranking": 35348,
            "num": 539
        },
        {
            "score": 482,
            "ranking": 35901,
            "num": 553
        },
        {
            "score": 481,
            "ranking": 36499,
            "num": 598
        },
        {
            "score": 480,
            "ranking": 37066,
            "num": 567
        },
        {
            "score": 479,
            "ranking": 37646,
            "num": 580
        },
        {
            "score": 478,
            "ranking": 38199,
            "num": 553
        },
        {
            "score": 477,
            "ranking": 38822,
            "num": 623
        },
        {
            "score": 476,
            "ranking": 39428,
            "num": 606
        },
        {
            "score": 475,
            "ranking": 40006,
            "num": 578
        },
        {
            "score": 474,
            "ranking": 40625,
            "num": 619
        },
        {
            "score": 473,
            "ranking": 41235,
            "num": 610
        },
        {
            "score": 472,
            "ranking": 41834,
            "num": 599
        },
        {
            "score": 471,
            "ranking": 42432,
            "num": 598
        },
        {
            "score": 470,
            "ranking": 43063,
            "num": 631
        },
        {
            "score": 469,
            "ranking": 43670,
            "num": 607
        },
        {
            "score": 468,
            "ranking": 44277,
            "num": 607
        },
        {
            "score": 467,
            "ranking": 44907,
            "num": 630
        },
        {
            "score": 466,
            "ranking": 45564,
            "num": 657
        },
        {
            "score": 465,
            "ranking": 46195,
            "num": 631
        },
        {
            "score": 464,
            "ranking": 46847,
            "num": 652
        },
        {
            "score": 463,
            "ranking": 47454,
            "num": 607
        },
        {
            "score": 462,
            "ranking": 48087,
            "num": 633
        },
        {
            "score": 461,
            "ranking": 48727,
            "num": 640
        },
        {
            "score": 460,
            "ranking": 49367,
            "num": 640
        },
        {
            "score": 459,
            "ranking": 50003,
            "num": 636
        },
        {
            "score": 458,
            "ranking": 50660,
            "num": 657
        },
        {
            "score": 457,
            "ranking": 51308,
            "num": 648
        },
        {
            "score": 456,
            "ranking": 51937,
            "num": 629
        },
        {
            "score": 455,
            "ranking": 52583,
            "num": 646
        },
        {
            "score": 454,
            "ranking": 53238,
            "num": 655
        },
        {
            "score": 453,
            "ranking": 53871,
            "num": 633
        },
        {
            "score": 452,
            "ranking": 54523,
            "num": 652
        },
        {
            "score": 451,
            "ranking": 55147,
            "num": 624
        },
        {
            "score": 450,
            "ranking": 55793,
            "num": 646
        },
        {
            "score": 449,
            "ranking": 56463,
            "num": 670
        },
        {
            "score": 448,
            "ranking": 57102,
            "num": 639
        },
        {
            "score": 447,
            "ranking": 57809,
            "num": 707
        },
        {
            "score": 446,
            "ranking": 58470,
            "num": 661
        },
        {
            "score": 445,
            "ranking": 59131,
            "num": 661
        },
        {
            "score": 444,
            "ranking": 59827,
            "num": 696
        },
        {
            "score": 443,
            "ranking": 60485,
            "num": 658
        },
        {
            "score": 442,
            "ranking": 61157,
            "num": 672
        },
        {
            "score": 441,
            "ranking": 61848,
            "num": 691
        },
        {
            "score": 440,
            "ranking": 62551,
            "num": 703
        },
        {
            "score": 439,
            "ranking": 63227,
            "num": 676
        },
        {
            "score": 438,
            "ranking": 63911,
            "num": 684
        },
        {
            "score": 437,
            "ranking": 64579,
            "num": 668
        },
        {
            "score": 436,
            "ranking": 65256,
            "num": 677
        },
        {
            "score": 435,
            "ranking": 65944,
            "num": 688
        },
        {
            "score": 434,
            "ranking": 66637,
            "num": 693
        },
        {
            "score": 433,
            "ranking": 67322,
            "num": 685
        },
        {
            "score": 432,
            "ranking": 68036,
            "num": 714
        },
        {
            "score": 431,
            "ranking": 68682,
            "num": 646
        },
        {
            "score": 430,
            "ranking": 69326,
            "num": 644
        },
        {
            "score": 429,
            "ranking": 70003,
            "num": 677
        },
        {
            "score": 428,
            "ranking": 70684,
            "num": 681
        },
        {
            "score": 427,
            "ranking": 71357,
            "num": 673
        },
        {
            "score": 426,
            "ranking": 72037,
            "num": 680
        },
        {
            "score": 425,
            "ranking": 72731,
            "num": 694
        },
        {
            "score": 424,
            "ranking": 73388,
            "num": 657
        },
        {
            "score": 423,
            "ranking": 74085,
            "num": 697
        },
        {
            "score": 422,
            "ranking": 74795,
            "num": 710
        },
        {
            "score": 421,
            "ranking": 75521,
            "num": 726
        },
        {
            "score": 420,
            "ranking": 76252,
            "num": 731
        },
        {
            "score": 419,
            "ranking": 76981,
            "num": 729
        },
        {
            "score": 418,
            "ranking": 77726,
            "num": 745
        },
        {
            "score": 417,
            "ranking": 78438,
            "num": 712
        },
        {
            "score": 416,
            "ranking": 79160,
            "num": 722
        },
        {
            "score": 415,
            "ranking": 79872,
            "num": 712
        },
        {
            "score": 414,
            "ranking": 80603,
            "num": 731
        },
        {
            "score": 413,
            "ranking": 81291,
            "num": 688
        },
        {
            "score": 412,
            "ranking": 82033,
            "num": 742
        },
        {
            "score": 411,
            "ranking": 82829,
            "num": 796
        },
        {
            "score": 410,
            "ranking": 83550,
            "num": 721
        },
        {
            "score": 409,
            "ranking": 84284,
            "num": 734
        },
        {
            "score": 408,
            "ranking": 84988,
            "num": 704
        },
        {
            "score": 407,
            "ranking": 85746,
            "num": 758
        },
        {
            "score": 406,
            "ranking": 86462,
            "num": 716
        },
        {
            "score": 405,
            "ranking": 87125,
            "num": 663
        },
        {
            "score": 404,
            "ranking": 87833,
            "num": 708
        },
        {
            "score": 403,
            "ranking": 88572,
            "num": 739
        },
        {
            "score": 402,
            "ranking": 89312,
            "num": 740
        },
        {
            "score": 401,
            "ranking": 90047,
            "num": 735
        },
        {
            "score": 400,
            "ranking": 90813,
            "num": 766
        },
        {
            "score": 399,
            "ranking": 91552,
            "num": 739
        },
        {
            "score": 398,
            "ranking": 92274,
            "num": 722
        },
        {
            "score": 397,
            "ranking": 92993,
            "num": 719
        },
        {
            "score": 396,
            "ranking": 93728,
            "num": 735
        },
        {
            "score": 395,
            "ranking": 94473,
            "num": 745
        },
        {
            "score": 394,
            "ranking": 95211,
            "num": 738
        },
        {
            "score": 393,
            "ranking": 95961,
            "num": 750
        },
        {
            "score": 392,
            "ranking": 96677,
            "num": 716
        },
        {
            "score": 391,
            "ranking": 97426,
            "num": 749
        },
        {
            "score": 390,
            "ranking": 98191,
            "num": 765
        },
        {
            "score": 389,
            "ranking": 98952,
            "num": 761
        },
        {
            "score": 388,
            "ranking": 99716,
            "num": 764
        },
        {
            "score": 387,
            "ranking": 100491,
            "num": 775
        },
        {
            "score": 386,
            "ranking": 101233,
            "num": 742
        },
        {
            "score": 385,
            "ranking": 101987,
            "num": 754
        },
        {
            "score": 384,
            "ranking": 102723,
            "num": 736
        },
        {
            "score": 383,
            "ranking": 103483,
            "num": 760
        },
        {
            "score": 382,
            "ranking": 104241,
            "num": 758
        },
        {
            "score": 381,
            "ranking": 104982,
            "num": 741
        },
        {
            "score": 380,
            "ranking": 105805,
            "num": 823
        },
        {
            "score": 379,
            "ranking": 106575,
            "num": 770
        },
        {
            "score": 378,
            "ranking": 107352,
            "num": 777
        },
        {
            "score": 377,
            "ranking": 108131,
            "num": 779
        },
        {
            "score": 376,
            "ranking": 108913,
            "num": 782
        },
        {
            "score": 375,
            "ranking": 109662,
            "num": 749
        },
        {
            "score": 374,
            "ranking": 110414,
            "num": 752
        },
        {
            "score": 373,
            "ranking": 111124,
            "num": 710
        },
        {
            "score": 372,
            "ranking": 111856,
            "num": 732
        },
        {
            "score": 371,
            "ranking": 112656,
            "num": 800
        },
        {
            "score": 370,
            "ranking": 113419,
            "num": 763
        },
        {
            "score": 369,
            "ranking": 114199,
            "num": 780
        },
        {
            "score": 368,
            "ranking": 114960,
            "num": 761
        },
        {
            "score": 367,
            "ranking": 115767,
            "num": 807
        },
        {
            "score": 366,
            "ranking": 116531,
            "num": 764
        },
        {
            "score": 365,
            "ranking": 117345,
            "num": 814
        },
        {
            "score": 364,
            "ranking": 118146,
            "num": 801
        },
        {
            "score": 363,
            "ranking": 118936,
            "num": 790
        },
        {
            "score": 362,
            "ranking": 119694,
            "num": 758
        },
        {
            "score": 361,
            "ranking": 120467,
            "num": 773
        },
        {
            "score": 360,
            "ranking": 121234,
            "num": 767
        },
        {
            "score": 359,
            "ranking": 122080,
            "num": 846
        },
        {
            "score": 358,
            "ranking": 122865,
            "num": 785
        },
        {
            "score": 357,
            "ranking": 123643,
            "num": 778
        },
        {
            "score": 356,
            "ranking": 124409,
            "num": 766
        },
        {
            "score": 355,
            "ranking": 125225,
            "num": 816
        },
        {
            "score": 354,
            "ranking": 126026,
            "num": 801
        },
        {
            "score": 353,
            "ranking": 126827,
            "num": 801
        },
        {
            "score": 352,
            "ranking": 127656,
            "num": 829
        },
        {
            "score": 351,
            "ranking": 128437,
            "num": 781
        },
        {
            "score": 350,
            "ranking": 129270,
            "num": 833
        },
        {
            "score": 349,
            "ranking": 130099,
            "num": 829
        },
        {
            "score": 348,
            "ranking": 130928,
            "num": 829
        },
        {
            "score": 347,
            "ranking": 131769,
            "num": 841
        },
        {
            "score": 346,
            "ranking": 132609,
            "num": 840
        },
        {
            "score": 345,
            "ranking": 133466,
            "num": 857
        },
        {
            "score": 344,
            "ranking": 134340,
            "num": 874
        },
        {
            "score": 343,
            "ranking": 135190,
            "num": 850
        },
        {
            "score": 342,
            "ranking": 136016,
            "num": 826
        },
        {
            "score": 341,
            "ranking": 136861,
            "num": 845
        },
        {
            "score": 340,
            "ranking": 137710,
            "num": 849
        },
        {
            "score": 339,
            "ranking": 138554,
            "num": 844
        },
        {
            "score": 338,
            "ranking": 139341,
            "num": 787
        },
        {
            "score": 337,
            "ranking": 140208,
            "num": 867
        },
        {
            "score": 336,
            "ranking": 141089,
            "num": 881
        },
        {
            "score": 335,
            "ranking": 141891,
            "num": 802
        },
        {
            "score": 334,
            "ranking": 142769,
            "num": 878
        },
        {
            "score": 333,
            "ranking": 143619,
            "num": 850
        },
        {
            "score": 332,
            "ranking": 144457,
            "num": 838
        },
        {
            "score": 331,
            "ranking": 145275,
            "num": 818
        },
        {
            "score": 330,
            "ranking": 146136,
            "num": 861
        },
        {
            "score": 329,
            "ranking": 146978,
            "num": 842
        },
        {
            "score": 328,
            "ranking": 147826,
            "num": 848
        },
        {
            "score": 327,
            "ranking": 148683,
            "num": 857
        },
        {
            "score": 326,
            "ranking": 149541,
            "num": 858
        },
        {
            "score": 325,
            "ranking": 150413,
            "num": 872
        },
        {
            "score": 324,
            "ranking": 151268,
            "num": 855
        },
        {
            "score": 323,
            "ranking": 152157,
            "num": 889
        },
        {
            "score": 322,
            "ranking": 153056,
            "num": 899
        },
        {
            "score": 321,
            "ranking": 153944,
            "num": 888
        },
        {
            "score": 320,
            "ranking": 154811,
            "num": 867
        },
        {
            "score": 319,
            "ranking": 155668,
            "num": 857
        },
        {
            "score": 318,
            "ranking": 156517,
            "num": 849
        },
        {
            "score": 317,
            "ranking": 157386,
            "num": 869
        },
        {
            "score": 316,
            "ranking": 158261,
            "num": 875
        },
        {
            "score": 315,
            "ranking": 159102,
            "num": 841
        },
        {
            "score": 314,
            "ranking": 159987,
            "num": 885
        },
        {
            "score": 313,
            "ranking": 160794,
            "num": 807
        },
        {
            "score": 312,
            "ranking": 161629,
            "num": 835
        },
        {
            "score": 311,
            "ranking": 162415,
            "num": 786
        },
        {
            "score": 310,
            "ranking": 163186,
            "num": 771
        },
        {
            "score": 309,
            "ranking": 164024,
            "num": 838
        },
        {
            "score": 308,
            "ranking": 164833,
            "num": 809
        },
        {
            "score": 307,
            "ranking": 165647,
            "num": 814
        },
        {
            "score": 306,
            "ranking": 166474,
            "num": 827
        },
        {
            "score": 305,
            "ranking": 167296,
            "num": 822
        },
        {
            "score": 304,
            "ranking": 168147,
            "num": 851
        },
        {
            "score": 303,
            "ranking": 168946,
            "num": 799
        },
        {
            "score": 302,
            "ranking": 169804,
            "num": 858
        },
        {
            "score": 301,
            "ranking": 170647,
            "num": 843
        },
        {
            "score": 300,
            "ranking": 171505,
            "num": 858
        },
        {
            "score": 299,
            "ranking": 172341,
            "num": 836
        },
        {
            "score": 298,
            "ranking": 173212,
            "num": 871
        },
        {
            "score": 297,
            "ranking": 173994,
            "num": 782
        },
        {
            "score": 296,
            "ranking": 174804,
            "num": 810
        },
        {
            "score": 295,
            "ranking": 175621,
            "num": 817
        },
        {
            "score": 294,
            "ranking": 176457,
            "num": 836
        },
        {
            "score": 293,
            "ranking": 177304,
            "num": 847
        },
        {
            "score": 292,
            "ranking": 178107,
            "num": 803
        },
        {
            "score": 291,
            "ranking": 178932,
            "num": 825
        },
        {
            "score": 290,
            "ranking": 179700,
            "num": 768
        },
        {
            "score": 289,
            "ranking": 180517,
            "num": 817
        },
        {
            "score": 288,
            "ranking": 181334,
            "num": 817
        },
        {
            "score": 287,
            "ranking": 182114,
            "num": 780
        },
        {
            "score": 286,
            "ranking": 182835,
            "num": 721
        },
        {
            "score": 285,
            "ranking": 183651,
            "num": 816
        },
        {
            "score": 284,
            "ranking": 184435,
            "num": 784
        },
        {
            "score": 283,
            "ranking": 185203,
            "num": 768
        },
        {
            "score": 282,
            "ranking": 186017,
            "num": 814
        },
        {
            "score": 281,
            "ranking": 186794,
            "num": 777
        },
        {
            "score": 280,
            "ranking": 187496,
            "num": 702
        },
        {
            "score": 279,
            "ranking": 188267,
            "num": 771
        },
        {
            "score": 278,
            "ranking": 189000,
            "num": 733
        },
        {
            "score": 277,
            "ranking": 189752,
            "num": 752
        },
        {
            "score": 276,
            "ranking": 190451,
            "num": 699
        },
        {
            "score": 275,
            "ranking": 191154,
            "num": 703
        },
        {
            "score": 274,
            "ranking": 191859,
            "num": 705
        },
        {
            "score": 273,
            "ranking": 192600,
            "num": 741
        },
        {
            "score": 272,
            "ranking": 193336,
            "num": 736
        },
        {
            "score": 271,
            "ranking": 194065,
            "num": 729
        },
        {
            "score": 270,
            "ranking": 194743,
            "num": 678
        },
        {
            "score": 269,
            "ranking": 195433,
            "num": 690
        },
        {
            "score": 268,
            "ranking": 196124,
            "num": 691
        },
        {
            "score": 267,
            "ranking": 196796,
            "num": 672
        },
        {
            "score": 266,
            "ranking": 197405,
            "num": 609
        },
        {
            "score": 265,
            "ranking": 198089,
            "num": 684
        },
        {
            "score": 264,
            "ranking": 198751,
            "num": 662
        },
        {
            "score": 263,
            "ranking": 199366,
            "num": 615
        },
        {
            "score": 262,
            "ranking": 200029,
            "num": 663
        },
        {
            "score": 261,
            "ranking": 200623,
            "num": 594
        },
        {
            "score": 260,
            "ranking": 201224,
            "num": 601
        },
        {
            "score": 259,
            "ranking": 201905,
            "num": 681
        },
        {
            "score": 258,
            "ranking": 202532,
            "num": 627
        },
        {
            "score": 257,
            "ranking": 203161,
            "num": 629
        },
        {
            "score": 256,
            "ranking": 203773,
            "num": 612
        },
        {
            "score": 255,
            "ranking": 204411,
            "num": 638
        },
        {
            "score": 254,
            "ranking": 204975,
            "num": 564
        },
        {
            "score": 253,
            "ranking": 205594,
            "num": 619
        },
        {
            "score": 252,
            "ranking": 206185,
            "num": 591
        },
        {
            "score": 251,
            "ranking": 206835,
            "num": 650
        },
        {
            "score": 250,
            "ranking": 207443,
            "num": 608
        },
        {
            "score": 249,
            "ranking": 207995,
            "num": 552
        },
        {
            "score": 248,
            "ranking": 208560,
            "num": 565
        },
        {
            "score": 247,
            "ranking": 209134,
            "num": 574
        },
        {
            "score": 246,
            "ranking": 209660,
            "num": 526
        },
        {
            "score": 245,
            "ranking": 210137,
            "num": 477
        },
        {
            "score": 244,
            "ranking": 210659,
            "num": 522
        },
        {
            "score": 243,
            "ranking": 211161,
            "num": 502
        },
        {
            "score": 242,
            "ranking": 211669,
            "num": 508
        },
        {
            "score": 241,
            "ranking": 212161,
            "num": 492
        },
        {
            "score": 240,
            "ranking": 212659,
            "num": 498
        },
        {
            "score": 239,
            "ranking": 213142,
            "num": 483
        },
        {
            "score": 238,
            "ranking": 213587,
            "num": 445
        },
        {
            "score": 237,
            "ranking": 214056,
            "num": 469
        },
        {
            "score": 236,
            "ranking": 214527,
            "num": 471
        },
        {
            "score": 235,
            "ranking": 214982,
            "num": 455
        },
        {
            "score": 234,
            "ranking": 215405,
            "num": 423
        },
        {
            "score": 233,
            "ranking": 215873,
            "num": 468
        },
        {
            "score": 232,
            "ranking": 216304,
            "num": 431
        },
        {
            "score": 231,
            "ranking": 216698,
            "num": 394
        },
        {
            "score": 230,
            "ranking": 217120,
            "num": 422
        },
        {
            "score": 229,
            "ranking": 217515,
            "num": 395
        },
        {
            "score": 228,
            "ranking": 217926,
            "num": 411
        },
        {
            "score": 227,
            "ranking": 218361,
            "num": 435
        },
        {
            "score": 226,
            "ranking": 218742,
            "num": 381
        },
        {
            "score": 225,
            "ranking": 219126,
            "num": 384
        },
        {
            "score": 224,
            "ranking": 219531,
            "num": 405
        },
        {
            "score": 223,
            "ranking": 219902,
            "num": 371
        },
        {
            "score": 222,
            "ranking": 220258,
            "num": 356
        },
        {
            "score": 221,
            "ranking": 220658,
            "num": 400
        },
        {
            "score": 220,
            "ranking": 221023,
            "num": 365
        },
        {
            "score": 219,
            "ranking": 221371,
            "num": 348
        },
        {
            "score": 218,
            "ranking": 221717,
            "num": 346
        },
        {
            "score": 217,
            "ranking": 222045,
            "num": 328
        },
        {
            "score": 216,
            "ranking": 222410,
            "num": 365
        },
        {
            "score": 215,
            "ranking": 222748,
            "num": 338
        },
        {
            "score": 214,
            "ranking": 223064,
            "num": 316
        },
        {
            "score": 213,
            "ranking": 223404,
            "num": 340
        },
        {
            "score": 212,
            "ranking": 223715,
            "num": 311
        },
        {
            "score": 211,
            "ranking": 224022,
            "num": 307
        },
        {
            "score": 210,
            "ranking": 224286,
            "num": 264
        },
        {
            "score": 209,
            "ranking": 224595,
            "num": 309
        },
        {
            "score": 208,
            "ranking": 224878,
            "num": 283
        },
        {
            "score": 207,
            "ranking": 225136,
            "num": 258
        },
        {
            "score": 206,
            "ranking": 225418,
            "num": 282
        },
        {
            "score": 205,
            "ranking": 225688,
            "num": 270
        },
        {
            "score": 204,
            "ranking": 226007,
            "num": 319
        },
        {
            "score": 203,
            "ranking": 226258,
            "num": 251
        },
        {
            "score": 202,
            "ranking": 226526,
            "num": 268
        },
        {
            "score": 201,
            "ranking": 226771,
            "num": 245
        },
        {
            "score": 200,
            "ranking": 227029,
            "num": 258
        },
        {
            "score": 199,
            "ranking": 227254,
            "num": 225
        },
        {
            "score": 198,
            "ranking": 227494,
            "num": 240
        },
        {
            "score": 197,
            "ranking": 227739,
            "num": 245
        },
        {
            "score": 196,
            "ranking": 227959,
            "num": 220
        },
        {
            "score": 195,
            "ranking": 228188,
            "num": 229
        },
        {
            "score": 194,
            "ranking": 228406,
            "num": 218
        },
        {
            "score": 193,
            "ranking": 228614,
            "num": 208
        },
        {
            "score": 192,
            "ranking": 228816,
            "num": 202
        },
        {
            "score": 191,
            "ranking": 229014,
            "num": 198
        },
        {
            "score": 190,
            "ranking": 229221,
            "num": 207
        },
        {
            "score": 189,
            "ranking": 229410,
            "num": 189
        },
        {
            "score": 188,
            "ranking": 229590,
            "num": 180
        },
        {
            "score": 187,
            "ranking": 229772,
            "num": 182
        },
        {
            "score": 186,
            "ranking": 229970,
            "num": 198
        },
        {
            "score": 185,
            "ranking": 230126,
            "num": 156
        },
        {
            "score": 184,
            "ranking": 230324,
            "num": 198
        },
        {
            "score": 183,
            "ranking": 230457,
            "num": 133
        },
        {
            "score": 182,
            "ranking": 230613,
            "num": 156
        },
        {
            "score": 181,
            "ranking": 230771,
            "num": 158
        },
        {
            "score": 180,
            "ranking": 230920,
            "num": 149
        },
        {
            "score": 179,
            "ranking": 231044,
            "num": 124
        },
        {
            "score": 178,
            "ranking": 231166,
            "num": 122
        },
        {
            "score": 177,
            "ranking": 231287,
            "num": 121
        },
        {
            "score": 176,
            "ranking": 231401,
            "num": 114
        },
        {
            "score": 175,
            "ranking": 231511,
            "num": 110
        },
        {
            "score": 174,
            "ranking": 231616,
            "num": 105
        },
        {
            "score": 173,
            "ranking": 231726,
            "num": 110
        },
        {
            "score": 172,
            "ranking": 231818,
            "num": 92
        },
        {
            "score": 171,
            "ranking": 231916,
            "num": 98
        },
        {
            "score": 170,
            "ranking": 232030,
            "num": 114
        },
        {
            "score": 169,
            "ranking": 232123,
            "num": 93
        },
        {
            "score": 168,
            "ranking": 232224,
            "num": 101
        },
        {
            "score": 167,
            "ranking": 232311,
            "num": 87
        },
        {
            "score": 166,
            "ranking": 232382,
            "num": 71
        },
        {
            "score": 165,
            "ranking": 232452,
            "num": 70
        },
        {
            "score": 164,
            "ranking": 232533,
            "num": 81
        },
        {
            "score": 163,
            "ranking": 232619,
            "num": 86
        },
        {
            "score": 162,
            "ranking": 232700,
            "num": 81
        },
        {
            "score": 161,
            "ranking": 232782,
            "num": 82
        },
        {
            "score": 160,
            "ranking": 232843,
            "num": 61
        },
        {
            "score": 159,
            "ranking": 232910,
            "num": 67
        },
        {
            "score": 158,
            "ranking": 232982,
            "num": 72
        },
        {
            "score": 157,
            "ranking": 233033,
            "num": 51
        },
        {
            "score": 156,
            "ranking": 233092,
            "num": 59
        },
        {
            "score": 155,
            "ranking": 233143,
            "num": 51
        },
        {
            "score": 154,
            "ranking": 233189,
            "num": 46
        },
        {
            "score": 153,
            "ranking": 233242,
            "num": 53
        }
    ]
}